webpackJsonp([83859446858435],{

/***/ 122:
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(361)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

	/* The following list is defined in React's core */
	var IS_UNITLESS = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	module.exports = function(name, value) {
	  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
	    return value + 'px';
	  } else {
	    return value;
	  }
	};

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added
	 * @returns {Date} the new date with the days added
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays (dirtyDate, dirtyAmount) {
	  var date = parse(dirtyDate)
	  var amount = Number(dirtyAmount)
	  date.setDate(date.getDate() + amount)
	  return date
	}
	
	module.exports = addDays


/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(72)
	
	var MILLISECONDS_IN_HOUR = 3600000
	
	/**
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added
	 * @returns {Date} the new date with the hours added
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
	}
	
	module.exports = addHours


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(58)
	var setISOYear = __webpack_require__(263)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added
	 * @returns {Date} the new date with the ISO week-numbering years added
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * var result = addISOYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
	}
	
	module.exports = addISOYears


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @returns {Date} the new date with the milliseconds added
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds (dirtyDate, dirtyAmount) {
	  var timestamp = parse(dirtyDate).getTime()
	  var amount = Number(dirtyAmount)
	  return new Date(timestamp + amount)
	}
	
	module.exports = addMilliseconds


/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(72)
	
	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added
	 * @returns {Date} the new date with the minutes added
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
	}
	
	module.exports = addMinutes


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var getDaysInMonth = __webpack_require__(156)
	
	/**
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added
	 * @returns {Date} the new date with the months added
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths (dirtyDate, dirtyAmount) {
	  var date = parse(dirtyDate)
	  var amount = Number(dirtyAmount)
	  var desiredMonth = date.getMonth() + amount
	  var dateWithDesiredMonth = new Date(0)
	  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
	  dateWithDesiredMonth.setHours(0, 0, 0, 0)
	  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
	  return date
	}
	
	module.exports = addMonths


/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	var addMonths = __webpack_require__(97)
	
	/**
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added
	 * @returns {Date} the new date with the quarters added
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * var result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  var months = amount * 3
	  return addMonths(dirtyDate, months)
	}
	
	module.exports = addQuarters


/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(72)
	
	/**
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added
	 * @returns {Date} the new date with the seconds added
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, amount * 1000)
	}
	
	module.exports = addSeconds


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	var addDays = __webpack_require__(71)
	
	/**
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added
	 * @returns {Date} the new date with the weeks added
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * var result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  var days = amount * 7
	  return addDays(dirtyDate, days)
	}
	
	module.exports = addWeeks


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	var addMonths = __webpack_require__(97)
	
	/**
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added
	 * @returns {Date} the new date with the years added
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMonths(dirtyDate, amount * 12)
	}
	
	module.exports = addYears


/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Range Helpers
	 * @summary Is the given date range overlapping with another date range?
	 *
	 * @description
	 * Is the given date range overlapping with another date range?
	 *
	 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
	 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
	 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
	 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
	 * @returns {Boolean} whether the date ranges are overlapping
	 * @throws {Error} startDate of a date range cannot be after its endDate
	 *
	 * @example
	 * // For overlapping date ranges:
	 * areRangesOverlapping(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping date ranges:
	 * areRangesOverlapping(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
	 * )
	 * //=> false
	 */
	function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
	  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
	  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
	  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
	  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()
	
	  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
	    throw new Error('The start of the range cannot be after the end of the range')
	  }
	
	  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
	}
	
	module.exports = areRangesOverlapping


/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date[]|String[]|Number[]} datesArray - the array to search
	 * @returns {Number} an index of the date closest to the given date
	 * @throws {TypeError} the second argument must be an instance of Array
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * var result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
	  if (!(dirtyDatesArray instanceof Array)) {
	    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
	  }
	
	  var dateToCompare = parse(dirtyDateToCompare)
	  var timeToCompare = dateToCompare.getTime()
	
	  var result
	  var minDistance
	
	  dirtyDatesArray.forEach(function (dirtyDate, index) {
	    var currentDate = parse(dirtyDate)
	    var distance = Math.abs(timeToCompare - currentDate.getTime())
	    if (result === undefined || distance < minDistance) {
	      result = index
	      minDistance = distance
	    }
	  })
	
	  return result
	}
	
	module.exports = closestIndexTo


/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date[]|String[]|Number[]} datesArray - the array to search
	 * @returns {Date} the date from the array closest to the given date
	 * @throws {TypeError} the second argument must be an instance of Array
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo (dirtyDateToCompare, dirtyDatesArray) {
	  if (!(dirtyDatesArray instanceof Array)) {
	    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
	  }
	
	  var dateToCompare = parse(dirtyDateToCompare)
	  var timeToCompare = dateToCompare.getTime()
	
	  var result
	  var minDistance
	
	  dirtyDatesArray.forEach(function (dirtyDate) {
	    var currentDate = parse(dirtyDate)
	    var distance = Math.abs(timeToCompare - currentDate.getTime())
	    if (result === undefined || distance < minDistance) {
	      result = currentDate
	      minDistance = distance
	    }
	  })
	
	  return result
	}
	
	module.exports = closestTo


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * var result = compareAsc(
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * )
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var timeLeft = dateLeft.getTime()
	  var dateRight = parse(dirtyDateRight)
	  var timeRight = dateRight.getTime()
	
	  if (timeLeft < timeRight) {
	    return -1
	  } else if (timeLeft > timeRight) {
	    return 1
	  } else {
	    return 0
	  }
	}
	
	module.exports = compareAsc


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * var result = compareDesc(
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * )
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var timeLeft = dateLeft.getTime()
	  var dateRight = parse(dirtyDateRight)
	  var timeRight = dateRight.getTime()
	
	  if (timeLeft > timeRight) {
	    return -1
	  } else if (timeLeft < timeRight) {
	    return 1
	  } else {
	    return 0
	  }
	}
	
	module.exports = compareDesc


/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	var startOfISOWeek = __webpack_require__(74)
	
	var MILLISECONDS_IN_MINUTE = 60000
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * var result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
	  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
	  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)
	
	  var timestampLeft = startOfISOWeekLeft.getTime() -
	    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	  var timestampRight = startOfISOWeekRight.getTime() -
	    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
	}
	
	module.exports = differenceInCalendarISOWeeks


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(58)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * var result = differenceInCalendarISOYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
	  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
	}
	
	module.exports = differenceInCalendarISOYears


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()
	
	  return yearDiff * 12 + monthDiff
	}
	
	module.exports = differenceInCalendarMonths


/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	var getQuarter = __webpack_require__(251)
	var parse = __webpack_require__(5)
	
	/**
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
	  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)
	
	  return yearDiff * 4 + quarterDiff
	}
	
	module.exports = differenceInCalendarQuarters


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	var startOfWeek = __webpack_require__(158)
	
	var MILLISECONDS_IN_MINUTE = 60000
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   {weekStartsOn: 1}
	 * )
	 * //=> 2
	 */
	function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
	  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)
	
	  var timestampLeft = startOfWeekLeft.getTime() -
	    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	  var timestampRight = startOfWeekRight.getTime() -
	    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
	}
	
	module.exports = differenceInCalendarWeeks


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  return dateLeft.getFullYear() - dateRight.getFullYear()
	}
	
	module.exports = differenceInCalendarYears


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var differenceInCalendarDays = __webpack_require__(152)
	var compareAsc = __webpack_require__(73)
	
	/**
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 */
	function differenceInDays (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
	  dateLeft.setDate(dateLeft.getDate() - sign * difference)
	
	  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastDayNotFull)
	}
	
	module.exports = differenceInDays


/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(98)
	
	var MILLISECONDS_IN_HOUR = 3600000
	
	/**
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of hours
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * var result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInHours


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var differenceInCalendarISOYears = __webpack_require__(241)
	var compareAsc = __webpack_require__(73)
	var subISOYears = __webpack_require__(269)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * var result = differenceInISOYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
	  dateLeft = subISOYears(dateLeft, sign * difference)
	
	  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastISOYearNotFull)
	}
	
	module.exports = differenceInISOYears


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * var result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getTime() - dateRight.getTime()
	}
	
	module.exports = differenceInMilliseconds


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(98)
	
	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the number of minutes between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of minutes
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * var result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 */
	function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInMinutes


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var differenceInCalendarMonths = __webpack_require__(242)
	var compareAsc = __webpack_require__(73)
	
	/**
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 7
	 */
	function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
	  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)
	
	  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastMonthNotFull)
	}
	
	module.exports = differenceInMonths


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	var differenceInMonths = __webpack_require__(153)
	
	/**
	 * @category Quarter Helpers
	 * @summary Get the number of full quarters between the given dates.
	 *
	 * @description
	 * Get the number of full quarters between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full quarters
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInQuarters


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(98)
	
	/**
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of seconds
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * var result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInSeconds


/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	var differenceInDays = __webpack_require__(244)
	
	/**
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full weeks
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 2
	 */
	function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInWeeks


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var differenceInCalendarYears = __webpack_require__(243)
	var compareAsc = __webpack_require__(73)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 1
	 */
	function differenceInYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
	  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)
	
	  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastYearNotFull)
	}
	
	module.exports = differenceInYears


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	var compareDesc = __webpack_require__(151)
	var parse = __webpack_require__(5)
	var differenceInSeconds = __webpack_require__(154)
	var differenceInMonths = __webpack_require__(153)
	var enLocale = __webpack_require__(262)
	
	var MINUTES_IN_DAY = 1440
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520
	var MINUTES_IN_MONTH = 43200
	var MINUTES_IN_TWO_MONTHS = 86400
	
	/**
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date|String|Number} date - the other date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the distance in words
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = distanceInWords(
	 *   new Date(2014, 6, 2),
	 *   new Date(2015, 0, 1)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * var result = distanceInWords(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = distanceInWords(
	 *   new Date(2016, 0, 1),
	 *   new Date(2015, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = distanceInWords(
	 *   new Date(2016, 7, 1),
	 *   new Date(2015, 0, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
	  var options = dirtyOptions || {}
	
	  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)
	
	  var locale = options.locale
	  var localize = enLocale.distanceInWords.localize
	  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
	    localize = locale.distanceInWords.localize
	  }
	
	  var localizeOptions = {
	    addSuffix: Boolean(options.addSuffix),
	    comparison: comparison
	  }
	
	  var dateLeft, dateRight
	  if (comparison > 0) {
	    dateLeft = parse(dirtyDateToCompare)
	    dateRight = parse(dirtyDate)
	  } else {
	    dateLeft = parse(dirtyDate)
	    dateRight = parse(dirtyDateToCompare)
	  }
	
	  var seconds = differenceInSeconds(dateRight, dateLeft)
	  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
	  var minutes = Math.round(seconds / 60) - offset
	  var months
	
	  // 0 up to 2 mins
	  if (minutes < 2) {
	    if (options.includeSeconds) {
	      if (seconds < 5) {
	        return localize('lessThanXSeconds', 5, localizeOptions)
	      } else if (seconds < 10) {
	        return localize('lessThanXSeconds', 10, localizeOptions)
	      } else if (seconds < 20) {
	        return localize('lessThanXSeconds', 20, localizeOptions)
	      } else if (seconds < 40) {
	        return localize('halfAMinute', null, localizeOptions)
	      } else if (seconds < 60) {
	        return localize('lessThanXMinutes', 1, localizeOptions)
	      } else {
	        return localize('xMinutes', 1, localizeOptions)
	      }
	    } else {
	      if (minutes === 0) {
	        return localize('lessThanXMinutes', 1, localizeOptions)
	      } else {
	        return localize('xMinutes', minutes, localizeOptions)
	      }
	    }
	
	  // 2 mins up to 0.75 hrs
	  } else if (minutes < 45) {
	    return localize('xMinutes', minutes, localizeOptions)
	
	  // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return localize('aboutXHours', 1, localizeOptions)
	
	  // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60)
	    return localize('aboutXHours', hours, localizeOptions)
	
	  // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return localize('xDays', 1, localizeOptions)
	
	  // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY)
	    return localize('xDays', days, localizeOptions)
	
	  // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH)
	    return localize('aboutXMonths', months, localizeOptions)
	  }
	
	  months = differenceInMonths(dateRight, dateLeft)
	
	  // 2 months up to 12 months
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
	    return localize('xMonths', nearestMonth, localizeOptions)
	
	  // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12
	    var years = Math.floor(months / 12)
	
	    // N years up to 1 years 3 months
	    if (monthsSinceStartOfYear < 3) {
	      return localize('aboutXYears', years, localizeOptions)
	
	    // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return localize('overXYears', years, localizeOptions)
	
	    // N years 9 months up to N year 12 months
	    } else {
	      return localize('almostXYears', years + 1, localizeOptions)
	    }
	  }
	}
	
	module.exports = distanceInWords


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	var compareDesc = __webpack_require__(151)
	var parse = __webpack_require__(5)
	var differenceInSeconds = __webpack_require__(154)
	var enLocale = __webpack_require__(262)
	
	var MINUTES_IN_DAY = 1440
	var MINUTES_IN_MONTH = 43200
	var MINUTES_IN_YEAR = 525600
	
	/**
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Date|String|Number} date - the other date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the distance in words
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = distanceInWordsStrict(
	 *   new Date(2014, 6, 2),
	 *   new Date(2015, 0, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * var result = distanceInWordsStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = distanceInWordsStrict(
	 *   new Date(2016, 0, 1),
	 *   new Date(2015, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * var result = distanceInWordsStrict(
	 *   new Date(2016, 0, 1),
	 *   new Date(2015, 0, 1),
	 *   {unit: 'm'}
	 * )
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 28 January 2015, in months, rounded up?
	 * var result = distanceInWordsStrict(
	 *   new Date(2015, 0, 28),
	 *   new Date(2015, 0, 1),
	 *   {unit: 'M', partialMethod: 'ceil'}
	 * )
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = distanceInWordsStrict(
	 *   new Date(2016, 7, 1),
	 *   new Date(2015, 0, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
	  var options = dirtyOptions || {}
	
	  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)
	
	  var locale = options.locale
	  var localize = enLocale.distanceInWords.localize
	  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
	    localize = locale.distanceInWords.localize
	  }
	
	  var localizeOptions = {
	    addSuffix: Boolean(options.addSuffix),
	    comparison: comparison
	  }
	
	  var dateLeft, dateRight
	  if (comparison > 0) {
	    dateLeft = parse(dirtyDateToCompare)
	    dateRight = parse(dirtyDate)
	  } else {
	    dateLeft = parse(dirtyDate)
	    dateRight = parse(dirtyDateToCompare)
	  }
	
	  var unit
	  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
	  var seconds = differenceInSeconds(dateRight, dateLeft)
	  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
	  var minutes = mathPartial(seconds / 60) - offset
	  var hours, days, months, years
	
	  if (options.unit) {
	    unit = String(options.unit)
	  } else {
	    if (minutes < 1) {
	      unit = 's'
	    } else if (minutes < 60) {
	      unit = 'm'
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'h'
	    } else if (minutes < MINUTES_IN_MONTH) {
	      unit = 'd'
	    } else if (minutes < MINUTES_IN_YEAR) {
	      unit = 'M'
	    } else {
	      unit = 'Y'
	    }
	  }
	
	  // 0 up to 60 seconds
	  if (unit === 's') {
	    return localize('xSeconds', seconds, localizeOptions)
	
	  // 1 up to 60 mins
	  } else if (unit === 'm') {
	    return localize('xMinutes', minutes, localizeOptions)
	
	  // 1 up to 24 hours
	  } else if (unit === 'h') {
	    hours = mathPartial(minutes / 60)
	    return localize('xHours', hours, localizeOptions)
	
	  // 1 up to 30 days
	  } else if (unit === 'd') {
	    days = mathPartial(minutes / MINUTES_IN_DAY)
	    return localize('xDays', days, localizeOptions)
	
	  // 1 up to 12 months
	  } else if (unit === 'M') {
	    months = mathPartial(minutes / MINUTES_IN_MONTH)
	    return localize('xMonths', months, localizeOptions)
	
	  // 1 year up to max Date
	  } else if (unit === 'Y') {
	    years = mathPartial(minutes / MINUTES_IN_YEAR)
	    return localize('xYears', years, localizeOptions)
	  }
	
	  throw new Error('Unknown unit: ' + unit)
	}
	
	module.exports = distanceInWordsStrict


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	var distanceInWords = __webpack_require__(245)
	
	/**
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * @param {Date|String|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the distance in words
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = distanceInWordsToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = distanceInWordsToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = distanceInWordsToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = distanceInWordsToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function distanceInWordsToNow (dirtyDate, dirtyOptions) {
	  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
	}
	
	module.exports = distanceInWordsToNow


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Day Helpers
	 * @summary Return the array of dates within the specified range.
	 *
	 * @description
	 * Return the array of dates within the specified range.
	 *
	 * @param {Date|String|Number} startDate - the first date
	 * @param {Date|String|Number} endDate - the last date
	 * @param {Number} [step=1] - the step between each day
	 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
	 * @throws {Error} startDate cannot be after endDate
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * var result = eachDay(
	 *   new Date(2014, 9, 6),
	 *   new Date(2014, 9, 10)
	 * )
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
	  var startDate = parse(dirtyStartDate)
	  var endDate = parse(dirtyEndDate)
	  var step = dirtyStep !== undefined ? dirtyStep : 1
	
	  var endTime = endDate.getTime()
	
	  if (startDate.getTime() > endTime) {
	    throw new Error('The first date cannot be after the second date')
	  }
	
	  var dates = []
	
	  var currentDate = startDate
	  currentDate.setHours(0, 0, 0, 0)
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push(parse(currentDate))
	    currentDate.setDate(currentDate.getDate() + step)
	  }
	
	  return dates
	}
	
	module.exports = eachDay


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a day
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfDay


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an hour
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMinutes(59, 59, 999)
	  return date
	}
	
	module.exports = endOfHour


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	var endOfWeek = __webpack_require__(247)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek (dirtyDate) {
	  return endOfWeek(dirtyDate, {weekStartsOn: 1})
	}
	
	module.exports = endOfISOWeek


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(58)
	var startOfISOWeek = __webpack_require__(74)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * var result = endOfISOYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOYear (dirtyDate) {
	  var year = getISOYear(dirtyDate)
	  var fourthOfJanuaryOfNextYear = new Date(0)
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
	  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
	  date.setMilliseconds(date.getMilliseconds() - 1)
	  return date
	}
	
	module.exports = endOfISOYear


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a minute
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setSeconds(59, 999)
	  return date
	}
	
	module.exports = endOfMinute


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a month
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var month = date.getMonth()
	  date.setFullYear(date.getFullYear(), month + 1, 0)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfMonth


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var currentMonth = date.getMonth()
	  var month = currentMonth - currentMonth % 3 + 3
	  date.setMonth(month, 0)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfQuarter


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a second
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMilliseconds(999)
	  return date
	}
	
	module.exports = endOfSecond


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	var endOfDay = __webpack_require__(155)
	
	/**
	 * @category Day Helpers
	 * @summary Return the end of today.
	 *
	 * @description
	 * Return the end of today.
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday () {
	  return endOfDay(new Date())
	}
	
	module.exports = endOfToday


/***/ }),

/***/ 527:
/***/ (function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day + 1)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfTomorrow


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)
	
	  date.setDate(date.getDate() + diff)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfWeek


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of a year
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  date.setFullYear(year + 1, 0, 0)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfYear


/***/ }),

/***/ 529:
/***/ (function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day - 1)
	  date.setHours(23, 59, 59, 999)
	  return date
	}
	
	module.exports = endOfYesterday


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of month
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * var result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate (dirtyDate) {
	  var date = parse(dirtyDate)
	  var dayOfMonth = date.getDate()
	  return dayOfMonth
	}
	
	module.exports = getDate


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of week
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * var result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  return day
	}
	
	module.exports = getDay


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  var monthIndex = date.getMonth()
	  var lastDayOfMonth = new Date(0)
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
	  lastDayOfMonth.setHours(0, 0, 0, 0)
	  return lastDayOfMonth.getDate()
	}
	
	module.exports = getDaysInMonth


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	var isLeapYear = __webpack_require__(252)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 *
	 * @example
	 * // How many days are in 2012?
	 * var result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear (dirtyDate) {
	  return isLeapYear(dirtyDate) ? 366 : 365
	}
	
	module.exports = getDaysInYear


/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the hours
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * var result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours (dirtyDate) {
	  var date = parse(dirtyDate)
	  var hours = date.getHours()
	  return hours
	}
	
	module.exports = getHours


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * var result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay (dirtyDate) {
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	
	  if (day === 0) {
	    day = 7
	  }
	
	  return day
	}
	
	module.exports = getISODay


/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	var startOfISOYear = __webpack_require__(99)
	var addWeeks = __webpack_require__(150)
	
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	function getISOWeeksInYear (dirtyDate) {
	  var thisYear = startOfISOYear(dirtyDate)
	  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
	  var diff = nextYear.valueOf() - thisYear.valueOf()
	  // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK)
	}
	
	module.exports = getISOWeeksInYear


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the milliseconds
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds (dirtyDate) {
	  var date = parse(dirtyDate)
	  var milliseconds = date.getMilliseconds()
	  return milliseconds
	}
	
	module.exports = getMilliseconds


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the minutes
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes (dirtyDate) {
	  var date = parse(dirtyDate)
	  var minutes = date.getMinutes()
	  return minutes
	}
	
	module.exports = getMinutes


/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the month
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * var result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var month = date.getMonth()
	  return month
	}
	
	module.exports = getMonth


/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000
	
	/**
	 * @category Range Helpers
	 * @summary Get the number of days that overlap in two date ranges
	 *
	 * @description
	 * Get the number of days that overlap in two date ranges
	 *
	 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
	 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
	 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
	 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
	 * @returns {Number} the number of days that overlap in two date ranges
	 * @throws {Error} startDate of a date range cannot be after its endDate
	 *
	 * @example
	 * // For overlapping date ranges adds 1 for each started overlapping day:
	 * getOverlappingDaysInRanges(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping date ranges returns 0:
	 * getOverlappingDaysInRanges(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
	 * )
	 * //=> 0
	 */
	function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
	  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
	  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
	  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
	  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()
	
	  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
	    throw new Error('The start of the range cannot be after the end of the range')
	  }
	
	  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
	
	  if (!isOverlapping) {
	    return 0
	  }
	
	  var overlapStartDate = comparedStartTime < initialStartTime
	    ? initialStartTime
	    : comparedStartTime
	
	  var overlapEndDate = comparedEndTime > initialEndTime
	    ? initialEndTime
	    : comparedEndTime
	
	  var differenceInMs = overlapEndDate - overlapStartDate
	
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
	}
	
	module.exports = getOverlappingDaysInRanges


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the quarter
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * var result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var quarter = Math.floor(date.getMonth() / 3) + 1
	  return quarter
	}
	
	module.exports = getQuarter


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the seconds
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds (dirtyDate) {
	  var date = parse(dirtyDate)
	  var seconds = date.getSeconds()
	  return seconds
	}
	
	module.exports = getSeconds


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the timestamp
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime (dirtyDate) {
	  var date = parse(dirtyDate)
	  var timestamp = date.getTime()
	  return timestamp
	}
	
	module.exports = getTime


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the year
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * var result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  return year
	}
	
	module.exports = getYear


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  addDays: __webpack_require__(71),
	  addHours: __webpack_require__(235),
	  addISOYears: __webpack_require__(236),
	  addMilliseconds: __webpack_require__(72),
	  addMinutes: __webpack_require__(237),
	  addMonths: __webpack_require__(97),
	  addQuarters: __webpack_require__(238),
	  addSeconds: __webpack_require__(239),
	  addWeeks: __webpack_require__(150),
	  addYears: __webpack_require__(240),
	  areRangesOverlapping: __webpack_require__(505),
	  closestIndexTo: __webpack_require__(506),
	  closestTo: __webpack_require__(507),
	  compareAsc: __webpack_require__(73),
	  compareDesc: __webpack_require__(151),
	  differenceInCalendarDays: __webpack_require__(152),
	  differenceInCalendarISOWeeks: __webpack_require__(508),
	  differenceInCalendarISOYears: __webpack_require__(241),
	  differenceInCalendarMonths: __webpack_require__(242),
	  differenceInCalendarQuarters: __webpack_require__(509),
	  differenceInCalendarWeeks: __webpack_require__(510),
	  differenceInCalendarYears: __webpack_require__(243),
	  differenceInDays: __webpack_require__(244),
	  differenceInHours: __webpack_require__(511),
	  differenceInISOYears: __webpack_require__(512),
	  differenceInMilliseconds: __webpack_require__(98),
	  differenceInMinutes: __webpack_require__(513),
	  differenceInMonths: __webpack_require__(153),
	  differenceInQuarters: __webpack_require__(514),
	  differenceInSeconds: __webpack_require__(154),
	  differenceInWeeks: __webpack_require__(515),
	  differenceInYears: __webpack_require__(516),
	  distanceInWords: __webpack_require__(245),
	  distanceInWordsStrict: __webpack_require__(517),
	  distanceInWordsToNow: __webpack_require__(518),
	  eachDay: __webpack_require__(519),
	  endOfDay: __webpack_require__(155),
	  endOfHour: __webpack_require__(520),
	  endOfISOWeek: __webpack_require__(521),
	  endOfISOYear: __webpack_require__(522),
	  endOfMinute: __webpack_require__(523),
	  endOfMonth: __webpack_require__(246),
	  endOfQuarter: __webpack_require__(524),
	  endOfSecond: __webpack_require__(525),
	  endOfToday: __webpack_require__(526),
	  endOfTomorrow: __webpack_require__(527),
	  endOfWeek: __webpack_require__(247),
	  endOfYear: __webpack_require__(528),
	  endOfYesterday: __webpack_require__(529),
	  format: __webpack_require__(248),
	  getDate: __webpack_require__(530),
	  getDay: __webpack_require__(531),
	  getDayOfYear: __webpack_require__(532),
	  getDaysInMonth: __webpack_require__(156),
	  getDaysInYear: __webpack_require__(533),
	  getHours: __webpack_require__(534),
	  getISODay: __webpack_require__(249),
	  getISOWeek: __webpack_require__(250),
	  getISOWeeksInYear: __webpack_require__(535),
	  getISOYear: __webpack_require__(58),
	  getMilliseconds: __webpack_require__(536),
	  getMinutes: __webpack_require__(537),
	  getMonth: __webpack_require__(538),
	  getOverlappingDaysInRanges: __webpack_require__(539),
	  getQuarter: __webpack_require__(251),
	  getSeconds: __webpack_require__(540),
	  getTime: __webpack_require__(541),
	  getYear: __webpack_require__(542),
	  isAfter: __webpack_require__(543),
	  isBefore: __webpack_require__(544),
	  isDate: __webpack_require__(325),
	  isEqual: __webpack_require__(545),
	  isFirstDayOfMonth: __webpack_require__(546),
	  isFriday: __webpack_require__(547),
	  isFuture: __webpack_require__(548),
	  isLastDayOfMonth: __webpack_require__(549),
	  isLeapYear: __webpack_require__(252),
	  isMonday: __webpack_require__(550),
	  isPast: __webpack_require__(551),
	  isSameDay: __webpack_require__(552),
	  isSameHour: __webpack_require__(253),
	  isSameISOWeek: __webpack_require__(254),
	  isSameISOYear: __webpack_require__(255),
	  isSameMinute: __webpack_require__(256),
	  isSameMonth: __webpack_require__(257),
	  isSameQuarter: __webpack_require__(258),
	  isSameSecond: __webpack_require__(259),
	  isSameWeek: __webpack_require__(157),
	  isSameYear: __webpack_require__(260),
	  isSaturday: __webpack_require__(553),
	  isSunday: __webpack_require__(554),
	  isThisHour: __webpack_require__(555),
	  isThisISOWeek: __webpack_require__(556),
	  isThisISOYear: __webpack_require__(557),
	  isThisMinute: __webpack_require__(558),
	  isThisMonth: __webpack_require__(559),
	  isThisQuarter: __webpack_require__(560),
	  isThisSecond: __webpack_require__(561),
	  isThisWeek: __webpack_require__(562),
	  isThisYear: __webpack_require__(563),
	  isThursday: __webpack_require__(564),
	  isToday: __webpack_require__(565),
	  isTomorrow: __webpack_require__(566),
	  isTuesday: __webpack_require__(567),
	  isValid: __webpack_require__(568),
	  isWednesday: __webpack_require__(569),
	  isWeekend: __webpack_require__(570),
	  isWithinRange: __webpack_require__(571),
	  isYesterday: __webpack_require__(572),
	  lastDayOfISOWeek: __webpack_require__(573),
	  lastDayOfISOYear: __webpack_require__(574),
	  lastDayOfMonth: __webpack_require__(575),
	  lastDayOfQuarter: __webpack_require__(576),
	  lastDayOfWeek: __webpack_require__(261),
	  lastDayOfYear: __webpack_require__(577),
	  max: __webpack_require__(578),
	  min: __webpack_require__(579),
	  parse: __webpack_require__(5),
	  setDate: __webpack_require__(580),
	  setDay: __webpack_require__(581),
	  setDayOfYear: __webpack_require__(582),
	  setHours: __webpack_require__(583),
	  setISODay: __webpack_require__(584),
	  setISOWeek: __webpack_require__(585),
	  setISOYear: __webpack_require__(263),
	  setMilliseconds: __webpack_require__(586),
	  setMinutes: __webpack_require__(587),
	  setMonth: __webpack_require__(264),
	  setQuarter: __webpack_require__(588),
	  setSeconds: __webpack_require__(589),
	  setYear: __webpack_require__(590),
	  startOfDay: __webpack_require__(48),
	  startOfHour: __webpack_require__(265),
	  startOfISOWeek: __webpack_require__(74),
	  startOfISOYear: __webpack_require__(99),
	  startOfMinute: __webpack_require__(266),
	  startOfMonth: __webpack_require__(591),
	  startOfQuarter: __webpack_require__(267),
	  startOfSecond: __webpack_require__(268),
	  startOfToday: __webpack_require__(592),
	  startOfTomorrow: __webpack_require__(593),
	  startOfWeek: __webpack_require__(158),
	  startOfYear: __webpack_require__(594),
	  startOfYesterday: __webpack_require__(595),
	  subDays: __webpack_require__(596),
	  subHours: __webpack_require__(597),
	  subISOYears: __webpack_require__(269),
	  subMilliseconds: __webpack_require__(598),
	  subMinutes: __webpack_require__(599),
	  subMonths: __webpack_require__(600),
	  subQuarters: __webpack_require__(601),
	  subSeconds: __webpack_require__(602),
	  subWeeks: __webpack_require__(603),
	  subYears: __webpack_require__(604)
	}


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be after the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter (dirtyDate, dirtyDateToCompare) {
	  var date = parse(dirtyDate)
	  var dateToCompare = parse(dirtyDateToCompare)
	  return date.getTime() > dateToCompare.getTime()
	}
	
	module.exports = isAfter


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be before the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore (dirtyDate, dirtyDateToCompare) {
	  var date = parse(dirtyDate)
	  var dateToCompare = parse(dirtyDateToCompare)
	  return date.getTime() < dateToCompare.getTime()
	}
	
	module.exports = isBefore


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0)
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual (dirtyLeftDate, dirtyRightDate) {
	  var dateLeft = parse(dirtyLeftDate)
	  var dateRight = parse(dirtyRightDate)
	  return dateLeft.getTime() === dateRight.getTime()
	}
	
	module.exports = isEqual


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth (dirtyDate) {
	  return parse(dirtyDate).getDate() === 1
	}
	
	module.exports = isFirstDayOfMonth


/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * var result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 5
	}
	
	module.exports = isFriday


/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture (dirtyDate) {
	  return parse(dirtyDate).getTime() > new Date().getTime()
	}
	
	module.exports = isFuture


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var endOfDay = __webpack_require__(155)
	var endOfMonth = __webpack_require__(246)
	
	/**
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  return endOfDay(date).getTime() === endOfMonth(date).getTime()
	}
	
	module.exports = isLastDayOfMonth


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * var result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
	}
	
	module.exports = isLeapYear


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * var result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 1
	}
	
	module.exports = isMonday


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * var result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast (dirtyDate) {
	  return parse(dirtyDate).getTime() < new Date().getTime()
	}
	
	module.exports = isPast


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(48)
	
	/**
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(
	 *   new Date(2014, 8, 4, 6, 0),
	 *   new Date(2014, 8, 4, 18, 0)
	 * )
	 * //=> true
	 */
	function isSameDay (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
	  var dateRightStartOfDay = startOfDay(dirtyDateRight)
	
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
	}
	
	module.exports = isSameDay


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	var startOfHour = __webpack_require__(265)
	
	/**
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour?
	 *
	 * @description
	 * Are the given dates in the same hour?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * var result = isSameHour(
	 *   new Date(2014, 8, 4, 6, 0),
	 *   new Date(2014, 8, 4, 6, 30)
	 * )
	 * //=> true
	 */
	function isSameHour (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
	  var dateRightStartOfHour = startOfHour(dirtyDateRight)
	
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
	}
	
	module.exports = isSameHour


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	var isSameWeek = __webpack_require__(157)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week?
	 *
	 * @description
	 * Are the given dates in the same ISO week?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * var result = isSameISOWeek(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 8, 7)
	 * )
	 * //=> true
	 */
	function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
	  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
	}
	
	module.exports = isSameISOWeek


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	var startOfISOYear = __webpack_require__(99)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * var result = isSameISOYear(
	 *   new Date(2003, 11, 29),
	 *   new Date(2005, 0, 2)
	 * )
	 * //=> true
	 */
	function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
	  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)
	
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
	}
	
	module.exports = isSameISOYear


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	var startOfMinute = __webpack_require__(266)
	
	/**
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute?
	 *
	 * @description
	 * Are the given dates in the same minute?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
	 * // in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 */
	function isSameMinute (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
	  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)
	
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
	}
	
	module.exports = isSameMinute


/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(
	 *   new Date(2014, 8, 2),
	 *   new Date(2014, 8, 25)
	 * )
	 * //=> true
	 */
	function isSameMonth (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getFullYear() === dateRight.getFullYear() &&
	    dateLeft.getMonth() === dateRight.getMonth()
	}
	
	module.exports = isSameMonth


/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	var startOfQuarter = __webpack_require__(267)
	
	/**
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same year quarter?
	 *
	 * @description
	 * Are the given dates in the same year quarter?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(
	 *   new Date(2014, 0, 1),
	 *   new Date(2014, 2, 8)
	 * )
	 * //=> true
	 */
	function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
	  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)
	
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
	}
	
	module.exports = isSameQuarter


/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	var startOfSecond = __webpack_require__(268)
	
	/**
	 * @category Second Helpers
	 * @summary Are the given dates in the same second?
	 *
	 * @description
	 * Are the given dates in the same second?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
	 * // in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 */
	function isSameSecond (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
	  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)
	
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
	}
	
	module.exports = isSameSecond


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	var startOfWeek = __webpack_require__(158)
	
	/**
	 * @category Week Helpers
	 * @summary Are the given dates in the same week?
	 *
	 * @description
	 * Are the given dates in the same week?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(
	 *   new Date(2014, 7, 31),
	 *   new Date(2014, 8, 4)
	 * )
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(
	 *   new Date(2014, 7, 31),
	 *   new Date(2014, 8, 4),
	 *   {weekStartsOn: 1}
	 * )
	 * //=> false
	 */
	function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
	  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)
	
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
	}
	
	module.exports = isSameWeek


/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(
	 *   new Date(2014, 8, 2),
	 *   new Date(2014, 8, 25)
	 * )
	 * //=> true
	 */
	function isSameYear (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getFullYear() === dateRight.getFullYear()
	}
	
	module.exports = isSameYear


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * var result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 6
	}
	
	module.exports = isSaturday


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * var result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 0
	}
	
	module.exports = isSunday


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	var isSameHour = __webpack_require__(253)
	
	/**
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * var result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour (dirtyDate) {
	  return isSameHour(new Date(), dirtyDate)
	}
	
	module.exports = isThisHour


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	var isSameISOWeek = __webpack_require__(254)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * var result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isThisISOWeek (dirtyDate) {
	  return isSameISOWeek(new Date(), dirtyDate)
	}
	
	module.exports = isThisISOWeek


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	var isSameISOYear = __webpack_require__(255)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Is the given date in the same ISO week-numbering year as the current date?
	 *
	 * @description
	 * Is the given date in the same ISO week-numbering year as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week-numbering year
	 *
	 * @example
	 * // If today is 25 September 2014,
	 * // is 30 December 2013 in this ISO week-numbering year?
	 * var result = isThisISOYear(new Date(2013, 11, 30))
	 * //=> true
	 */
	function isThisISOYear (dirtyDate) {
	  return isSameISOYear(new Date(), dirtyDate)
	}
	
	module.exports = isThisISOYear


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	var isSameMinute = __webpack_require__(256)
	
	/**
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	function isThisMinute (dirtyDate) {
	  return isSameMinute(new Date(), dirtyDate)
	}
	
	module.exports = isThisMinute


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	var isSameMonth = __webpack_require__(257)
	
	/**
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * var result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	function isThisMonth (dirtyDate) {
	  return isSameMonth(new Date(), dirtyDate)
	}
	
	module.exports = isThisMonth


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	var isSameQuarter = __webpack_require__(258)
	
	/**
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * var result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter (dirtyDate) {
	  return isSameQuarter(new Date(), dirtyDate)
	}
	
	module.exports = isThisQuarter


/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	var isSameSecond = __webpack_require__(259)
	
	/**
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond (dirtyDate) {
	  return isSameSecond(new Date(), dirtyDate)
	}
	
	module.exports = isThisSecond


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	var isSameWeek = __webpack_require__(157)
	
	/**
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
	 * //=> false
	 */
	function isThisWeek (dirtyDate, dirtyOptions) {
	  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
	}
	
	module.exports = isThisWeek


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	var isSameYear = __webpack_require__(260)
	
	/**
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * var result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear (dirtyDate) {
	  return isSameYear(new Date(), dirtyDate)
	}
	
	module.exports = isThisYear


/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * var result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 4
	}
	
	module.exports = isThursday


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(48)
	
	/**
	 * @category Day Helpers
	 * @summary Is the given date today?
	 *
	 * @description
	 * Is the given date today?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday (dirtyDate) {
	  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
	}
	
	module.exports = isToday


/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(48)
	
	/**
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow (dirtyDate) {
	  var tomorrow = new Date()
	  tomorrow.setDate(tomorrow.getDate() + 1)
	  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
	}
	
	module.exports = isTomorrow


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * var result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 2
	}
	
	module.exports = isTuesday


/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * var result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday (dirtyDate) {
	  return parse(dirtyDate).getDay() === 3
	}
	
	module.exports = isWednesday


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * var result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend (dirtyDate) {
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  return day === 0 || day === 6
	}
	
	module.exports = isWeekend


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Range Helpers
	 * @summary Is the given date within the range?
	 *
	 * @description
	 * Is the given date within the range?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @param {Date|String|Number} startDate - the start of range
	 * @param {Date|String|Number} endDate - the end of range
	 * @returns {Boolean} the date is within the range
	 * @throws {Error} startDate cannot be after endDate
	 *
	 * @example
	 * // For the date within the range:
	 * isWithinRange(
	 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
	 * )
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the range:
	 * isWithinRange(
	 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
	 * )
	 * //=> false
	 */
	function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
	  var time = parse(dirtyDate).getTime()
	  var startTime = parse(dirtyStartDate).getTime()
	  var endTime = parse(dirtyEndDate).getTime()
	
	  if (startTime > endTime) {
	    throw new Error('The start of the range cannot be after the end of the range')
	  }
	
	  return time >= startTime && time <= endTime
	}
	
	module.exports = isWithinRange


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(48)
	
	/**
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday (dirtyDate) {
	  var yesterday = new Date()
	  yesterday.setDate(yesterday.getDate() - 1)
	  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
	}
	
	module.exports = isYesterday


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	var lastDayOfWeek = __webpack_require__(261)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek (dirtyDate) {
	  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
	}
	
	module.exports = lastDayOfISOWeek


/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(58)
	var startOfISOWeek = __webpack_require__(74)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOYear (dirtyDate) {
	  var year = getISOYear(dirtyDate)
	  var fourthOfJanuary = new Date(0)
	  fourthOfJanuary.setFullYear(year + 1, 0, 4)
	  fourthOfJanuary.setHours(0, 0, 0, 0)
	  var date = startOfISOWeek(fourthOfJanuary)
	  date.setDate(date.getDate() - 1)
	  return date
	}
	
	module.exports = lastDayOfISOYear


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of a month
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var month = date.getMonth()
	  date.setFullYear(date.getFullYear(), month + 1, 0)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = lastDayOfMonth


/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of a quarter
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var currentMonth = date.getMonth()
	  var month = currentMonth - currentMonth % 3 + 3
	  date.setMonth(month, 0)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = lastDayOfQuarter


/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)
	
	  date.setHours(0, 0, 0, 0)
	  date.setDate(date.getDate() + diff)
	  return date
	}
	
	module.exports = lastDayOfWeek


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the last day of a year
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  date.setFullYear(year + 1, 0, 0)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = lastDayOfYear


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {...(Date|String|Number)} dates - the dates to compare
	 * @returns {Date} the latest of the dates
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max(
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * )
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max () {
	  var dirtyDates = Array.prototype.slice.call(arguments)
	  var dates = dirtyDates.map(function (dirtyDate) {
	    return parse(dirtyDate)
	  })
	  var latestTimestamp = Math.max.apply(null, dates)
	  return new Date(latestTimestamp)
	}
	
	module.exports = max


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Common Helpers
	 * @summary Return the earliest of the given dates.
	 *
	 * @description
	 * Return the earliest of the given dates.
	 *
	 * @param {...(Date|String|Number)} dates - the dates to compare
	 * @returns {Date} the earliest of the dates
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * var result = min(
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * )
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min () {
	  var dirtyDates = Array.prototype.slice.call(arguments)
	  var dates = dirtyDates.map(function (dirtyDate) {
	    return parse(dirtyDate)
	  })
	  var earliestTimestamp = Math.min.apply(null, dates)
	  return new Date(earliestTimestamp)
	}
	
	module.exports = min


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month setted
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * var result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate (dirtyDate, dirtyDayOfMonth) {
	  var date = parse(dirtyDate)
	  var dayOfMonth = Number(dirtyDayOfMonth)
	  date.setDate(dayOfMonth)
	  return date
	}
	
	module.exports = setDate


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var addDays = __webpack_require__(71)
	
	/**
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week setted
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * var result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If week starts with Monday, set Sunday to 1 September 2014:
	 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay (dirtyDate, dirtyDay, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	  var date = parse(dirtyDate)
	  var day = Number(dirtyDay)
	  var currentDay = date.getDay()
	
	  var remainder = day % 7
	  var dayIndex = (remainder + 7) % 7
	
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
	  return addDays(date, diff)
	}
	
	module.exports = setDay


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year setted
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear (dirtyDate, dirtyDayOfYear) {
	  var date = parse(dirtyDate)
	  var dayOfYear = Number(dirtyDayOfYear)
	  date.setMonth(0)
	  date.setDate(dayOfYear)
	  return date
	}
	
	module.exports = setDayOfYear


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours setted
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours (dirtyDate, dirtyHours) {
	  var date = parse(dirtyDate)
	  var hours = Number(dirtyHours)
	  date.setHours(hours)
	  return date
	}
	
	module.exports = setHours


/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var addDays = __webpack_require__(71)
	var getISODay = __webpack_require__(249)
	
	/**
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week setted
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * var result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay (dirtyDate, dirtyDay) {
	  var date = parse(dirtyDate)
	  var day = Number(dirtyDay)
	  var currentDay = getISODay(date)
	  var diff = day - currentDay
	  return addDays(date, diff)
	}
	
	module.exports = setISODay


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var getISOWeek = __webpack_require__(250)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week setted
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * var result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek (dirtyDate, dirtyISOWeek) {
	  var date = parse(dirtyDate)
	  var isoWeek = Number(dirtyISOWeek)
	  var diff = getISOWeek(date) - isoWeek
	  date.setDate(date.getDate() - diff * 7)
	  return date
	}
	
	module.exports = setISOWeek


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var startOfISOYear = __webpack_require__(99)
	var differenceInCalendarDays = __webpack_require__(152)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} isoYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year setted
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * var result = setISOYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOYear (dirtyDate, dirtyISOYear) {
	  var date = parse(dirtyDate)
	  var isoYear = Number(dirtyISOYear)
	  var diff = differenceInCalendarDays(date, startOfISOYear(date))
	  var fourthOfJanuary = new Date(0)
	  fourthOfJanuary.setFullYear(isoYear, 0, 4)
	  fourthOfJanuary.setHours(0, 0, 0, 0)
	  date = startOfISOYear(fourthOfJanuary)
	  date.setDate(date.getDate() + diff)
	  return date
	}
	
	module.exports = setISOYear


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds setted
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds (dirtyDate, dirtyMilliseconds) {
	  var date = parse(dirtyDate)
	  var milliseconds = Number(dirtyMilliseconds)
	  date.setMilliseconds(milliseconds)
	  return date
	}
	
	module.exports = setMilliseconds


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes setted
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes (dirtyDate, dirtyMinutes) {
	  var date = parse(dirtyDate)
	  var minutes = Number(dirtyMinutes)
	  date.setMinutes(minutes)
	  return date
	}
	
	module.exports = setMinutes


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var getDaysInMonth = __webpack_require__(156)
	
	/**
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month setted
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * var result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth (dirtyDate, dirtyMonth) {
	  var date = parse(dirtyDate)
	  var month = Number(dirtyMonth)
	  var year = date.getFullYear()
	  var day = date.getDate()
	
	  var dateWithDesiredMonth = new Date(0)
	  dateWithDesiredMonth.setFullYear(year, month, 15)
	  dateWithDesiredMonth.setHours(0, 0, 0, 0)
	  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth))
	  return date
	}
	
	module.exports = setMonth


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	var setMonth = __webpack_require__(264)
	
	/**
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter setted
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * var result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter (dirtyDate, dirtyQuarter) {
	  var date = parse(dirtyDate)
	  var quarter = Number(dirtyQuarter)
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
	  var diff = quarter - oldQuarter
	  return setMonth(date, date.getMonth() + diff * 3)
	}
	
	module.exports = setQuarter


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds setted
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds (dirtyDate, dirtySeconds) {
	  var date = parse(dirtyDate)
	  var seconds = Number(dirtySeconds)
	  date.setSeconds(seconds)
	  return date
	}
	
	module.exports = setSeconds


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year setted
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * var result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear (dirtyDate, dirtyYear) {
	  var date = parse(dirtyDate)
	  var year = Number(dirtyYear)
	  date.setFullYear(year)
	  return date
	}
	
	module.exports = setYear


/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an hour
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMinutes(0, 0, 0)
	  return date
	}
	
	module.exports = startOfHour


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a minute
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setSeconds(0, 0)
	  return date
	}
	
	module.exports = startOfMinute


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a month
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setDate(1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfMonth


/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter (dirtyDate) {
	  var date = parse(dirtyDate)
	  var currentMonth = date.getMonth()
	  var month = currentMonth - currentMonth % 3
	  date.setMonth(month, 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfQuarter


/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(5)
	
	/**
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a second
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setMilliseconds(0)
	  return date
	}
	
	module.exports = startOfSecond


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(48)
	
	/**
	 * @category Day Helpers
	 * @summary Return the start of today.
	 *
	 * @description
	 * Return the start of today.
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday () {
	  return startOfDay(new Date())
	}
	
	module.exports = startOfToday


/***/ }),

/***/ 593:
/***/ (function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day + 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfTomorrow


/***/ }),

/***/ 595:
/***/ (function(module, exports) {

	/**
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday () {
	  var now = new Date()
	  var year = now.getFullYear()
	  var month = now.getMonth()
	  var day = now.getDate()
	
	  var date = new Date(0)
	  date.setFullYear(year, month, day - 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfYesterday


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	var addDays = __webpack_require__(71)
	
	/**
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted
	 * @returns {Date} the new date with the days subtracted
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * var result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addDays(dirtyDate, -amount)
	}
	
	module.exports = subDays


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	var addHours = __webpack_require__(235)
	
	/**
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted
	 * @returns {Date} the new date with the hours subtracted
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addHours(dirtyDate, -amount)
	}
	
	module.exports = subHours


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	var addISOYears = __webpack_require__(236)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * var result = subISOYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addISOYears(dirtyDate, -amount)
	}
	
	module.exports = subISOYears


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(72)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted
	 * @returns {Date} the new date with the milliseconds subtracted
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, -amount)
	}
	
	module.exports = subMilliseconds


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	var addMinutes = __webpack_require__(237)
	
	/**
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted
	 * @returns {Date} the new date with the mintues subtracted
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMinutes(dirtyDate, -amount)
	}
	
	module.exports = subMinutes


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	var addMonths = __webpack_require__(97)
	
	/**
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted
	 * @returns {Date} the new date with the months subtracted
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * var result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMonths(dirtyDate, -amount)
	}
	
	module.exports = subMonths


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

	var addQuarters = __webpack_require__(238)
	
	/**
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted
	 * @returns {Date} the new date with the quarters subtracted
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * var result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addQuarters(dirtyDate, -amount)
	}
	
	module.exports = subQuarters


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	var addSeconds = __webpack_require__(239)
	
	/**
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted
	 * @returns {Date} the new date with the seconds subtracted
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addSeconds(dirtyDate, -amount)
	}
	
	module.exports = subSeconds


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	var addWeeks = __webpack_require__(150)
	
	/**
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted
	 * @returns {Date} the new date with the weeks subtracted
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * var result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addWeeks(dirtyDate, -amount)
	}
	
	module.exports = subWeeks


/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	var addYears = __webpack_require__(240)
	
	/**
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted
	 * @returns {Date} the new date with the years subtracted
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * var result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addYears(dirtyDate, -amount)
	}
	
	module.exports = subYears


/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

	var prefix = __webpack_require__(2280)
	var toCamelCase = __webpack_require__(2480)
	var cache = { 'float': 'cssFloat' }
	var addPxToStyle = __webpack_require__(882)
	
	function style (element, property, value) {
	  var camel = cache[property]
	  if (typeof camel === 'undefined') {
	    camel = detect(property)
	  }
	
	  // may be false if CSS prop is unsupported
	  if (camel) {
	    if (value === undefined) {
	      return element.style[camel]
	    }
	
	    element.style[camel] = addPxToStyle(camel, value)
	  }
	}
	
	function each (element, properties) {
	  for (var k in properties) {
	    if (properties.hasOwnProperty(k)) {
	      style(element, k, properties[k])
	    }
	  }
	}
	
	function detect (cssProp) {
	  var camel = toCamelCase(cssProp)
	  var result = prefix(camel)
	  cache[camel] = cache[cssProp] = cache[result] = result
	  return result
	}
	
	function set () {
	  if (arguments.length === 2) {
	    if (typeof arguments[1] === 'string') {
	      arguments[0].style.cssText = arguments[1]
	    } else {
	      each(arguments[0], arguments[1])
	    }
	  } else {
	    style(arguments[0], arguments[1], arguments[2])
	  }
	}
	
	module.exports = set
	module.exports.set = set
	
	module.exports.get = function (element, properties) {
	  if (Array.isArray(properties)) {
	    return properties.reduce(function (obj, prop) {
	      obj[prop] = style(element, prop || '')
	      return obj
	    }, {})
	  } else {
	    return style(element, properties || '')
	  }
	}


/***/ }),

/***/ 610:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(typeof navigator !== "undefined") && (function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return factory(root);
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory(root);
	    } else {
	        root.lottie = factory(root);
	        root.bodymovin = root.lottie;
	    }
	}((window || {}), function(window) {
	    "use strict";
	    var svgNS = "http://www.w3.org/2000/svg";
	
	var locationHref = '';
	
	var initialDefaultFrame = -999999;
	
	var subframeEnabled = true;
	var expressionsPlugin;
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var cachedColors = {};
	var bm_rounder = Math.round;
	var bm_rnd;
	var bm_pow = Math.pow;
	var bm_sqrt = Math.sqrt;
	var bm_abs = Math.abs;
	var bm_floor = Math.floor;
	var bm_max = Math.max;
	var bm_min = Math.min;
	var blitter = 10;
	
	var BMMath = {};
	(function(){
	    var propertyNames = Object.getOwnPropertyNames(Math);
	    var i, len = propertyNames.length;
	    for(i=0;i<len;i+=1){
	        BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	}());
	
	function ProjectInterface(){return {};}
	
	BMMath.random = Math.random;
	BMMath.abs = function(val){
	    var tOfVal = typeof val;
	    if(tOfVal === 'object' && val.length){
	        var absArr = createSizedArray(val.length);
	        var i, len = val.length;
	        for(i=0;i<len;i+=1){
	            absArr[i] = Math.abs(val[i]);
	        }
	        return absArr;
	    }
	    return Math.abs(val);
	
	};
	var defaultCurveSegments = 150;
	var degToRads = Math.PI/180;
	var roundCorner = 0.5519;
	
	function roundValues(flag){
	    if(flag){
	        bm_rnd = Math.round;
	    }else{
	        bm_rnd = function(val){
	            return val;
	        };
	    }
	}
	roundValues(false);
	
	function styleDiv(element){
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
	}
	
	function BMEnterFrameEvent(n,c,t,d){
	    this.type = n;
	    this.currentTime = c;
	    this.totalTime = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteEvent(n,d){
	    this.type = n;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteLoopEvent(n,c,t,d){
	    this.type = n;
	    this.currentLoop = t;
	    this.totalLoops = c;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMSegmentStartEvent(n,f,t){
	    this.type = n;
	    this.firstFrame = f;
	    this.totalFrames = t;
	}
	
	function BMDestroyEvent(n,t){
	    this.type = n;
	    this.target = t;
	}
	
	function randomString(length, chars){
	    if(chars === undefined){
	        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
	    }
	    var i;
	    var result = '';
	    for (i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
	    return result;
	}
	
	function HSVtoRGB(h, s, v) {
	    var r, g, b, i, f, p, q, t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	    switch (i % 6) {
	        case 0: r = v; g = t; b = p; break;
	        case 1: r = q; g = v; b = p; break;
	        case 2: r = p; g = v; b = t; break;
	        case 3: r = p; g = q; b = v; break;
	        case 4: r = t; g = p; b = v; break;
	        case 5: r = v; g = p; b = q; break;
	    }
	    return [ r,
	        g,
	         b ];
	}
	
	function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b), min = Math.min(r, g, b),
	        d = max - min,
	        h,
	        s = (max === 0 ? 0 : d / max),
	        v = max / 255;
	
	    switch (max) {
	        case min: h = 0; break;
	        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
	        case g: h = (b - r) + d * 2; h /= 6 * d; break;
	        case b: h = (r - g) + d * 4; h /= 6 * d; break;
	    }
	
	    return [
	         h,
	         s,
	         v
	    ];
	}
	
	function addSaturationToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[1] += offset;
	    if (hsv[1] > 1) {
	        hsv[1] = 1;
	    }
	    else if (hsv[1] <= 0) {
	        hsv[1] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addBrightnessToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[2] += offset;
	    if (hsv[2] > 1) {
	        hsv[2] = 1;
	    }
	    else if (hsv[2] < 0) {
	        hsv[2] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addHueToRGB(color,offset) {
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[0] += offset/360;
	    if (hsv[0] > 1) {
	        hsv[0] -= 1;
	    }
	    else if (hsv[0] < 0) {
	        hsv[0] += 1;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	var rgbToHex = (function(){
	    var colorMap = [];
	    var i;
	    var hex;
	    for(i=0;i<256;i+=1){
	        hex = i.toString(16);
	        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
	    }
	
	    return function(r, g, b) {
	        if(r<0){
	            r = 0;
	        }
	        if(g<0){
	            g = 0;
	        }
	        if(b<0){
	            b = 0;
	        }
	        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	}());
	function BaseEvent(){}
	BaseEvent.prototype = {
		triggerEvent: function (eventName, args) {
		    if (this._cbs[eventName]) {
		        var len = this._cbs[eventName].length;
		        for (var i = 0; i < len; i++){
		            this._cbs[eventName][i](args);
		        }
		    }
		},
		addEventListener: function (eventName, callback) {
		    if (!this._cbs[eventName]){
		        this._cbs[eventName] = [];
		    }
		    this._cbs[eventName].push(callback);
	
			return function() {
				this.removeEventListener(eventName, callback);
			}.bind(this);
		},
		removeEventListener: function (eventName,callback){
		    if (!callback){
		        this._cbs[eventName] = null;
		    }else if(this._cbs[eventName]){
		        var i = 0, len = this._cbs[eventName].length;
		        while(i<len){
		            if(this._cbs[eventName][i] === callback){
		                this._cbs[eventName].splice(i,1);
		                i -=1;
		                len -= 1;
		            }
		            i += 1;
		        }
		        if(!this._cbs[eventName].length){
		            this._cbs[eventName] = null;
		        }
		    }
		}
	};
	var createTypedArray = (function(){
		function createRegularArray(type, len){
			var i = 0, arr = [], value;
			switch(type) {
				case 'int16':
				case 'uint8c':
					value = 1;
					break;
				default:
					value = 1.1;
					break;
			}
			for(i = 0; i < len; i += 1) {
				arr.push(value);
			}
			return arr;
		}
		function createTypedArray(type, len){
			if(type === 'float32') {
				return new Float32Array(len);
			} else if(type === 'int16') {
				return new Int16Array(len);
			} else if(type === 'uint8c') {
				return new Uint8ClampedArray(len);
			}
		}
		if(typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
			return createTypedArray;
		} else {
			return createRegularArray;
		}
	}());
	
	function createSizedArray(len) {
		return Array.apply(null,{length:len});
	}
	function createNS(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElementNS(svgNS, type);
	}
	function createTag(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElement(type);
	}
	function DynamicPropertyContainer(){};
	DynamicPropertyContainer.prototype = {
		addDynamicProperty: function(prop) {
			if(this.dynamicProperties.indexOf(prop) === -1) {
		        this.dynamicProperties.push(prop);
		        this.container.addDynamicProperty(this);
		    	this._isAnimated = true;
		    }
		},
		iterateDynamicProperties: function(){
		    this._mdf = false;
		    var i, len = this.dynamicProperties.length;
		    for(i=0;i<len;i+=1){
		        this.dynamicProperties[i].getValue();
		        if(this.dynamicProperties[i]._mdf) {
		            this._mdf = true;
		        }
		    }
		},
		initDynamicPropertyContainer: function(container){
		    this.container = container;
		    this.dynamicProperties = [];
		    this._mdf = false;
		    this._isAnimated = false;
		}
	}
	/*!
	 Transformation Matrix v2.0
	 (c) Epistemex 2014-2015
	 www.epistemex.com
	 By Ken Fyrstenberg
	 Contributions by leeoniya.
	 License: MIT, header required.
	 */
	
	/**
	 * 2D transformation matrix object initialized with identity matrix.
	 *
	 * The matrix can synchronize a canvas context by supplying the context
	 * as an argument, or later apply current absolute transform to an
	 * existing context.
	 *
	 * All values are handled as floating point values.
	 *
	 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	 * @prop {number} a - scale x
	 * @prop {number} b - shear y
	 * @prop {number} c - shear x
	 * @prop {number} d - scale y
	 * @prop {number} e - translate x
	 * @prop {number} f - translate y
	 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	 * @constructor
	 */
	
	var Matrix = (function(){
	
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;
	
	    function reset(){
	        this.props[0] = 1;
	        this.props[1] = 0;
	        this.props[2] = 0;
	        this.props[3] = 0;
	        this.props[4] = 0;
	        this.props[5] = 1;
	        this.props[6] = 0;
	        this.props[7] = 0;
	        this.props[8] = 0;
	        this.props[9] = 0;
	        this.props[10] = 1;
	        this.props[11] = 0;
	        this.props[12] = 0;
	        this.props[13] = 0;
	        this.props[14] = 0;
	        this.props[15] = 1;
	        return this;
	    }
	
	    function rotate(angle) {
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }
	
	    function rotateX(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin,  mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateY(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos,  0,  mSin, 0, 0, 1, 0, 0, -mSin,  0,  mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }
	
	    function shear(sx,sy){
	        return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay){
	        return this.shear(_tan(ax), _tan(ay));
	    }
	
	    function skewFromAxis(ax, angle){
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, mSin,  0, 0, -mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(1, 0,  0, 0, _tan(ax),  1, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	        sz = isNaN(sz) ? 1 : sz;
	        if(sx == 1 && sy == 1 && sz == 1){
	            return this;
	        }
	        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	        this.props[0] = a;
	        this.props[1] = b;
	        this.props[2] = c;
	        this.props[3] = d;
	        this.props[4] = e;
	        this.props[5] = f;
	        this.props[6] = g;
	        this.props[7] = h;
	        this.props[8] = i;
	        this.props[9] = j;
	        this.props[10] = k;
	        this.props[11] = l;
	        this.props[12] = m;
	        this.props[13] = n;
	        this.props[14] = o;
	        this.props[15] = p;
	        return this;
	    }
	
	    function translate(tx, ty, tz) {
	        tz = tz || 0;
	        if(tx !== 0 || ty !== 0 || tz !== 0){
	            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
	        }
	        return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	
	        var _p = this.props;
	
	        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
	            //NOTE: commenting this condition because TurboFan deoptimizes code when present
	            //if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	                _p[12] = _p[12] * a2 + _p[15] * m2;
	                _p[13] = _p[13] * f2 + _p[15] * n2;
	                _p[14] = _p[14] * k2 + _p[15] * o2;
	                _p[15] = _p[15] * p2;
	            //}
	            this._identityCalculated = false;
	            return this;
	        }
	
	        var a1 = _p[0];
	        var b1 = _p[1];
	        var c1 = _p[2];
	        var d1 = _p[3];
	        var e1 = _p[4];
	        var f1 = _p[5];
	        var g1 = _p[6];
	        var h1 = _p[7];
	        var i1 = _p[8];
	        var j1 = _p[9];
	        var k1 = _p[10];
	        var l1 = _p[11];
	        var m1 = _p[12];
	        var n1 = _p[13];
	        var o1 = _p[14];
	        var p1 = _p[15];
	
	        /* matrix order (canvas compatible):
	         * ace
	         * bdf
	         * 001
	         */
	        _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	        _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
	        _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
	        _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;
	
	        _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
	        _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
	        _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
	        _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;
	
	        _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
	        _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
	        _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
	        _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;
	
	        _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
	        _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
	        _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
	        _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;
	
	        this._identityCalculated = false;
	        return this;
	    }
	
	    function isIdentity() {
	        if(!this._identityCalculated){
	            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	            this._identityCalculated = true;
	        }
	        return this._identity;
	    }
	
	    function equals(matr){
	        var i = 0;
	        while (i < 16) {
	            if(matr.props[i] !== this.props[i]) {
	                return false;
	            }
	            i+=1;
	        }
	        return true;
	    }
	
	    function clone(matr){
	        var i;
	        for(i=0;i<16;i+=1){
	            matr.props[i] = this.props[i];
	        }
	    }
	
	    function cloneFromProps(props){
	        var i;
	        for(i=0;i<16;i+=1){
	            this.props[i] = props[i];
	        }
	    }
	
	    function applyToPoint(x, y, z) {
	
	        return {
	            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	        };
	        /*return {
	         x: x * me.a + y * me.c + me.e,
	         y: x * me.b + y * me.d + me.f
	         };*/
	    }
	    function applyToX(x, y, z) {
	        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	    function applyToY(x, y, z) {
	        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	    function applyToZ(x, y, z) {
	        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function inversePoint(pt) {
	        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	        var a = this.props[5]/determinant;
	        var b = - this.props[1]/determinant;
	        var c = - this.props[4]/determinant;
	        var d = this.props[0]/determinant;
	        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
	        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
	        return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
	    }
	
	    function inversePoints(pts){
	        var i, len = pts.length, retPts = [];
	        for(i=0;i<len;i+=1){
	            retPts[i] = inversePoint(pts[i]);
	        }
	        return retPts;
	    }
	
	    function applyToTriplePoints(pt1, pt2, pt3) {
	        var arr = createTypedArray('float32', 6);
	        if(this.isIdentity()) {
	            arr[0] = pt1[0];
	            arr[1] = pt1[1];
	            arr[2] = pt2[0];
	            arr[3] = pt2[1];
	            arr[4] = pt3[0];
	            arr[5] = pt3[1];
	        } else {
	            var p0 = this.props[0], p1 = this.props[1], p4 = this.props[4], p5 = this.props[5], p12 = this.props[12], p13 = this.props[13];
	            arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	            arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	            arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	            arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	            arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	            arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	        }
	        return arr;
	    }
	
	    function applyToPointArray(x,y,z){
	        var arr;
	        if(this.isIdentity()) {
	            arr = [x,y,z];
	        } else {
	            arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	        }
	        return arr;
	    }
	
	    function applyToPointStringified(x, y) {
	        if(this.isIdentity()) {
	            return x + ',' + y;
	        }
	        var _p = this.props;
	        return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100+','+ Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }
	
	    function toCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var i = 0;
	        var props = this.props;
	        var cssValue = 'matrix3d(';
	        var v = 10000;
	        while(i<16){
	            cssValue += _rnd(props[i]*v)/v;
	            cssValue += i === 15 ? ')':',';
	            i += 1;
	        }
	        return cssValue;
	    }
	
	    function roundMatrixProperty(val) {
	        var v = 10000;
	        if((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
	            return _rnd(val * v) / v;
	        }
	        return val;
	    }
	
	    function to2dCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var props = this.props;
	        var _a = roundMatrixProperty(props[0]);
	        var _b = roundMatrixProperty(props[1]);
	        var _c = roundMatrixProperty(props[4]);
	        var _d = roundMatrixProperty(props[5]);
	        var _e = roundMatrixProperty(props[12]);
	        var _f = roundMatrixProperty(props[13]);
	        return "matrix(" + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ")";
	    }
	
	    return function(){
	        this.reset = reset;
	        this.rotate = rotate;
	        this.rotateX = rotateX;
	        this.rotateY = rotateY;
	        this.rotateZ = rotateZ;
	        this.skew = skew;
	        this.skewFromAxis = skewFromAxis;
	        this.shear = shear;
	        this.scale = scale;
	        this.setTransform = setTransform;
	        this.translate = translate;
	        this.transform = transform;
	        this.applyToPoint = applyToPoint;
	        this.applyToX = applyToX;
	        this.applyToY = applyToY;
	        this.applyToZ = applyToZ;
	        this.applyToPointArray = applyToPointArray;
	        this.applyToTriplePoints = applyToTriplePoints;
	        this.applyToPointStringified = applyToPointStringified;
	        this.toCSS = toCSS;
	        this.to2dCSS = to2dCSS;
	        this.clone = clone;
	        this.cloneFromProps = cloneFromProps;
	        this.equals = equals;
	        this.inversePoints = inversePoints;
	        this.inversePoint = inversePoint;
	        this._t = this.transform;
	        this.isIdentity = isIdentity;
	        this._identity = true;
	        this._identityCalculated = false;
	
	        this.props = createTypedArray('float32', 16);
	        this.reset();
	    };
	}());
	
	/*
	 Copyright 2014 David Bau.
	
	 Permission is hereby granted, free of charge, to any person obtaining
	 a copy of this software and associated documentation files (the
	 "Software"), to deal in the Software without restriction, including
	 without limitation the rights to use, copy, modify, merge, publish,
	 distribute, sublicense, and/or sell copies of the Software, and to
	 permit persons to whom the Software is furnished to do so, subject to
	 the following conditions:
	
	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	 */
	
	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	    var global = this,
	        width = 256,        // each RC4 output is 0 <= x < 256
	        chunks = 6,         // at least six RC4 outputs for each double
	        digits = 52,        // there are 52 significant digits in a double
	        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	        startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto;         // node.js crypto module, initialized at the bottom.
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	    function seedrandom(seed, options, callback) {
	        var key = [];
	        options = (options === true) ? { entropy: true } : (options || {});
	
	        // Flatten the seed string or build one from local entropy if needed.
	        var shortseed = mixkey(flatten(
	            options.entropy ? [seed, tostring(pool)] :
	                (seed === null) ? autoseed() : seed, 3), key);
	
	        // Use the seed to initialize an ARC4 generator.
	        var arc4 = new ARC4(key);
	
	        // This function returns a random double in [0, 1) that contains
	        // randomness in every bit of the mantissa of the IEEE 754 value.
	        var prng = function() {
	            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	                d = startdenom,                 //   and denominator d = 2 ^ 48.
	                x = 0;                          //   and no 'extra last byte'.
	            while (n < significance) {          // Fill up all significant digits by
	                n = (n + x) * width;              //   shifting numerator and
	                d *= width;                       //   denominator and generating a
	                x = arc4.g(1);                    //   new least-significant-byte.
	            }
	            while (n >= overflow) {             // To avoid rounding up, before adding
	                n /= 2;                           //   last byte, shift everything
	                d /= 2;                           //   right using integer math until
	                x >>>= 1;                         //   we have exactly the desired bits.
	            }
	            return (n + x) / d;                 // Form the number within [0, 1).
	        };
	
	        prng.int32 = function() { return arc4.g(4) | 0; };
	        prng.quick = function() { return arc4.g(4) / 0x100000000; };
	        prng.double = prng;
	
	        // Mix the randomness into accumulated entropy.
	        mixkey(tostring(arc4.S), pool);
	
	        // Calling convention: what to return as a function of prng, seed, is_math.
	        return (options.pass || callback ||
	        function(prng, seed, is_math_call, state) {
	            if (state) {
	                // Load the arc4 state from the given state if it has an S array.
	                if (state.S) { copy(state, arc4); }
	                // Only provide the .state method if requested via options.state.
	                prng.state = function() { return copy(arc4, {}); };
	            }
	
	            // If called as a method of Math (Math.seedrandom()), mutate
	            // Math.random because that is how seedrandom.js has worked since v1.0.
	            if (is_math_call) { math[rngname] = prng; return seed; }
	
	            // Otherwise, it is a newer calling convention, so return the
	            // prng directly.
	            else return prng;
	        })(
	            prng,
	            shortseed,
	            'global' in options ? options.global : (this == math),
	            options.state);
	    }
	    math['seed' + rngname] = seedrandom;
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	    function ARC4(key) {
	        var t, keylen = key.length,
	            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	        // The empty key [] is treated as [0].
	        if (!keylen) { key = [keylen++]; }
	
	        // Set up S using the standard key scheduling algorithm.
	        while (i < width) {
	            s[i] = i++;
	        }
	        for (i = 0; i < width; i++) {
	            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	            s[j] = t;
	        }
	
	        // The "g" method returns the next (count) outputs as one number.
	        me.g = function(count) {
	            // Using instance members instead of closure state nearly doubles speed.
	            var t, r = 0,
	                i = me.i, j = me.j, s = me.S;
	            while (count--) {
	                t = s[i = mask & (i + 1)];
	                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	            }
	            me.i = i; me.j = j;
	            return r;
	            // For robust unpredictability, the function call below automatically
	            // discards an initial batch of values.  This is called RC4-drop[256].
	            // See http://google.com/search?q=rsa+fluhrer+response&btnI
	        };
	    }
	
	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	    function copy(f, t) {
	        t.i = f.i;
	        t.j = f.j;
	        t.S = f.S.slice();
	        return t;
	    }
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	    function flatten(obj, depth) {
	        var result = [], typ = (typeof obj), prop;
	        if (depth && typ == 'object') {
	            for (prop in obj) {
	                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	            }
	        }
	        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	    }
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	    function mixkey(seed, key) {
	        var stringseed = seed + '', smear, j = 0;
	        while (j < stringseed.length) {
	            key[mask & j] =
	                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	        }
	        return tostring(key);
	    }
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	    function autoseed() {
	        try {
	            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
	            var out = new Uint8Array(width);
	            (global.crypto || global.msCrypto).getRandomValues(out);
	            return tostring(out);
	        } catch (e) {
	            var browser = global.navigator,
	                plugins = browser && browser.plugins;
	            return [+new Date(), global, plugins, global.screen, tostring(pool)];
	        }
	    }
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	    function tostring(a) {
	        return String.fromCharCode.apply(0, a);
	    }
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	    mixkey(math.random(), pool);
	
	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	
	// End anonymous scope, and pass initial values.
	})(
	    [],     // pool: entropy pool starts empty
	    BMMath    // math: package containing random, pow, and seedrandom
	);
	var BezierFactory = (function(){
	    /**
	     * BezierEasing - use bezier curve for transition easing function
	     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	     *
	     * Credits: is based on Firefox's nsSMILKeySpline.cpp
	     * Usage:
	     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	     * spline.get(x) => returns the easing value | x must be in [0, 1] range
	     *
	     */
	
	        var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a,b,c,d,nm){
	        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
	        if(beziers[str]){
	            return beziers[str];
	        }
	        var bezEasing = new BezierEasing([a,b,c,d]);
	        beziers[str] = bezEasing;
	        return bezEasing;
	    }
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	    var float32ArraySupported = typeof Float32Array === "function";
	
	    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	    function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	    function calcBezier (aT, aA1, aA2) {
	        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	    }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	    function getSlope (aT, aA1, aA2) {
	        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide (aX, aA, aB, mX1, mX2) {
	        var currentX, currentT, i = 0;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            } else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    }
	
	    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	            var currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) return aGuessT;
	            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    }
	
	    /**
	     * points is an array of [ mX1, mY1, mX2, mY2 ]
	     */
	    function BezierEasing (points) {
	        this._p = points;
	        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	        this._precomputed = false;
	
	        this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	
	        get: function (x) {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            if (!this._precomputed) this._precompute();
	            if (mX1 === mY1 && mX2 === mY2) return x; // linear
	            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	            if (x === 0) return 0;
	            if (x === 1) return 1;
	            return calcBezier(this._getTForX(x), mY1, mY2);
	        },
	
	        // Private part
	
	        _precompute: function () {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            this._precomputed = true;
	            if (mX1 !== mY1 || mX2 !== mY2)
	                this._calcSampleValues();
	        },
	
	        _calcSampleValues: function () {
	            var mX1 = this._p[0],
	                mX2 = this._p[2];
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        },
	
	        /**
	         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	         */
	        _getTForX: function (aX) {
	            var mX1 = this._p[0],
	                mX2 = this._p[2],
	                mSampleValues = this._mSampleValues;
	
	            var intervalStart = 0.0;
	            var currentSample = 1;
	            var lastSample = kSplineTableSize - 1;
	
	            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	            --currentSample;
	
	            // Interpolate to provide an initial guess for t
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
	            var guessForT = intervalStart + dist * kSampleStepSize;
	
	            var initialSlope = getSlope(guessForT, mX1, mX2);
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	            } else if (initialSlope === 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	            }
	        }
	    };
	
	    return ob;
	
	}());
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	    if(!window.requestAnimationFrame)
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = setTimeout(function () {
	                    callback(currTime + timeToCall);
	                },
	                timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    if(!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	}());
	
	function extendPrototype(sources,destination){
	    var i, len = sources.length, sourcePrototype;
	    for (i = 0;i < len;i += 1) {
	        sourcePrototype = sources[i].prototype;
	        for (var attr in sourcePrototype) {
	            if (sourcePrototype.hasOwnProperty(attr)) destination.prototype[attr] = sourcePrototype[attr];
	        }
	    }
	}
	
	function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	}
	
	function createProxyFunction(prototype) {
		function ProxyFunction(){}
		ProxyFunction.prototype = prototype;
		return ProxyFunction;
	}
	function bezFunction(){
	
	    var easingFunctions = [];
	    var math = Math;
	
	    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
	        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
	        return det1 > -0.001 && det1 < 0.001;
	    }
	
	    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
	        if(z1 === 0 && z2 === 0 && z3 === 0) {
	            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
	        }
	        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
	        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
	        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
	        var diffDist;
	        if(dist1 > dist2){
	            if(dist1 > dist3){
	                diffDist = dist1 - dist2 - dist3;
	            } else {
	                diffDist = dist3 - dist2 - dist1;
	            }
	        } else if(dist3 > dist2){
	            diffDist = dist3 - dist2 - dist1;
	        } else {
	            diffDist = dist2 - dist1 - dist3;
	        }
	        return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    var getBezierLength = (function(){
	
	        return function(pt1,pt2,pt3,pt4){
	            var curveSegments = defaultCurveSegments;
	            var k;
	            var i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point = [],lastPoint = [];
	            var lengthData = bezier_length_pool.newElement();
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint[i] !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                    lastPoint[i] = point[i];
	                }
	                if(ptDistance){
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                }
	                lengthData.percents[k] = perc;
	                lengthData.lengths[k] = addedLength;
	            }
	            lengthData.addedLength = addedLength;
	            return lengthData;
	        };
	    }());
	
	    function getSegmentsLength(shapeData) {
	        var segmentsLength = segments_length_pool.newElement();
	        var closed = shapeData.c;
	        var pathV = shapeData.v;
	        var pathO = shapeData.o;
	        var pathI = shapeData.i;
	        var i, len = shapeData._length;
	        var lengths = segmentsLength.lengths;
	        var totalLength = 0;
	        for(i=0;i<len-1;i+=1){
	            lengths[i] = getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
	            totalLength += lengths[i].addedLength;
	        }
	        if(closed){
	            lengths[i] = getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
	            totalLength += lengths[i].addedLength;
	        }
	        segmentsLength.totalLength = totalLength;
	        return segmentsLength;
	    }
	
	    function BezierData(length){
	        this.segmentLength = 0;
	        this.points = new Array(length);
	    }
	
	    function PointData(partial,point){
	        this.partialLength = partial;
	        this.point = point;
	    }
	
	    var buildBezierData = (function(){
	
	        var storedData = {};
	
	        return function (keyData){
	            var pt1 = keyData.s;
	            var pt2 = keyData.e;
	            var pt3 = keyData.to;
	            var pt4 = keyData.ti;
	            var bezierName = (pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g, 'p');
	            if(storedData[bezierName]){
	                keyData.bezierData = storedData[bezierName];
	                return;
	            }
	            var curveSegments = defaultCurveSegments;
	            var k, i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point,lastPoint = null;
	            if (pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
	                curveSegments = 2;
	            }
	            var bezierData = new BezierData(curveSegments);
	            len = pt3.length;
	            for (k = 0; k < curveSegments; k += 1) {
	                point = createSizedArray(len);
	                perc = k / (curveSegments - 1);
	                ptDistance = 0;
	                for (i = 0; i < len; i += 1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                }
	                ptDistance = bm_sqrt(ptDistance);
	                addedLength += ptDistance;
	                bezierData.points[k] = new PointData(ptDistance, point);
	                lastPoint = point;
	            }
	            bezierData.segmentLength = addedLength;
	            keyData.bezierData = bezierData;
	            storedData[bezierName] = bezierData;
	        };
	    }());
	
	    function getDistancePerc(perc,bezierData){
	        var percents = bezierData.percents;
	        var lengths = bezierData.lengths;
	        var len = percents.length;
	        var initPos = bm_floor((len-1)*perc);
	        var lengthPos = perc*bezierData.addedLength;
	        var lPerc = 0;
	        if(initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]){
	            return percents[initPos];
	        }else{
	            var dir = lengths[initPos] > lengthPos ? -1 : 1;
	            var flag = true;
	            while(flag){
	                if(lengths[initPos] <= lengthPos && lengths[initPos+1] > lengthPos){
	                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos+1] - lengths[initPos]);
	                    flag = false;
	                }else{
	                    initPos += dir;
	                }
	                if(initPos < 0 || initPos >= len - 1){
	                    //FIX for TypedArrays that don't store floating point values with enough accuracy
	                    if(initPos === len - 1) {
	                        return percents[initPos];
	                    }
	                    flag = false;
	                }
	            }
	            return percents[initPos] + (percents[initPos+1] - percents[initPos])*lPerc;
	        }
	    }
	
	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	        var t1 = getDistancePerc(percent,bezierData);
	        var u0 = 1;
	        var u1 = 1 - t1;
	        var ptX = Math.round((u1*u1*u1* pt1[0] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[0] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[0] + t1*t1*t1* pt2[0])* 1000) / 1000;
	        var ptY = Math.round((u1*u1*u1* pt1[1] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[1] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[1] + t1*t1*t1* pt2[1])* 1000) / 1000;
	        return [ptX, ptY];
	    }
	
	    function getSegmentArray() {
	
	    }
	
	    var bezier_segment_points = createTypedArray('float32', 8);
	
	    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){
	
	        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
	        var t0 = getDistancePerc(startPerc,bezierData);
	        endPerc = endPerc > 1 ? 1 : endPerc;
	        var t1 = getDistancePerc(endPerc,bezierData);
	        var i, len = pt1.length;
	        var u0 = 1 - t0;
	        var u1 = 1 - t1;
	        var u0u0u0 = u0*u0*u0;
	        var t0u0u0_3 = t0*u0*u0*3;
	        var t0t0u0_3 = t0*t0*u0*3;
	        var t0t0t0 = t0*t0*t0;
	        //
	        var u0u0u1 = u0*u0*u1;
	        var t0u0u1_3 = t0*u0*u1 + u0*t0*u1 + u0*u0*t1;
	        var t0t0u1_3 = t0*t0*u1 + u0*t0*t1 + t0*u0*t1;
	        var t0t0t1 = t0*t0*t1;
	        //
	        var u0u1u1 = u0*u1*u1;
	        var t0u1u1_3 = t0*u1*u1 + u0*t1*u1 + u0*u1*t1;
	        var t0t1u1_3 = t0*t1*u1 + u0*t1*t1 + t0*u1*t1;
	        var t0t1t1 = t0*t1*t1;
	        //
	        var u1u1u1 = u1*u1*u1;
	        var t1u1u1_3 = t1*u1*u1 + u1*t1*u1 + u1*u1*t1;
	        var t1t1u1_3 = t1*t1*u1 + u1*t1*t1 + t1*u1*t1;
	        var t1t1t1 = t1*t1*t1;
	        for(i=0;i<len;i+=1){
	            bezier_segment_points[i * 4] = Math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 1] = Math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 2] = Math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 3] = Math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000;
	        }
	
	        return bezier_segment_points;
	    }
	
	    return {
	        getSegmentsLength : getSegmentsLength,
	        getNewSegment : getNewSegment,
	        getPointInSegment : getPointInSegment,
	        buildBezierData : buildBezierData,
	        pointOnLine2D : pointOnLine2D,
	        pointOnLine3D : pointOnLine3D
	    };
	}
	
	var bez = bezFunction();
	function dataFunctionManager(){
	
	    //var tCanvasHelper = createTag('canvas').getContext('2d');
	
	    function completeLayers(layers, comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData) || layerData.completed){
	                continue;
	            }
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.layers = findCompLayers(layerData.refId, comps);
	                completeLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                completeShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                completeText(layerData, fontManager);
	            }
	        }
	    }
	
	    function findCompLayers(id,comps){
	        var i = 0, len = comps.length;
	        while(i<len){
	            if(comps[i].id === id){
	                if(!comps[i].layers.__used) {
	                    comps[i].layers.__used = true;
	                    return comps[i].layers;
	                }
	                return JSON.parse(JSON.stringify(comps[i].layers));
	            }
	            i += 1;
	        }
	    }
	
	    function completeShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                completeShapes(arr[i].it);
	            }
	        }
	        /*if(hasPaths){
	            //mx: distance
	            //ss: sensitivity
	            //dc: decay
	            arr.splice(arr.length-1,0,{
	                "ty": "ms",
	                "mx":20,
	                "ss":10,
	                 "dc":0.001,
	                "maxDist":200
	            });
	        }*/
	    }
	
	    function convertPathsToAbsoluteValues(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] += path.v[i][0];
	            path.i[i][1] += path.v[i][1];
	            path.o[i][0] += path.v[i][0];
	            path.o[i][1] += path.v[i][1];
	        }
	    }
	
	    function checkVersion(minimum,animVersionString){
	        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
	        if(minimum[0]>animVersion[0]){
	            return true;
	        } else if(animVersion[0] > minimum[0]){
	            return false;
	        }
	        if(minimum[1]>animVersion[1]){
	            return true;
	        } else if(animVersion[1] > minimum[1]){
	            return false;
	        }
	        if(minimum[2]>animVersion[2]){
	            return true;
	        } else if(animVersion[2] > minimum[2]){
	            return false;
	        }
	    }
	
	    var checkText = (function(){
	        var minimumVersion = [4,4,14];
	
	        function updateTextLayer(textLayer){
	            var documentData = textLayer.t.d;
	            textLayer.t.d = {
	                k: [
	                    {
	                        s:documentData,
	                        t:0
	                    }
	                ]
	            };
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 5){
	                    updateTextLayer(layers[i]);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkChars = (function() {
	        var minimumVersion = [4,7,99];
	        return function (animationData){
	            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
	                var i, len = animationData.chars.length, j, jLen, k, kLen;
	                var pathData, paths;
	                for(i = 0; i < len; i += 1) {
	                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
	                        paths = animationData.chars[i].data.shapes[0].it;
	                        jLen = paths.length;
	
	                        for(j = 0; j < jLen; j += 1) {
	                            pathData = paths[j].ks.k;
	                            if(!pathData.__converted) {
	                                convertPathsToAbsoluteValues(paths[j].ks.k);
	                                pathData.__converted = true;
	                            }
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkColors = (function(){
	        var minimumVersion = [4,1,9];
	
	        function iterateShapes(shapes){
	            var i, len = shapes.length;
	            var j, jLen;
	            for(i=0;i<len;i+=1){
	                if(shapes[i].ty === 'gr'){
	                    iterateShapes(shapes[i].it);
	                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
	                    if(shapes[i].c.k && shapes[i].c.k[0].i){
	                        jLen = shapes[i].c.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(shapes[i].c.k[j].s){
	                                shapes[i].c.k[j].s[0] /= 255;
	                                shapes[i].c.k[j].s[1] /= 255;
	                                shapes[i].c.k[j].s[2] /= 255;
	                                shapes[i].c.k[j].s[3] /= 255;
	                            }
	                            if(shapes[i].c.k[j].e){
	                                shapes[i].c.k[j].e[0] /= 255;
	                                shapes[i].c.k[j].e[1] /= 255;
	                                shapes[i].c.k[j].e[2] /= 255;
	                                shapes[i].c.k[j].e[3] /= 255;
	                            }
	                        }
	                    } else {
	                        shapes[i].c.k[0] /= 255;
	                        shapes[i].c.k[1] /= 255;
	                        shapes[i].c.k[2] /= 255;
	                        shapes[i].c.k[3] /= 255;
	                    }
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 4){
	                    iterateShapes(layers[i].shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkShapes = (function(){
	        var minimumVersion = [4,4,18];
	
	
	
	        function completeShapes(arr){
	            var i, len = arr.length;
	            var j, jLen;
	            var hasPaths = false;
	            for(i=len-1;i>=0;i-=1){
	                if(arr[i].ty == 'sh'){
	                    if(arr[i].ks.k.i){
	                        arr[i].ks.k.c = arr[i].closed;
	                    }else{
	                        jLen = arr[i].ks.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(arr[i].ks.k[j].s){
	                                arr[i].ks.k[j].s[0].c = arr[i].closed;
	                            }
	                            if(arr[i].ks.k[j].e){
	                                arr[i].ks.k[j].e[0].c = arr[i].closed;
	                            }
	                        }
	                    }
	                    hasPaths = true;
	                }else if(arr[i].ty == 'gr'){
	                    completeShapes(arr[i].it);
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var layerData;
	            var i, len = layers.length;
	            var j, jLen, k, kLen;
	            for(i=0;i<len;i+=1){
	                layerData = layers[i];
	                if(layerData.hasMask){
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(maskProps[j].pt.k.i){
	                            maskProps[j].pt.k.c = maskProps[j].cl;
	                        }else{
	                            kLen = maskProps[j].pt.k.length;
	                            for(k=0;k<kLen;k+=1){
	                                if(maskProps[j].pt.k[k].s){
	                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                                }
	                                if(maskProps[j].pt.k[k].e){
	                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                                }
	                            }
	                        }
	                    }
	                }
	                if(layerData.ty === 4){
	                    completeShapes(layerData.shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    function completeData(animationData, fontManager){
	        if(animationData.__complete){
	            return;
	        }
	        checkColors(animationData);
	        checkText(animationData);
	        checkChars(animationData);
	        checkShapes(animationData);
	        completeLayers(animationData.layers, animationData.assets, fontManager);
	        animationData.__complete = true;
	        //blitAnimation(animationData, animationData.assets, fontManager);
	    }
	
	    function completeText(data, fontManager){
	        if(data.t.a.length === 0 && !('m' in data.t.p)){
	            data.singleShape = true;
	        }
	    }
	
	    var moduleOb = {};
	    moduleOb.completeData = completeData;
	
	    return moduleOb;
	}
	
	var dataManager = dataFunctionManager();
	var FontManager = (function(){
	
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	        w: 0,
	        size:0,
	        shapes:[]
	    };
	    var combinedCharacters = [];
	    //Hindi characters
	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366
	    , 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379
	    , 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
	
	    function setUpNode(font, family){
	        var parentNode = createTag('span');
	        parentNode.style.fontFamily    = family;
	        var node = createTag('span');
	        // Characters that vary significantly among different fonts
	        node.innerHTML = 'giItT1WQy@!-/#';
	        // Visible - so we can measure it - but not on the screen
	        parentNode.style.position      = 'absolute';
	        parentNode.style.left          = '-10000px';
	        parentNode.style.top           = '-10000px';
	        // Large font size makes even subtle changes obvious
	        parentNode.style.fontSize      = '300px';
	        // Reset any font properties
	        parentNode.style.fontVariant   = 'normal';
	        parentNode.style.fontStyle     = 'normal';
	        parentNode.style.fontWeight    = 'normal';
	        parentNode.style.letterSpacing = '0';
	        parentNode.appendChild(node);
	        document.body.appendChild(parentNode);
	
	        // Remember width with no applied web font
	        var width = node.offsetWidth;
	        node.style.fontFamily = font + ', '+family;
	        return {node:node, w:width, parent:parentNode};
	    }
	
	    function checkLoadedFonts() {
	        var i, len = this.fonts.length;
	        var node, w;
	        var loadedCount = len;
	        for(i=0;i<len; i+= 1){
	            if(this.fonts[i].loaded){
	                loadedCount -= 1;
	                continue;
	            }
	            if(this.fonts[i].fOrigin === 't' || this.fonts[i].origin === 2){
	                if(window.Typekit && window.Typekit.load && this.typekitLoaded === 0){
	                    this.typekitLoaded = 1;
	                    try{window.Typekit.load({
	                        async: true,
	                        active: function() {
	                            this.typekitLoaded = 2;
	                        }.bind(this)
	                    });}catch(e){}
	                }
	                if(this.typekitLoaded === 2) {
	                    this.fonts[i].loaded = true;
	                }
	            } else if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
	                this.fonts[i].loaded = true;
	            } else{
	                node = this.fonts[i].monoCase.node;
	                w = this.fonts[i].monoCase.w;
	                if(node.offsetWidth !== w){
	                    loadedCount -= 1;
	                    this.fonts[i].loaded = true;
	                }else{
	                    node = this.fonts[i].sansCase.node;
	                    w = this.fonts[i].sansCase.w;
	                    if(node.offsetWidth !== w){
	                        loadedCount -= 1;
	                        this.fonts[i].loaded = true;
	                    }
	                }
	                if(this.fonts[i].loaded){
	                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	                }
	            }
	        }
	
	        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
	            setTimeout(checkLoadedFonts.bind(this),20);
	        }else{
	            setTimeout(function(){this.loaded = true;}.bind(this),0);
	
	        }
	    }
	
	    function createHelper(def, fontData){
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px';
	        //tHelper.style.fontFamily = fontData.fFamily;
	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontData.fStyle);
	        tHelper.setAttribute('font-weight', fontData.fWeight);
	        tHelper.textContent = '1';
	        if(fontData.fClass){
	            tHelper.style.fontFamily = 'inherit';
	            tHelper.className = fontData.fClass;
	        } else {
	            tHelper.style.fontFamily = fontData.fFamily;
	        }
	        def.appendChild(tHelper);
	        var tCanvasHelper = createTag('canvas').getContext('2d');
	        tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px '+ fontData.fFamily;
	        //tCanvasHelper.font = ' 100px '+ fontData.fFamily;
	        return tHelper;
	    }
	
	    function addFonts(fontData, defs){
	        if(!fontData){
	            this.loaded = true;
	            return;
	        }
	        if(this.chars){
	            this.loaded = true;
	            this.fonts = fontData.list;
	            return;
	        }
	
	
	        var fontArr = fontData.list;
	        var i, len = fontArr.length;
	        for(i=0; i<len; i+= 1){
	            fontArr[i].loaded = false;
	            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
	            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
	            if(!fontArr[i].fPath) {
	                fontArr[i].loaded = true;
	            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
	                var s = createTag('style');
	                s.type = "text/css";
	                s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
	                defs.appendChild(s);
	            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
	                var l = createTag('link');
	                l.type = "text/css";
	                l.rel = "stylesheet";
	                l.href = fontArr[i].fPath;
	                document.body.appendChild(l);
	            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
	                var sc = createTag('script');
	                sc.setAttribute('src',fontArr[i].fPath);
	                defs.appendChild(sc);
	            }
	            fontArr[i].helper = createHelper(defs,fontArr[i]);
	            fontArr[i].cache = {};
	            this.fonts.push(fontArr[i]);
	        }
	        //On some cases the font even if it is loaded, it won't load correctly when measuring text on canvas.
	        //Adding this timeout seems to fix it
	       setTimeout(function() {
	            checkLoadedFonts.bind(this)();
	        }.bind(this), 100);
	    }
	
	    function addChars(chars){
	        if(!chars){
	            return;
	        }
	        if(!this.chars){
	            this.chars = [];
	        }
	        var i, len = chars.length;
	        var j, jLen = this.chars.length, found;
	        for(i=0;i<len;i+=1){
	            j = 0;
	            found = false;
	            while(j<jLen){
	                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
	                    found = true;
	                }
	                j += 1;
	            }
	            if(!found){
	                this.chars.push(chars[i]);
	                jLen += 1;
	            }
	        }
	    }
	
	    function getCharData(char, style, font){
	        var i = 0, len = this.chars.length;
	        while( i < len) {
	            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
	                return this.chars[i];
	            }
	            i+= 1;
	        }
	        if(console && console.warn) {
	            console.warn('Missing character from exported characters list: ', char, style, font);
	        }
	        return emptyChar;
	    }
	
	    function measureText(char, fontName, size) {
	        var fontData = this.getFontByName(fontName);
	        var index = char.charCodeAt(0);
	        if(!fontData.cache[index + 1]) {
	            var tHelper = fontData.helper;
	            //Canvas version
	            //fontData.cache[index] = tHelper.measureText(char).width / 100;
	            //SVG version
	            //console.log(tHelper.getBBox().width)
	            /*tHelper.textContent = '|' + char + '|';
	            var doubleSize = tHelper.getComputedTextLength();
	            tHelper.textContent = '||';
	            var singleSize = tHelper.getComputedTextLength();
	            fontData.cache[index + 1] = (doubleSize - singleSize)/100;*/
	           
	            tHelper.textContent = char;
	            fontData.cache[index + 1] = (tHelper.getComputedTextLength())/100;
	        }
	        return fontData.cache[index + 1] * size;
	    }
	
	    function getFontByName(name){
	        var i = 0, len = this.fonts.length;
	        while(i<len){
	            if(this.fonts[i].fName === name) {
	                return this.fonts[i];
	            }
	            i += 1;
	        }
	        return this.fonts[0];
	    }
	
	    function getCombinedCharacterCodes() {
	        return combinedCharacters;
	    }
	
	    var Font = function(){
	        this.fonts = [];
	        this.chars = null;
	        this.typekitLoaded = 0;
	        this.loaded = false;
	        this.initTime = Date.now();
	    };
	    //TODO: for now I'm adding these methods to the Class and not the prototype. Think of a better way to implement it. 
	    Font.getCombinedCharacterCodes = getCombinedCharacterCodes;
	
	    Font.prototype.addChars = addChars;
	    Font.prototype.addFonts = addFonts;
	    Font.prototype.getCharData = getCharData;
	    Font.prototype.getFontByName = getFontByName;
	    Font.prototype.measureText = measureText;
	
	    return Font;
	
	}());
	var PropertyFactory = (function(){
	
	    var initFrame = initialDefaultFrame;
	    var math_abs = Math.abs;
	
	    function interpolateValue(frameNum, caching){
	        var offsetTime = this.offsetTime;
	        var newValue;
	        if(this.propType === 'multidimensional') {
	            newValue = createTypedArray('float32', this.pv.length);
	        }
	        var iterationIndex = caching.lastIndex;
	        var i = iterationIndex;
	        var len = this.keyframes.length- 1,flag = true;
	        var keyData, nextKeyData;
	
	        while(flag){
	            keyData = this.keyframes[i];
	            nextKeyData = this.keyframes[i+1];
	            if(i == len-1 && frameNum >= nextKeyData.t - offsetTime){
	                if(keyData.h){
	                    keyData = nextKeyData;
	                }
	                iterationIndex = 0;
	                break;
	            }
	            if((nextKeyData.t - offsetTime) > frameNum){
	                iterationIndex = i;
	                break;
	            }
	            if(i < len - 1){
	                i += 1;
	            }else{
	                iterationIndex = 0;
	                flag = false;
	            }
	        }
	
	        var k, kLen,perc,jLen, j, fnc;
	        if(keyData.to){
	
	            if(!keyData.bezierData){
	                bez.buildBezierData(keyData);
	            }
	            var bezierData = keyData.bezierData;
	            if(frameNum >= nextKeyData.t-offsetTime || frameNum < keyData.t-offsetTime){
	                var ind = frameNum >= nextKeyData.t-offsetTime ? bezierData.points.length - 1 : 0;
	                kLen = bezierData.points[ind].point.length;
	                for(k = 0; k < kLen; k += 1){
	                    newValue[k] = bezierData.points[ind].point[k];
	                }
	                caching._lastBezierData = null;
	            }else{
	                if(keyData.__fnct){
	                    fnc = keyData.__fnct;
	                }else{
	                    fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;
	                    keyData.__fnct = fnc;
	                }
	                perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
	                var distanceInLine = bezierData.segmentLength*perc;
	
	                var segmentPerc;
	                var addedLength =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastAddedLength : 0;
	                j =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastPoint : 0;
	                flag = true;
	                jLen = bezierData.points.length;
	                while(flag){
	                    addedLength +=bezierData.points[j].partialLength;
	                    if(distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1){
	                        kLen = bezierData.points[j].point.length;
	                        for(k=0;k<kLen;k+=1){
	                            newValue[k] = bezierData.points[j].point[k];
	                        }
	                        break;
	                    }else if(distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
	                        segmentPerc = (distanceInLine-addedLength)/(bezierData.points[j+1].partialLength);
	                        kLen = bezierData.points[j].point.length;
	                        for(k=0;k<kLen;k+=1){
	                            newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k])*segmentPerc;
	                        }
	                        break;
	                    }
	                    if(j < jLen - 1){
	                        j += 1;
	                    }else{
	                        flag = false;
	                    }
	                }
	                caching._lastPoint = j;
	                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	                caching._lastBezierData = bezierData;
	            }
	        }else{
	            var outX,outY,inX,inY, keyValue;
	            len = keyData.s.length;
	            if(this.sh && keyData.h !== 1) {
	                if(frameNum >= nextKeyData.t-offsetTime){
	                    newValue[0] = keyData.e[0];
	                    newValue[1] = keyData.e[1];
	                    newValue[2] = keyData.e[2];
	                }else if(frameNum <= keyData.t-offsetTime){
	                    newValue[0] = keyData.s[0];
	                    newValue[1] = keyData.s[1];
	                    newValue[2] = keyData.s[2];
	                }else{
	                    var quatStart = createQuaternion(keyData.s);
	                    var quatEnd = createQuaternion(keyData.e);
	                    var time = (frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime));
	                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	                }
	                
	            } else {
	                for(i=0;i<len;i+=1){
	                    if(keyData.h !== 1){
	                        if(frameNum >= nextKeyData.t-offsetTime){
	                            perc = 1;
	                        }else if(frameNum < keyData.t-offsetTime){
	                            perc = 0;
	                        }else{
	                            if(keyData.o.x.constructor === Array){
	                                if(!keyData.__fnct){
	                                    keyData.__fnct = [];
	                                }
	                                if (!keyData.__fnct[i]) {
	                                    outX = keyData.o.x[i] || keyData.o.x[0];
	                                    outY = keyData.o.y[i] || keyData.o.y[0];
	                                    inX = keyData.i.x[i] || keyData.i.x[0];
	                                    inY = keyData.i.y[i] || keyData.i.y[0];
	                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                    keyData.__fnct[i] = fnc;
	                                } else {
	                                    fnc = keyData.__fnct[i];
	                                }
	                            } else {
	                                if (!keyData.__fnct) {
	                                    outX = keyData.o.x;
	                                    outY = keyData.o.y;
	                                    inX = keyData.i.x;
	                                    inY = keyData.i.y;
	                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                    keyData.__fnct = fnc;
	                                } else{
	                                    fnc = keyData.__fnct;
	                                }
	                            }
	                            perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
	                        }
	                    }
	
	                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
	
	                    if(len === 1){
	                        newValue = keyValue;
	                    }else{
	                        newValue[i] = keyValue;
	                    }
	                }
	            }
	        }
	        caching.lastIndex = iterationIndex;
	        return newValue;
	    }
	
	    //based on @Toji's https://github.com/toji/gl-matrix/
	    function slerp(a, b, t) {
	        var out = [];
	        var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bx = b[0], by = b[1], bz = b[2], bw = b[3]
	
	        var omega, cosom, sinom, scale0, scale1;
	
	        cosom = ax * bx + ay * by + az * bz + aw * bw;
	        if (cosom < 0.0) {
	            cosom = -cosom;
	            bx = -bx;
	            by = -by;
	            bz = -bz;
	            bw = -bw;
	        }
	        if ((1.0 - cosom) > 0.000001) {
	            omega = Math.acos(cosom);
	            sinom = Math.sin(omega);
	            scale0 = Math.sin((1.0 - t) * omega) / sinom;
	            scale1 = Math.sin(t * omega) / sinom;
	        } else {
	            scale0 = 1.0 - t;
	            scale1 = t;
	        }
	        out[0] = scale0 * ax + scale1 * bx;
	        out[1] = scale0 * ay + scale1 * by;
	        out[2] = scale0 * az + scale1 * bz;
	        out[3] = scale0 * aw + scale1 * bw;
	
	        return out;
	    }
	
	    function quaternionToEuler(out, quat) {
	        var qx = quat[0];
	        var qy = quat[1];
	        var qz = quat[2];
	        var qw = quat[3];
	        var heading = Math.atan2(2*qy*qw-2*qx*qz , 1 - 2*qy*qy - 2*qz*qz)
	        var attitude = Math.asin(2*qx*qy + 2*qz*qw) 
	        var bank = Math.atan2(2*qx*qw-2*qy*qz , 1 - 2*qx*qx - 2*qz*qz);
	        out[0] = heading/degToRads;
	        out[1] = attitude/degToRads;
	        out[2] = bank/degToRads;
	    }
	
	    function createQuaternion(values) {
	        var heading = values[0] * degToRads;
	        var attitude = values[1] * degToRads;
	        var bank = values[2] * degToRads;
	        var c1 = Math.cos(heading / 2);
	        var c2 = Math.cos(attitude / 2);
	        var c3 = Math.cos(bank / 2);
	        var s1 = Math.sin(heading / 2);
	        var s2 = Math.sin(attitude / 2);
	        var s3 = Math.sin(bank / 2);
	        var w = c1 * c2 * c3 - s1 * s2 * s3;
	        var x = s1 * s2 * c3 + c1 * c2 * s3;
	        var y = s1 * c2 * c3 + c1 * s2 * s3;
	        var z = c1 * s2 * c3 - s1 * c2 * s3;
	
	        return [x,y,z,w];
	    }
	
	    function getValueAtCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length- 1].t-this.offsetTime;
	        if(!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))){
	            this._caching.lastIndex = this._caching.lastFrame < frameNum ? this._caching.lastIndex : 0;
	            var renderResult = this.interpolateValue(frameNum, this._caching);
	            this.pv = renderResult;
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }
	
	    function setVValue(val) {
	        var multipliedValue;
	        if(this.propType === 'unidimensional') {
	            multipliedValue = val * this.mult;
	            if(math_abs(this.v - multipliedValue) > 0.00001) {
	                this.v = multipliedValue;
	                this._mdf = true;
	            }
	        } else {
	            var i = 0, len = this.v.length;
	            while (i < len) {
	                multipliedValue = val[i] * this.mult;
	                if (math_abs(this.v[i] - multipliedValue) > 0.00001) {
	                    this.v[i] = multipliedValue;
	                    this._mdf = true;
	                }
	                i += 1;
	            }
	        }
	    }
	
	    function processEffectsSequence() {
	        if(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	            return;
	        }        
	        if(this.lock) {
	            this.setVValue(this.pv);
	            return;
	        }
	        this.lock = true;
	        this._mdf = this._isFirstFrame;
	        var multipliedValue;
	        var i, len = this.effectsSequence.length;
	        var finalValue = this.kf ? this.pv : this.data.k;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        this.setVValue(finalValue);
	        this._isFirstFrame = false;
	        this.lock = false;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }
	
	    function ValueProperty(elem, data, mult, container){
	        this.propType = 'unidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this.v = mult ? data.k * mult : data.k;
	        this.pv = data.k;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.vel = 0;
	        this.effectsSequence = [];
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }
	
	    function MultiDimensionalProperty(elem, data, mult, container) {
	        this.propType = 'multidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.frameId = -1;
	        var i, len = data.k.length;
	        this.v = createTypedArray('float32', len);
	        this.pv = createTypedArray('float32', len);
	        var arr = createTypedArray('float32', len);
	        this.vel = createTypedArray('float32', len);
	        for (i = 0; i < len; i += 1) {
	            this.v[i] = data.k[i] * this.mult;
	            this.pv[i] = data.k[i];
	        }
	        this._isFirstFrame = true;
	        this.effectsSequence = [];
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }
	
	    function KeyframedValueProperty(elem, data, mult, container) {
	        this.propType = 'unidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.frameId = -1;
	        this._caching = {lastFrame: initFrame, lastIndex: 0, value: 0};
	        this.k = true;
	        this.kf = true;
	        this.data = data;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.v = initFrame;
	        this.pv = initFrame;
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.addEffect = addEffect;
	    }
	
	    function KeyframedMultidimensionalProperty(elem, data, mult, container){
	        this.propType = 'multidimensional';
	        var i, len = data.k.length;
	        var s, e,to,ti;
	        for (i = 0; i < len - 1; i += 1) {
	            if (data.k[i].to && data.k[i].s && data.k[i].e) {
	                s = data.k[i].s;
	                e = data.k[i].e;
	                to = data.k[i].to;
	                ti = data.k[i].ti;
	                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
	                    data.k[i].to = null;
	                    data.k[i].ti = null;
	                }
	                if(s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	                    if(s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
	                        data.k[i].to = null;
	                        data.k[i].ti = null;
	                    }
	                }
	            }
	        }
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.k = true;
	        this.kf = true;
	        this._isFirstFrame = true;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.frameId = -1;
	        var arrLen = data.k[0].s.length;
	        this.v = createTypedArray('float32', arrLen);
	        this.pv = createTypedArray('float32', arrLen);
	        for (i = 0; i < arrLen; i += 1) {
	            this.v[i] = initFrame;
	            this.pv[i] = initFrame;
	        }
	        this._caching={lastFrame:initFrame,lastIndex:0,value:createTypedArray('float32', arrLen)};
	        this.addEffect = addEffect;
	    }
	
	    function getProp(elem,data,type, mult, container) {
	        var p;
	        if(data.a === 0){
	            if(type === 0) {
	                p = new ValueProperty(elem,data,mult, container);
	            } else {
	                p = new MultiDimensionalProperty(elem,data, mult, container);
	            }
	        } else if(data.a === 1){
	            if(type === 0) {
	                p = new KeyframedValueProperty(elem,data,mult, container);
	            } else {
	                p = new KeyframedMultidimensionalProperty(elem,data, mult, container);
	            }
	        } else if(!data.k.length){
	            p = new ValueProperty(elem,data, mult, container);
	        }else if(typeof(data.k[0]) === 'number'){
	            p = new MultiDimensionalProperty(elem,data, mult, container);
	        }else{
	            switch(type){
	                case 0:
	                    p = new KeyframedValueProperty(elem,data,mult, container);
	                    break;
	                case 1:
	                    p = new KeyframedMultidimensionalProperty(elem,data,mult, container);
	                    break;
	            }
	        }
	        if(p.effectsSequence.length){
	            container.addDynamicProperty(p);
	        }
	        return p;
	    }
	
	    var ob = {
	        getProp: getProp
	    };
	    return ob;
	}());
	var TransformPropertyFactory = (function() {
	
	    function applyToMatrix(mat) {
	        var _mdf = this._mdf;
	        this.iterateDynamicProperties();
	        this._mdf = this._mdf || _mdf;
	        if (this.a) {
	            mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	        if (this.s) {
	            mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	        if (this.sk) {
	            mat.skewFromAxis(-this.sk.v, this.sa.v);
	        }
	        if (this.r) {
	            mat.rotate(-this.r.v);
	        } else {
	            mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	        if (this.data.p.s) {
	            if (this.data.p.z) {
	                mat.translate(this.px.v, this.py.v, -this.pz.v);
	            } else {
	                mat.translate(this.px.v, this.py.v, 0);
	            }
	        } else {
	            mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	    }
	    function processKeys(forceRender){
	        if (this.elem.globalData.frameId === this.frameId) {
	            return;
	        }
	        if(this._isDirty) {
	            this.precalculateMatrix();
	            this._isDirty = false;
	        }
	
	        this.iterateDynamicProperties();
	
	        if (this._mdf || forceRender) {
	            this.v.cloneFromProps(this.pre.props);
	            if (this.appliedTransformations < 1) {
	                this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            }
	            if(this.appliedTransformations < 2) {
	                this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            }
	            if (this.sk && this.appliedTransformations < 3) {
	                this.v.skewFromAxis(-this.sk.v, this.sa.v);
	            }
	            if (this.r && this.appliedTransformations < 4) {
	                this.v.rotate(-this.r.v);
	            } else if (!this.r && this.appliedTransformations < 4){
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if (this.autoOriented && this.p.keyframes && this.p.getValueAtTime) {
	                var v1,v2;
	                if (this.p._caching.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
	                    v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / this.elem.globalData.frameRate,0);
	                    v2 = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0);
	                } else if(this.p._caching.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	                    v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate), 0);
	                    v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / this.elem.globalData.frameRate, 0);
	                } else {
	                    v1 = this.p.pv;
	                    v2 = this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime - 0.01) / this.elem.globalData.frameRate, this.p.offsetTime);
	                }
	                this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	            }
	            if(this.data.p.s){
	                if(this.data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else{
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function precalculateMatrix() {
	        if(!this.a.k) {
	            this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            this.appliedTransformations = 1;
	        } else {
	            return;
	        }
	        if(!this.s.effectsSequence.length) {
	            this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            this.appliedTransformations = 2;
	        } else {
	            return;
	        }
	        if(this.sk) {
	            if(!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	                this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	            this.appliedTransformations = 3;
	            } else {
	                return;
	            }
	        }
	        if (this.r) {
	            if(!this.r.effectsSequence.length) {
	                this.pre.rotate(-this.r.v);
	                this.appliedTransformations = 4;
	            } else {
	                return;
	            }
	        } else if(!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	            this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            this.appliedTransformations = 4;
	        }
	    }
	
	    function autoOrient(){
	        //
	        //var prevP = this.getValueAtTime();
	    }
	
	    function addDynamicProperty(prop) {
	        this._addDynamicProperty(prop);
	        this.elem.addDynamicProperty(prop);
	        this._isDirty = true;
	    }
	
	    function TransformProperty(elem,data,container){
	        this.elem = elem;
	        this.frameId = -1;
	        this.propType = 'transform';
	        this.data = data;
	        this.v = new Matrix();
	        //Precalculated matrix with non animated properties
	        this.pre = new Matrix();
	        this.appliedTransformations = 0;
	        this.initDynamicPropertyContainer(container || elem);
	        if(data.p.s){
	            this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this);
	            this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this);
	            if(data.p.z){
	                this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this);
	            }
	        }else{
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	        }
	        if(data.r) {
	            this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
	        } else if(data.rx) {
	            this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	            this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	            this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
	            if(data.or.k[0].ti) {
	                var i, len = data.or.k.length;
	                for(i=0;i<len;i+=1) {
	                    data.or.k[i].to = data.or.k[i].ti = null;
	                }
	            }
	            this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
	            //sh Indicates it needs to be capped between -180 and 180
	            this.or.sh = true;
	        }
	        if(data.sk){
	            this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	            this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	        }
	        if(data.a) {
	            this.a = PropertyFactory.getProp(elem,data.a,1,0,this);
	        }
	        if(data.s) {
	            this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this);
	        }
	        // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
	        if(data.o){
	            this.o = PropertyFactory.getProp(elem,data.o,0,0.01,elem);
	        } else {
	            this.o = {_mdf:false,v:1};
	        }
	        this._isDirty = true;
	        if(!this.dynamicProperties.length){
	            this.getValue(true);
	        }
	    }
	
	    TransformProperty.prototype = {
	        applyToMatrix: applyToMatrix,
	        getValue: processKeys,
	        precalculateMatrix: precalculateMatrix,
	        autoOrient: autoOrient
	    }
	
	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
	
	    function getTransformProperty(elem,data,container){
	        return new TransformProperty(elem,data,container);
	    }
	
	    return {
	        getTransformProperty: getTransformProperty
	    };
	
	}());
	function ShapePath(){
		this.c = false;
		this._length = 0;
		this._maxLength = 8;
		this.v = createSizedArray(this._maxLength);
		this.o = createSizedArray(this._maxLength);
		this.i = createSizedArray(this._maxLength);
	}
	
	ShapePath.prototype.setPathData = function(closed, len) {
		this.c = closed;
		this.setLength(len);
		var i = 0;
		while(i < len){
			this.v[i] = point_pool.newElement();
			this.o[i] = point_pool.newElement();
			this.i[i] = point_pool.newElement();
			i += 1;
		}
	};
	
	ShapePath.prototype.setLength = function(len) {
		while(this._maxLength < len) {
			this.doubleArrayLength();
		}
		this._length = len;
	};
	
	ShapePath.prototype.doubleArrayLength = function() {
		this.v = this.v.concat(createSizedArray(this._maxLength));
		this.i = this.i.concat(createSizedArray(this._maxLength));
		this.o = this.o.concat(createSizedArray(this._maxLength));
		this._maxLength *= 2;
	};
	
	ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
		var arr;
		this._length = Math.max(this._length, pos + 1);
		if(this._length >= this._maxLength) {
			this.doubleArrayLength();
		}
		switch(type){
			case 'v':
				arr = this.v;
				break;
			case 'i':
				arr = this.i;
				break;
			case 'o':
				arr = this.o;
				break;
		}
		if(!arr[pos] || (arr[pos] && !replace)){
			arr[pos] = point_pool.newElement();
		}
		arr[pos][0] = x;
		arr[pos][1] = y;
	};
	
	ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
		this.setXYAt(vX,vY,'v',pos, replace);
		this.setXYAt(oX,oY,'o',pos, replace);
		this.setXYAt(iX,iY,'i',pos, replace);
	};
	
	ShapePath.prototype.reverse = function() {
		var newPath = new ShapePath();
		newPath.setPathData(this.c, this._length);
		var vertices = this.v, outPoints = this.o, inPoints = this.i;
		var init = 0;
		if (this.c) {
			newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	        init = 1;
	    }
	    var cnt = this._length - 1;
	    var len = this._length;
	
	    var i;
	    for (i = init; i < len; i += 1) {
	    	newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	        cnt -= 1;
	    }
	    return newPath;
	};
	var ShapePropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateShape(frameNum, previousValue, caching) {
	        var iterationIndex = caching.lastIndex;
	        var keyPropS,keyPropE,isHold, j, k, jLen, kLen, perc, vertexValue;
	        var kf = this.keyframes;
	        if(frameNum < kf[0].t-this.offsetTime){
	            keyPropS = kf[0].s[0];
	            isHold = true;
	            iterationIndex = 0;
	        }else if(frameNum >= kf[kf.length - 1].t-this.offsetTime){
	            if(kf[kf.length - 2].h === 1){
	                keyPropS = kf[kf.length - 1].s[0];
	            }else{
	                keyPropS = kf[kf.length - 2].e[0];
	            }
	            isHold = true;
	        }else{
	            var i = iterationIndex;
	            var len = kf.length- 1,flag = true,keyData,nextKeyData;
	            while(flag){
	                keyData = kf[i];
	                nextKeyData = kf[i+1];
	                if((nextKeyData.t - this.offsetTime) > frameNum){
	                    break;
	                }
	                if(i < len - 1){
	                    i += 1;
	                }else{
	                    flag = false;
	                }
	            }
	            isHold = keyData.h === 1;
	            iterationIndex = i;
	            if(!isHold){
	                if(frameNum >= nextKeyData.t-this.offsetTime){
	                    perc = 1;
	                }else if(frameNum < keyData.t-this.offsetTime){
	                    perc = 0;
	                }else{
	                    var fnc;
	                    if(keyData.__fnct){
	                        fnc = keyData.__fnct;
	                    }else{
	                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
	                        keyData.__fnct = fnc;
	                    }
	                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                }
	                keyPropE = keyData.e[0];
	            }
	            keyPropS = keyData.s[0];
	        }
	        jLen = previousValue._length;
	        kLen = keyPropS.i[0].length;
	        caching.lastIndex = iterationIndex;
	
	        for(j=0;j<jLen;j+=1){
	            for(k=0;k<kLen;k+=1){
	                vertexValue = isHold ? keyPropS.i[j][k] :  keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
	                previousValue.i[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.o[j][k] :  keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
	                previousValue.o[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.v[j][k] :  keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
	                previousValue.v[j][k] = vertexValue;
	            }
	        }
	    }
	
	    function interpolateShapeCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	        var lastFrame = this._caching.lastFrame;
	        if(!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))){
	            ////
	            this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	            this.interpolateShape(frameNum, this.pv, this._caching);
	            ////
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }
	
	    function resetShape(){
	        this.paths = this.localShapeCollection;
	    }
	
	    function shapesEqual(shape1, shape2) {
	        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
	            return false;
	        }
	        var i, len = shape1._length;
	        for(i = 0; i < len; i += 1) {
	            if(shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]){
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function processEffectsSequence() {
	        if(this.lock || this.elem.globalData.frameId === this.frameId) {
	            return;
	        }
	        this.lock = true;
	        this.frameId = this.elem.globalData.frameId;
	        this._mdf = false;
	        var finalValue = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
	        var i, len = this.effectsSequence.length;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        if(!shapesEqual(this.v, finalValue)) {
	            this.v = shape_pool.clone(finalValue);
	            this.localShapeCollection.releaseShapes();
	            this.localShapeCollection.addShape(this.v);
	            this._mdf = true;
	            this.paths = this.localShapeCollection;
	        }
	        this.lock = false;
	    };
	
	    function ShapeProperty(elem, data, type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.container = elem;
	        this.elem = elem;
	        this.data = data;
	        this.k = false;
	        this.kf = false;
	        this._mdf = false;
	        var pathData = type === 3 ? data.pt.k : data.ks.k;
	        this.v = shape_pool.clone(pathData);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.reset = resetShape;
	        this.effectsSequence = [];
	    }
	
	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }
	
	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.addEffect = addEffect;
	
	    function KeyframedShapeProperty(elem,data,type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.elem = elem;
	        this.container = elem;
	        this.offsetTime = elem.data.st;
	        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	        this.k = true;
	        this.kf = true;
	        var i, len = this.keyframes[0].s[0].i.length;
	        var jLen = this.keyframes[0].s[0].i[0].length;
	        this.v = shape_pool.newElement();
	        this.v.setPathData(this.keyframes[0].s[0].c, len);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.lastFrame = initFrame;
	        this.reset = resetShape;
	        this._caching = {lastFrame: initFrame, lastIndex: 0};
	        this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }
	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;
	
	    var EllShapeProperty = (function(){
	
	        var cPoint = roundCorner;
	
	        function EllShapeProperty(elem,data) {
	            /*this.v = {
	                v: createSizedArray(4),
	                i: createSizedArray(4),
	                o: createSizedArray(4),
	                c: true
	            };*/
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 4);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.paths = this.localShapeCollection;
	            this.localShapeCollection.addShape(this.v);
	            this.d = data.d;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertEllToPath();
	            }
	        };
	
	        EllShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function (){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	
	                if(this._mdf){
	                    this.convertEllToPath();
	                }
	            },
	            convertEllToPath: function() {
	                var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
	                var _cw = this.d !== 3;
	                var _v = this.v;
	                _v.v[0][0] = p0;
	                _v.v[0][1] = p1 - s1;
	                _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.v[1][1] = p1;
	                _v.v[2][0] = p0;
	                _v.v[2][1] = p1 + s1;
	                _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.v[3][1] = p1;
	                _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.i[0][1] = p1 - s1;
	                _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.i[1][1] = p1 - s1 * cPoint;
	                _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.i[2][1] = p1 + s1;
	                _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.i[3][1] = p1 + s1 * cPoint;
	                _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.o[0][1] = p1 - s1;
	                _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.o[1][1] = p1 + s1 * cPoint;
	                _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.o[2][1] = p1 + s1;
	                _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.o[3][1] = p1 - s1 * cPoint;
	            }
	        }
	
	        extendPrototype([DynamicPropertyContainer], EllShapeProperty);
	
	        return EllShapeProperty;
	    }());
	
	    var StarShapeProperty = (function() {
	
	        function StarShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 0);
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.data = data;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            if(data.sy === 1){
	                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this);
	                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this);
	                this.convertToPath = this.convertStarToPath;
	            } else {
	                this.convertToPath = this.convertPolygonToPath;
	            }
	            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this);
	            this.or = PropertyFactory.getProp(elem,data.or,0,0,this);
	            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertToPath();
	            }
	        };
	
	        StarShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function() {
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertToPath();
	                }
	            },
	            convertStarToPath: function() {
	                var numPts = Math.floor(this.pt.v)*2;
	                var angle = Math.PI*2/numPts;
	                /*this.v.v.length = numPts;
	                this.v.i.length = numPts;
	                this.v.o.length = numPts;*/
	                var longFlag = true;
	                var longRad = this.or.v;
	                var shortRad = this.ir.v;
	                var longRound = this.os.v;
	                var shortRound = this.is.v;
	                var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
	                var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
	                var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
	                currentAng += this.r.v;
	                var dir = this.data.d === 3 ? -1 : 1;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    rad = longFlag ? longRad : shortRad;
	                    roundness = longFlag ? longRound : shortRound;
	                    perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	
	                    /*this.v.v[i] = [x,y];
	                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                    this.v._length = numPts;*/
	                    longFlag = !longFlag;
	                    currentAng += angle*dir;
	                }
	            },
	            convertPolygonToPath: function() {
	                var numPts = Math.floor(this.pt.v);
	                var angle = Math.PI*2/numPts;
	                var rad = this.or.v;
	                var roundness = this.os.v;
	                var perimSegment = 2*Math.PI*rad/(numPts*4);
	                var i, currentAng = -Math.PI/ 2;
	                var dir = this.data.d === 3 ? -1 : 1;
	                currentAng += this.r.v;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	                    currentAng += angle*dir;
	                }
	                this.paths.length = 0;
	                this.paths[0] = this.v;
	            }
	
	        }
	        extendPrototype([DynamicPropertyContainer], StarShapeProperty);
	
	        return StarShapeProperty;
	    }());
	
	    var RectShapeProperty = (function() {
	
	         function RectShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.c = true;
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertRectToPath();
	            }
	        };
	
	        RectShapeProperty.prototype = {
	            convertRectToPath: function (){
	                var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
	                var round = bm_min(v0,v1,this.r.v);
	                var cPoint = round*(1-roundCorner);
	                this.v._length = 0;
	
	                if(this.d === 2 || this.d === 1) {
	                    this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
	                    this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
	                    }
	                }else{
	                    this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
	                        this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
	                        this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
	                        this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);
	
	                    }
	                }
	            },
	            getValue: function(frameNum){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertRectToPath();
	                }
	
	            },
	            reset: resetShape
	        }
	        extendPrototype([DynamicPropertyContainer], RectShapeProperty);
	
	        return RectShapeProperty;
	    }());
	
	    function getShapeProp(elem,data,type){
	        var prop;
	        if(type === 3 || type === 4){
	            var dataProp = type === 3 ? data.pt : data.ks;
	            var keys = dataProp.k;
	            if(dataProp.a === 1 || keys.length){
	                prop = new KeyframedShapeProperty(elem, data, type);
	            }else{
	                prop = new ShapeProperty(elem, data, type);
	            }
	        }else if(type === 5){
	            prop = new RectShapeProperty(elem, data);
	        }else if(type === 6){
	            prop = new EllShapeProperty(elem, data);
	        }else if(type === 7){
	            prop = new StarShapeProperty(elem, data);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    }
	
	    function getConstructorFunction() {
	        return ShapeProperty;
	    }
	
	    function getKeyframedConstructorFunction() {
	        return KeyframedShapeProperty;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	}());
	var ShapeModifiers = (function(){
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm,factory){
	        if(!modifiers[nm]){
	            modifiers[nm] = factory;
	        }
	    }
	
	    function getModifier(nm,elem, data){
	        return new modifiers[nm](elem, data);
	    }
	
	    return ob;
	}());
	
	function ShapeModifier(){}
	ShapeModifier.prototype.initModifierProperties = function(){};
	ShapeModifier.prototype.addShapeToModifier = function(){};
	ShapeModifier.prototype.addShape = function(data){
	    if(!this.closed){
	        var shapeData = {shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()};
	        this.shapes.push(shapeData);
	        this.addShapeToModifier(shapeData);
	        if(this._isAnimated) {
	            data.setAsAnimated();
	        }
	    }
	};
	ShapeModifier.prototype.init = function(elem,data){
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else{
	        this.getValue(true);
	    }
	};
	ShapeModifier.prototype.processKeys = function(){
	    if(this.elem.globalData.frameId === this.frameId){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};
	
	extendPrototype([DynamicPropertyContainer], ShapeModifier);
	function TrimModifier(){
	}
	extendPrototype([ShapeModifier], TrimModifier);
	TrimModifier.prototype.initModifierProperties = function(elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	};
	
	TrimModifier.prototype.addShapeToModifier = function(shapeData){
	    shapeData.pathsData = [];
	};
	
	TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];
	    if (e <= 1) {
	        segments.push({
	            s: s,
	            e: e
	        });
	    } else if (s >= 1) {
	        segments.push({
	            s: s - 1,
	            e: e - 1
	        });
	    } else {
	        segments.push({
	            s: s,
	            e: 1
	        });
	        segments.push({
	            s: 0,
	            e: e - 1
	        });
	    }
	    var shapeSegments = [];
	    var i, len = segments.length, segmentOb;
	    for (i = 0; i < len; i += 1) {
	        segmentOb = segments[i];
	        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
	            
	        } else {
	            var shapeS, shapeE;
	            if (segmentOb.s * totalModifierLength <= addedLength) {
	                shapeS = 0;
	            } else {
	                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	            }
	            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	                shapeE = 1;
	            } else {
	                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
	            }
	            shapeSegments.push([shapeS, shapeE]);
	        }
	    }
	    if (!shapeSegments.length) {
	        shapeSegments.push([0, 0]);
	    }
	    return shapeSegments;
	};
	
	TrimModifier.prototype.releasePathsData = function(pathsData) {
	    var i, len = pathsData.length;
	    for (i = 0; i < len; i += 1) {
	        segments_length_pool.release(pathsData[i]);
	    }
	    pathsData.length = 0;
	    return pathsData;
	};
	
	TrimModifier.prototype.processShapes = function(_isFirstFrame) {
	    var s, e;
	    if (this._mdf || _isFirstFrame) {
	        var o = (this.o.v % 360) / 360;
	        if (o < 0) {
	            o += 1;
	        }
	        s = this.s.v + o;
	        e = this.e.v + o;
	        if (s === e) {
	
	        }
	        if (s > e) {
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        s = Math.round(s*1000)/1000;
	        e = Math.round(e*1000)/1000;
	        this.sValue = s;
	        this.eValue = e;
	    } else {
	        s = this.sValue;
	        e = this.eValue;
	    }
	    var shapePaths;
	    var i, len = this.shapes.length, j, jLen;
	    var pathsData, pathData, totalShapeLength, totalModifierLength = 0;
	
	    if (e === s) {
	        for (i = 0; i < len; i += 1) {
	            this.shapes[i].localShapeCollection.releaseShapes();
	            this.shapes[i].shape._mdf = true;
	            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	        }
	    } else if (!((e === 1 && s === 0) || (e===0 && s === 1))){
	        var segments = [], shapeData, localShapeCollection;
	        for (i = 0; i < len; i += 1) {
	            shapeData = this.shapes[i];
	            // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
	            if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	                shapeData.shape.paths = shapeData.localShapeCollection;
	            } else {
	                shapePaths = shapeData.shape.paths;
	                jLen = shapePaths._length;
	                totalShapeLength = 0;
	                if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	                    totalShapeLength = shapeData.totalShapeLength;
	                } else {
	                    pathsData = this.releasePathsData(shapeData.pathsData);
	                    for (j = 0; j < jLen; j += 1) {
	                        pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	                        pathsData.push(pathData);
	                        totalShapeLength += pathData.totalLength;
	                    }
	                    shapeData.totalShapeLength = totalShapeLength;
	                    shapeData.pathsData = pathsData;
	                }
	
	                totalModifierLength += totalShapeLength;
	                shapeData.shape._mdf = true;
	            }
	        }
	        var shapeS = s, shapeE = e, addedLength = 0, edges;
	        for (i = len - 1; i >= 0; i -= 1) {
	            shapeData = this.shapes[i];
	            if (shapeData.shape._mdf) {
	                localShapeCollection = shapeData.localShapeCollection;
	                localShapeCollection.releaseShapes();
	                //if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
	                if (this.m === 2 && len > 1) {
	                    edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	                    addedLength += shapeData.totalShapeLength;
	                } else {
	                    edges = [[shapeS, shapeE]];
	                }
	                jLen = edges.length;
	                for (j = 0; j < jLen; j += 1) {
	                    shapeS = edges[j][0];
	                    shapeE = edges[j][1];
	                    segments.length = 0;
	                    if (shapeE <= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength * shapeE
	                        });
	                    } else if (shapeS >= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * (shapeS - 1),
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    } else {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength
	                        });
	                        segments.push({
	                            s:0,
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    }
	                    var newShapesData = this.addShapes(shapeData,segments[0]);
	                    if (segments[0].s !== segments[0].e) {
	                        if (segments.length > 1) {
	                            if (shapeData.shape.v.c) {
	                                var lastShape = newShapesData.pop();
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                            } else {
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1]);
	                            }
	                        } 
	                        this.addPaths(newShapesData, localShapeCollection);
	                    }
	                    
	                }
	                shapeData.shape.paths = localShapeCollection;
	            }
	        }
	    } else if (this._mdf) {
	        for (i = 0; i < len; i += 1) {
	            this.shapes[i].shape._mdf = true;
	        }
	    }
	};
	
	TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
	    var i, len = newPaths.length;
	    for (i = 0; i < len; i += 1) {
	        localShapeCollection.addShape(newPaths[i]);
	    }
	};
	
	TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }
	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	};
	
	TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }
	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	};
	
	TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i, len = shapeData.shape.paths._length, j, jLen;
	    var addedLength = 0;
	    var currentLengthData,segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	    if (!shapePath) {
	        shapePath = shape_pool.newElement();
	        segmentCount = 0;
	        initPos = 0;
	    } else {
	        segmentCount = shapePath._length;
	        initPos = shapePath._length;
	    }
	    shapes.push(shapePath);
	    for (i = 0; i < len; i += 1) {
	        lengths = pathsData[i].lengths;
	        shapePath.c = shapePaths[i].c;
	        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	        for (j = 1; j < jLen; j +=1) {
	            currentLengthData = lengths[j-1];
	            if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	                addedLength += currentLengthData.addedLength;
	                shapePath.c = false;
	            } else if(addedLength > shapeSegment.e) {
	                shapePath.c = false;
	                break;
	            } else {
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	                addedLength += currentLengthData.addedLength;
	                segmentCount += 1;
	            }
	        }
	        if (shapePaths[i].c) {
	            currentLengthData = lengths[j - 1];
	            if (addedLength <= shapeSegment.e) {
	                var segmentLength = lengths[j - 1].addedLength;
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	            } else {
	                shapePath.c = false;
	            }
	            addedLength += currentLengthData.addedLength;
	            segmentCount += 1;
	        }
	        if (shapePath._length) {
	            shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1],'o', shapePath._length - 1);
	        }
	        if (addedLength > shapeSegment.e) {
	            break;
	        }
	        if (i < len - 1) {
	            shapePath = shape_pool.newElement();
	            newShape = true;
	            shapes.push(shapePath);
	            segmentCount = 0;
	        }
	    }
	    return shapes;
	};
	
	
	ShapeModifiers.registerModifier('tm', TrimModifier);
	function RoundCornersModifier(){}
	extendPrototype([ShapeModifier],RoundCornersModifier);
	RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	};
	
	RoundCornersModifier.prototype.processPath = function(path, round){
	    var cloned_path = shape_pool.newElement();
	    cloned_path.c = path.c;
	    var i, len = path._length;
	    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
	    var vX,vY,oX,oY,iX,iY;
	    for(i=0;i<len;i+=1){
	        currentV = path.v[i];
	        currentO = path.o[i];
	        currentI = path.i[i];
	        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
	            if((i===0 || i === len - 1) && !path.c){
	                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
	                /*cloned_path.v[index] = currentV;
	                cloned_path.o[index] = currentO;
	                cloned_path.i[index] = currentI;*/
	                index += 1;
	            } else {
	                if(i===0){
	                    closerV = path.v[len-1];
	                } else {
	                    closerV = path.v[i-1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
	                oX = vX-(vX-currentV[0])*roundCorner;
	                oY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	
	                if(i === len - 1){
	                    closerV = path.v[0];
	                } else {
	                    closerV = path.v[i+1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
	                iX = vX-(vX-currentV[0])*roundCorner;
	                iY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	            }
	        } else {
	            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
	            index += 1;
	        }
	    }
	    return cloned_path;
	};
	
	RoundCornersModifier.prototype.processShapes = function(_isFirstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var rd = this.rd.v;
	
	    if(rd !== 0){
	        var shapeData, newPaths, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            newPaths = shapeData.shape.paths;
	            localShapeCollection = shapeData.localShapeCollection;
	            if(!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)){
	                localShapeCollection.releaseShapes();
	                shapeData.shape._mdf = true;
	                shapePaths = shapeData.shape.paths.shapes;
	                jLen = shapeData.shape.paths._length;
	                for(j=0;j<jLen;j+=1){
	                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
	                }
	            }
	            shapeData.shape.paths = shapeData.localShapeCollection;
	        }
	
	    }
	    if(!this.dynamicProperties.length){
	        this._mdf = false;
	    }
	};
	
	ShapeModifiers.registerModifier('rd',RoundCornersModifier);
	function RepeaterModifier(){}
	extendPrototype([ShapeModifier], RepeaterModifier);
	
	RepeaterModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem,data.c,0,null,this);
	    this.o = PropertyFactory.getProp(elem,data.o,0,null,this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem,data.tr,this);
	    this.data = data;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	};
	
	RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	};
	
	RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,arr[pos]);
	    var cont = 0;
	    while(pos>0){
	        pos -= 1;
	        //this._elements.unshift(arr.splice(pos,1)[0]);
	        this._elements.unshift(arr[pos]);
	        cont += 1;
	    }
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else{
	        this.getValue(true);
	    }
	};
	
	RepeaterModifier.prototype.resetElements = function(elements){
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._processed = false;
	        if(elements[i].ty === 'gr'){
	            this.resetElements(elements[i].it);
	        }
	    }
	};
	
	RepeaterModifier.prototype.cloneElements = function(elements){
	    var i, len = elements.length;
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	};
	
	RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
	    var i, len = elements.length;
	    for(i = 0; i < len ; i += 1) {
	        elements[i]._render = renderFlag;
	        if(elements[i].ty === 'gr') {
	            this.changeGroupRender(elements[i].it, renderFlag);
	        }
	    }
	};
	
	RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
	    var items, itemsTransform, i, dir, cont;
	    if(this._mdf || _isFirstFrame){
	        var copies = Math.ceil(this.c.v);
	        if(this._groups.length < copies){
	            while(this._groups.length < copies){
	                var group = {
	                    it:this.cloneElements(this._elements),
	                    ty:'gr'
	                };
	                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":1,"ix":6,"k":[{s:0,e:0,t:0},{s:0,e:0,t:1}]},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
	                
	                this.arr.splice(0,0,group);
	                this._groups.splice(0,0,group);
	                this._currentCopies += 1;
	            }
	            this.elem.reloadShapes();
	        }
	        cont = 0;
	        var renderFlag;
	        for(i = 0; i  <= this._groups.length - 1; i += 1){
	            renderFlag = cont < copies;
	            this._groups[i]._render = renderFlag;
	            this.changeGroupRender(this._groups[i].it, renderFlag);
	            cont += 1;
	        }
	        
	        this._currentCopies = copies;
	        ////
	
	        var offset = this.o.v;
	        var offsetModulo = offset%1;
	        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	        var k;
	        var tMat = this.tr.v.props;
	        var pProps = this.pMatrix.props;
	        var rProps = this.rMatrix.props;
	        var sProps = this.sMatrix.props;
	        this.pMatrix.reset();
	        this.rMatrix.reset();
	        this.sMatrix.reset();
	        this.tMatrix.reset();
	        this.matrix.reset();
	        var iteration = 0;
	
	        if(offset > 0) {
	            while(iteration<roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                iteration += 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	                iteration += offsetModulo;
	            }
	        } else if(offset < 0) {
	            while(iteration>roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	                iteration -= 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
	                iteration -= offsetModulo;
	            }
	        }
	        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	        dir = this.data.m === 1 ? 1 : -1;
	        cont = this._currentCopies;
	        var j, jLen;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            jLen = itemsTransform.length;
	            items[items.length - 1].transform.mProps._mdf = true;
	            items[items.length - 1].transform.op._mdf = true;
	            if(iteration !== 0){
	                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
	                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                }
	                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
	                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
	                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
	                
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	                this.matrix.reset();
	            } else {
	                this.matrix.reset();
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	            }
	            iteration += 1;
	            cont -= 1;
	            i += dir;
	        }
	    } else {
	        cont = this._currentCopies;
	        i = 0;
	        dir = 1;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            items[items.length - 1].transform.mProps._mdf = false;
	            items[items.length - 1].transform.op._mdf = false;
	            cont -= 1;
	            i += dir;
	        }
	    }
	};
	
	RepeaterModifier.prototype.addShape = function(){};
	
	ShapeModifiers.registerModifier('rp',RepeaterModifier);
	function ShapeCollection(){
		this._length = 0;
		this._maxLength = 4;
		this.shapes = createSizedArray(this._maxLength);
	}
	
	ShapeCollection.prototype.addShape = function(shapeData){
		if(this._length === this._maxLength){
			this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
			this._maxLength *= 2;
		}
		this.shapes[this._length] = shapeData;
		this._length += 1;
	};
	
	ShapeCollection.prototype.releaseShapes = function(){
		var i;
		for(i = 0; i < this._length; i += 1) {
			shape_pool.release(this.shapes[i]);
		}
		this._length = 0;
	};
	function DashProperty(elem, data, renderer) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32',  data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32',  1);
	    this.initDynamicPropertyContainer(elem);
	    var i, len = data.length || 0, prop;
	    for(i = 0; i < len; i += 1) {
	        prop = PropertyFactory.getProp(elem,data[i].v,0, 0, this);
	        this.k = prop.k || this.k;
	        this.dataProps[i] = {n:data[i].n,p:prop};
	    }
	    if(!this.k){
	        this.getValue(true);
	    }
	    this._isAnimated = this.k;
	}
	
	DashProperty.prototype.getValue = function(forceRender) {
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;
	    if (this._mdf) {
	        var i = 0, len = this.dataProps.length;
	        if(this.renderer === 'svg') {
	            this.dashStr = '';
	        }
	        for(i=0;i<len;i+=1){
	            if(this.dataProps[i].n != 'o'){
	                if(this.renderer === 'svg') {
	                    this.dashStr += ' ' + this.dataProps[i].p.v;
	                }else{
	                    this.dashArray[i] = this.dataProps[i].p.v;
	                }
	            }else{
	                this.dashoffset[0] = this.dataProps[i].p.v;
	            }
	        }
	    }
	};
	extendPrototype([DynamicPropertyContainer], DashProperty);
	function GradientProperty(elem,data){
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p*4);
	    var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(elem);
	    this.prop = PropertyFactory.getProp(elem,data.k,1,null,this);
	    this.k = this.prop.k;
	    this.getValue(true);
	}
	
	GradientProperty.prototype.comparePoints = function(values, points) {
	    var i = 0, len = this.o.length/2, diff;
	    while(i < len) {
	        diff = Math.abs(values[i*4] - values[points*4 + i*2]);
	        if(diff > 0.01){
	            return false;
	        }
	        i += 1;
	    }
	    return true;
	};
	
	GradientProperty.prototype.checkCollapsable = function() {
	    if (this.o.length/2 !== this.c.length/4) {
	        return false;
	    }
	    if (this.data.k.k[0].s) {
	        var i = 0, len = this.data.k.k.length;
	        while (i < len) {
	            if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	                return false;
	            }
	            i += 1;
	        }
	    } else if(!this.comparePoints(this.data.k.k, this.data.p)) {
	        return false;
	    }
	    return true;
	};
	
	GradientProperty.prototype.getValue = function(forceRender){
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;
	    if(this.prop._mdf || forceRender){
	        var i, len = this.data.p*4;
	        var mult, val;
	        for(i=0;i<len;i+=1){
	            mult = i%4 === 0 ? 100 : 255;
	            val = Math.round(this.prop.v[i]*mult);
	            if(this.c[i] !== val){
	                this.c[i] = val;
	                this._cmdf = !forceRender;
	            }
	        }
	        if(this.o.length){
	            len = this.prop.v.length;
	            for(i=this.data.p*4;i<len;i+=1){
	                mult = i%2 === 0 ? 100 : 1;
	                val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
	                if(this.o[i-this.data.p*4] !== val){
	                    this.o[i-this.data.p*4] = val;
	                    this._omdf = !forceRender;
	                }
	            }
	        }
	        this._mdf = !forceRender;
	    }
	};
	
	extendPrototype([DynamicPropertyContainer], GradientProperty);
	var buildShapeString = function(pathNodes, length, closed, mat) {
		if(length === 0) {
	            return '';
	        }
	        var _o = pathNodes.o;
	        var _i = pathNodes.i;
	        var _v = pathNodes.v;
	        var i, shapeString = " M" + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	        for(i = 1; i < length; i += 1) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[i][0], _i[i][1]) + " " + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	        }
	        if (closed && length) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[0][0], _i[0][1]) + " " + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	            shapeString += 'z';
	        }
	        return shapeString;
	}
	var ImagePreloader = (function(){
	
	    function imageLoaded(){
	        this.loadedAssets += 1;
	        if(this.loadedAssets === this.totalImages){
	            if(this.imagesLoadedCb) {
	                this.imagesLoadedCb(null);
	            }
	        }
	    }
	
	    function getAssetsPath(assetData){
	        var path = '';
	        if(this.assetsPath){
	            var imagePath = assetData.p;
	            if(imagePath.indexOf('images/') !== -1){
	                imagePath = imagePath.split('/')[1];
	            }
	            path = this.assetsPath + imagePath;
	        } else {
	            path = this.path;
	            path += assetData.u ? assetData.u : '';
	            path += assetData.p;
	        }
	        return path;
	    }
	
	    function loadImage(path){
	        var img = createTag('img');
	        img.addEventListener('load', imageLoaded.bind(this), false);
	        img.addEventListener('error', imageLoaded.bind(this), false);
	        img.src = path;
	    }
	    function loadAssets(assets, cb){
	        this.imagesLoadedCb = cb;
	        this.totalAssets = assets.length;
	        var i;
	        for(i=0;i<this.totalAssets;i+=1){
	            if(!assets[i].layers){
	                loadImage.bind(this)(getAssetsPath.bind(this)(assets[i]));
	                this.totalImages += 1;
	            }
	        }
	    }
	
	    function setPath(path){
	        this.path = path || '';
	    }
	
	    function setAssetsPath(path){
	        this.assetsPath = path || '';
	    }
	
	    function destroy() {
	        this.imagesLoadedCb = null;
	    }
	
	    return function ImagePreloader(){
	        this.loadAssets = loadAssets;
	        this.setAssetsPath = setAssetsPath;
	        this.setPath = setPath;
	        this.destroy = destroy;
	        this.assetsPath = '';
	        this.path = '';
	        this.totalAssets = 0;
	        this.totalImages = 0;
	        this.loadedAssets = 0;
	        this.imagesLoadedCb = null;
	    };
	}());
	var featureSupport = (function(){
		var ob = {
			maskType: true
		};
		if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
		   ob.maskType = false;
		}
		return ob;
	}());
	var filtersFactory = (function(){
		var ob = {};
		ob.createFilter = createFilter;
		ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
		function createFilter(filId){
	        	var fil = createNS('filter');
	        	fil.setAttribute('id',filId);
	                fil.setAttribute('filterUnits','objectBoundingBox');
	                fil.setAttribute('x','0%');
	                fil.setAttribute('y','0%');
	                fil.setAttribute('width','100%');
	                fil.setAttribute('height','100%');
	                return fil;
		}
	
		function createAlphaToLuminanceFilter(){
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type','matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	                return feColorMatrix;
		}
	
		return ob;
	}());
	function TextAnimatorProperty(textData, renderType, elem){
	    this._isFirstFrame = true;
		this._hasMaskedPath = false;
		this._frameId = -1;
		this._textData = textData;
		this._renderType = renderType;
	    this._elem = elem;
		this._animatorsData = createSizedArray(this._textData.a.length);
		this._pathData = {};
		this._moreOptions = {
			alignment: {}
		};
		this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);
	
	}
	
	TextAnimatorProperty.prototype.searchProperties = function(){
	    var i, len = this._textData.a.length, animatorProps;
	    var getProp = PropertyFactory.getProp;
	    for(i=0;i<len;i+=1){
	        animatorProps = this._textData.a[i];
	        this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }
	    if(this._textData.p && 'm' in this._textData.p){
	        this._pathData = {
	            f: getProp(this._elem,this._textData.p.f,0,0,this),
	            l: getProp(this._elem,this._textData.p.l,0,0,this),
	            r: this._textData.p.r,
	            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	        };
	        this._hasMaskedPath = true;
	    } else {
	        this._hasMaskedPath = false;
	    }
	    this._moreOptions.alignment = getProp(this._elem,this._textData.m.a,1,0,this);
	};
	
	TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag){
	    this.lettersChangedFlag = lettersChangedFlag;
	    if(!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	        return;
	    }
	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var data = this.data;
	    var xPos,yPos;
	    var i, len;
	    var letters = documentData.l, pathInfo, currentLength, currentPoint, segmentLength, flag, pointInd, segmentInd, prevPoint, points, segments, partialLength, totalLength, perc, tanAngle, mask;
	    if(this._hasMaskedPath) {
	        mask = this._pathData.m;
	        if(!this._pathData.n || this._pathData._mdf){
	            var paths = mask.v;
	            if(this._pathData.r){
	                paths = paths.reverse();
	            }
	            // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
	            pathInfo = {
	                tLength: 0,
	                segments: []
	            };
	            len = paths._length - 1;
	            var pathData;
	            totalLength = 0;
	            for (i = 0; i < len; i += 1) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[i + 1],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            i = len;
	            if (mask.v.c) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[0],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            this._pathData.pi = pathInfo;
	        }
	        pathInfo = this._pathData.pi;
	
	        currentLength = this._pathData.f.v;
	        segmentInd = 0;
	        pointInd = 1;
	        segmentLength = 0;
	        flag = true;
	        segments = pathInfo.segments;
	        if (currentLength < 0 && mask.v.c) {
	            if (pathInfo.tLength < Math.abs(currentLength)) {
	                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	            }
	            segmentInd = segments.length - 1;
	            points = segments[segmentInd].bezierData.points;
	            pointInd = points.length - 1;
	            while (currentLength < 0) {
	                currentLength += points[pointInd].partialLength;
	                pointInd -= 1;
	                if (pointInd < 0) {
	                    segmentInd -= 1;
	                    points = segments[segmentInd].bezierData.points;
	                    pointInd = points.length - 1;
	                }
	            }
	
	        }
	        points = segments[segmentInd].bezierData.points;
	        prevPoint = points[pointInd - 1];
	        currentPoint = points[pointInd];
	        partialLength = currentPoint.partialLength;
	    }
	
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps, animatorSelector;
	    var j, jLen;
	    var letterValue;
	
	    jLen = animators.length;
	    var lastLetter;
	
	    var mult, ind = -1, offf, xPathPos, yPathPos;
	    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
	    var elemOpacity;
	    var sc,sw,fc,k;
	    var lineLength = 0;
	    var letterSw, letterSc, letterFc, letterM = '', letterP = this.defaultPropsArray, letterO;
	
	    //
	    if(documentData.j === 2 || documentData.j === 1) {
	        var animatorJustifyOffset = 0;
	        var animatorFirstCharOffset = 0;
	        var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	        var lastIndex = 0;
	        var isNewLine = true;
	
	        for (i = 0; i < len; i += 1) {
	            if (letters[i].n) {
	                if(animatorJustifyOffset) {
	                    animatorJustifyOffset += animatorFirstCharOffset;
	                }
	                while (lastIndex < i) {
	                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	                    lastIndex += 1;
	                }
	                animatorJustifyOffset = 0;
	                isNewLine = true;
	            } else {
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.t.propType) {
	                        if (isNewLine && documentData.j === 2) {
	                            animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	                        }
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	                        if (mult.length) {
	                            animatorJustifyOffset += animatorProps.t.v*mult[0] * justifyOffsetMult;
	                        } else {
	                            animatorJustifyOffset += animatorProps.t.v*mult * justifyOffsetMult;
	                        }
	                    }
	                }
	                isNewLine = false;
	            }
	        }
	        if(animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	        }
	        while(lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	        }
	    }
	    //
	
	    for( i = 0; i < len; i += 1) {
	
	        matrixHelper.reset();
	        elemOpacity = 1;
	        if(letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            currentLength = initPathPos ;
	            firstLine = false;
	            lineLength = 0;
	            if(this._hasMaskedPath) {
	                segmentInd = initSegmentInd;
	                pointInd = initPointInd;
	                points = segments[segmentInd].bezierData.points;
	                prevPoint = points[pointInd - 1];
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	                segmentLength = 0;
	            }
	            letterO = letterSw = letterFc = letterM = '';
	            letterP = this.defaultPropsArray;
	        }else{
	            if(this._hasMaskedPath) {
	                if(currentLine !== letters[i].line){
	                    switch(documentData.j){
	                        case 1:
	                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                            break;
	                        case 2:
	                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
	                            break;
	                    }
	                    currentLine = letters[i].line;
	                }
	                if (ind !== letters[i].ind) {
	                    if (letters[ind]) {
	                        currentLength += letters[ind].extra;
	                    }
	                    currentLength += letters[i].an / 2;
	                    ind = letters[i].ind;
	                }
	                currentLength += alignment[0] * letters[i].an / 200;
	                var animatorOffset = 0;
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.p.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.p.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.p.v[0] * mult;
	                        }
	
	                    }
	                    if (animatorProps.a.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.a.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.a.v[0] * mult;
	                        }
	
	                    }
	                }
	                flag = true;
	                while (flag) {
	                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	                        matrixHelper.translate(-alignment[0]*letters[i].an/200, -(alignment[1] * yOff / 100));
	                        flag = false;
	                    } else if (points) {
	                        segmentLength += currentPoint.partialLength;
	                        pointInd += 1;
	                        if (pointInd >= points.length) {
	                            pointInd = 0;
	                            segmentInd += 1;
	                            if (!segments[segmentInd]) {
	                                if (mask.v.c) {
	                                    pointInd = 0;
	                                    segmentInd = 0;
	                                    points = segments[segmentInd].bezierData.points;
	                                } else {
	                                    segmentLength -= currentPoint.partialLength;
	                                    points = null;
	                                }
	                            } else {
	                                points = segments[segmentInd].bezierData.points;
	                            }
	                        }
	                        if (points) {
	                            prevPoint = currentPoint;
	                            currentPoint = points[pointInd];
	                            partialLength = currentPoint.partialLength;
	                        }
	                    }
	                }
	                offf = letters[i].an / 2 - letters[i].add;
	                matrixHelper.translate(-offf, 0, 0);
	            } else {
	                offf = letters[i].an/2 - letters[i].add;
	                matrixHelper.translate(-offf,0,0);
	
	                // Grouping alignment
	                matrixHelper.translate(-alignment[0]*letters[i].an/200, -alignment[1]*yOff/100, 0);
	            }
	
	            lineLength += letters[i].l/2;
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.t.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    //This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
	                    if(xPos !== 0 || documentData.j !== 0) {
	                        if(this._hasMaskedPath) {
	                            if(mult.length) {
	                                currentLength += animatorProps.t.v*mult[0];
	                            } else {
	                                currentLength += animatorProps.t.v*mult;
	                            }
	                        }else{
	                            if(mult.length) {
	                                xPos += animatorProps.t.v*mult[0];
	                            } else {
	                                xPos += animatorProps.t.v*mult;
	                            }
	                        }
	                    }
	                }
	            }
	            lineLength += letters[i].l/2;
	            if(documentData.strokeWidthAnim) {
	                sw = documentData.sw || 0;
	            }
	            if(documentData.strokeColorAnim) {
	                if(documentData.sc){
	                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	                }else{
	                    sc = [0,0,0];
	                }
	            }
	            if(documentData.fillColorAnim && documentData.fc) {
	                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.a.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	
	                    if(mult.length){
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
	                    } else {
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.s.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(mult.length){
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
	                    } else {
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1) {
	                animatorProps = animators[j].a;
	                animatorSelector = animators[j].s;
	                mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                if (animatorProps.sk.propType) {
	                    if(mult.length) {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	                    } else {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	                    }
	                }
	                if (animatorProps.r.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	                    } else {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
	                    }
	                }
	                if (animatorProps.ry.propType) {
	
	                    if(mult.length) {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
	                    }else{
	                        matrixHelper.rotateY(animatorProps.ry.v*mult);
	                    }
	                }
	                if (animatorProps.rx.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
	                    } else {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult);
	                    }
	                }
	                if (animatorProps.o.propType) {
	                    if(mult.length) {
	                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
	                    } else {
	                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
	                    }
	                }
	                if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	                    if(mult.length) {
	                        sw += animatorProps.sw.v*mult[0];
	                    } else {
	                        sw += animatorProps.sw.v*mult;
	                    }
	                }
	                if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	                    for(k=0;k<3;k+=1){
	                        if(mult.length) {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0];
	                        } else {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult;
	                        }
	                    }
	                }
	                if (documentData.fillColorAnim && documentData.fc) {
	                    if(animatorProps.fc.propType){
	                        for(k=0;k<3;k+=1){
	                            if(mult.length) {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
	                            } else {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
	                            }
	                        }
	                    }
	                    if(animatorProps.fh.propType){
	                        if(mult.length) {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
	                        } else {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
	                        }
	                    }
	                    if(animatorProps.fs.propType){
	                        if(mult.length) {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
	                        } else {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
	                        }
	                    }
	                    if(animatorProps.fb.propType){
	                        if(mult.length) {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
	                        } else {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
	                        }
	                    }
	                }
	            }
	
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	
	                if (animatorProps.p.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	                        } else {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }else{
	                        if(mult.length) {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	                        } else {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        
	                        }
	                    }
	                }
	            }
	            if(documentData.strokeWidthAnim){
	                letterSw = sw < 0 ? 0 : sw;
	            }
	            if(documentData.strokeColorAnim){
	                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
	            }
	            if(documentData.fillColorAnim && documentData.fc){
	                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
	            }
	
	            if(this._hasMaskedPath) {
	                matrixHelper.translate(0,-documentData.ls);
	
	                matrixHelper.translate(0, alignment[1]*yOff/100 + yPos,0);
	                if (textData.p.p) {
	                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
	                    if (currentPoint.point[0] < prevPoint.point[0]) {
	                        rot += 180;
	                    }
	                    matrixHelper.rotate(-rot * Math.PI / 180);
	                }
	                matrixHelper.translate(xPathPos, yPathPos, 0);
	                currentLength -= alignment[0]*letters[i].an/200;
	                if(letters[i+1] && ind !== letters[i+1].ind){
	                    currentLength += letters[i].an / 2;
	                    currentLength += documentData.tr/1000*documentData.finalSize;
	                }
	            }else{
	
	                matrixHelper.translate(xPos,yPos,0);
	
	                if(documentData.ps){
	                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(0,-documentData.ls);
	                matrixHelper.translate(offf,0,0);
	                matrixHelper.translate(alignment[0]*letters[i].an/200,alignment[1]*yOff/100,0);
	                xPos += letters[i].l + documentData.tr/1000*documentData.finalSize;
	            }
	            if(renderType === 'html'){
	                letterM = matrixHelper.toCSS();
	            }else if(renderType === 'svg'){
	                letterM = matrixHelper.to2dCSS();
	            }else{
	                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
	            }
	            letterO = elemOpacity;
	        }
	
	        if(renderedLettersCount <= i) {
	            letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
	            this.renderedLetters.push(letterValue);
	            renderedLettersCount += 1;
	            this.lettersChangedFlag = true;
	        } else {
	            letterValue = this.renderedLetters[i];
	            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	        }
	    }
	};
	
	TextAnimatorProperty.prototype.getValue = function(){
		if(this._elem.globalData.frameId === this._frameId){
	        return;
	    }
	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};
	
	TextAnimatorProperty.prototype.mHelper = new Matrix();
	TextAnimatorProperty.prototype.defaultPropsArray = [];
	extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
	function TextAnimatorDataProperty(elem, animatorProps, container) {
		var defaultData = {propType:false};
		var getProp = PropertyFactory.getProp;
		var textAnimator_animatables = animatorProps.a;
		this.a = {
			r: textAnimator_animatables.r ? getProp(elem, textAnimator_animatables.r, 0, degToRads, container) : defaultData,
			rx: textAnimator_animatables.rx ? getProp(elem, textAnimator_animatables.rx, 0, degToRads, container) : defaultData,
			ry: textAnimator_animatables.ry ? getProp(elem, textAnimator_animatables.ry, 0, degToRads, container) : defaultData,
			sk: textAnimator_animatables.sk ? getProp(elem, textAnimator_animatables.sk, 0, degToRads, container) : defaultData,
			sa: textAnimator_animatables.sa ? getProp(elem, textAnimator_animatables.sa, 0, degToRads, container) : defaultData,
			s: textAnimator_animatables.s ? getProp(elem, textAnimator_animatables.s, 1, 0.01, container) : defaultData,
			a: textAnimator_animatables.a ? getProp(elem, textAnimator_animatables.a, 1, 0, container) : defaultData,
			o: textAnimator_animatables.o ? getProp(elem, textAnimator_animatables.o, 0, 0.01, container) : defaultData,
			p: textAnimator_animatables.p ? getProp(elem,textAnimator_animatables.p, 1, 0, container) : defaultData,
			sw: textAnimator_animatables.sw ? getProp(elem, textAnimator_animatables.sw, 0, 0, container) : defaultData,
			sc: textAnimator_animatables.sc ? getProp(elem, textAnimator_animatables.sc, 1, 0, container) : defaultData,
			fc: textAnimator_animatables.fc ? getProp(elem, textAnimator_animatables.fc, 1, 0, container) : defaultData,
			fh: textAnimator_animatables.fh ? getProp(elem, textAnimator_animatables.fh, 0, 0, container) : defaultData,
			fs: textAnimator_animatables.fs ? getProp(elem, textAnimator_animatables.fs, 0, 0.01, container) : defaultData,
			fb: textAnimator_animatables.fb ? getProp(elem, textAnimator_animatables.fb, 0, 0.01, container) : defaultData,
			t: textAnimator_animatables.t ? getProp(elem, textAnimator_animatables.t, 0, 0, container) : defaultData
		};
	
		this.s = TextSelectorProp.getTextSelectorProp(elem,animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	}
	function LetterProps(o, sw, sc, fc, m, p){
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	    	o: true,
	    	sw: !!sw,
	    	sc: !!sc,
	    	fc: !!fc,
	    	m: true,
	    	p: true
	    };
	}
	
	LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
		this._mdf.o = false;
		this._mdf.sw = false;
		this._mdf.sc = false;
		this._mdf.fc = false;
		this._mdf.m = false;
		this._mdf.p = false;
		var updated = false;
	
		if(this.o !== o) {
			this.o = o;
			this._mdf.o = true;
			updated = true;
		}
		if(this.sw !== sw) {
			this.sw = sw;
			this._mdf.sw = true;
			updated = true;
		}
		if(this.sc !== sc) {
			this.sc = sc;
			this._mdf.sc = true;
			updated = true;
		}
		if(this.fc !== fc) {
			this.fc = fc;
			this._mdf.fc = true;
			updated = true;
		}
		if(this.m !== m) {
			this.m = m;
			this._mdf.m = true;
			updated = true;
		}
		if(p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
			this.p = p;
			this._mdf.p = true;
			updated = true;
		}
		return updated;
	};
	function TextProperty(elem, data){
		this._frameId = initialDefaultFrame;
		this.pv = '';
		this.v = '';
		this.kf = false;
		this._isFirstFrame = true;
		this._mdf = false;
		this.data = data;
		this.elem = elem;
	    this.comp = this.elem.comp;
		this.keysIndex = -1;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
		this.currentData = {
			ascent: 0,
	        boxWidth: this.defaultBoxWidth,
	        f: '',
	        fStyle: '',
	        fWeight: '',
	        fc: '',
	        j: '',
	        justifyOffset: '',
	        l: [],
	        lh: 0,
	        lineWidths: [],
	        ls: '',
	        of: '',
	        s: '',
	        sc: '',
	        sw: 0,
	        t: 0,
	        tr: 0,
	        sz:0,
	        ps:null,
	        fillColorAnim: false,
	        strokeColorAnim: false,
	        strokeWidthAnim: false,
	        yOffset: 0,
	        finalSize:0,
	        finalText:[],
	        finalLineHeight: 0,
	        __test: true
	
		};
	    this.copyFromDocumentData(this.data.d.k[0].s);
	    
	    if(!this.searchProperty()) {
	        this.completeTextData(this.currentData);
	        this.keysIndex = 0;
	    }
	}
	
	TextProperty.prototype.defaultBoxWidth = [0,0];
	
	TextProperty.prototype.copyFromDocumentData = function(data) {
	    for(var s in data) {
	        this.currentData[s] = data[s];
	    }
	}
	
	TextProperty.prototype.setCurrentData = function(data, currentTextValue){
	        if(this.currentData !== data) {
	            if(!data.__complete) {
	                this.completeTextData(data);
	            }
	            this.copyFromDocumentData(data);
	            this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	            this.currentData.fillColorAnim = data.fillColorAnim || this.currentData.fillColorAnim;
	            this.currentData.strokeColorAnim = data.strokeColorAnim || this.currentData.strokeColorAnim;
	            this.currentData.strokeWidthAnim = data.strokeWidthAnim || this.currentData.strokeWidthAnim;
	            this._mdf = true;
	        } else if(currentTextValue !== this.currentData.t) {
	            this._mdf = true;
	            this.completeTextData(data);
	        }
			/*var currentData = this.currentData;
	        currentData.ascent = data.ascent;
	        currentData.boxWidth = data.boxWidth ? data.boxWidth : currentData.boxWidth;
	        currentData.f = data.f;
	        currentData.fStyle = data.fStyle;
	        currentData.fWeight = data.fWeight;
	        currentData.fc = data.fc;
	        currentData.j = data.j;
	        currentData.justifyOffset = data.justifyOffset;
	        currentData.l = data.l;
	        currentData.lh = data.lh;
	        currentData.lineWidths = data.lineWidths;
	        currentData.ls = data.ls;
	        currentData.of = data.of;
	        currentData.s = data.s;
	        currentData.sc = data.sc;
	        currentData.sw = data.sw;
	        currentData.sz = data.sz;
	        currentData.ps = data.ps;
	        currentData.t = data.t;
	        currentData.tr = data.tr;
	        currentData.fillColorAnim = data.fillColorAnim || currentData.fillColorAnim;
	        currentData.strokeColorAnim = data.strokeColorAnim || currentData.strokeColorAnim;
	        currentData.strokeWidthAnim = data.strokeWidthAnim || currentData.strokeWidthAnim;
	        currentData.yOffset = data.yOffset;
	        currentData.finalSize = data.finalSize;
	        currentData.finalLineHeight = data.finalLineHeight;
	        currentData.finalText = data.finalText;*/
	};
	
	TextProperty.prototype.searchProperty = function() {
	    return this.searchKeyframes();
	};
	
	TextProperty.prototype.searchKeyframes = function() {
	    this.kf = this.data.d.k.length > 1;
	    if(this.kf) {
	        this.addEffect(this.getKeyframeValue.bind(this));
	    }
	    return this.kf;
	}
	
	TextProperty.prototype.addEffect = function(effectFunction) {
		this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	};
	
	TextProperty.prototype.getValue = function(_finalValue) {
	    if((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	        return;
	    }
	    var currentTextValue = this.currentData.t;        
	    if(this.lock) {
	        this.setCurrentData(this.currentData, currentTextValue);
	        return;
	    }
	    this.lock = true;
	    this._mdf = false;
	    var multipliedValue;
	    var i, len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.currentData;
	    for(i = 0; i < len; i += 1) {
	        finalValue = this.effectsSequence[i](finalValue);
	    }
	    this.setCurrentData(finalValue, currentTextValue);
	    this.pv = this.v = this.currentData;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	}
	
	TextProperty.prototype.getKeyframeValue = function(currentValue) {
	    var textKeys = this.data.d.k, textDocumentData;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0, len = textKeys.length;
	    while(i <= len - 1) {
	        textDocumentData = textKeys[i].s;
	        if(i === len - 1 || textKeys[i+1].t > frameNum){
	            break;
	        }
	        i += 1;
	    }
	    if(this.keysIndex !== i) {
	        currentValue = textDocumentData;
	        this.keysIndex = i;
	    }
	    return currentValue;
	};
	
	TextProperty.prototype.buildFinalText = function(text) {
	    var combinedCharacters = FontManager.getCombinedCharacterCodes();
	    var charactersArray = [];
	    var i = 0, len = text.length;
	    while (i < len) {
	        if (combinedCharacters.indexOf(text.charCodeAt(i)) !== -1) {
	            charactersArray[charactersArray.length - 1] += text.charAt(i);
	        } else {
	            charactersArray.push(text.charAt(i));
	        }
	        i += 1;
	    }
	    return charactersArray;
	}
	
	TextProperty.prototype.completeTextData = function(documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i, len;
	    var newLineFlag, index = 0, val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j, jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData, cLength = 0;
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
	
	    var fWeight = 'normal', fStyle = 'normal';
	    len = styles.length;
	    var styleName;
	    for(i=0;i<len;i+=1){
	        styleName = styles[i].toLowerCase();
	        switch(styleName) {
	            case 'italic':
	            fStyle = 'italic';
	            break;
	            case 'bold':
	            fWeight = '700';
	            break;
	            case 'black':
	            fWeight = '900';
	            break;
	            case 'medium':
	            fWeight = '500';
	            break;
	            case 'regular':
	            case 'normal':
	            fWeight = '400';
	            break;
	            case 'light':
	            case 'thin':
	            fWeight = '200';
	            break;
	        }
	    }
	    documentData.fWeight = fontData.fWeight || fWeight;
	    documentData.fStyle = fStyle;
	    len = documentData.t.length;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    if(documentData.sz){
	        var flag = true;
	        var boxWidth = documentData.sz[0];
	        var boxHeight = documentData.sz[1];
	        var currentHeight, finalText;
	        while(flag) {
	            finalText = this.buildFinalText(documentData.t);
	            currentHeight = 0;
	            lineWidth = 0;
	            len = finalText.length;
	            trackingOffset = documentData.tr/1000*documentData.finalSize;
	            var lastSpaceIndex = -1;
	            for(i=0;i<len;i+=1){
	                newLineFlag = false;
	                if(finalText[i] === ' '){
	                    lastSpaceIndex = i;
	                }else if(finalText[i].charCodeAt(0) === 13){
	                    lineWidth = 0;
	                    newLineFlag = true;
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                }
	                if(fontManager.chars){
	                    charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	                    cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	                }else{
	                    //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	                }
	                if(lineWidth + cLength > boxWidth && finalText[i] !== ' '){
	                    if(lastSpaceIndex === -1){
	                        len += 1;
	                    } else {
	                        i = lastSpaceIndex;
	                    }
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                    finalText.splice(i, lastSpaceIndex === i ? 1 : 0,"\r");
	                    //finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
	                    lastSpaceIndex = -1;
	                    lineWidth = 0;
	                }else {
	                    lineWidth += cLength;
	                    lineWidth += trackingOffset;
	                }
	            }
	            currentHeight += fontData.ascent*documentData.finalSize/100;
	            if(this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	                documentData.finalSize -= 1;
	                documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	            } else {
	                documentData.finalText = finalText;
	                len = documentData.finalText.length;
	                flag = false;
	            }
	        }
	
	    }
	    lineWidth = - trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	    for (i = 0;i < len ;i += 1) {
	        newLineFlag = false;
	        currentChar = documentData.finalText[i];
	        if(currentChar === ' '){
	            val = '\u00A0';
	        }else if(currentChar.charCodeAt(0) === 13){
	            uncollapsedSpaces = 0;
	            lineWidths.push(lineWidth);
	            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	            lineWidth = - 2 * trackingOffset;
	            val = '';
	            newLineFlag = true;
	            currentLine += 1;
	        }else{
	            val = documentData.finalText[i];
	        }
	        if(fontManager.chars){
	            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	            cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	        }else{
	            //var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	            //tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        }
	
	        //
	        if(currentChar === ' '){
	            uncollapsedSpaces += cLength + trackingOffset;
	        } else {
	            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	            uncollapsedSpaces = 0;
	        }
	        letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine, animatorJustifyOffset: 0});
	        if(anchorGrouping == 2){
	            currentSize += cLength;
	            if(val === '' || val === '\u00A0' || i === len - 1){
	                if(val === '' || val === '\u00A0'){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                index += 1;
	                currentSize = 0;
	            }
	        }else if(anchorGrouping == 3){
	            currentSize += cLength;
	            if(val === '' || i === len - 1){
	                if(val === ''){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                currentSize = 0;
	                index += 1;
	            }
	        }else{
	            letters[index].ind = index;
	            letters[index].extra = 0;
	            index += 1;
	        }
	    }
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	    if(documentData.sz){
	        documentData.boxWidth = documentData.sz[0];
	        documentData.justifyOffset = 0;
	    }else{
	        documentData.boxWidth = maxLineWidth;
	        switch(documentData.j){
	            case 1:
	                documentData.justifyOffset = - documentData.boxWidth;
	                break;
	            case 2:
	                documentData.justifyOffset = - documentData.boxWidth/2;
	                break;
	            default:
	                documentData.justifyOffset = 0;
	        }
	    }
	    documentData.lineWidths = lineWidths;
	
	    var animators = data.a, animatorData, letterData;
	    jLen = animators.length;
	    var based, ind, indexes = [];
	    for(j=0;j<jLen;j+=1){
	        animatorData = animators[j];
	        if(animatorData.a.sc){
	            documentData.strokeColorAnim = true;
	        }
	        if(animatorData.a.sw){
	            documentData.strokeWidthAnim = true;
	        }
	        if(animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb){
	            documentData.fillColorAnim = true;
	        }
	        ind = 0;
	        based = animatorData.s.b;
	        for(i=0;i<len;i+=1){
	            letterData = letters[i];
	            letterData.anIndexes[j] = ind;
	            if((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== '\u00A0') || (based == 3 && (letterData.n || letterData.val == '\u00A0' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))){
	                if(animatorData.s.rn === 1){
	                    indexes.push(ind);
	                }
	                ind += 1;
	            }
	        }
	        data.a[j].s.totalChars = ind;
	        var currentInd = -1, newInd;
	        if(animatorData.s.rn === 1){
	            for(i = 0; i < len; i += 1){
	                letterData = letters[i];
	                if(currentInd != letterData.anIndexes[j]){
	                    currentInd = letterData.anIndexes[j];
	                    newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
	                }
	                letterData.anIndexes[j] = newInd;
	            }
	        }
	    }
	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize*1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent*documentData.finalSize/100;
	};
	
	TextProperty.prototype.updateDocumentData = function(newData, index) {
		index = index === undefined 
	    ? this.keysIndex === -1 
	        ? 0 
	        : this.keysIndex 
	    : index;
	    var dData = this.data.d.k[index].s;
	    for(var s in newData) {
	        dData[s] = newData[s];
	    }
	    this.recalculate(index);
	};
	
	TextProperty.prototype.recalculate = function(index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = this.kf ? -1 : 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	}
	
	TextProperty.prototype.canResizeFont = function(_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	};
	
	TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	};
	
	var TextSelectorProp = (function(){
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;
	
	    function TextSelectorProp(elem,data){
	        this._currentTextLength = -1;
	        this.k = false;
	        this.data = data;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.finalS = 0;
	        this.finalE = 0;
	        this.initDynamicPropertyContainer(elem);
	        this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this);
	        if('e' in data){
	            this.e = PropertyFactory.getProp(elem,data.e,0,0,this);
	        }else{
	            this.e = {v:100};
	        }
	        this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this);
	        this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this);
	        this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this);
	        this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this);
	        if(!this.dynamicProperties.length){
	            this.getValue();
	        }
	    }
	
	    TextSelectorProp.prototype = {
	        getMult: function(ind) {
	            if(this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	                this.getValue();
	            }
	            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
	            var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
	            var mult = 0;
	            var s = this.finalS;
	            var e = this.finalE;
	            var type = this.data.sh;
	            if(type == 2){
	                if(e === s){
	                    mult = ind >= e ? 1 : 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	                mult = easer(mult);
	            }else if(type == 3){
	                if(e === s){
	                    mult = ind >= e ? 0 : 1;
	                }else{
	                    mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	
	                mult = easer(mult);
	            }else if(type == 4){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                    if(mult<0.5){
	                        mult *= 2;
	                    }else{
	                        mult = 1 - 2*(mult-0.5);
	                    }
	                }
	                mult = easer(mult);
	            }else if(type == 5){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    var tot = e - s;
	                    /*ind += 0.5;
	                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    var x = -tot/2+ind;
	                    var a = tot/2;
	                    mult = Math.sqrt(1 - (x*x)/(a*a));
	                }
	                mult = easer(mult);
	            }else if(type == 6){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
	                    /*
	                     ind = Math.min(Math.max(s,ind),e-1);
	                     mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
	                     mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
	                }
	                mult = easer(mult);
	            }else {
	                if(ind >= floor(s)){
	                    if(ind-s < 0){
	                        mult = 1 - (s - ind);
	                    }else{
	                        mult = max(0,min(e-ind,1));
	                    }
	                }
	                mult = easer(mult);
	            }
	            return mult*this.a.v;
	        },
	        getValue: function(newCharsFlag) {
	            this.iterateDynamicProperties();
	            this._mdf = newCharsFlag || this._mdf;
	            this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
	            if(newCharsFlag && this.data.r === 2) {
	                this.e.v = this._currentTextLength;
	            }
	            var divisor = this.data.r === 2 ? 1 : 100 / this._currentTextLength;
	            var o = this.o.v/divisor;
	            var s = this.s.v/divisor + o;
	            var e = (this.e.v/divisor) + o;
	            if(s>e){
	                var _s = s;
	                s = e;
	                e = _s;
	            }
	            this.finalS = s;
	            this.finalE = e;
	        }
	    }
	    extendPrototype([DynamicPropertyContainer], TextSelectorProp);
	
	    function getTextSelectorProp(elem, data,arr) {
	        return new TextSelectorProp(elem, data, arr);
	    }
	
	    return {
	        getTextSelectorProp: getTextSelectorProp
	    };
	}());
	
	    
	var pool_factory = (function() {
		return function(initialLength, _create, _release, _clone) {
	
			var _length = 0;
			var _maxLength = initialLength;
			var pool = createSizedArray(_maxLength);
	
			var ob = {
				newElement: newElement,
				release: release
			};
	
			function newElement(){
				var element;
				if(_length){
					_length -= 1;
					element = pool[_length];
				} else {
					element = _create();
				}
				return element;
			}
	
			function release(element) {
				if(_length === _maxLength) {
					pool = pooling.double(pool);
					_maxLength = _maxLength*2;
				}
				if (_release) {
					_release(element);
				}
				pool[_length] = element;
				_length += 1;
			}
	
			function clone() {
				var clonedElement = newElement();
				return _clone(clonedElement);
			}
	
			return ob;
		};
	}());
	
	var pooling = (function(){
	
		function double(arr){
			return arr.concat(createSizedArray(arr.length));
		}
	
		return {
			double: double
		};
	}());
	var point_pool = (function(){
	
		function create() {
			return createTypedArray('float32', 2);
		}
		return pool_factory(8, create);
	}());
	var shape_pool = (function(){
	
		function create() {
			return new ShapePath();
		}
	
		function release(shapePath) {
			var len = shapePath._length, i;
			for(i = 0; i < len; i += 1) {
				point_pool.release(shapePath.v[i]);
				point_pool.release(shapePath.i[i]);
				point_pool.release(shapePath.o[i]);
				shapePath.v[i] = null;
				shapePath.i[i] = null;
				shapePath.o[i] = null;
			}
			shapePath._length = 0;
			shapePath.c = false;
		}
	
		function clone(shape) {
			var cloned = factory.newElement();
			var i, len = shape._length === undefined ? shape.v.length : shape._length;
			cloned.setLength(len);
			cloned.c = shape.c;
			var pt;
			
			for(i = 0; i < len; i += 1) {
				cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
			}
			return cloned;
		}
	
		var factory = pool_factory(4, create, release);
		factory.clone = clone;
	
		return factory;
	}());
	var shapeCollection_pool = (function(){
		var ob = {
			newShapeCollection: newShapeCollection,
			release: release
		};
	
		var _length = 0;
		var _maxLength = 4;
		var pool = createSizedArray(_maxLength);
	
		function newShapeCollection(){
			var shapeCollection;
			if(_length){
				_length -= 1;
				shapeCollection = pool[_length];
			} else {
				shapeCollection = new ShapeCollection();
			}
			return shapeCollection;
		}
	
		function release(shapeCollection) {
			var i, len = shapeCollection._length;
			for(i = 0; i < len; i += 1) {
				shape_pool.release(shapeCollection.shapes[i]);
			}
			shapeCollection._length = 0;
	
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
		return ob;
	}());
	var segments_length_pool = (function(){
	
		function create() {
			return {
				lengths: [],
				totalLength: 0
			};
		}
	
		function release(element) {
			var i, len = element.lengths.length;
			for(i=0;i<len;i+=1) {
				bezier_length_pool.release(element.lengths[i]);
			}
			element.lengths.length = 0;
		}
	
		return pool_factory(8, create, release);
	}());
	var bezier_length_pool = (function(){
	
		function create() {
			return {
	            addedLength: 0,
	            percents: createTypedArray('float32', defaultCurveSegments),
	            lengths: createTypedArray('float32', defaultCurveSegments),
	        };
		}
		return pool_factory(8, create);
	}());
	function BaseRenderer(){}
	BaseRenderer.prototype.checkLayers = function(num){
	    var i, len = this.layers.length, data;
	    this.completeLayers = true;
	    for (i = len - 1; i >= 0; i--) {
	        if (!this.elements[i]) {
	            data = this.layers[i];
	            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
	            {
	                this.buildItem(i);
	            }
	        }
	        this.completeLayers = this.elements[i] ? this.completeLayers:false;
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.createItem = function(layer){
	    switch(layer.ty){
	        case 2:
	            return this.createImage(layer);
	        case 0:
	            return this.createComp(layer);
	        case 1:
	            return this.createSolid(layer);
	        case 3:
	            return this.createNull(layer);
	        case 4:
	            return this.createShape(layer);
	        case 5:
	            return this.createText(layer);
	        case 13:
	            return this.createCamera(layer);
	    }
	    return this.createNull(layer);
	};
	
	BaseRenderer.prototype.createCamera = function(){
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	};
	
	BaseRenderer.prototype.buildAllItems = function(){
	    var i, len = this.layers.length;
	    for(i=0;i<len;i+=1){
	        this.buildItem(i);
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.includeLayers = function(newLayers){
	    this.completeLayers = false;
	    var i, len = newLayers.length;
	    var j, jLen = this.layers.length;
	    for(i=0;i<len;i+=1){
	        j = 0;
	        while(j<jLen){
	            if(this.layers[j].id == newLayers[i].id){
	                this.layers[j] = newLayers[i];
	                break;
	            }
	            j += 1;
	        }
	    }
	};
	
	BaseRenderer.prototype.setProjectInterface = function(pInterface){
	    this.globalData.projectInterface = pInterface;
	};
	
	BaseRenderer.prototype.initItems = function(){
	    if(!this.globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	};
	BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i=0, len = layers.length;
	    while (i < len) {
	        if (layers[i].ind == parentName) {
	            if (!elements[i] || elements[i] === true) {
	                this.buildItem(i);
	                this.addPendingElement(element);
	            } else {
	                hierarchy.push(elements[i]);
	                elements[i].setAsParent();
	                if(layers[i].parent !== undefined) {
	                    this.buildElementParenting(element, layers[i].parent, hierarchy);
	                } else {
	                    element.setHierarchy(hierarchy);
	                }
	            }
	        }
	        i += 1;
	    }
	};
	
	BaseRenderer.prototype.addPendingElement = function(element){
	    this.pendingElements.push(element);
	};
	
	BaseRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i]);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function SVGRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    var defs = createNS( 'defs');
	    this.svgElement.appendChild(defs);
	    this.renderConfig = {
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
	        viewBoxOnly: (config && config.viewBoxOnly) || false,
	        viewBoxSize: (config && config.viewBoxSize) || false,
	        className: (config && config.className) || ''
	    };
	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        defs: defs,
	        frameId: 0,
	        compSize: {w:0,h:0},
	        renderConfig: this.renderConfig,
	        fontManager: new FontManager()
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	
	}
	
	extendPrototype([BaseRenderer],SVGRenderer);
	
	SVGRenderer.prototype.createNull = function (data) {
	    return new NullElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createShape = function (data) {
	    return new SVGShapeElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createText = function (data) {
	    return new SVGTextElement(data,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createImage = function (data) {
	    return new IImageElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createSolid = function (data) {
	    return new ISolidElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.configAnimation = function(animData){
	    this.svgElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
	    if(this.renderConfig.viewBoxSize) {
	        this.svgElement.setAttribute('viewBox',this.renderConfig.viewBoxSize);
	    } else {
	        this.svgElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
	    }
	
	    if(!this.renderConfig.viewBoxOnly) {
	        this.svgElement.setAttribute('width',animData.w);
	        this.svgElement.setAttribute('height',animData.h);
	        this.svgElement.style.width = '100%';
	        this.svgElement.style.height = '100%';
	        this.svgElement.style.transform = 'translate3d(0,0,0)';
	    }
	    if(this.renderConfig.className) {
	        this.svgElement.setAttribute('class', this.renderConfig.className);
	    }
	    this.svgElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
	    //this.layerElement.style.transform = 'translate3d(0,0,0)';
	    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	    this.animationItem.wrapper.appendChild(this.svgElement);
	    //Mask animation
	    var defs = this.globalData.defs;
	
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize.w = animData.w;
	    this.globalData.compSize.h = animData.h;
	    this.globalData.frameRate = animData.fr;
	    this.data = animData;
	
	    var maskElement = createNS( 'clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width',animData.w);
	    rect.setAttribute('height',animData.h);
	    rect.setAttribute('x',0);
	    rect.setAttribute('y',0);
	    var maskId = 'animationMask_'+randomString(10);
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute("clip-path", "url(" + locationHref + "#"+maskId+")");
	
	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,defs);
	    this.elements = createSizedArray(animData.layers.length);
	};
	
	
	SVGRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	SVGRenderer.prototype.updateContainerSize = function () {
	};
	
	SVGRenderer.prototype.buildItem  = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	
	    elements[pos] = element;
	    if(expressionsPlugin){
	        if(this.layers[pos].ty === 0){
	            this.globalData.projectInterface.registerComposition(element);
	        }
	        element.initExpressions();
	    }
	    this.appendElementInPos(element,pos);
	    if(this.layers[pos].tt){
	        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
	            this.buildItem(pos - 1);
	            this.addPendingElement(element);
	        } else {
	            element.setMatte(elements[pos - 1].layerId);
	        }
	    }
	};
	
	SVGRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	        if(element.data.tt){
	            var i = 0, len = this.elements.length;
	            while(i<len){
	                if(this.elements[i] === element){
	                    element.setMatte(this.elements[i - 1].layerId);
	                    break;
	                }
	                i += 1;
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.renderFrame = function(num){
	    if(this.renderedFrame === num || this.destroyed){
	        return;
	    }
	    if(num === null){
	        num = this.renderedFrame;
	    }else{
	        this.renderedFrame = num;
	    }
	    // console.log('-------');
	    // console.log('FRAME ',num);
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        for (i = 0; i < len; i += 1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var i = 0;
	    var nextElement;
	    while(i<pos){
	        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
	            nextElement = this.elements[i].getBaseElement();
	        }
	        i += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	        this.layerElement.appendChild(newElement);
	    }
	};
	
	SVGRenderer.prototype.hide = function(){
	    this.layerElement.style.display = 'none';
	};
	
	SVGRenderer.prototype.show = function(){
	    this.layerElement.style.display = 'block';
	};
	
	function MaskElement(data,element,globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i, len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';
	
	
	    var path, properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j, jLen;
	    var layerId = randomString(10);
	    var rect, expansor, feMorph,x;
	    var maskType = 'clipPath', maskRef = 'clip-path';
	    for (i = 0; i < len; i++) {
	
	        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
	            maskType = 'mask';
	            maskRef = 'mask';
	        }
	
	        if((properties[i].mode == 's' || properties[i].mode == 'i') && count === 0){
	            rect = createNS( 'rect');
	            rect.setAttribute('fill', '#ffffff');
	            rect.setAttribute('width', this.element.comp.data.w);
	            rect.setAttribute('height', this.element.comp.data.h);
	            currentMasks.push(rect);
	        } else {
	            rect = null;
	        }
	
	        path = createNS( 'path');
	        if(properties[i].mode == 'n') {
	            // TODO move this to a factory or to a constructor
	            this.viewData[i] = {
	                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	                elem: path,
	                lastPath: ''
	            };
	            defs.appendChild(path);
	            continue;
	        }
	        count += 1;
	
	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000':'#ffffff');
	        path.setAttribute('clip-rule','nonzero');
	        var filterID;
	
	        if (properties[i].x.k !== 0) {
	            maskType = 'mask';
	            maskRef = 'mask';
	            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.element);
	            filterID = 'fi_'+randomString(10);
	            expansor = createNS('filter');
	            expansor.setAttribute('id',filterID);
	            feMorph = createNS('feMorphology');
	            feMorph.setAttribute('operator','dilate');
	            feMorph.setAttribute('in','SourceGraphic');
	            feMorph.setAttribute('radius','0');
	            expansor.appendChild(feMorph);
	            defs.appendChild(expansor);
	            path.setAttribute('stroke', properties[i].mode === 's' ? '#000000':'#ffffff');
	        } else {
	            feMorph = null;
	            x = null;
	        }
	
	        // TODO move this to a factory or to a constructor
	        this.storedData[i] = {
	             elem: path,
	             x: x,
	             expan: feMorph,
	            lastPath: '',
	            lastOperator:'',
	            filterId:filterID,
	            lastRadius:0
	        };
	        if(properties[i].mode == 'i'){
	            jLen = currentMasks.length;
	            var g = createNS('g');
	            for(j=0;j<jLen;j+=1){
	                g.appendChild(currentMasks[j]);
	            }
	            var mask = createNS('mask');
	            mask.setAttribute('mask-type','alpha');
	            mask.setAttribute('id',layerId+'_'+count);
	            mask.appendChild(path);
	            defs.appendChild(mask);
	            g.setAttribute('mask','url(' + locationHref + '#'+layerId+'_'+count+')');
	
	            currentMasks.length = 0;
	            currentMasks.push(g);
	        }else{
	            currentMasks.push(path);
	        }
	        if(properties[i].inv && !this.solidPath){
	            this.solidPath = this.createLayerSolidPath();
	        }
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	            elem: path,
	            lastPath: '',
	            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	            invRect: rect
	        };
	        if(!this.viewData[i].prop.k){
	            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	    }
	
	    this.maskElement = createNS( maskType);
	
	    len = currentMasks.length;
	    for(i=0;i<len;i+=1){
	        this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    if(count > 0){
	        this.maskElement.setAttribute('id', layerId);
	        this.element.maskedElement.setAttribute(maskRef, "url(" + locationHref + "#" + layerId + ")");
	        defs.appendChild(this.maskElement);
	    }
	    if (this.viewData.length) {
	        this.element.addRenderableComponent(this);
	    }
	
	}
	
	MaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos].prop;
	};
	
	MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        if(this.viewData[i].prop._mdf || isFirstFrame){
	            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	        if(this.viewData[i].op._mdf || isFirstFrame){
	            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
	        }
	        if(this.masksProperties[i].mode !== 'n'){
	            if(this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)){
	                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
	                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
	            }
	            if(this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)){
	                var feMorph = this.storedData[i].expan;
	                if(this.storedData[i].x.v < 0){
	                    if(this.storedData[i].lastOperator !== 'erode'){
	                        this.storedData[i].lastOperator = 'erode';
	                        this.storedData[i].elem.setAttribute('filter','url(' + locationHref + '#'+this.storedData[i].filterId+')');
	                    }
	                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
	                }else{
	                    if(this.storedData[i].lastOperator !== 'dilate'){
	                        this.storedData[i].lastOperator = 'dilate';
	                        this.storedData[i].elem.setAttribute('filter',null);
	                    }
	                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);
	
	                }
	            }
	        }
	    }
	};
	
	MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	};
	
	MaskElement.prototype.createLayerSolidPath = function(){
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w ;
	    path += ' v' + this.globalData.compSize.h ;
	    path += ' h-' + this.globalData.compSize.w ;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	};
	
	MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
	    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    var i, len;
	    len = pathNodes._length;
	    for(i=1;i<len;i+=1){
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	    }
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    if(pathNodes.c && len > 1){
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    }
	    //pathNodes.__renderedString = pathString;
	
	
	    if(viewData.lastPath !== pathString){
	        var pathShapeValue = '';
	        if(viewData.elem){
	            if(pathNodes.c){
	                pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	            }
	            viewData.elem.setAttribute('d',pathShapeValue);
	        }
	        viewData.lastPath = pathString;
	    }
	};
	
	MaskElement.prototype.destroy = function(){
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	};
	/**
	 * @file 
	 * Handles AE's layer parenting property.
	 *
	 */
	
	function HierarchyElement(){}
	
	HierarchyElement.prototype = {
		/**
	     * @function 
	     * Initializes hierarchy properties
	     *
	     */
		initHierarchy: function() {
			//element's parent list
		    this.hierarchy = [];
		    //if element is parent of another layer _isParent will be true
		    this._isParent = false;
		    this.checkParenting();
		},
		/**
	     * @function 
	     * Sets layer's hierarchy.
	     * @param {array} hierarch
	     * layer's parent list
	     *
	     */ 
		setHierarchy: function(hierarchy){
		    this.hierarchy = hierarchy;
		},
		/**
	     * @function 
	     * Sets layer as parent.
	     *
	     */ 
		setAsParent: function() {
		    this._isParent = true;
		},
		/**
	     * @function 
	     * Searches layer's parenting chain
	     *
	     */ 
		checkParenting: function(){
		    if (this.data.parent !== undefined){
		        this.comp.buildElementParenting(this, this.data.parent, []);
		    }
		}
	};
	/**
	 * @file 
	 * Handles element's layer frame update.
	 * Checks layer in point and out point
	 *
	 */
	
	function FrameElement(){}
	
	FrameElement.prototype = {
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     */
	    initFrame: function(){
	        //set to true when inpoint is rendered
	        this._isFirstFrame = false;
	        //list of animated properties
	        this.dynamicProperties = [];
	        // If layer has been modified in current tick this will be true
	        this._mdf = false;
	    },
	    /**
	     * @function 
	     * Calculates all dynamic values
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * @param {boolean} isVisible
	     * if layers is currently in range
	     * 
	     */
	    prepareProperties: function(num, isVisible) {
	        var i, len = this.dynamicProperties.length;
	        for (i = 0;i < len; i += 1) {
	            if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
	                this.dynamicProperties[i].getValue();
	                if (this.dynamicProperties[i]._mdf) {
	                    this.globalData._mdf = true;
	                    this._mdf = true;
	                }
	            }
	        }
	    },
	    addDynamicProperty: function(prop) {
	        if(this.dynamicProperties.indexOf(prop) === -1) {
	            this.dynamicProperties.push(prop);
	        }
	    }
	};
	function TransformElement(){}
	
	TransformElement.prototype = {
	    initTransform: function() {
	        this.finalTransform = {
	            mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {o:0},
	            _matMdf: false,
	            _opMdf: false,
	            mat: new Matrix()
	        };
	        if (this.data.ao) {
	            this.finalTransform.mProp.autoOriented = true;
	        }
	
	        //TODO: check TYPE 11: Guided elements
	        if (this.data.ty !== 11) {
	            //this.createElements();
	        }
	    },
	    renderTransform: function() {
	
	        this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	        this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
	
	        if (this.hierarchy) {
	            var mat;
	            var finalMat = this.finalTransform.mat;
	            var i = 0, len = this.hierarchy.length;
	            //Checking if any of the transformation matrices in the hierarchy chain has changed.
	            if (!this.finalTransform._matMdf) {
	                while (i < len) {
	                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
	                        this.finalTransform._matMdf = true;
	                        break;
	                    }
	                    i += 1;
	                }
	            }
	            
	            if (this.finalTransform._matMdf) {
	                mat = this.finalTransform.mProp.v.props;
	                finalMat.cloneFromProps(mat);
	                for (i = 0; i < len; i += 1) {
	                    mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                    finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
	                }
	            }
	        }
	    },
	    globalToLocal: function(pt) {
	        var transforms = [];
	        transforms.push(this.finalTransform);
	        var flag = true;
	        var comp = this.comp;
	        while (flag) {
	            if (comp.finalTransform) {
	                if (comp.data.hasMask) {
	                    transforms.splice(0, 0, comp.finalTransform);
	                }
	                comp = comp.comp;
	            } else {
	                flag = false;
	            }
	        }
	        var i, len = transforms.length,ptNew;
	        for (i = 0; i < len; i += 1) {
	            ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
	            //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	            pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	        }
	        return pt;
	    },
	    mHelper: new Matrix()
	};
	function RenderableElement(){
	
	}
	
	RenderableElement.prototype = {
	    initRenderable: function() {
	        //layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	        this.isInRange = false;
	        //layer's display state
	        this.hidden = false;
	        // If layer's transparency equals 0, it can be hidden
	        this.isTransparent = false;
	        //list of animated components
	        this.renderableComponents = [];
	    },
	    addRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) === -1) {
	            this.renderableComponents.push(component);
	        }
	    },
	    removeRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) !== -1) {
	            this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	        }
	    },
	    prepareRenderableFrame: function(num) {
	        this.checkLayerLimits(num);
	    },
	    checkTransparency: function(){
	        if(this.finalTransform.mProp.o.v <= 0) {
	            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
	                this.isTransparent = true;
	                this.hide();
	            }
	        } else if(this.isTransparent) {
	            this.isTransparent = false;
	            this.show();
	        }
	    },
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * 
	     */
	    checkLayerLimits: function(num) {
	        if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
	        {
	            if(this.isInRange !== true){
	                this.globalData._mdf = true;
	                this._mdf = true;
	                this.isInRange = true;
	                this.show();
	            }
	        } else {
	            if(this.isInRange !== false){
	                this.globalData._mdf = true;
	                this.isInRange = false;
	                this.hide();
	            }
	        }
	    },
	    renderRenderable: function() {
	        var i, len = this.renderableComponents.length;
	        for(i = 0; i < len; i += 1) {
	            this.renderableComponents[i].renderFrame(this._isFirstFrame);
	        }
	        /*this.maskManager.renderFrame(this.finalTransform.mat);
	        this.renderableEffectsManager.renderFrame(this._isFirstFrame);*/
	    },
	    sourceRectAtTime: function(){
	        return {
	            top:0,
	            left:0,
	            width:100,
	            height:100
	        };
	    },
	    getLayerSize: function(){
	        if(this.data.ty === 5){
	            return {w:this.data.textData.width,h:this.data.textData.height};
	        }else{
	            return {w:this.data.width,h:this.data.height};
	        }
	    }
	};
	function RenderableDOMElement() {}
	
	(function(){
	    var _prototype = {
	        initElement: function(data,globalData,comp) {
	            this.initFrame();
	            this.initBaseData(data, globalData, comp);
	            this.initTransform(data, globalData, comp);
	            this.initHierarchy();
	            this.initRenderable();
	            this.initRendererElement();
	            this.createContainerElements();
	            this.addMasks();
	            this.createContent();
	            this.hide();
	        },
	        hide: function(){
	            if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	                var elem = this.baseElement || this.layerElement;
	                elem.style.display = 'none';
	                this.hidden = true;
	            }
	        },
	        show: function(){
	            if (this.isInRange && !this.isTransparent){
	                if (!this.data.hd) {
	                    var elem = this.baseElement || this.layerElement;
	                    elem.style.display = 'block';
	                }
	                this.hidden = false;
	                this._isFirstFrame = true;
	            }
	        },
	        renderFrame: function() {
	            //If it is exported as hidden (data.hd === true) no need to render
	            //If it is not visible no need to render
	            if (this.data.hd || this.hidden) {
	                return;
	            }
	            this.renderTransform();
	            this.renderRenderable();
	            this.renderElement();
	            this.renderInnerContent();
	            if (this._isFirstFrame) {
	                this._isFirstFrame = false;
	            }
	        },
	        renderInnerContent: function() {},
	        prepareFrame: function(num) {
	            this._mdf = false;
	            this.prepareRenderableFrame(num);
	            this.prepareProperties(num, this.isInRange);
	            this.checkTransparency();
	        },
	        destroy: function(){
	            this.innerElem =  null;
	            this.destroyBaseElement();
	        }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	}());
	function ProcessedElement(element, position) {
		this.elem = element;
		this.pos = position;
	}
	function SVGStyleData(data, level) {
		this.data = data;
		this.type = data.ty;
		this.d = '';
		this.lvl = level;
		this._mdf = false;
		this.closed = false;
		this.pElem = createNS('path');
		this.msElem = null;
	}
	
	SVGStyleData.prototype.reset = function() {
		this.d = '';
		this._mdf = false;
	};
	function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level;
	    //TODO find if there are some cases where _isAnimated can be false. 
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape
	    this._isAnimated = !!shape.k;
	    // TODO: commenting this for now since all shapes are animated
	    var i = 0, len = transformers.length;
	    while(i < len) {
	    	if(transformers[i].mProps.dynamicProperties.length) {
	    		this._isAnimated = true;
	    		break;
	    	}
	    	i += 1;
	    }
	}
	
	SVGShapeData.prototype.setAsAnimated = function() {
	    this._isAnimated = true;
	}
	function SVGTransformData(mProps, op, container) {
		this.transform = {
			mProps: mProps,
			op: op,
			container: container
		};
		this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	}
	function SVGStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	}
	
	extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
	function SVGFillStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	}
	
	extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
	function SVGGradientFillStyleData(elem, data, styleOb){
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	}
	
	SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb){
	    this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
	    this.s = PropertyFactory.getProp(elem,data.s,1,null,this);
	    this.e = PropertyFactory.getProp(elem,data.e,1,null,this);
	    this.h = PropertyFactory.getProp(elem,data.h||{k:0},0,0.01,this);
	    this.a = PropertyFactory.getProp(elem,data.a||{k:0},0,degToRads,this);
	    this.g = new GradientProperty(elem,data.g,this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	
	};
	
	SVGGradientFillStyleData.prototype.setGradientData = function(pathElement,data){
	
	    var gradientId = 'gr_'+randomString(10);
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id',gradientId);
	    gfill.setAttribute('spreadMethod','pad');
	    gfill.setAttribute('gradientUnits','userSpaceOnUse');
	    var stops = [];
	    var stop, j, jLen;
	    jLen = data.g.p*4;
	    for(j=0;j<jLen;j+=4){
	        stop = createNS('stop');
	        gfill.appendChild(stop);
	        stops.push(stop);
	    }
	    pathElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(#'+gradientId+')');
	    
	    this.gf = gfill;
	    this.cst = stops;
	};
	
	SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb){
	    if(this.g._hasOpacity && !this.g._collapsable){
	        var stop, j, jLen;
	        var mask = createNS("mask");
	        var maskElement = createNS( 'path');
	        mask.appendChild(maskElement);
	        var opacityId = 'op_'+randomString(10);
	        var maskId = 'mk_'+randomString(10);
	        mask.setAttribute('id',maskId);
	        var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	        opFill.setAttribute('id',opacityId);
	        opFill.setAttribute('spreadMethod','pad');
	        opFill.setAttribute('gradientUnits','userSpaceOnUse');
	        jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	        var stops = this.stops;
	        for(j=data.g.p*4;j<jLen;j+=2){
	            stop = createNS('stop');
	            stop.setAttribute('stop-color','rgb(255,255,255)');
	            opFill.appendChild(stop);
	            stops.push(stop);
	        }
	        maskElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(#'+opacityId+')');
	        this.of = opFill;
	        this.ms = mask;
	        this.ost = stops;
	        this.maskId = maskId;
	        styleOb.msElem = maskElement;
	    }
	};
	
	extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
	function SVGGradientStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	}
	
	extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
	function ShapeGroupData() {
		this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	}
	var SVGElementsRenderer = (function() {
		var _identityMatrix = new Matrix();
		var _matrixHelper = new Matrix();
	
		var ob = {
			createRenderFunction: createRenderFunction
		}
	
		function createRenderFunction(data) {
		    var ty = data.ty;
		    switch(data.ty) {
		        case 'fl':
		        return renderFill;
		        case 'gf':
		        return renderGradient;
		        case 'gs':
		        return renderGradientStroke;
		        case 'st':
		        return renderStroke;
		        case 'sh':
		        case 'el':
		        case 'rc':
		        case 'sr':
		        return renderPath;
		        case 'tr':
		        return renderContentTransform;
		    }
		}
	
		function renderContentTransform(styleData, itemData, isFirstFrame) {
		    if(isFirstFrame || itemData.transform.op._mdf){
		        itemData.transform.container.setAttribute('opacity',itemData.transform.op.v);
		    }
		    if(isFirstFrame || itemData.transform.mProps._mdf){
		        itemData.transform.container.setAttribute('transform',itemData.transform.mProps.v.to2dCSS());
		    }
		}
	
		function renderPath(styleData, itemData, isFirstFrame) {
		    var j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.styles.length;
		    var lvl = itemData.lvl;
		    var paths, mat, props, iterations, k;
		    for(l=0;l<lLen;l+=1){
		        redraw = itemData.sh._mdf || isFirstFrame;
		        if(itemData.styles[l].lvl < lvl){
		            mat = _matrixHelper.reset();
		            iterations = lvl - itemData.styles[l].lvl;
		            k = itemData.transformers.length-1;
		            while(!redraw && iterations > 0) {
		                redraw = itemData.transformers[k].mProps._mdf || redraw;
		                iterations --;
		                k --;
		            }
		            if(redraw) {
		                iterations = lvl - itemData.styles[l].lvl;
		                k = itemData.transformers.length-1;
		                while(iterations > 0) {
		                    props = itemData.transformers[k].mProps.v.props;
		                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
		                    iterations --;
		                    k --;
		                }
		            }
		        } else {
		            mat = _identityMatrix;
		        }
		        paths = itemData.sh.paths;
		        jLen = paths._length;
		        if(redraw){
		            pathStringTransformed = '';
		            for(j=0;j<jLen;j+=1){
		                pathNodes = paths.shapes[j];
		                if(pathNodes && pathNodes._length){
		                    pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
		                }
		            }
		            itemData.caches[l] = pathStringTransformed;
		        } else {
		            pathStringTransformed = itemData.caches[l];
		        }
		        itemData.styles[l].d += pathStringTransformed;
		        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
		    }
		}
	
		function renderFill (styleData,itemData, isFirstFrame){
		    var styleElem = itemData.style;
	
		    if(itemData.c._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
		    }
		};
	
		function renderGradientStroke (styleData, itemData, isFirstFrame) {
		    renderGradient(styleData, itemData, isFirstFrame);
		    renderStroke(styleData, itemData, isFirstFrame);
		}
	
		function renderGradient(styleData, itemData, isFirstFrame) {
		    var gfill = itemData.gf;
		    var hasOpacity = itemData.g._hasOpacity;
		    var pt1 = itemData.s.v, pt2 = itemData.e.v;
	
		    if (itemData.o._mdf || isFirstFrame) {
		        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
		        itemData.style.pElem.setAttribute(attr, itemData.o.v);
		    }
		    if (itemData.s._mdf || isFirstFrame) {
		        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
		        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
		        gfill.setAttribute(attr1, pt1[0]);
		        gfill.setAttribute(attr2, pt1[1]);
		        if (hasOpacity && !itemData.g._collapsable) {
		            itemData.of.setAttribute(attr1, pt1[0]);
		            itemData.of.setAttribute(attr2, pt1[1]);
		        }
		    }
		    var stops, i, len, stop;
		    if (itemData.g._cmdf || isFirstFrame) {
		        stops = itemData.cst;
		        var cValues = itemData.g.c;
		        len = stops.length;
		        for (i = 0; i < len; i += 1){
		            stop = stops[i];
		            stop.setAttribute('offset', cValues[i * 4] + '%');
		            stop.setAttribute('stop-color','rgb('+ cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ','+cValues[i * 4 + 3] + ')');
		        }
		    }
		    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
		        var oValues = itemData.g.o;
		        if(itemData.g._collapsable) {
		            stops = itemData.cst;
		        } else {
		            stops = itemData.ost;
		        }
		        len = stops.length;
		        for (i = 0; i < len; i += 1) {
		            stop = stops[i];
		            if(!itemData.g._collapsable) {
		                stop.setAttribute('offset', oValues[i * 2] + '%');
		            }
		            stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
		        }
		    }
		    if (styleData.t === 1) {
		        if (itemData.e._mdf  || isFirstFrame) {
		            gfill.setAttribute('x2', pt2[0]);
		            gfill.setAttribute('y2', pt2[1]);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('x2', pt2[0]);
		                itemData.of.setAttribute('y2', pt2[1]);
		            }
		        }
		    } else {
		        var rad;
		        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
		            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            gfill.setAttribute('r', rad);
		            if(hasOpacity && !itemData.g._collapsable){
		                itemData.of.setAttribute('r', rad);
		            }
		        }
		        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
		            if (!rad) {
		                rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            }
		            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	
		            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99: itemData.h.v;
		            var dist = rad * percent;
		            var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
		            var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
		            gfill.setAttribute('fx', x);
		            gfill.setAttribute('fy', y);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('fx', x);
		                itemData.of.setAttribute('fy', y);
		            }
		        }
		        //gfill.setAttribute('fy','200');
		    }
		};
	
		function renderStroke(styleData, itemData, isFirstFrame) {
		    var styleElem = itemData.style;
		    var d = itemData.d;
		    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
		        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
		        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
		    }
		    if(itemData.c && (itemData.c._mdf || isFirstFrame)){
		        styleElem.pElem.setAttribute('stroke','rgb(' + bm_floor(itemData.c.v[0]) + ',' + bm_floor(itemData.c.v[1]) + ',' + bm_floor(itemData.c.v[2]) + ')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
		    }
		    if(itemData.w._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
		        if(styleElem.msElem){
		            styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
		        }
		    }
		};
	
		return ob;
	}())
	function BaseElement(){
	}
	
	BaseElement.prototype = {
	    checkMasks: function(){
	        if(!this.data.hasMask){
	            return false;
	        }
	        var i = 0, len = this.data.masksProperties.length;
	        while(i<len) {
	            if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
	                return true;
	            }
	            i += 1;
	        }
	        return false;
	    },
	    initExpressions: function(){
	        this.layerInterface = LayerExpressionInterface(this);
	        if(this.data.hasMask && this.maskManager) {
	            this.layerInterface.registerMaskInterface(this.maskManager);
	        }
	        var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
	        this.layerInterface.registerEffectsInterface(effectsInterface);
	
	        if(this.data.ty === 0 || this.data.xt){
	            this.compInterface = CompExpressionInterface(this);
	        } else if(this.data.ty === 4){
	            this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData,this.itemsData,this.layerInterface);
	            this.layerInterface.content = this.layerInterface.shapeInterface;
	        } else if(this.data.ty === 5){
	            this.layerInterface.textInterface = TextExpressionInterface(this);
	            this.layerInterface.text = this.layerInterface.textInterface;
	        }
	    },
	    blendModeEnums: {
	        1:'multiply',
	        2:'screen',
	        3:'overlay',
	        4:'darken',
	        5:'lighten',
	        6:'color-dodge',
	        7:'color-burn',
	        8:'hard-light',
	        9:'soft-light',
	        10:'difference',
	        11:'exclusion',
	        12:'hue',
	        13:'saturation',
	        14:'color',
	        15:'luminosity'
	    },
	    getBlendMode: function(){
	        return this.blendModeEnums[this.data.bm] || '';
	    },
	    setBlendMode: function(){
	        var blendModeValue = this.getBlendMode();
	        var elem = this.baseElement || this.layerElement;
	
	        elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function(data, globalData, comp){
	        this.globalData = globalData;
	        this.comp = comp;
	        this.data = data;
	        this.layerId = 'ly_'+randomString(10);
	        
	        //Stretch factor for old animations missing this property.
	        if(!this.data.sr){
	            this.data.sr = 1;
	        }
	        // effects manager
	        this.effectsManager = new EffectsManager(this.data,this,this.dynamicProperties);
	        
	    },
	    getType: function(){
	        return this.type;
	    }
	}
	function NullElement(data,globalData,comp){
	    this.initFrame();
		this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	}
	
	NullElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};
	
	NullElement.prototype.renderFrame = function() {
	};
	
	NullElement.prototype.getBaseElement = function() {
		return null;
	};
	
	NullElement.prototype.destroy = function() {
	};
	
	NullElement.prototype.sourceRectAtTime = function() {
	};
	
	NullElement.prototype.hide = function() {
	};
	
	extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement], NullElement);
	
	function SVGBaseElement(){
	}
	
	SVGBaseElement.prototype = {
	    initRendererElement: function() {
	        this.layerElement = createNS('g');
	    },
	    createContainerElements: function(){
	        this.matteElement = createNS('g');
	        this.transformedElement = this.layerElement;
	        this.maskedElement = this.layerElement;
	        this._sizeChanged = false;
	        var layerElementParent = null;
	        //If this layer acts as a mask for the following layer
	        var filId, fil, gg;
	        if (this.data.td) {
	            if (this.data.td == 3 || this.data.td == 1) {
	                var masker = createNS('mask');
	                masker.setAttribute('id', this.layerId);
	                masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha');
	                masker.appendChild(this.layerElement);
	                layerElementParent = masker;
	                this.globalData.defs.appendChild(masker);
	                // This is only for IE and Edge when mask if of type alpha
	                if (!featureSupport.maskType && this.data.td == 1) {
	                    masker.setAttribute('mask-type', 'luminance');
	                    filId = randomString(10);
	                    fil = filtersFactory.createFilter(filId);
	                    this.globalData.defs.appendChild(fil);
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    masker.appendChild(gg);
	                    gg.setAttribute('filter','url(' + locationHref + '#' + filId + ')');
	                }
	            } else if(this.data.td == 2) {
	                var maskGroup = createNS('mask');
	                maskGroup.setAttribute('id', this.layerId);
	                maskGroup.setAttribute('mask-type','alpha');
	                var maskGrouper = createNS('g');
	                maskGroup.appendChild(maskGrouper);
	                filId = randomString(10);
	                fil = filtersFactory.createFilter(filId);
	                ////
	
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type', 'matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
	                fil.appendChild(feColorMatrix);
	
	                ////
	                /*var feCTr = createNS('feComponentTransfer');
	                feCTr.setAttribute('in','SourceGraphic');
	                fil.appendChild(feCTr);
	                var feFunc = createNS('feFuncA');
	                feFunc.setAttribute('type','table');
	                feFunc.setAttribute('tableValues','1.0 0.0');
	                feCTr.appendChild(feFunc);*/
	                this.globalData.defs.appendChild(fil);
	                var alphaRect = createNS('rect');
	                alphaRect.setAttribute('width',  this.comp.data.w);
	                alphaRect.setAttribute('height', this.comp.data.h);
	                alphaRect.setAttribute('x','0');
	                alphaRect.setAttribute('y','0');
	                alphaRect.setAttribute('fill','#ffffff');
	                alphaRect.setAttribute('opacity','0');
	                maskGrouper.setAttribute('filter', 'url(' + locationHref + '#'+filId+')');
	                maskGrouper.appendChild(alphaRect);
	                maskGrouper.appendChild(this.layerElement);
	                layerElementParent = maskGrouper;
	                if (!featureSupport.maskType) {
	                    maskGroup.setAttribute('mask-type', 'luminance');
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    maskGrouper.appendChild(alphaRect);
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    maskGrouper.appendChild(gg);
	                }
	                this.globalData.defs.appendChild(maskGroup);
	            }
	        } else if (this.data.tt) {
	            this.matteElement.appendChild(this.layerElement);
	            layerElementParent = this.matteElement;
	            this.baseElement = this.matteElement;
	        } else {
	            this.baseElement = this.layerElement;
	        }
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id', this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        //Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
	        if (this.data.ty === 0 && !this.data.hd) {
	            var cp = createNS( 'clipPath');
	            var pt = createNS('path');
	            pt.setAttribute('d','M0,0 L' + this.data.w + ',0' + ' L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	            var clipId = 'cp_'+randomString(8);
	            cp.setAttribute('id',clipId);
	            cp.appendChild(pt);
	            this.globalData.defs.appendChild(cp);
	
	            if (this.checkMasks()) {
	                var cpGroup = createNS('g');
	                cpGroup.setAttribute('clip-path','url(' + locationHref + '#'+clipId + ')');
	                cpGroup.appendChild(this.layerElement);
	                this.transformedElement = cpGroup;
	                if (layerElementParent) {
	                    layerElementParent.appendChild(this.transformedElement);
	                } else {
	                    this.baseElement = this.transformedElement;
	                }
	            } else {
	                this.layerElement.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	            }
	            
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }
	        this.renderableEffectsManager = new SVGEffects(this);
	
	    },
	    renderElement: function() {
	        if (this.finalTransform._matMdf) {
	            this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
	        }
	        if (this.finalTransform._opMdf) {
	            this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
	        }
	    },
	    destroyBaseElement: function() {
	        this.layerElement = null;
	        this.matteElement = null;
	        this.maskManager.destroy();
	    },
	    getBaseElement: function() {
	        if (this.data.hd) {
	            return null;
	        }
	        return this.baseElement;
	    },
	    addMasks: function() {
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    setMatte: function(id) {
	        if (!this.matteElement) {
	            return;
	        }
	        this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + id + ")");
	    }
	};
	function IShapeElement(){
	}
	
	IShapeElement.prototype = {
	    addShapeToModifiers: function(data) {
	        var i, len = this.shapeModifiers.length;
	        for(i=0;i<len;i+=1){
	            this.shapeModifiers[i].addShape(data);
	        }
	    },
	    isShapeInAnimatedModifiers: function(data) {
	        var i = 0, len = this.shapeModifiers.length;
	        while(i < len) {
	            if(this.shapeModifiers[i].isAnimatedWithShape(data)) {
	                return true;
	            }
	        }
	        return false;
	    },
	    renderModifiers: function() {
	        if(!this.shapeModifiers.length){
	            return;
	        }
	        var i, len = this.shapes.length;
	        for(i=0;i<len;i+=1){
	            this.shapes[i].sh.reset();
	        }
	
	        len = this.shapeModifiers.length;
	        for(i=len-1;i>=0;i-=1){
	            this.shapeModifiers[i].processShapes(this._isFirstFrame);
	        }
	    },
	    lcEnum: {
	        '1': 'butt',
	        '2': 'round',
	        '3': 'square'
	    },
	    ljEnum: {
	        '1': 'miter',
	        '2': 'round',
	        '3': 'butt'
	    },
	    searchProcessedElement: function(elem){
	        var elements = this.processedElements;
	        var i = 0, len = elements.length;
	        while(i < len){
	            if(elements[i].elem === elem){
	                return elements[i].pos;
	            }
	            i += 1;
	        }
	        return 0;
	    },
	    addProcessedElement: function(elem, pos){
	        var elements = this.processedElements;
	        var i = elements.length;
	        while(i){
	            i -= 1;
	            if(elements[i].elem === elem){
	                elements[i].pos = pos;
	                return;
	            }
	        }
	        elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function(num) {
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	    }
	};
	function ITextElement(){
	}
	
	ITextElement.prototype.initElement = function(data,globalData,comp){
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.addMasks();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	};
	
	ITextElement.prototype.prepareFrame = function(num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(this.textProperty._mdf || this.textProperty._isFirstFrame) {
	        this.buildNewText();
	        this.textProperty._isFirstFrame = false;
	        this.textProperty._mdf = false;
	    }
	};
	
	ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
	    var j,jLen = shapes.length;
	    var k, kLen, pathNodes;
	    var shapeStr = '';
	    for(j=0;j<jLen;j+=1){
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	    }
	    return shapeStr;
	};
	
	ITextElement.prototype.updateDocumentData = function(newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	};
	
	ITextElement.prototype.canResizeFont = function(_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	};
	
	ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	};
	
	ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if(documentData.ps){
	        matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	    }
	    matrixHelper.translate(0,-documentData.ls,0);
	    switch(documentData.j){
	        case 1:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]),0,0);
	            break;
	        case 2:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber] )/2,0,0);
	            break;
	    }
	    matrixHelper.translate(xPos, yPos, 0);
	};
	
	
	ITextElement.prototype.buildColor = function(colorData) {
	    return 'rgb(' + Math.round(colorData[0]*255) + ',' + Math.round(colorData[1]*255) + ',' + Math.round(colorData[2]*255) + ')';
	};
	
	ITextElement.prototype.emptyProp = new LetterProps();
	
	ITextElement.prototype.destroy = function(){
	    
	};
	function ICompElement(){}
	
	extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
	
	ICompElement.prototype.initElement = function(data,globalData,comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.addMasks();
	    if(this.data.xt || !globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	    this.hide();
	};
	
	/*ICompElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.hideElement();
	        var i,len = this.elements.length;
	        for( i = 0; i < len; i+=1 ){
	            if(this.elements[i]){
	                this.elements[i].hide();
	            }
	        }
	    }
	};*/
	
	ICompElement.prototype.prepareFrame = function(num){
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(!this.isInRange && !this.data.xt){
	        return;
	    }
	
	    if (!this.tm._placeholder) {
	        var timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	        this.renderedFrame = timeRemapped;
	    } else {
	        this.renderedFrame = num/this.data.sr;
	    }
	    var i,len = this.elements.length;
	    if(!this.completeLayers){
	        this.checkLayers(this.renderedFrame);
	    }
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	            if(this.elements[i]._mdf) {
	                this._mdf = true;
	            }
	        }
	    }
	};
	
	ICompElement.prototype.renderInnerContent = function() {
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i += 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	ICompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	ICompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	ICompElement.prototype.destroyElements = function(){
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	};
	
	ICompElement.prototype.destroy = function(){
	    this.destroyElements();
	    this.destroyBaseElement();
	};
	
	function IImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], IImageElement);
	
	IImageElement.prototype.createContent = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width',this.assetData.w+"px");
	    this.innerElem.setAttribute('height',this.assetData.h+"px");
	    this.innerElem.setAttribute('preserveAspectRatio','xMidYMid slice');
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	    
	    this.layerElement.appendChild(this.innerElem);
	};
	
	function ISolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([IImageElement], ISolidElement);
	
	ISolidElement.prototype.createContent = function(){
	
	    var rect = createNS('rect');
	    ////rect.style.width = this.data.sw;
	    ////rect.style.height = this.data.sh;
	    ////rect.style.fill = this.data.sc;
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    this.layerElement.appendChild(rect);
	};
	function SVGCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    //this.layerElement = createNS('g');
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}
	
	extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);
	function SVGTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], SVGTextElement);
	
	SVGTextElement.prototype.createContent = function(){
	
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	        this.textContainer = createNS('text');
	    }
	};
	
	SVGTextElement.prototype.buildTextContents = function(textArray) {
	    var i = 0, len = textArray.length;
	    var textContents = [], currentTextContent = '';
	    while (i < len) {
	        if(textArray[i] === String.fromCharCode(13)) {
	            textContents.push(currentTextContent);
	            currentTextContent = '';
	        } else {
	            currentTextContent += textArray[i];
	        }
	        i += 1;
	    }
	    textContents.push(currentTextContent);
	    return textContents;
	}
	
	SVGTextElement.prototype.buildNewText = function(){
	    var i, len;
	
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
	    if(documentData.fc) {
	        this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    }else{
	        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	        this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(fontData.fClass){
	        this.layerElement.setAttribute('class',fontData.fClass);
	    } else {
	        this.layerElement.setAttribute('font-family', fontData.fFamily);
	        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	        this.layerElement.setAttribute('font-style', fStyle);
	        this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	    var letters = documentData.l || [];
	    var usesGlyphs = this.globalData.fontManager.chars;
	    len = letters.length;
	    if(!len){
	        return;
	    }
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '', singleShape = this.data.singleShape;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    if(singleShape && !usesGlyphs && !documentData.sz) {
	        var tElement = this.textContainer;
	        var justify = 'start';
	        switch(documentData.j) {
	            case 1:
	                justify = 'end';
	                break;
	            case 2:
	                justify = 'middle';
	                break;
	        }
	        tElement.setAttribute('text-anchor',justify);
	        tElement.setAttribute('letter-spacing',trackingOffset);
	        var textContent = this.buildTextContents(documentData.finalText);
	        len = textContent.length;
	        yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	        for ( i = 0; i < len; i += 1) {
	            tSpan = this.textSpans[i] || createNS('tspan');
	            tSpan.textContent = textContent[i];
	            tSpan.setAttribute('x', 0);
	            tSpan.setAttribute('y', yPos);
	            tSpan.style.display = 'inherit';
	            tElement.appendChild(tSpan);
	            this.textSpans[i] = tSpan;
	            yPos += documentData.finalLineHeight;
	        }
	        
	        this.layerElement.appendChild(tElement);
	    } else {
	        var cachedSpansLength = this.textSpans.length;
	        var shapeData, charData;
	        for (i = 0; i < len; i += 1) {
	            if(!usesGlyphs || !singleShape || i === 0){
	                tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs?'path':'text');
	                if (cachedSpansLength <= i) {
	                    tSpan.setAttribute('stroke-linecap', 'butt');
	                    tSpan.setAttribute('stroke-linejoin','round');
	                    tSpan.setAttribute('stroke-miterlimit','4');
	                    this.textSpans[i] = tSpan;
	                    this.layerElement.appendChild(tSpan);
	                }
	                tSpan.style.display = 'inherit';
	            }
	            
	            matrixHelper.reset();
	            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	            if (singleShape) {
	                if(letters[i].n) {
	                    xPos = -trackingOffset;
	                    yPos += documentData.yOffset;
	                    yPos += firstLine ? 1 : 0;
	                    firstLine = false;
	                }
	                this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	                xPos += letters[i].l || 0;
	                //xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	                xPos += trackingOffset;
	            }
	            if(usesGlyphs) {
	                charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	                shapeData = charData && charData.data || {};
	                shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	                if(!singleShape){
	                    tSpan.setAttribute('d',this.createPathShape(matrixHelper,shapes));
	                } else {
	                    shapeStr += this.createPathShape(matrixHelper,shapes);
	                }
	            } else {
	                if(singleShape) {
	                    tSpan.setAttribute("transform", "translate(" + matrixHelper.props[12] + "," + matrixHelper.props[13] + ")");
	                }
	                tSpan.textContent = letters[i].val;
	                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            }
	            //
	        }
	        if (singleShape) {
	            tSpan.setAttribute('d',shapeStr);
	        }
	    }
	    while (i < this.textSpans.length){
	        this.textSpans[i].style.display = 'none';
	        i += 1;
	    }
	    
	    this._sizeChanged = true;
	};
	
	SVGTextElement.prototype.sourceRectAtTime = function(time){
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();
	    if(this._sizeChanged){
	        this._sizeChanged = false;
	        var textBox = this.layerElement.getBBox();
	        this.bbox = {
	            top: textBox.y,
	            left: textBox.x,
	            width: textBox.width,
	            height: textBox.height
	        };
	    }
	    return this.bbox;
	};
	
	SVGTextElement.prototype.renderInnerContent = function(){
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	        if(this.lettersChangedFlag || this.textAnimator.lettersChangedFlag){
	            this._sizeChanged = true;
	            var  i,len;
	            var renderedLetters = this.textAnimator.renderedLetters;
	
	            var letters = this.textProperty.currentData.l;
	
	            len = letters.length;
	            var renderedLetter, textSpan;
	            for(i=0;i<len;i+=1){
	                if(letters[i].n){
	                    continue;
	                }
	                renderedLetter = renderedLetters[i];
	                textSpan = this.textSpans[i];
	                if(renderedLetter._mdf.m) {
	                    textSpan.setAttribute('transform',renderedLetter.m);
	                }
	                if(renderedLetter._mdf.o) {
	                    textSpan.setAttribute('opacity',renderedLetter.o);
	                }
	                if(renderedLetter._mdf.sw){
	                    textSpan.setAttribute('stroke-width',renderedLetter.sw);
	                }
	                if(renderedLetter._mdf.sc){
	                    textSpan.setAttribute('stroke',renderedLetter.sc);
	                }
	                if(renderedLetter._mdf.fc){
	                    textSpan.setAttribute('fill',renderedLetter.fc);
	                }
	            }
	        }
	    }
	};
	function SVGShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableDOMElement], SVGShapeElement);
	
	SVGShapeElement.prototype.initSecondaryElement = function() {
	};
	
	SVGShapeElement.prototype.identityMatrix = new Matrix();
	
	SVGShapeElement.prototype.buildExpressionInterface = function(){};
	
	SVGShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	};
	
	/*
	This method searches for multiple shapes that affect a single element and one of them is animated
	*/
	SVGShapeElement.prototype.filterUniqueShapes = function(){
	    var i, len = this.shapes.length, shape;
	    var j, jLen = this.stylesList.length;
	    var style, count = 0;
	    var tempShapes = [];
	    var areAnimated = false;
	    for(j = 0; j < jLen; j += 1) {
	        style = this.stylesList[j];
	        areAnimated = false;
	        tempShapes.length = 0;
	        for(i = 0; i < len; i += 1) {
	            shape = this.shapes[i];
	            if(shape.styles.indexOf(style) !== -1) {
	                tempShapes.push(shape);
	                areAnimated = shape._isAnimated || areAnimated;
	            }
	        }
	        if(tempShapes.length > 1 && areAnimated) {
	            this.setShapesAsAnimated(tempShapes);
	        }
	    }
	}
	
	SVGShapeElement.prototype.setShapesAsAnimated = function(shapes){
	    var i, len = shapes.length;
	    for(i = 0; i < len; i += 1) {
	        shapes[i].setAsAnimated();
	    }
	}
	
	SVGShapeElement.prototype.createStyleElement = function(data, level){
	    //TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);
	
	    var pathElement = styleOb.pElem;
	    if(data.ty === 'st') {
	        elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if(data.ty === 'fl') {
	        elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if(data.ty === 'gf' || data.ty === 'gs') {
	        var gradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	        elementData = new gradientConstructor(this, data, styleOb);
	        this.globalData.defs.appendChild(elementData.gf);
	        if (elementData.maskId) {
	            this.globalData.defs.appendChild(elementData.ms);
	            this.globalData.defs.appendChild(elementData.of);
	            pathElement.setAttribute('mask','url(#' + elementData.maskId + ')');
	        }
	    }
	    
	    if(data.ty === 'st' || data.ty === 'gs') {
	        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
	        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
	        pathElement.setAttribute('fill-opacity','0');
	        if(data.lj === 1) {
	            pathElement.setAttribute('stroke-miterlimit',data.ml);
	        }
	    }
	
	    if(data.r === 2) {
	        pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if(data.ln){
	        pathElement.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        pathElement.setAttribute('class',data.cl);
	    }
	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = new ShapeGroupData();
	    if(data.ln){
	        elementData.gr.setAttribute('id',data.ln);
	    }
	    return elementData;
	};
	
	SVGShapeElement.prototype.createTransformElement = function(data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this,data,this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
	    var ty = 4;
	    if(data.ty === 'rc'){
	        ty = 5;
	    }else if(data.ty === 'el'){
	        ty = 6;
	    }else if(data.ty === 'sr'){
	        ty = 7;
	    }
	    var shapeProperty = ShapePropertyFactory.getShapeProp(this,data,ty,this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
	    var i = 0, len = this.animatedContents.length;
	    while(i < len) {
	        if(this.animatedContents[i].element === element) {
	            return;
	        }
	        i += 1;
	    }
	    this.animatedContents.push({
	        fn: SVGElementsRenderer.createRenderFunction(data),
	        element: element,
	        data: data
	    });
	};
	
	SVGShapeElement.prototype.setElementStyles = function(elementData){
	    var arr = elementData.styles;
	    var j, jLen = this.stylesList.length;
	    for (j = 0; j < jLen; j += 1) {
	        if (!this.stylesList[j].closed) {
	            arr.push(this.stylesList[j]);
	        }
	    }
	};
	
	SVGShapeElement.prototype.reloadShapes = function(){
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for( i = 0; i < len; i += 1) {
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;
	    for(i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	};
	
	SVGShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container, level, transformers, render){
	    var ownTransformers = [].concat(transformers);
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], styleOb, currentTransform, modifier, processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], level);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].style.pElem);
	            }
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr, level + 1, ownTransformers, render);
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].gr);
	            }
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], container);
	            }
	            currentTransform = itemsData[i].transform;
	            ownTransformers.push(currentTransform);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	            }
	            this.setElementStyles(itemsData[i]);
	
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        }else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownStyles.length;
	    for(i=0;i<len;i+=1){
	        ownStyles[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	SVGShapeElement.prototype.renderInnerContent = function() {
	    this.renderModifiers();
	    var i, len = this.stylesList.length;
	    for(i=0;i<len;i+=1){
	        this.stylesList[i].reset();
	    }
	    this.renderShape();
	
	    for (i = 0; i < len; i += 1) {
	        if (this.stylesList[i]._mdf || this._isFirstFrame) {
	            if(this.stylesList[i].msElem){
	                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
	                //Adding M0 0 fixes same mask bug on all browsers
	                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	            }
	            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	        }
	    }
	};
	
	SVGShapeElement.prototype.renderShape = function() {
	    var i, len = this.animatedContents.length;
	    var animatedContent;
	    for(i = 0; i < len; i += 1) {
	        animatedContent = this.animatedContents[i];
	        if(this._isFirstFrame || animatedContent.element._isAnimated) {
	            animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	        }
	    }
	}
	
	SVGShapeElement.prototype.destroy = function(){
	    this.destroyBaseElement();
	    this.shapeData = null;
	    this.itemsData = null;
	};
	
	function SVGTintFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
	        var feMerge = createNS('feMerge');
	        filter.appendChild(feMerge);
	        var feMergeNode;
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','SourceGraphic');
	        feMerge.appendChild(feMergeNode);
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','f2');
	        feMerge.appendChild(feMergeNode);
	    }
	}
	
	SVGTintFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var colorBlack = this.filterManager.effectElements[0].p.v;
	        var colorWhite = this.filterManager.effectElements[1].p.v;
	        var opacity = this.filterManager.effectElements[2].p.v/100;
	        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGFillFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	}
	SVGFillFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color = this.filterManager.effectElements[2].p.v;
	        var opacity = this.filterManager.effectElements[6].p.v;
	        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
	    }
	};
	function SVGStrokeEffect(elem, filterManager){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	}
	
	SVGStrokeEffect.prototype.initialize = function(){
	
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path,groupPath, i, len;
	    if(this.filterManager.effectElements[1].p.v === 1){
	        len = this.elem.maskManager.masksProperties.length;
	        i = 0;
	    } else {
	        i = this.filterManager.effectElements[0].p.v - 1;
	        len = i + 1;
	    }
	    groupPath = createNS('g'); 
	    groupPath.setAttribute('fill','none');
	    groupPath.setAttribute('stroke-linecap','round');
	    groupPath.setAttribute('stroke-dashoffset',1);
	    for(i;i<len;i+=1){
	        path = createNS('path');
	        groupPath.appendChild(path);
	        this.paths.push({p:path,m:i});
	    }
	    if(this.filterManager.effectElements[10].p.v === 3){
	        var mask = createNS('mask');
	        var id = 'stms_' + randomString(10);
	        mask.setAttribute('id',id);
	        mask.setAttribute('mask-type','alpha');
	        mask.appendChild(groupPath);
	        this.elem.globalData.defs.appendChild(mask);
	        var g = createNS('g');
	        g.setAttribute('mask','url(' + locationHref + '#'+id+')');
	        if(elemChildren[0]){
	            g.appendChild(elemChildren[0]);
	        }
	        this.elem.layerElement.appendChild(g);
	        this.masker = mask;
	        groupPath.setAttribute('stroke','#fff');
	    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(this.filterManager.effectElements[10].p.v === 2){
	            elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	            while(elemChildren.length){
	                this.elem.layerElement.removeChild(elemChildren[0]);
	            }
	        }
	        this.elem.layerElement.appendChild(groupPath);
	        this.elem.layerElement.removeAttribute('mask');
	        groupPath.setAttribute('stroke','#fff');
	    }
	    this.initialized = true;
	    this.pathMasker = groupPath;
	};
	
	SVGStrokeEffect.prototype.renderFrame = function(forceRender){
	    if(!this.initialized){
	        this.initialize();
	    }
	    var i, len = this.paths.length;
	    var mask, path;
	    for(i=0;i<len;i+=1){
	        if(this.paths[i].m === -1) {
	            continue;
	        }
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	        if(forceRender || this.filterManager._mdf || mask.prop._mdf){
	            path.setAttribute('d',mask.lastPath);
	        }
	        if(forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf){
	            var dasharrayValue;
	            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
	                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var l = path.getTotalLength();
	                dasharrayValue = '0 0 0 ' + l*s + ' ';
	                var lineLength = l*(e-s);
	                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	                var units = Math.floor(lineLength/segment);
	                var j;
	                for(j=0;j<units;j+=1){
	                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
	                }
	                dasharrayValue += '0 ' + l*10 + ' 0 0';
	            } else {
	                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	            }
	            path.setAttribute('stroke-dasharray',dasharrayValue);
	        }
	    }
	    if(forceRender || this.filterManager.effectElements[4].p._mdf){
	        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
	    }
	    
	    if(forceRender || this.filterManager.effectElements[6].p._mdf){
	        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
	    }
	    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(forceRender || this.filterManager.effectElements[3].p._mdf){
	            var color = this.filterManager.effectElements[3].p.v;
	            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
	        }
	    }
	};
	function SVGTritoneFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	    filter.appendChild(feComponentTransfer);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	}
	
	SVGTritoneFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color1 = this.filterManager.effectElements[0].p.v;
	        var color2 = this.filterManager.effectElements[1].p.v;
	        var color3 = this.filterManager.effectElements[2].p.v;
	        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	        this.feFuncR.setAttribute('tableValues', tableR);
	        this.feFuncG.setAttribute('tableValues', tableG);
	        this.feFuncB.setAttribute('tableValues', tableB);
	        //var opacity = this.filterManager.effectElements[2].p.v/100;
	        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGProLevelsFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer');
	    var feFuncR, feFuncG, feFuncB;
	    
	    if(effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1){
	        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    }
	    if(effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1){
	        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    }
	    if(effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1){
	        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	    if(effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1){
	        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    }
	    
	    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        feComponentTransfer = createNS('feComponentTransfer');
	    }
	
	    if(effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1){
	
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	}
	
	SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	};
	
	SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null,{length:segments});
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack; 
	    var inputDelta = inputWhite - inputBlack; 
	    while(cnt <= 256) {
	        perc = cnt/256;
	        if(perc <= min){
	            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	        } else if(perc >= max){
	            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	        } else {
	            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
	        }
	        table[pos++] = colorValue;
	        cnt += 256/(segments-1);
	    }
	    return table.join(' ');
	};
	
	SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var val, cnt, perc, bezier;
	        var effectElements = this.filterManager.effectElements;
	        if(this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)){
	            val = this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);
	            this.feFuncRComposed.setAttribute('tableValues',val);
	            this.feFuncGComposed.setAttribute('tableValues',val);
	            this.feFuncBComposed.setAttribute('tableValues',val);
	        }
	
	
	        if(this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)){
	            val = this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);
	            this.feFuncR.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)){
	            val = this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);
	            this.feFuncG.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)){
	            val = this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);
	            this.feFuncB.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)){
	            val = this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);
	            this.feFuncA.setAttribute('tableValues',val);
	        }
	        
	    }
	};
	function SVGDropShadowEffect(filter, filterManager){
	    filter.setAttribute('x','-100%');
	    filter.setAttribute('y','-100%');
	    filter.setAttribute('width','400%');
	    filter.setAttribute('height','400%');
	    this.filterManager = filterManager;
	
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in','SourceAlpha');
	    feGaussianBlur.setAttribute('result','drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation','0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx','25');
	    feOffset.setAttribute('dy','0');
	    feOffset.setAttribute('in','drop_shadow_1');
	    feOffset.setAttribute('result','drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color','#00ff00');
	    feFlood.setAttribute('flood-opacity','1');
	    feFlood.setAttribute('result','drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in','drop_shadow_3');
	    feComposite.setAttribute('in2','drop_shadow_2');
	    feComposite.setAttribute('operator','in');
	    feComposite.setAttribute('result','drop_shadow_4');
	    filter.appendChild(feComposite);
	
	
	    var feMerge = createNS('feMerge');
	    filter.appendChild(feMerge);
	    var feMergeNode;
	    feMergeNode = createNS('feMergeNode');
	    feMerge.appendChild(feMergeNode);
	    feMergeNode = createNS('feMergeNode');
	    feMergeNode.setAttribute('in','SourceGraphic');
	    this.feMergeNode = feMergeNode;
	    this.feMerge = feMerge;
	    this.originalNodeAdded = false;
	    feMerge.appendChild(feMergeNode);
	}
	
	SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        if(forceRender || this.filterManager.effectElements[4].p._mdf){
	            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	        }
	        if(forceRender || this.filterManager.effectElements[0].p._mdf){
	            var col = this.filterManager.effectElements[0].p.v;
	            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
	        }
	        if(forceRender || this.filterManager.effectElements[1].p._mdf){
	            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
	        }
	        if(forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf){
	            var distance = this.filterManager.effectElements[3].p.v;
	            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	            var x = distance * Math.cos(angle);
	            var y = distance * Math.sin(angle);
	            this.feOffset.setAttribute('dx', x);
	            this.feOffset.setAttribute('dy', y);
	        }
	        /*if(forceRender || this.filterManager.effectElements[5].p._mdf){
	            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
	                this.feMerge.removeChild(this.feMergeNode);
	                this.originalNodeAdded = false;
	            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
	                this.feMerge.appendChild(this.feMergeNode);
	                this.originalNodeAdded = true;
	            }
	        }*/
	    }
	};
	var _svgMatteSymbols = [];
	var _svgMatteMaskCounter = 0;
	
	function SVGMatte3Effect(filterElem, filterManager, elem){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	}
	
	SVGMatte3Effect.prototype.findSymbol = function(mask) {
	    var i = 0, len = _svgMatteSymbols.length;
	    while(i < len) {
	        if(_svgMatteSymbols[i] === mask) {
	            return _svgMatteSymbols[i];
	        }
	        i += 1;
	    }
	    return null;
	};
	
	SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;
	    if(!parentNode) {
	        return;
	    }
	    var children = parentNode.children;
	    var i = 0, len = children.length;
	    while (i < len) {
	        if (children[i] === mask.layerElement) {
	            break;
	        }
	        i += 1;
	    }
	    var nextChild;
	    if (i <= len - 2) {
	        nextChild = children[i + 1];
	    }
	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);
	    if(nextChild) {
	        parentNode.insertBefore(useElem, nextChild);
	    } else {
	        parentNode.appendChild(useElem);
	    }
	};
	
	SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
	    if(!this.findSymbol(mask)) {
	        var symbolId = 'matte_' + randomString(5) + '_' + _svgMatteMaskCounter++;
	        var masker = createNS('mask');
	        masker.setAttribute('id', mask.layerId);
	        masker.setAttribute('mask-type', 'alpha');
	        _svgMatteSymbols.push(mask);
	        var defs = elem.globalData.defs;
	        defs.appendChild(masker);
	        var symbol = createNS('symbol');
	        symbol.setAttribute('id', symbolId);
	        this.replaceInParent(mask, symbolId);
	        symbol.appendChild(mask.layerElement);
	        defs.appendChild(symbol);
	        var useElem = createNS('use');
	        useElem.setAttribute('href', '#' + symbolId);
	        masker.appendChild(useElem);
	        mask.data.hd = false;
	        mask.show();
	    }
	    elem.setMatte(mask.layerId);
	};
	
	SVGMatte3Effect.prototype.initialize = function() {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var i = 0, len = this.elem.comp.elements.length;
	    while (i < len) {
	    	if (this.elem.comp.elements[i].data.ind === ind) {
	    		this.setElementAsMask(this.elem, this.elem.comp.elements[i]);
	    	}
	    	i += 1;
	    }
	    this.initialized = true;
	};
	
	SVGMatte3Effect.prototype.renderFrame = function() {
		if(!this.initialized) {
			this.initialize();
		}
	};
	function SVGEffects(elem){
	    var i, len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = randomString(10);
	    var fil = filtersFactory.createFilter(filId);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	    for(i=0;i<len;i+=1){
	        filterManager = null;
	        if(elem.data.ef[i].ty === 20){
	            count += 1;
	            filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 21){
	            count += 1;
	            filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 22){
	            filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 23){
	            count += 1;
	            filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 24){
	            count += 1;
	            filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 25){
	            count += 1;
	            filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 28){
	            //count += 1;
	            filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
	        }
	        if(filterManager) {
	            this.filters.push(filterManager);
	        }
	    }
	    if(count){
	        elem.globalData.defs.appendChild(fil);
	        elem.layerElement.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	    }
	    if (this.filters.length) {
	        elem.addRenderableComponent(this);
	    }
	}
	
	SVGEffects.prototype.renderFrame = function(_isFirstFrame){
	    var i, len = this.filters.length;
	    for(i=0;i<len;i+=1){
	        this.filters[i].renderFrame(_isFirstFrame);
	    }
	};
	var animationManager = (function(){
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var idled = true;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	
	    function removeElement(ev){
	        var i = 0;
	        var animItem = ev.target;
	        while(i<len) {
	            if (registeredAnimations[i].animation === animItem) {
	                registeredAnimations.splice(i, 1);
	                i -= 1;
	                len -= 1;
	                if(!animItem.isPaused){
	                    subtractPlayingCount();
	                }
	            }
	            i += 1;
	        }
	    }
	
	    function registerAnimation(element, animationData){
	        if(!element){
	            return null;
	        }
	        var i=0;
	        while(i<len){
	            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
	                return registeredAnimations[i].animation;
	            }
	            i+=1;
	        }
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, element);
	        animItem.setData(element, animationData);
	        return animItem;
	    }
	
	    function addPlayingCount(){
	        playingAnimationsNum += 1;
	        activate();
	    }
	
	    function subtractPlayingCount(){
	        playingAnimationsNum -= 1;
	        if(playingAnimationsNum === 0){
	            idled = true;
	        }
	    }
	
	    function setupAnimation(animItem, element){
	        animItem.addEventListener('destroy',removeElement);
	        animItem.addEventListener('_active',addPlayingCount);
	        animItem.addEventListener('_idle',subtractPlayingCount);
	        registeredAnimations.push({elem: element,animation:animItem});
	        len += 1;
	    }
	
	    function loadAnimation(params){
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, null);
	        animItem.setParams(params);
	        return animItem;
	    }
	
	
	    function setSpeed(val,animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setSpeed(val, animation);
	        }
	    }
	
	    function setDirection(val, animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setDirection(val, animation);
	        }
	    }
	
	    function play(animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.play(animation);
	        }
	    }
	    function resume(nowTime) {
	        var elapsedTime = nowTime - initTime;
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.advanceTime(elapsedTime);
	        }
	        initTime = nowTime;
	        if(!idled) {
	            window.requestAnimationFrame(resume);
	        } else {
	            _stopped = true;
	        }
	    }
	
	    function first(nowTime){
	        initTime = nowTime;
	        window.requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.pause(animation);
	        }
	    }
	
	    function goToAndStop(value,isFrame,animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
	        }
	    }
	
	    function stop(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.stop(animation);
	        }
	    }
	
	    function togglePause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.togglePause(animation);
	        }
	    }
	
	    function destroy(animation) {
	        var i;
	        for(i=(len-1);i>=0;i-=1){
	            registeredAnimations[i].animation.destroy(animation);
	        }
	    }
	
	    function searchAnimations(animationData, standalone, renderer){
	        var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
	                  [].slice.call(document.getElementsByClassName('bodymovin')));
	        var i, len = animElements.length;
	        for(i=0;i<len;i+=1){
	            if(renderer){
	                animElements[i].setAttribute('data-bm-type',renderer);
	            }
	            registerAnimation(animElements[i], animationData);
	        }
	        if(standalone && len === 0){
	            if(!renderer){
	                renderer = 'svg';
	            }
	            var body = document.getElementsByTagName('body')[0];
	            body.innerHTML = '';
	            var div = createTag('div');
	            div.style.width = '100%';
	            div.style.height = '100%';
	            div.setAttribute('data-bm-type',renderer);
	            body.appendChild(div);
	            registerAnimation(div, animationData);
	        }
	    }
	
	    function resize(){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.resize();
	        }
	    }
	
	    /*function start(){
	        window.requestAnimationFrame(first);
	    }*/
	
	    function activate(){
	        if(idled){
	            idled = false;
	            if(_stopped) {
	                window.requestAnimationFrame(first);
	                _stopped = false;
	            }
	        }
	    }
	
	    //start();
	
	    //setTimeout(start,0);
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize;
	    //moduleOb.start = start;
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    return moduleOb;
	}());
	
	var AnimationItem = function () {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.pendingElements = 0;
	    this.playCount = 0;
	    this.animationData = {};
	    this.layers = [];
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = randomString(10);
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.subframeEnabled = subframeEnabled;
	    this.segments = [];
	    this._idle = true;
	    this.projectInterface = ProjectInterface();
	};
	
	extendPrototype([BaseEvent], AnimationItem);
	
	AnimationItem.prototype.setParams = function(params) {
	    var self = this;
	    if(params.context){
	        this.context = params.context;
	    }
	    if(params.wrapper || params.container){
	        this.wrapper = params.wrapper || params.container;
	    }
	    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
	    switch(animType){
	        case 'canvas':
	            this.renderer = new CanvasRenderer(this, params.rendererSettings);
	            break;
	        case 'svg':
	            this.renderer = new SVGRenderer(this, params.rendererSettings);
	            break;
	        default:
	            this.renderer = new HybridRenderer(this, params.rendererSettings);
	            break;
	    }
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if(params.loop === '' || params.loop === null){
	    }else if(params.loop === false){
	        this.loop = false;
	    }else if(params.loop === true){
	        this.loop = true;
	    }else{
	        this.loop = parseInt(params.loop);
	    }
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name :  '';
	    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
	    this.assetsPath = params.assetsPath;
	    if(params.animationData){
	        self.configAnimation(params.animationData);
	    }else if(params.path){
	        if(params.path.substr(-4) != 'json'){
	            if (params.path.substr(-1, 1) != '/') {
	                params.path += '/';
	            }
	            params.path += 'data.json';
	        }
	
	        var xhr = new XMLHttpRequest();
	        if(params.path.lastIndexOf('\\') != -1){
	            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
	        }else{
	            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
	        }
	        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
	        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
	        xhr.open('GET', params.path, true);
	        xhr.send();
	        xhr.onreadystatechange = function () {
	            if (xhr.readyState == 4) {
	                if(xhr.status == 200){
	                    self.configAnimation(JSON.parse(xhr.responseText));
	                }else{
	                    try{
	                        var response = JSON.parse(xhr.responseText);
	                        self.configAnimation(response);
	                    }catch(err){
	                    }
	                }
	            }
	        };
	    }
	};
	
	AnimationItem.prototype.setData = function (wrapper, animationData) {
	    var params = {
	        wrapper: wrapper,
	        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
	    };
	    var wrapperAttributes = wrapper.attributes;
	
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
	
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	    if(loop === ''){
	    }else if(loop === 'false'){
	        params.loop = false;
	    }else if(loop === 'true'){
	        params.loop = true;
	    }else{
	        params.loop = parseInt(loop);
	    }
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== "false";
	
	    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if(prerender === 'false'){
	        params.prerender = false;
	    }
	    this.setParams(params);
	};
	
	AnimationItem.prototype.includeLayers = function(data) {
	    if(data.op > this.animationData.op){
	        this.animationData.op = data.op;
	        this.totalFrames = Math.floor(data.op - this.animationData.ip);
	        this.animationData.tf = this.totalFrames;
	    }
	    var layers = this.animationData.layers;
	    var i, len = layers.length;
	    var newLayers = data.layers;
	    var j, jLen = newLayers.length;
	    for(j=0;j<jLen;j+=1){
	        i = 0;
	        while(i<len){
	            if(layers[i].id == newLayers[j].id){
	                layers[i] = newLayers[j];
	                break;
	            }
	            i += 1;
	        }
	    }
	    if(data.chars || data.fonts){
	        this.renderer.globalData.fontManager.addChars(data.chars);
	        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	    if(data.assets){
	        len = data.assets.length;
	        for(i = 0; i < len; i += 1){
	            this.animationData.assets.push(data.assets[i]);
	        }
	    }
	    //this.totalFrames = 50;
	    //this.animationData.tf = 50;
	    this.animationData.__complete = false;
	    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	    this.renderer.includeLayers(data.layers);
	    if(expressionsPlugin){
	        expressionsPlugin.initExpressions(this);
	    }
	    this.renderer.renderFrame(-1);
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.loadNextSegment = function() {
	    var segments = this.animationData.segments;
	    if(!segments || segments.length === 0 || !this.autoloadSegments){
	        this.trigger('data_ready');
	        this.timeCompleted = this.animationData.tf;
	        return;
	    }
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var xhr = new XMLHttpRequest();
	    var self = this;
	    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    xhr.open('GET', segmentPath, true);
	    xhr.send();
	    xhr.onreadystatechange = function () {
	        if (xhr.readyState == 4) {
	            if(xhr.status == 200){
	                self.includeLayers(JSON.parse(xhr.responseText));
	            }else{
	                try{
	                    var response = JSON.parse(xhr.responseText);
	                    self.includeLayers(response);
	                }catch(err){
	                }
	            }
	        }
	    };
	};
	
	AnimationItem.prototype.loadSegments = function() {
	    var segments = this.animationData.segments;
	    if(!segments) {
	        this.timeCompleted = this.animationData.tf;
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.configAnimation = function (animData) {
	    var _this = this;
	    if(!this.renderer){
	        return;
	    }
	    this.animationData = animData;
	    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	    this.animationData.tf = this.totalFrames;
	    this.renderer.configAnimation(animData);
	    if(!animData.assets){
	        animData.assets = [];
	    }
	    if(animData.comps) {
	        animData.assets = animData.assets.concat(animData.comps);
	        animData.comps = null;
	    }
	    this.renderer.searchExtraCompositions(animData.assets);
	
	    this.layers = this.animationData.layers;
	    this.assets = this.animationData.assets;
	    this.frameRate = this.animationData.fr;
	    this.firstFrame = Math.round(this.animationData.ip);
	    this.frameMult = this.animationData.fr / 1000;
	    this.trigger('config_ready');
	    this.imagePreloader = new ImagePreloader();
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(animData.assets, function(err) {
	        if(!err) {
	            _this.trigger('loaded_images');
	        }
	    });
	    this.loadSegments();
	    this.updaFrameModifier();
	    if(this.renderer.globalData.fontManager){
	        this.waitForFontsLoaded();
	    }else{
	        dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	        this.checkLoaded();
	    }
	};
	
	AnimationItem.prototype.waitForFontsLoaded = (function(){
	    function checkFontsLoaded(){
	        if(this.renderer.globalData.fontManager.loaded){
	            dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	            //this.renderer.buildItems(this.animationData.layers);
	            this.checkLoaded();
	        }else{
	            setTimeout(checkFontsLoaded.bind(this),20);
	        }
	    }
	
	    return function(){
	        checkFontsLoaded.bind(this)();
	    };
	}());
	
	AnimationItem.prototype.addPendingElement = function () {
	    this.pendingElements += 1;
	};
	
	AnimationItem.prototype.elementLoaded = function () {
	    this.pendingElements--;
	    this.checkLoaded();
	};
	
	AnimationItem.prototype.checkLoaded = function () {
	    if (this.pendingElements === 0) {
	        if(expressionsPlugin){
	            expressionsPlugin.initExpressions(this);
	        }
	        this.renderer.initItems();
	        setTimeout(function(){
	            this.trigger('DOMLoaded');
	        }.bind(this),0);
	        this.isLoaded = true;
	        this.gotoFrame();
	        if(this.autoplay){
	            this.play();
	        }
	    }
	};
	
	AnimationItem.prototype.resize = function () {
	    this.renderer.updateContainerSize();
	};
	
	AnimationItem.prototype.setSubframe = function(flag){
	    this.subframeEnabled = flag ? true : false;
	};
	
	AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.subframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame;
	
	    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
	        this.currentFrame = this.timeCompleted;
	    }
	    this.trigger('enterFrame');
	    this.renderFrame();
	};
	
	AnimationItem.prototype.renderFrame = function () {
	    if(this.isLoaded === false){
	        return;
	    }
	    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	};
	
	AnimationItem.prototype.play = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.isPaused = false;
	        if(this._idle){
	            this._idle = false;
	            this.trigger('_active');
	        }
	    }
	};
	
	AnimationItem.prototype.pause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === false){
	        this.isPaused = true;
	        this._idle = true;
	        this.trigger('_idle');
	    }
	};
	
	AnimationItem.prototype.togglePause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.play();
	    }else{
	        this.pause();
	    }
	};
	
	AnimationItem.prototype.stop = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.pause();
	    this.playCount = 0;
	    this.setCurrentRawFrameValue(0);
	};
	
	AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(isFrame){
	        this.setCurrentRawFrameValue(value);
	    }else{
	        this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	    this.pause();
	};
	
	AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    this.goToAndStop(value, isFrame, name);
	    this.play();
	};
	
	AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	        return;
	    }
	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false;
	    // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	        if (!this.loop || this.playCount === this.loop) {
	            if (!this.checkSegments(nextValue % this.totalFrames)) {
	                _isComplete = true;
	                nextValue = this.totalFrames - 1;
	            }
	        } else if (nextValue >= this.totalFrames) {
	            this.playCount += 1;
	            if (!this.checkSegments(nextValue % this.totalFrames)) {
	                this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	                this.trigger('loopComplete');
	            }
	        } else {
	            this.setCurrentRawFrameValue(nextValue);
	        }
	    } else if(nextValue < 0) {
	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	            if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	                this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
	                this.trigger('loopComplete');
	            } else {
	                _isComplete = true;
	                nextValue = 0;
	            }
	        }
	    } else {
	        this.setCurrentRawFrameValue(nextValue);
	    }
	    if (_isComplete) {
	        this.setCurrentRawFrameValue(nextValue);
	        this.pause();
	        this.trigger('complete');
	    }
	};
	
	AnimationItem.prototype.adjustSegment = function(arr, offset){
	    this.playCount = 0;
	    if(arr[1] < arr[0]){
	        if(this.frameModifier > 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(-1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[0] - arr[1];
	        this.firstFrame = arr[1];
	        this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if(arr[1] > arr[0]){
	        if(this.frameModifier < 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[1] - arr[0];
	        this.firstFrame = arr[0];
	        this.setCurrentRawFrameValue(0.001 + offset);
	    }
	    this.trigger('segmentStart');
	};
	AnimationItem.prototype.setSegment = function (init,end) {
	    var pendingFrame = -1;
	    if(this.isPaused) {
	        if (this.currentRawFrame + this.firstFrame < init) {
	            pendingFrame = init;
	        } else if (this.currentRawFrame + this.firstFrame > end) {
	            pendingFrame = end - init;
	        }
	    }
	
	    this.firstFrame = init;
	    this.timeCompleted = this.totalFrames = end - init;
	    if(pendingFrame !== -1) {
	        this.goToAndStop(pendingFrame,true);
	    }
	};
	
	AnimationItem.prototype.playSegments = function (arr,forceFlag) {
	    if(typeof arr[0] === 'object'){
	        var i, len = arr.length;
	        for(i=0;i<len;i+=1){
	            this.segments.push(arr[i]);
	        }
	    }else{
	        this.segments.push(arr);
	    }
	    if(forceFlag){
	        this.checkSegments(0);
	    }
	    if(this.isPaused){
	        this.play();
	    }
	};
	
	AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip,this.animationData.op]);
	    //this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
	    if(forceFlag){
	        this.checkSegments(0);
	    }
	};
	AnimationItem.prototype.checkSegments = function(offset){
	    if(this.segments.length) {
	        this.adjustSegment(this.segments.shift(), offset);
	        return true;
	    }
	    return false;
	};
	
	AnimationItem.prototype.destroy = function (name) {
	    if((name && this.name != name) || !this.renderer){
	        return;
	    }
	    this.renderer.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
	    this.renderer = null;
	};
	
	AnimationItem.prototype.setCurrentRawFrameValue = function(value){
	    this.currentRawFrame = value;
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	};
	
	AnimationItem.prototype.getPath = function () {
	    return this.path;
	};
	
	AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	    if(this.assetsPath){
	        var imagePath = assetData.p;
	        if(imagePath.indexOf('images/') !== -1){
	            imagePath = imagePath.split('/')[1];
	        }
	        path = this.assetsPath + imagePath;
	    } else {
	        path = this.path;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	    }
	    return path;
	};
	
	AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0, len = this.assets.length;
	    while (i < len) {
	        if(id == this.assets[i].id){
	            return this.assets[i];
	        }
	        i += 1;
	    }
	};
	
	AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	};
	
	AnimationItem.prototype.show = function () {
	    this.renderer.show();
	};
	
	AnimationItem.prototype.getAssets = function () {
	    return this.assets;
	};
	
	AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	};
	
	AnimationItem.prototype.trigger = function(name){
	    if(this._cbs && this._cbs[name]){
	        switch(name){
	            case 'enterFrame':
	                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	                break;
	            case 'loopComplete':
	                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	                break;
	            case 'complete':
	                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
	                break;
	            case 'segmentStart':
	                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	                break;
	            case 'destroy':
	                this.triggerEvent(name,new BMDestroyEvent(name,this));
	                break;
	            default:
	                this.triggerEvent(name);
	        }
	    }
	    if(name === 'enterFrame' && this.onEnterFrame){
	        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	    }
	    if(name === 'loopComplete' && this.onLoopComplete){
	        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	    }
	    if(name === 'complete' && this.onComplete){
	        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
	    }
	    if(name === 'segmentStart' && this.onSegmentStart){
	        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	    }
	    if(name === 'destroy' && this.onDestroy){
	        this.onDestroy.call(this,new BMDestroyEvent(name,this));
	    }
	};
	
	function EffectsManager(){}
	function CanvasRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.renderConfig = {
	        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
	        context: (config && config.context) || null,
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        className: (config && config.className) || ''
	    };
	    this.renderConfig.dpr = (config && config.dpr) || 1;
	    if (this.animationItem.wrapper) {
	        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
	    }
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1,
	        _mdf: false,
	        renderConfig: this.renderConfig,
	        currentGlobalAlpha: -1
	    };
	    var i, len = 15;
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	}
	extendPrototype([BaseRenderer],CanvasRenderer);
	
	CanvasRenderer.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;
	
	CanvasRenderer.prototype.ctxTransform = function(props){
	    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
	        return;
	    }
	    this.transformMat.cloneFromProps(props);
	    var cProps = this.contextData.cTr.props;
	    this.transformMat.transform(cProps[0],cProps[1],cProps[2],cProps[3],cProps[4],cProps[5],cProps[6],cProps[7],cProps[8],cProps[9],cProps[10],cProps[11],cProps[12],cProps[13],cProps[14],cProps[15]);
	    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    this.contextData.cTr.cloneFromProps(this.transformMat.props);
	    var trProps = this.contextData.cTr.props;
	    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
	};
	
	CanvasRenderer.prototype.ctxOpacity = function(op){
	    /*if(op === 1){
	        return;
	    }*/
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	        return;
	    }
	    this.contextData.cO *= op < 0 ? 0 : op;
	    if(this.globalData.currentGlobalAlpha !== this.contextData.cO) {
	        this.canvasContext.globalAlpha = this.contextData.cO;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	    }
	};
	
	CanvasRenderer.prototype.reset = function(){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    this.contextData.reset();
	};
	
	CanvasRenderer.prototype.save = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.save();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.save();
	    }
	    var props = this.contextData.cTr.props;
	    if(this.contextData._length <= this.contextData.cArrPos) {
	        this.contextData.duplicate();
	    }
	    var i, arr = this.contextData.saved[this.contextData.cArrPos];
	    for (i = 0; i < 16; i += 1) {
	        arr[i] = props[i];
	    }
	    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
	    this.contextData.cArrPos += 1;
	};
	
	CanvasRenderer.prototype.restore = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.restore();
	        this.globalData.blendMode = 'source-over';
	    }
	    this.contextData.cArrPos -= 1;
	    var popped = this.contextData.saved[this.contextData.cArrPos];
	    var i,arr = this.contextData.cTr.props;
	    for(i=0;i<16;i+=1){
	        arr[i] = popped[i];
	    }
	    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
	    popped = this.contextData.savedOp[this.contextData.cArrPos];
	    this.contextData.cO = popped;
	    if(this.globalData.currentGlobalAlpha !== popped) {
	        this.canvasContext.globalAlpha = popped;
	        this.globalData.currentGlobalAlpha = popped;
	    }
	};
	
	CanvasRenderer.prototype.configAnimation = function(animData){
	    if(this.animationItem.wrapper){
	        this.animationItem.container = createTag('canvas');
	        this.animationItem.container.style.width = '100%';
	        this.animationItem.container.style.height = '100%';
	        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
	        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
	        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
	        this.animationItem.wrapper.appendChild(this.animationItem.container);
	        this.canvasContext = this.animationItem.container.getContext('2d');
	        if(this.renderConfig.className) {
	            this.animationItem.container.setAttribute('class', this.renderConfig.className);
	        }
	    }else{
	        this.canvasContext = this.renderConfig.context;
	    }
	    this.data = animData;
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.totalFrames = Math.floor(animData.tf);
	    this.globalData.compWidth = animData.w;
	    this.globalData.compHeight = animData.h;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	        w: animData.w,
	        h:animData.h,
	        sx:0,
	        sy:0,
	        tx:0,
	        ty:0
	    };
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,document.body);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem);
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);
	
	    this.updateContainerSize();
	};
	
	CanvasRenderer.prototype.updateContainerSize = function () {
	    this.reset();
	    var elementWidth,elementHeight;
	    if(this.animationItem.wrapper && this.animationItem.container){
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
	        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
	    }else{
	        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
	        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
	    }
	    var elementRel,animationRel;
	    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
	        var par = this.renderConfig.preserveAspectRatio.split(' ');
	        var fillType = par[1] || 'meet';
	        var pos = par[0] || 'xMidYMid';
	        var xPos = pos.substr(0,4);
	        var yPos = pos.substr(4);
	        elementRel = elementWidth/elementHeight;
	        animationRel = this.transformCanvas.w/this.transformCanvas.h;
	        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
	            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        }else{
	            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	        }
	
	        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
	        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.tx = 0;
	        }
	        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
	        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.ty = 0;
	        }
	
	    }else if(this.renderConfig.preserveAspectRatio == 'none'){
	        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }else{
	        this.transformCanvas.sx = this.renderConfig.dpr;
	        this.transformCanvas.sy = this.renderConfig.dpr;
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }
	    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
	    /*var i, len = this.elements.length;
	    for(i=0;i<len;i+=1){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(this.globalData.transformCanvas);
	        }
	    }*/
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	};
	
	CanvasRenderer.prototype.destroy = function () {
	    if(this.renderConfig.clearCanvas) {
	        this.animationItem.wrapper.innerHTML = '';
	    }
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	};
	
	CanvasRenderer.prototype.renderFrame = function(num){
	    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === -1){
	        return;
	    }
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = false;
	    this.globalData.projectInterface.currentFrame = num;
	
	     // console.log('--------');
	     // console.log('NEW: ',num);
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for (i = 0; i < len; i++) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        if(this.renderConfig.clearCanvas === true){
	            this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	        }else{
	            this.save();
	        }
	        for (i = len - 1; i >= 0; i-=1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	        if(this.renderConfig.clearCanvas !== true){
	            this.restore();
	        }
	    }
	};
	
	CanvasRenderer.prototype.buildItem = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    var element = this.createItem(this.layers[pos], this,this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /*if(this.layers[pos].ty === 0){
	        element.resize(this.globalData.transformCanvas);
	    }*/
	};
	
	CanvasRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	CanvasRenderer.prototype.hide = function(){
	    this.animationItem.container.style.display = 'none';
	};
	
	CanvasRenderer.prototype.show = function(){
	    this.animationItem.container.style.display = 'block';
	};
	
	function HybridRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	        className: (config && config.className) || '',
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true
	    };
	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	
	}
	
	extendPrototype([BaseRenderer],HybridRenderer);
	
	HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	HybridRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	HybridRenderer.prototype.appendElementInPos = function(element, pos){
	    var newDOMElement = element.getBaseElement();
	    if(!newDOMElement){
	        return;
	    }
	    var layer = this.layers[pos];
	    if(!layer.ddd || !this.supports3d){
	        if(this.threeDElements) {
	            this.addTo3dContainer(newDOMElement,pos);
	        } else {
	            var i = 0;
	            var nextDOMElement, nextLayer, tmpDOMElement;
	            while(i<pos){
	                if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
	                    nextLayer = this.elements[i];
	                    tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	                    nextDOMElement = tmpDOMElement || nextDOMElement;
	                }
	                i += 1;
	            }
	            if(nextDOMElement){
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	                }
	            } else {
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.appendChild(newDOMElement);
	                }
	            }
	        }
	        
	    } else {
	        this.addTo3dContainer(newDOMElement,pos);
	    }
	};
	
	HybridRenderer.prototype.createShape = function (data) {
	    if(!this.supports3d){
	        return new SVGShapeElement(data, this.globalData, this);
	    }
	    return new HShapeElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createText = function (data) {
	    if(!this.supports3d){
	        return new SVGTextElement(data, this.globalData, this);
	    }
	    return new HTextElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	};
	
	HybridRenderer.prototype.createImage = function (data) {
	    if(!this.supports3d){
	        return new IImageElement(data, this.globalData, this);
	    }
	    return new HImageElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createComp = function (data) {
	    if(!this.supports3d){
	        return new SVGCompElement(data, this.globalData, this);
	    }
	    return new HCompElement(data, this.globalData, this);
	
	};
	
	HybridRenderer.prototype.createSolid = function (data) {
	    if(!this.supports3d){
	        return new ISolidElement(data, this.globalData, this);
	    }
	    return new HSolidElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;
	
	HybridRenderer.prototype.getThreeDContainerByPos = function(pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len) {
	        if(this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	            return this.threeDElements[i].perspectiveElem;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.createThreeDContainer = function(pos, type){
	    var perspectiveElem = createTag('div');
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);
	    if(type === '3d') {
	        perspectiveElem.style.width = this.globalData.compSize.w+'px';
	        perspectiveElem.style.height = this.globalData.compSize.h+'px';
	        perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
	        container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    }
	    
	    perspectiveElem.appendChild(container);
	    //this.resizerElem.appendChild(perspectiveElem);
	    var threeDContainerData = {
	        container:container,
	        perspectiveElem:perspectiveElem,
	        startPos: pos,
	        endPos: pos,
	        type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	};
	
	HybridRenderer.prototype.build3dContainers = function(){
	    var i, len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';
	    for(i=0;i<len;i+=1){
	        if(this.layers[i].ddd && this.layers[i].ty !== 3){
	            if(currentContainer !== '3d'){
	                currentContainer = '3d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'3d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        } else {
	            if(currentContainer !== '2d'){
	                currentContainer = '2d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'2d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        }
	    }
	    len = this.threeDElements.length;
	    for(i = len - 1; i >= 0; i --) {
	        this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	};
	
	HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len){
	        if(pos <= this.threeDElements[i].endPos){
	            var j = this.threeDElements[i].startPos;
	            var nextElement;
	            while(j<pos){
	                if(this.elements[j] && this.elements[j].getBaseElement){
	                    nextElement = this.elements[j].getBaseElement();
	                }
	                j += 1;
	            }
	            if(nextElement){
	                this.threeDElements[i].container.insertBefore(elem, nextElement);
	            } else {
	                this.threeDElements[i].container.appendChild(elem);
	            }
	            break;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.configAnimation = function(animData){
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    resizerElem.style.width = animData.w+'px';
	    resizerElem.style.height = animData.h+'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
	    if(this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }
	    wrapper.appendChild(resizerElem);
	
	    resizerElem.style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width','1');
	    svg.setAttribute('height','1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.globalData.defs = defs;
	    this.data = animData;
	    //Mask animation
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.frameRate = animData.fr;
	    this.layers = animData.layers;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,svg);
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	};
	
	HybridRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	HybridRenderer.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth/elementHeight;
	    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
	    var sx,sy,tx,ty;
	    if(animationRel>elementRel){
	        sx = elementWidth/(this.globalData.compSize.w);
	        sy = elementWidth/(this.globalData.compSize.w);
	        tx = 0;
	        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
	    }else{
	        sx = elementHeight/(this.globalData.compSize.h);
	        sy = elementHeight/(this.globalData.compSize.h);
	        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
	        ty = 0;
	    }
	    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
	};
	
	HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	HybridRenderer.prototype.hide = function(){
	    this.resizerElem.style.display = 'none';
	};
	
	HybridRenderer.prototype.show = function(){
	    this.resizerElem.style.display = 'block';
	};
	
	HybridRenderer.prototype.initItems = function(){
	    this.buildAllItems();
	    if(this.camera){
	        this.camera.setup();
	    } else {
	        var cWidth = this.globalData.compSize.w;
	        var cHeight = this.globalData.compSize.h;
	        var i, len = this.threeDElements.length;
	        for(i=0;i<len;i+=1){
	            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
	        }
	    }
	};
	
	HybridRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createTag('div');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function CVShapeData(element, data) {
	    this.nodes = [];
	    this.trNodes = [];
	    this.tr = [0,0,0,0,0,0];
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    this.sh = ShapePropertyFactory.getShapeProp(element,data,ty,element);
	    this.st = false;
	    this.fl = false;
	}
	
	CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
	function CVContextData() {
		this.saved = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    this.cO = 1;
	    var i, len = 15;
	    this.savedOp = createTypedArray('float32', len);
	    for(i=0;i<len;i+=1){
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = len;
	}
	
	CVContextData.prototype.duplicate = function() {
		var newLength = this._length * 2;
		var currentSavedOp = this.savedOp;
	    this.savedOp = createTypedArray('float32', newLength);
	    this.savedOp.set(currentSavedOp);
	    var i = 0;
	    for(i = this._length; i < newLength; i += 1) {
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = newLength;
	};
	
	CVContextData.prototype.reset = function() {
		this.cArrPos = 0;
		this.cTr.reset();
	    this.cO = 1;
	};
	function CVBaseElement(){
	}
	
	CVBaseElement.prototype = {
	    createElements: function(){},
	    initRendererElement: function(){},
	    createContainerElements: function(){
	        this.canvasContext = this.globalData.canvasContext;
	        this.renderableEffectsManager = new CVEffects(this);
	    },
	    createContent: function(){},
	    setBlendMode: function(){
	        var globalData = this.globalData;
	        if(globalData.blendMode !== this.data.bm) {
	            globalData.blendMode = this.data.bm;
	            var blendModeValue = this.getBlendMode();
	            globalData.canvasContext.globalCompositeOperation = blendModeValue;
	        }
	    },
	    addMasks: function(){
	        this.maskManager = new CVMaskElement(this.data, this);
	    },
	    hideElement: function(){
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	            this.hidden = true;
	        }
	    },
	    showElement: function(){
	        if (this.isInRange && !this.isTransparent){
	            this.hidden = false;
	            this._isFirstFrame = true;
	            this.maskManager._isFirstFrame = true;
	        }
	    },
	    renderFrame: function() {
	        if (this.hidden) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.setBlendMode();
	        this.globalData.renderer.save();
	        this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
	        this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
	        this.renderInnerContent();
	        this.globalData.renderer.restore();
	        if(this.maskManager.hasMasks) {
	            this.globalData.renderer.restore(true);
	        }
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.canvasContext = null;
	        this.data = null;
	        this.globalData = null;
	        this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	};
	CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
	
	function CVImageElement(data, globalData, comp){
	    this.failed = false;
	    this.img = new Image();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	    this.globalData.addPendingElement();
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
	
	CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	CVImageElement.prototype.imageLoaded = function() {
	    this.globalData.elementLoaded();
	    if(this.assetData.w !== this.img.width || this.assetData.h !== this.img.height){
	        var canvas = createTag('canvas');
	        canvas.width = this.assetData.w;
	        canvas.height = this.assetData.h;
	        var ctx = canvas.getContext('2d');
	
	        var imgW = this.img.width;
	        var imgH = this.img.height;
	        var imgRel = imgW / imgH;
	        var canvasRel = this.assetData.w/this.assetData.h;
	        var widthCrop, heightCrop;
	        if(imgRel>canvasRel){
	            heightCrop = imgH;
	            widthCrop = heightCrop*canvasRel;
	        } else {
	            widthCrop = imgW;
	            heightCrop = widthCrop/canvasRel;
	        }
	        ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
	        this.img = canvas;
	    }
	};
	
	CVImageElement.prototype.imageFailed = function() {
	    this.failed = true;
	    this.globalData.elementLoaded();
	};
	
	CVImageElement.prototype.createContent = function(){
	    var img = this.img;
	    img.addEventListener('load', this.imageLoaded.bind(this), false);
	    img.addEventListener('error', this.imageFailed.bind(this), false);
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    img.src = assetPath;
	
	};
	
	CVImageElement.prototype.renderInnerContent = function(parentMatrix){
	    if (this.failed) {
	        return;
	    }
	    this.canvasContext.drawImage(this.img, 0, 0);
	};
	
	CVImageElement.prototype.destroy = function(){
	    this.img = null;
	};
	function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate, this) : {_placeholder:true};
	}
	
	extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);
	
	CVCompElement.prototype.renderInnerContent = function() {
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	CVCompElement.prototype.destroy = function(){
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.layers = null;
	    this.elements = null;
	};
	
	function CVMaskElement(data,element){
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i, len = this.masksProperties.length, hasMasks = false;
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            hasMasks = true;
	        }
	        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3);
	    }
	    this.hasMasks = hasMasks;
	    if(hasMasks) {
	        this.element.addRenderableComponent(this);
	    }
	}
	
	CVMaskElement.prototype.renderFrame = function () {
	    if(!this.hasMasks){
	        return;
	    }
	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i, len = this.masksProperties.length;
	    var pt,pts,data;
	    ctx.beginPath();
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            if (this.masksProperties[i].inv) {
	                ctx.moveTo(0, 0);
	                ctx.lineTo(this.element.globalData.compWidth, 0);
	                ctx.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight);
	                ctx.lineTo(0, this.element.globalData.compHeight);
	                ctx.lineTo(0, 0);
	            }
	            data = this.viewData[i].v;
	            pt = transform.applyToPointArray(data.v[0][0],data.v[0][1],0);
	            ctx.moveTo(pt[0], pt[1]);
	            var j, jLen = data._length;
	            for (j = 1; j < jLen; j++) {
	                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	            }
	            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }
	    }
	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	};
	
	CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
	
	CVMaskElement.prototype.destroy = function(){
	    this.element = null;
	};
	function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.initElement(data, globalData, comp);
	}
	
	extendPrototype([BaseElement,TransformElement,CVBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableElement], CVShapeElement);
	
	CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
	
	CVShapeElement.prototype.transformHelper = {opacity:1,mat:new Matrix(),_matMdf:false,_opMdf:false};
	
	CVShapeElement.prototype.dashResetter = [];
	
	CVShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true);
	};
	
	CVShapeElement.prototype.createStyleElement = function(data){
	    var styleElem = {
	        data: data,
	        type: data.ty,
	        elements: []
	    };
	    var elementData = {};
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,this);
	        if(!elementData.c.k){
	            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
	        }
	    }
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,this);
	    if(data.ty == 'st') {
	        styleElem.lc = this.lcEnum[data.lc] || 'round';
	        styleElem.lj = this.ljEnum[data.lj] || 'round';
	        if(data.lj == 1) {
	            styleElem.ml = data.ml;
	        }
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,this);
	        if(!elementData.w.k){
	            styleElem.wi = elementData.w.v;
	        }
	        if(data.d){
	            var d = new DashProperty(this,data.d,'canvas');
	            elementData.d = d;
	            if(!elementData.d.k){
	                styleElem.da = elementData.d.dashArray;
	                styleElem.do = elementData.d.dashoffset[0];
	            }
	        }
	
	    } else {
	
	        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	};
	
	CVShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    return elementData;
	};
	
	CVShapeElement.prototype.createTransformElement = function(data) {
	    var elementData = {
	        transform : {
	            mat: new Matrix(),
	            opacity: 1,
	            _matMdf:false,
	            _opMdf:false,
	            op: PropertyFactory.getProp(this,data.o,0,0.01,this),
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,this)
	        },
	        elements: []
	    };
	    return elementData;
	};
	
	CVShapeElement.prototype.createShapeElement = function(data) {
	    var elementData = new CVShapeData(this, data);
	    
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    var j, jLen = this.stylesList.length;
	    var hasStrokes = false, hasFills = false;
	    for(j=0;j<jLen;j+=1){
	        if(!this.stylesList[j].closed){
	            this.stylesList[j].elements.push(elementData);
	            if(this.stylesList[j].type === 'st'){
	                hasStrokes = true;
	            }else{
	                hasFills = true;
	            }
	        }
	    }
	    elementData.st = hasStrokes;
	    elementData.fl = hasFills;
	    return elementData;
	};
	
	CVShapeElement.prototype.reloadShapes = function(){
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for(i=0;i<len;i+=1){
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true);
	    len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	};
	
	CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData, render){
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownArrays = [], ownModifiers = [], processedPos, modifier;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i]);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            
	            ownArrays.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData, render);
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i]);
	            }
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i]);
	            }
	            
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        } else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownArrays.length;
	    for(i=0;i<len;i+=1){
	        ownArrays[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	CVShapeElement.prototype.renderInnerContent = function() {
	
	    this.transformHelper.mat.reset();
	    this.transformHelper.opacity = 1;
	    this.transformHelper._matMdf = false;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.renderShape(this.transformHelper,this.shapesData,this.itemsData,true);
	};
	
	CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
	    var props, groupMatrix;
	    if(parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	        groupTransform.opacity = parentTransform.opacity;
	        groupTransform.opacity *= groupTransform.op.v;
	        groupTransform._opMdf = true;
	    }
	    if(parentTransform._matMdf || groupTransform.mProps._mdf || this._isFirstFrame) {
	        groupMatrix = groupTransform.mat;
	        groupMatrix.cloneFromProps(groupTransform.mProps.v.props);
	        groupTransform._matMdf = true;
	        props = parentTransform.mat.props;
	        groupMatrix.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    }
	};
	
	CVShapeElement.prototype.drawLayer = function() {
	    var i, len = this.stylesList.length;
	    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type, currentStyle;
	    for(i=0;i<len;i+=1){
	        currentStyle = this.stylesList[i];
	        type = currentStyle.type;
	        if((type === 'st' && currentStyle.wi === 0) || !currentStyle.data._render || currentStyle.coOp === 0){
	            continue;
	        }
	        renderer.save();
	        elems = currentStyle.elements;
	        if(type === 'st'){
	            ctx.strokeStyle = currentStyle.co;
	            ctx.lineWidth = currentStyle.wi;
	            ctx.lineCap = currentStyle.lc;
	            ctx.lineJoin = currentStyle.lj;
	            ctx.miterLimit = currentStyle.ml || 0;
	        }else{
	            ctx.fillStyle = currentStyle.co;
	        }
	        renderer.ctxOpacity(currentStyle.coOp);
	        if(this.globalData.currentGlobalAlpha !== 0) {
	            if(type !== 'st'){
	                ctx.beginPath();
	            }
	            jLen = elems.length;
	            for(j=0;j<jLen;j+=1){
	                if(type === 'st'){
	                    ctx.beginPath();
	                    if(currentStyle.da){
	                        ctx.setLineDash(currentStyle.da);
	                        ctx.lineDashOffset = currentStyle.do;
	                        this.globalData.isDashed = true;
	                    }else if(this.globalData.isDashed){
	                        ctx.setLineDash(this.dashResetter);
	                        this.globalData.isDashed = false;
	                    }
	                }
	                nodes = elems[j].trNodes;
	                kLen = nodes.length;
	
	                for(k=0;k<kLen;k+=1){
	                    if(nodes[k].t == 'm'){
	                        ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
	                    }else if(nodes[k].t == 'c'){
	                        ctx.bezierCurveTo(nodes[k].pts[0],nodes[k].pts[1],nodes[k].pts[2],nodes[k].pts[3],nodes[k].pts[4],nodes[k].pts[5]);
	                    }else{
	                        ctx.closePath();
	                    }
	                }
	                if(type === 'st'){
	                    ctx.stroke();
	                }
	            }
	            if(type !== 'st'){
	                ctx.fill(currentStyle.r);
	            }
	            
	        }
	        renderer.restore();
	    }
	};
	
	CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
	    var i, len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;
	    for(i=len;i>=0;i-=1){
	        if(items[i].ty == 'tr'){
	            groupTransform = data[i].transform;
	            this.renderShapeTransform(parentTransform, groupTransform);
	        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
	            this.renderPath(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'fl'){
	            this.renderFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'st'){
	            this.renderStroke(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gr'){
	            this.renderShape(groupTransform,items[i].it,data[i].it);
	        }else if(items[i].ty == 'tm'){
	            //
	        }
	    }
	    if(isMain){
	        this.drawLayer();
	    }
	    
	};
	CVShapeElement.prototype.renderPath = function(pathData,itemData,groupTransform){
	    var len, i, j,jLen;
	    var redraw = groupTransform._matMdf || itemData.sh._mdf || this._isFirstFrame;
	    if(redraw) {
	        var paths = itemData.sh.paths, groupTransformMat = groupTransform.mat;
	        jLen = pathData._render === false ? 0 : paths._length;
	        var pathStringTransformed = itemData.trNodes;
	        pathStringTransformed.length = 0;
	        for(j=0;j<jLen;j+=1){
	            var pathNodes = paths.shapes[j];
	            if(pathNodes && pathNodes.v){
	                len = pathNodes._length;
	                for (i = 1; i < len; i += 1) {
	                    if (i == 1) {
	                        pathStringTransformed.push({
	                            t: 'm',
	                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                        });
	                    }
	                    pathStringTransformed.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	                    });
	                }
	                if (len == 1) {
	                    pathStringTransformed.push({
	                        t: 'm',
	                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                }
	                if (pathNodes.c && len) {
	                    pathStringTransformed.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	                    });
	                    pathStringTransformed.push({
	                        t: 'z'
	                    });
	                }
	                itemData.lStr = pathStringTransformed;
	            }
	
	        }
	
	        if (itemData.st) {
	            for (i = 0; i < 16; i += 1) {
	                itemData.tr[i] = groupTransform.mat.props[i];
	            }
	        }
	        itemData.trNodes = pathStringTransformed;
	
	    }
	};
	
	
	
	CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	
	    if(itemData.c._mdf || this._isFirstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	};
	
	CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    var d = itemData.d;
	    if(d && (d._mdf  || this._isFirstFrame)){
	        styleElem.da = d.dashArray;
	        styleElem.do = d.dashoffset[0];
	    }
	    if(itemData.c._mdf || this._isFirstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	    if(itemData.w._mdf || this._isFirstFrame){
	        styleElem.wi = itemData.w.v;
	    }
	};
	
	
	CVShapeElement.prototype.destroy = function(){
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	};
	
	
	function CVSolidElement(data, globalData, comp) {
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
	
	CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	CVSolidElement.prototype.renderInnerContent = function() {
	    var ctx = this.canvasContext;
	    ctx.fillStyle = this.data.sc;
	    ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	};
	function CVTextElement(data, globalData, comp){
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	        fill: 'rgba(0,0,0,0)',
	        stroke: 'rgba(0,0,0,0)',
	        sWidth: 0,
	        fValue: ''
	    };
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement,ITextElement], CVTextElement);
	
	CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
	
	CVTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	
	    var hasFill = false;
	    if(documentData.fc) {
	        hasFill = true;
	        this.values.fill = this.buildColor(documentData.fc);
	    }else{
	        this.values.fill = 'rgba(0,0,0,0)';
	    }
	    this.fill = hasFill;
	    var hasStroke = false;
	    if(documentData.sc){
	        hasStroke = true;
	        this.values.stroke = this.buildColor(documentData.sc);
	        this.values.sWidth = documentData.sw;
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i, len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length;
	    //this.tHelper.font = this.values.fValue;
	    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var cnt = 0;
	    for (i = 0; i < len; i += 1) {
	        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        shapeData = charData && charData.data || {};
	        matrixHelper.reset();
	        if(singleShape && letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }
	
	        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	        jLen = shapes.length;
	        matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	        if(singleShape){
	            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	        }
	        commands = createSizedArray(jLen);
	        for(j=0;j<jLen;j+=1){
	            kLen = shapes[j].ks.k.i.length;
	            pathNodes = shapes[j].ks.k;
	            pathArr = [];
	            for(k=1;k<kLen;k+=1){
	                if(k==1){
	                    pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                }
	                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
	            }
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	            commands[j] = pathArr;
	        }
	        if(singleShape){
	            xPos += letters[i].l;
	            xPos += trackingOffset;
	        }
	        if(this.textSpans[cnt]){
	            this.textSpans[cnt].elem = commands;
	        } else {
	            this.textSpans[cnt] = {elem: commands};
	        }
	        cnt +=1;
	    }
	};
	
	CVTextElement.prototype.renderInnerContent = function(){
	    var ctx = this.canvasContext;
	    var finalMat = this.finalTransform.mat.props;
	    ctx.font = this.values.fValue;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 4;
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }
	
	    var  i,len, j, jLen, k, kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(renderedLetter){
	            this.globalData.renderer.save();
	            this.globalData.renderer.ctxTransform(renderedLetter.p);
	            this.globalData.renderer.ctxOpacity(renderedLetter.o);
	        }
	        if(this.fill){
	            if(renderedLetter && renderedLetter.fc){
	                if(lastFill !== renderedLetter.fc){
	                    lastFill = renderedLetter.fc;
	                    ctx.fillStyle = renderedLetter.fc;
	                }
	            }else if(lastFill !== this.values.fill){
	                lastFill = this.values.fill;
	                ctx.fillStyle = this.values.fill;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.fill();
	            ///ctx.fillText(this.textSpans[i].val,0,0);
	        }
	        if(this.stroke){
	            if(renderedLetter && renderedLetter.sw){
	                if(lastStrokeW !== renderedLetter.sw){
	                    lastStrokeW = renderedLetter.sw;
	                    ctx.lineWidth = renderedLetter.sw;
	                }
	            }else if(lastStrokeW !== this.values.sWidth){
	                lastStrokeW = this.values.sWidth;
	                ctx.lineWidth = this.values.sWidth;
	            }
	            if(renderedLetter && renderedLetter.sc){
	                if(lastStroke !== renderedLetter.sc){
	                    lastStroke = renderedLetter.sc;
	                    ctx.strokeStyle = renderedLetter.sc;
	                }
	            }else if(lastStroke !== this.values.stroke){
	                lastStroke = this.values.stroke;
	                ctx.strokeStyle = this.values.stroke;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.stroke();
	            ///ctx.strokeText(letters[i].val,0,0);
	        }
	        if(renderedLetter) {
	            this.globalData.renderer.restore();
	        }
	    }
	    /*if(this.data.hasMask){
	     this.globalData.renderer.restore(true);
	     }*/
	};
	function CVEffects() {
	
	}
	CVEffects.prototype.renderFrame = function(){};
	function HBaseElement(data,globalData,comp){}
	HBaseElement.prototype = {
	    checkBlendMode: function(){},
	    initRendererElement: function(){
	        this.baseElement = createTag(this.data.tg || 'div');
	        if(this.data.hasMask) {
	            this.svgElement = createNS('svg');
	            this.layerElement = createNS('g');
	            this.maskedElement = this.layerElement;
	            this.svgElement.appendChild(this.layerElement);
	            this.baseElement.appendChild(this.svgElement);
	        } else {
	            this.layerElement = this.baseElement;
	        }
	        styleDiv(this.baseElement);
	    },
	    createContainerElements: function(){
	        this.renderableEffectsManager = new CVEffects(this);
	        this.transformedElement = this.baseElement;
	        this.maskedElement = this.layerElement;
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id',this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }
	    },
	    renderElement: function() {
	        if(this.finalTransform._matMdf){
	            this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = this.finalTransform.mat.toCSS();
	        }
	        if(this.finalTransform._opMdf){
	            this.transformedElement.style.opacity = this.finalTransform.mProp.o.v;
	        }
	    },
	    renderFrame: function() {
	        //If it is exported as hidden (data.hd === true) no need to render
	        //If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.renderElement();
	        this.renderInnerContent();
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.layerElement = null;
	        this.transformedElement = null;
	        if(this.matteElement) {
	            this.matteElement = null;
	        }
	        if(this.maskManager) {
	            this.maskManager.destroy();
	            this.maskManager = null;
	        }
	    },
	    addMasks: function(){
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    setMatte: function(){}
	};
	HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	function HSolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], HSolidElement);
	
	HSolidElement.prototype.createContent = function(){
	    var rect;
	    if(this.data.hasMask){
	        rect = createNS('rect');
	        rect.setAttribute('width',this.data.sw);
	        rect.setAttribute('height',this.data.sh);
	        rect.setAttribute('fill',this.data.sc);
	        this.svgElement.setAttribute('width',this.data.sw);
	        this.svgElement.setAttribute('height',this.data.sh);
	    } else {
	        rect = createTag('div');
	        rect.style.width = this.data.sw + 'px';
	        rect.style.height = this.data.sh + 'px';
	        rect.style.backgroundColor = this.data.sc;
	    }
	    this.layerElement.appendChild(rect);
	};
	
	function HCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}
	
	extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
	HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
	
	HCompElement.prototype.createContainerElements = function(){
	    this._createBaseContainerElements();
	    //divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	    if(this.data.hasMask){
	        this.svgElement.setAttribute('width',this.data.w);
	        this.svgElement.setAttribute('height',this.data.h);
	        this.transformedElement = this.baseElement;
	    } else {
	        this.transformedElement = this.layerElement;
	    }
	};
	
	HCompElement.prototype.addTo3dContainer = function(elem,pos) {
	    var j = 0;
	    var nextElement;
	    while(j<pos){
	        if(this.elements[j] && this.elements[j].getBaseElement){
	            nextElement = this.elements[j].getBaseElement();
	        }
	        j += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(elem, nextElement);
	    } else {
	        this.layerElement.appendChild(elem);
	    }
	}
	
	function HShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	}
	extendPrototype([BaseElement,TransformElement,HSolidElement,SVGShapeElement,HBaseElement,HierarchyElement,FrameElement,RenderableElement], HShapeElement);
	HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
	
	HShapeElement.prototype.createContent = function(){
	    var cont;
	    this.baseElement.style.fontSize = 0;
	    if (this.data.hasMask) {
	        this.layerElement.appendChild(this.shapesContainer);
	        cont = this.svgElement;
	    } else {
	        cont = createNS('svg');
	        var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	        cont.setAttribute('width',size.w);
	        cont.setAttribute('height',size.h);
	        cont.appendChild(this.shapesContainer);
	        this.layerElement.appendChild(cont);
	    }
	
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.shapesContainer,0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	};
	
	HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
	    var i, len = transformers.length;
	    for(i = 0; i < len; i += 1) {
	        point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }
	    return point;
	}
	
	HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i, len = shape._length, vPoint, oPoint, nextIPoint, nextVPoint, bounds;
	    if (len <= 1) {
	        return;
	    }
	    for (i = 0; i < len - 1; i += 1) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	    if(shape.c) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	}
	
	HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bm_min(bounds.left, boundingBox.x);
	    boundingBox.xMax = bm_max(bounds.right, boundingBox.xMax);
	    boundingBox.y = bm_min(bounds.top, boundingBox.y);
	    boundingBox.yMax = bm_max(bounds.bottom, boundingBox.yMax);
	}
	
	HShapeElement.prototype.shapeBoundingBox = {
	    left:0,
	    right:0,
	    top:0,
	    bottom:0,
	}
	
	HShapeElement.prototype.tempBoundingBox = {
	    x:0,
	    xMax:0,
	    y:0,
	    yMax:0,
	    width:0,
	    height:0
	}
	
	HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
	
	    var bounds = [[p0[0],p3[0]], [p0[1],p3[1]]];
	
	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
	
	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];
	
	      b = b | 0;
	      a = a | 0;
	      c = c | 0;
	
	      if (a === 0) {
	
	        if (b === 0) {
	          continue;
	        }
	
	        t = -c / b;
	
	        if (0 < t && t < 1) {
	          bounds[i].push(this.calculateF(t,p0,p1,p2,p3,i));
	        }
	        continue;
	      }
	
	      b2ac = b * b - 4 * c * a;
	
	      if (b2ac < 0) {
	        continue;
	      }
	
	      t1 = (-b + bm_sqrt(b2ac))/(2 * a);
	      if (0 < t1 && t1 < 1) bounds[i].push(this.calculateF(t1,p0,p1,p2,p3,i));
	
	      t2 = (-b - bm_sqrt(b2ac))/(2 * a);
	      if (0 < t2 && t2 < 1) bounds[i].push(this.calculateF(t2,p0,p1,p2,p3,i));
	
	    }
	
	    this.shapeBoundingBox.left = bm_min.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bm_min.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bm_max.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bm_max.apply(null, bounds[1]);
	  };
	
	  HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
	    return bm_pow(1-t, 3) * p0[i]
	        + 3 * bm_pow(1-t, 2) * t * p1[i]
	        + 3 * (1-t) * bm_pow(t, 2) * p2[i]
	        + bm_pow(t, 3) * p3[i];
	  }
	
	HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
	    var i, len = itemsData.length, path;
	    for(i = 0; i < len; i += 1) {
	        if(itemsData[i] && itemsData[i].sh) {
	            this.calculateShapeBoundingBox(itemsData[i], boundingBox)
	        } else if(itemsData[i] && itemsData[i].it) {
	            this.calculateBoundingBox(itemsData[i].it, boundingBox)
	        }
	    }
	}
	
	HShapeElement.prototype.currentBoxContains = function(box) {
	    return this.currentBBox.x <= box.x 
	    && this.currentBBox.y <= box.y 
	    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
	    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height
	}
	
	HShapeElement.prototype.renderInnerContent = function() {
	    this._renderShapeFrame();
	
	    if(!this.hidden && (this._isFirstFrame || this._mdf)) {
	        var tempBoundingBox = this.tempBoundingBox;
	        var max = 999999;
	        tempBoundingBox.x = max;
	        tempBoundingBox.xMax = -max;
	        tempBoundingBox.y = max;
	        tempBoundingBox.yMax = -max;
	        this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	        tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	        tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
	        //var tempBoundingBox = this.shapeCont.getBBox();
	        if(this.currentBoxContains(tempBoundingBox)) {
	            return;
	        }
	        var changed = false;
	        if(this.currentBBox.w !== tempBoundingBox.width){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.shapeCont.setAttribute('width',tempBoundingBox.width);
	            changed = true;
	        }
	        if(this.currentBBox.h !== tempBoundingBox.height){
	            this.currentBBox.h = tempBoundingBox.height;
	            this.shapeCont.setAttribute('height',tempBoundingBox.height);
	            changed = true;
	        }
	        if(changed  || this.currentBBox.x !== tempBoundingBox.x  || this.currentBBox.y !== tempBoundingBox.y){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.currentBBox.h = tempBoundingBox.height;
	            this.currentBBox.x = tempBoundingBox.x;
	            this.currentBBox.y = tempBoundingBox.y;
	
	            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	
	};
	function HTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data,globalData,comp);
	
	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], HTextElement);
	
	HTextElement.prototype.createContent = function(){
	    this.isMasked = this.checkMasks();
	    if(this.isMasked){
	        this.renderType = 'svg';
	        this.compW = this.comp.data.w;
	        this.compH = this.comp.data.h;
	        this.svgElement.setAttribute('width',this.compW);
	        this.svgElement.setAttribute('height',this.compH);
	        var g = createNS('g');
	        this.maskedElement.appendChild(g);
	        this.innerElem = g;
	    } else {
	        this.renderType = 'html';
	        this.innerElem = this.layerElement;
	    }
	
	    this.checkParenting();
	
	};
	
	HTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    innerElemStyle.color = innerElemStyle.fill = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    if(documentData.sc){
	        innerElemStyle.stroke = this.buildColor(documentData.sc);
	        innerElemStyle.strokeWidth = documentData.sw+'px';
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(!this.globalData.fontManager.chars){
	        innerElemStyle.fontSize = documentData.finalSize+'px';
	        innerElemStyle.lineHeight = documentData.finalSize+'px';
	        if(fontData.fClass){
	            this.innerElem.className = fontData.fClass;
	        } else {
	            innerElemStyle.fontFamily = fontData.fFamily;
	            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	            innerElemStyle.fontStyle = fStyle;
	            innerElemStyle.fontWeight = fWeight;
	        }
	    }
	    var i, len;
	
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan,tParent,tCont;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '';
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!this.textPaths[cnt]){
	                tSpan = createNS('path');
	                tSpan.setAttribute('stroke-linecap', 'butt');
	                tSpan.setAttribute('stroke-linejoin','round');
	                tSpan.setAttribute('stroke-miterlimit','4');
	            } else {
	                tSpan = this.textPaths[cnt];
	            }
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tCont = tParent.children[0];
	                } else {
	
	                    tParent = createTag('div');
	                    tCont = createNS('svg');
	                    tCont.appendChild(tSpan);
	                    styleDiv(tParent);
	                }
	            }
	        }else{
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tSpan = this.textPaths[cnt];
	                } else {
	                    tParent = createTag('span');
	                    styleDiv(tParent);
	                    tSpan = createTag('span');
	                    styleDiv(tSpan);
	                    tParent.appendChild(tSpan);
	                }
	            } else {
	                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	            }
	        }
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            matrixHelper.reset();
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	                shapeStr = this.createPathShape(matrixHelper,shapes);
	                tSpan.setAttribute('d',shapeStr);
	            }
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                if(shapeData && shapeData.shapes){
	
	                    //document.body.appendChild is needed to get exact measure of shape
	                    document.body.appendChild(tCont);
	                    var boundingBox = tCont.getBBox();
	                    tCont.setAttribute('width',boundingBox.width + 2);
	                    tCont.setAttribute('height',boundingBox.height + 2);
	                    tCont.setAttribute('viewBox',(boundingBox.x-1)+' '+ (boundingBox.y-1)+' '+ (boundingBox.width+2)+' '+ (boundingBox.height+2));
	                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + (boundingBox.x-1) + 'px,' + (boundingBox.y-1) + 'px)';
	
	                    letters[i].yOffset = boundingBox.y-1;
	
	                } else{
	                    tCont.setAttribute('width',1);
	                    tCont.setAttribute('height',1);
	                }
	                    tParent.appendChild(tCont);
	            }else{
	                this.innerElem.appendChild(tSpan);
	            }
	        }else{
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                //
	                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.finalSize/1.2+'px,0)';
	            } else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }
	        //
	        if(!this.isMasked){
	            this.textSpans[cnt] = tParent;
	        }else{
	            this.textSpans[cnt] = tSpan;
	        }
	        this.textSpans[cnt].style.display = 'block';
	        this.textPaths[cnt] = tSpan;
	        cnt += 1;
	    }
	    while(cnt < this.textSpans.length){
	        this.textSpans[cnt].style.display = 'none';
	        cnt += 1;
	    }
	};
	
	HTextElement.prototype.renderInnerContent = function() {
	
	    if(this.data.singleShape){
	        if(!this._isFirstFrame && !this.lettersChangedFlag){
	            return;
	        } else {
	            // Todo Benchmark if using this is better than getBBox
	             if(this.isMasked && this.finalTransform._matMdf){
	                 this.svgElement.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
	                this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	             }
	        }
	    }
	
	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    if(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag){
	        return;
	    }
	    var  i,len, count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter, textSpan, textPath;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            count += 1;
	            continue;
	        }
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	        if(renderedLetter._mdf.m) {
	            if(!this.isMasked){
	                textSpan.style.transform = textSpan.style.webkitTransform = renderedLetter.m;
	            }else{
	                textSpan.setAttribute('transform',renderedLetter.m);
	            }
	        }
	        ////textSpan.setAttribute('opacity',renderedLetter.o);
	        textSpan.style.opacity = renderedLetter.o;
	        if(renderedLetter.sw && renderedLetter._mdf.sw){
	            textPath.setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc && renderedLetter._mdf.sc){
	            textPath.setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc && renderedLetter._mdf.fc){
	            textPath.setAttribute('fill',renderedLetter.fc);
	            textPath.style.color = renderedLetter.fc;
	        }
	    }
	
	    if(this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)){
	        var boundingBox = this.innerElem.getBBox();
	
	        if(this.currentBBox.w !== boundingBox.width){
	            this.currentBBox.w = boundingBox.width;
	            this.svgElement.setAttribute('width',boundingBox.width);
	        }
	        if(this.currentBBox.h !== boundingBox.height){
	            this.currentBBox.h = boundingBox.height;
	            this.svgElement.setAttribute('height',boundingBox.height);
	        }
	
	        var margin = 1;
	        if(this.currentBBox.w !== (boundingBox.width + margin*2) || this.currentBBox.h !== (boundingBox.height + margin*2)  || this.currentBBox.x !== (boundingBox.x - margin)  || this.currentBBox.y !== (boundingBox.y - margin)){
	            this.currentBBox.w = boundingBox.width + margin*2;
	            this.currentBBox.h = boundingBox.height + margin*2;
	            this.currentBBox.x = boundingBox.x - margin;
	            this.currentBBox.y = boundingBox.y - margin;
	
	            this.svgElement.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	};
	function HImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,HBaseElement,HSolidElement,HierarchyElement,FrameElement,RenderableElement], HImageElement);
	
	
	HImageElement.prototype.createContent = function(){
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if(this.data.hasMask){
	        this.imageElem = createNS('image');
	        this.imageElem.setAttribute('width',this.assetData.w+"px");
	        this.imageElem.setAttribute('height',this.assetData.h+"px");
	        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	        this.layerElement.appendChild(this.imageElem);
	        this.baseElement.setAttribute('width',this.assetData.w);
	        this.baseElement.setAttribute('height',this.assetData.h);
	    } else {
	        this.layerElement.appendChild(img);
	    }
	    img.src = assetPath;
	    if(this.data.ln){
	        this.baseElement.setAttribute('id',this.data.ln);
	    }
	};
	function HCameraElement(data,globalData,comp){
	    this.initFrame();
	    this.initBaseData(data,globalData,comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this,data.pe,0,0,this);
	    if(data.ks.p.s){
	        this.px = getProp(this,data.ks.p.x,1,0,this);
	        this.py = getProp(this,data.ks.p.y,1,0,this);
	        this.pz = getProp(this,data.ks.p.z,1,0,this);
	    }else{
	        this.p = getProp(this,data.ks.p,1,0,this);
	    }
	    if(data.ks.a){
	        this.a = getProp(this,data.ks.a,1,0,this);
	    }
	    if(data.ks.or.k.length && data.ks.or.k[0].to){
	        var i,len = data.ks.or.k.length;
	        for(i=0;i<len;i+=1){
	            data.ks.or.k[i].to = null;
	            data.ks.or.k[i].ti = null;
	        }
	    }
	    this.or = getProp(this,data.ks.or,1,degToRads,this);
	    this.or.sh = true;
	    this.rx = getProp(this,data.ks.rx,0,degToRads,this);
	    this.ry = getProp(this,data.ks.ry,0,degToRads,this);
	    this.rz = getProp(this,data.ks.rz,0,degToRads,this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true;
	}
	extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);
	
	HCameraElement.prototype.setup = function() {
	    var i, len = this.comp.threeDElements.length, comp;
	    for(i=0;i<len;i+=1){
	        //[perspectiveElem,container]
	        comp = this.comp.threeDElements[i];
	        if(comp.type === '3d') {
	            comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	            comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
	            comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        }
	    }
	};
	
	HCameraElement.prototype.createElements = function(){
	};
	
	HCameraElement.prototype.hide = function(){
	};
	
	HCameraElement.prototype.renderFrame = function(){
	    var _mdf = this._isFirstFrame;
	    var i, len;
	    if(this.hierarchy){
	        len = this.hierarchy.length;
	        for(i=0;i<len;i+=1){
	            _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	        }
	    }
	    if(_mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
	        this.mat.reset();
	
	        if(this.hierarchy){
	            var mat;
	            len = this.hierarchy.length - 1;
	            for (i = len; i >= 0; i -= 1) {
	                /*mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                console.log(mat)
	                this.mat.transform(-mat[0],-mat[1],-mat[2],-mat[3],-mat[4],-mat[5],-mat[6],-mat[7],-mat[8],-mat[9],-mat[10],-mat[11],-mat[12],-mat[13],-mat[14],mat[15]);
	                console.log(this.mat.props)*/
	                var mTransf = this.hierarchy[i].finalTransform.mProp;
	                this.mat.translate(-mTransf.p.v[0],-mTransf.p.v[1],mTransf.p.v[2]);
	                this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	                this.mat.scale(1/mTransf.s.v[0],1/mTransf.s.v[1],1/mTransf.s.v[2]);
	                this.mat.translate(mTransf.a.v[0],mTransf.a.v[1],mTransf.a.v[2]);
	            }
	        }
	
	        if(this.p){
	            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
	        }else{
	            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
	        }
	        if(this.a){
	            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
	            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
	            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
	            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
	            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
	            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
	            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);
	
	        }
	        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
	        this.mat.translate(0,0,this.pe.v);
	
	
	        
	
	
	        if(!this._prevMat.equals(this.mat) && this.comp.threeDElements) {
	            len = this.comp.threeDElements.length;
	            var comp;
	            for(i=0;i<len;i+=1){
	                comp = this.comp.threeDElements[i];
	                if(comp.type === '3d') {
	                    comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
	                }
	            }
	            this.mat.clone(this._prevMat);
	        }
	    }
	    this._isFirstFrame = false;
	};
	
	HCameraElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};
	
	HCameraElement.prototype.destroy = function(){
	};
	HCameraElement.prototype.initExpressions = function(){};
	HCameraElement.prototype.getBaseElement = function(){return null;};
	function HEffects() {
	}
	HEffects.prototype.renderFrame = function(){};
	var Expressions = (function(){
	    var ob = {};
	    ob.initExpressions = initExpressions;
	
	
	    function initExpressions(animation){
	        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	    }
	   return ob;
	}());
	
	expressionsPlugin = Expressions;
	
	var ExpressionManager = (function(){
	    'use strict';
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	
	    function duplicatePropertyValue(value, mult) {
	        mult = mult || 1;
	
	        if (typeof value === 'number'  || value instanceof Number) {
	            return value * mult;
	        } else if(value.i) {
	            return shape_pool.clone(value);
	        } else {
	            var arr = createTypedArray('float32', value.length);
	            var i, len = value.length;
	            for (i = 0; i < len; i += 1) {
	                arr[i] = value[i] * mult;
	            }
	            return arr;
	        }
	    }
	
	    function isTypeOfArray(arr) {
	        return arr.constructor === Array || arr.constructor === Float32Array;
	    }
	
	    function isNumerable(tOfV, v) {
	        return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
	    }
	
	    function $bm_neg(a){
	        var tOfA = typeof a;
	        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
	            return -a;
	        }
	        if(isTypeOfArray(a)){
	            var i, lenA = a.length;
	            var retArr = [];
	            for(i=0;i<lenA;i+=1){
	                retArr[i] = -a[i];
	            }
	            return retArr;
	        }
	    }
	
	    function sum(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(tOfA === 'string' || tOfB === 'string'){
	            return a + b;
	        }
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a + b;
	        }
	        if(isTypeOfArray(a) && isNumerable(tOfB, b)){
	            a = a.slice(0);
	            a[0] = a[0] + b;
	            return a;
	        }
	        if(isNumerable(tOfA, a) && isTypeOfArray(b)){
	            b = b.slice(0);
	            b[0] = a + b[0];
	            return b;
	        }
	        if(isTypeOfArray(a) && isTypeOfArray(b)){
	            
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] + b[i];
	                }else{
	                    retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	    var add = sum;
	
	    function sub(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            if(tOfA === 'string') {
	                a = parseInt(a);
	            }
	            if(tOfB === 'string') {
	                b = parseInt(b);
	            }
	            return a - b;
	        }
	        if( isTypeOfArray(a) && isNumerable(tOfB, b)){
	            a = a.slice(0);
	            a[0] = a[0] - b;
	            return a;
	        }
	        if(isNumerable(tOfA, a) &&  isTypeOfArray(b)){
	            b = b.slice(0);
	            b[0] = a - b[0];
	            return b;
	        }
	        if(isTypeOfArray(a) && isTypeOfArray(b)){
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] - b[i];
	                }else{
	                    retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	
	    function mul(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a * b;
	        }
	
	        var i, len;
	        if(isTypeOfArray(a) && isNumerable(tOfB, b)){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] * b;
	            }
	            return arr;
	        }
	        if(isNumerable(tOfA, a) && isTypeOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a * b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	
	    function div(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a / b;
	        }
	        var i, len;
	        if(isTypeOfArray(a) && isNumerable(tOfB, b)){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] / b;
	            }
	            return arr;
	        }
	        if(isNumerable(tOfA, a) && isTypeOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a / b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	    function mod(a,b) {
	        if(typeof a === 'string') {
	            a = parseInt(a);
	        }
	        if(typeof b === 'string') {
	            b = parseInt(b);
	        }
	        return a % b;
	    }
	
	    function clamp(num, min, max) {
	        if(min > max){
	            var mm = max;
	            max = min;
	            min = mm;
	        }
	        return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	        return val/degToRads;
	    }
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	        return val*degToRads;
	    }
	    var degrees_to_radians = radiansToDegrees;
	
	    var helperLengthArray = [0,0,0,0,0,0];
	
	    function length(arr1, arr2) {
	        if (typeof arr1 === 'number' || arr1 instanceof Number) {
	            arr2 = arr2 || 0;
	            return Math.abs(arr1 - arr2);
	        }
	        if(!arr2) {
	            arr2 = helperLengthArray;
	        }
	        var i, len = Math.min(arr1.length, arr2.length);
	        var addedLength = 0;
	        for (i = 0; i < len; i += 1) {
	            addedLength += Math.pow(arr2[i] - arr1[i], 2);
	        }
	        return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec) {
	        return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val) {
	        var r = val[0]; var g = val[1]; var b = val[2];
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if(max == min){
	            h = s = 0; // achromatic
	        }else{
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max){
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	
	        return [h, s, l,val[3]];
	    }
	
	    function hue2rgb(p, q, t){
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    function hslToRgb(val){
	        var h = val[0];
	        var s = val[1];
	        var l = val[2];
	
	        var r, g, b;
	
	        if(s === 0){
	            r = g = b = l; // achromatic
	        }else{
	
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }
	
	        return [r, g , b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2){
	        if(value1 === undefined || value2 === undefined){
	            return linear(t,0,1,tMin,tMax);
	        }
	        if(t <= tMin) {
	            return value1;
	        }else if(t >= tMax){
	            return value2;
	        }
	        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
	        if(!value1.length){
	            return value1 + (value2-value1)*perc;
	        }
	        var i, len = value1.length;
	        var arr = createTypedArray('float32', len);
	        for(i=0;i<len;i+=1){
	            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
	        }
	        return arr;
	    }
	    function random(min,max){
	        if(max === undefined){
	            if(min === undefined){
	                min = 0;
	                max = 1;
	            } else {
	                max = min;
	                min = undefined;
	            }
	        }
	        if(max.length){
	            var i, len = max.length;
	            if(!min){
	                min = createTypedArray('float32', len);
	            }
	            var arr = createTypedArray('float32', len);
	            var rnd = BMMath.random();
	            for(i=0;i<len;i+=1){
	                arr[i] = min[i] + rnd*(max[i]-min[i]);
	            }
	            return arr;
	        }
	        if(min === undefined){
	            min = 0;
	        }
	        var rndm = BMMath.random();
	        return min + rndm*(max-min);
	    }
	
	    function createPath(points, inTangents, outTangents, closed) {
	        var i, len = points.length;
	        var path = shape_pool.newElement();
	        path.setPathData(!!closed, len);
	        var arrPlaceholder = [0,0], inVertexPoint, outVertexPoint;
	        for(i = 0; i < len; i += 1) {
	            inVertexPoint = inTangents ? inTangents[i] : arrPlaceholder;
	            outVertexPoint = outTangents ? outTangents[i] : arrPlaceholder;
	            path.setTripleAt(points[i][0],points[i][1],outVertexPoint[0] + points[i][0],outVertexPoint[1] + points[i][1],inVertexPoint[0] + points[i][0],inVertexPoint[1] + points[i][1],i,true);
	        }
	        return path;
	    }
	
	    function initiateExpression(elem,data,property){
	        var val = data.x;
	        var needsVelocity = /velocity(?![\w\d])/.test(val);
	        var _needsRandom = val.indexOf('random') !== -1;
	        var elemType = elem.data.ty;
	        var transform,content,effect;
	        var thisProperty = property;
	        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
	        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        var width = elem.data.sw ? elem.data.sw : 0;
	        var height = elem.data.sh ? elem.data.sh : 0;
	        var loopIn, loop_in, loopOut, loop_out;
	        var toWorld,fromWorld,fromComp,fromCompToSurface,anchorPoint,thisLayer,thisComp,mask,valueAtTime,velocityAtTime;
	        var __expression_functions = [];
	        if(data.xf) {
	            var i, len = data.xf.length;
	            for(i = 0; i < len; i += 1) {
	                __expression_functions[i] = eval('(function(){ return ' + data.xf[i] + '}())');
	            }
	        }
	
	        var scoped_bm_rt;
	        var expression_function = eval('[function _expression_function(){' + val+';scoped_bm_rt=$bm_rt}' + ']')[0];
	        var numKeys = property.kf ? data.k.length : 0;
	
	        var wiggle = function wiggle(freq,amp){
	            var i,j, len = this.pv.length ? this.pv.length : 1;
	            var addedAmps = createTypedArray('float32', len);
	            freq = 5;
	            var iterations = Math.floor(time*freq);
	            i = 0;
	            j = 0;
	            while(i<iterations){
	                //var rnd = BMMath.random();
	                for(j=0;j<len;j+=1){
	                    addedAmps[j] += -amp + amp*2*BMMath.random();
	                    //addedAmps[j] += -amp + amp*2*rnd;
	                }
	                i += 1;
	            }
	            //var rnd2 = BMMath.random();
	            var periods = time*freq;
	            var perc = periods - Math.floor(periods);
	            var arr = createTypedArray('float32', len);
	            if(len>1){
	                for(j=0;j<len;j+=1){
	                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
	                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	                }
	                return arr;
	            } else {
	                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
	            }
	        }.bind(this);
	
	        if(thisProperty.loopIn) {
	            loopIn = thisProperty.loopIn.bind(thisProperty);
	            loop_in = loopIn;
	        }
	
	        if(thisProperty.loopOut) {
	            loopOut = thisProperty.loopOut.bind(thisProperty);
	            loop_out = loopOut;
	        }
	
	        function loopInDuration(type,duration){
	            return loopIn(type,duration,true);
	        }
	
	        function loopOutDuration(type,duration){
	            return loopOut(type,duration,true);
	        }
	
	        if(this.getValueAtTime) {
	            valueAtTime = this.getValueAtTime.bind(this);
	        }
	
	        if(this.getVelocityAtTime) {
	            velocityAtTime = this.getVelocityAtTime.bind(this);
	        }
	
	        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	        function lookAt(elem1,elem2){
	            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
	            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
	            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
	            return [yaw,pitch,0];
	        }
	
	        function easeOut(t, tMin, tMax, val1, val2){
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            return -(val2-val1) * t*(t-2) + val1;
	        }
	
	        function easeIn(t, tMin, tMax, val1, val2){
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            return (val2-val1)*t*t + val1;
	        }
	
	        function nearestKey(time){
	            var i, len = data.k.length,index,keyTime;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                index = 0;
	                keyTime = 0;
	            } else {
	                index = -1;
	                time *= elem.comp.globalData.frameRate;
	                if (time < data.k[0].t) {
	                    index = 1;
	                    keyTime = data.k[0].t;
	                } else {
	                    for(i=0;i<len-1;i+=1){
	                        if(time === data.k[i].t){
	                            index = i + 1;
	                            keyTime = data.k[i].t;
	                            break;
	                        }else if(time>data.k[i].t && time<data.k[i+1].t){
	                            if(time-data.k[i].t > data.k[i+1].t - time){
	                                index = i + 2;
	                                keyTime = data.k[i+1].t;
	                            } else {
	                                index = i + 1;
	                                keyTime = data.k[i].t;
	                            }
	                            break;
	                        }
	                    }
	                    if(index === -1){
	                        index = i + 1;
	                        keyTime = data.k[i].t;
	                    }
	                }
	                
	            }
	            var ob = {};
	            ob.index = index;
	            ob.time = keyTime/elem.comp.globalData.frameRate;
	            return ob;
	        }
	
	        function key(ind){
	            var ob, i, len;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                throw new Error('The property has no keyframe at index ' + ind);
	            }
	            ind -= 1;
	            ob = {
	                time: data.k[ind].t/elem.comp.globalData.frameRate
	            };
	            var arr;
	            if(ind === data.k.length - 1 && !data.k[ind].h){
	                arr = data.k[ind-1].e;
	            }else{
	                arr = data.k[ind].s;
	            }
	            len = arr.length;
	            for(i=0;i<len;i+=1){
	                ob[i] = arr[i];
	            }
	            return ob;
	        }
	
	        function framesToTime(frames, fps) { 
	            if (!fps) {
	                fps = elem.comp.globalData.frameRate;
	            }
	            return frames / fps;
	        }
	
	        function timeToFrames(t, fps) {
	            if (!t && t !== 0) {
	                t = time;
	            }
	            if (!fps) {
	                fps = elem.comp.globalData.frameRate;
	            }
	            return t * fps;
	        }
	
	        function seedRandom(seed){
	            BMMath.seedrandom(randSeed + seed);
	        }
	
	        function sourceRectAtTime() {
	            return elem.sourceRectAtTime();
	        }
	
	        var time, velocity, value, textIndex, textTotal, selectorValue;
	        var index = elem.data.ind;
	        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	        var parent;
	        var randSeed = Math.floor(Math.random()*1000000);
	        function executeExpression(_value) {
	            value = _value;
	            if (_needsRandom) {
	                seedRandom(randSeed);
	            }
	            if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	                return value;
	            }
	            if(this.propType === 'textSelector'){
	                textIndex = this.textIndex;
	                textTotal = this.textTotal;
	                selectorValue = this.selectorValue;
	            }
	            if (!thisLayer) {
	                thisLayer = elem.layerInterface;
	                thisComp = elem.comp.compInterface;
	                toWorld = thisLayer.toWorld.bind(thisLayer);
	                fromWorld = thisLayer.fromWorld.bind(thisLayer);
	                fromComp = thisLayer.fromComp.bind(thisLayer);
	                mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	                fromCompToSurface = fromComp;
	            }
	            if (!transform) {
	                transform = elem.layerInterface("ADBE Transform Group");
	                anchorPoint = transform.anchorPoint;
	            }
	            
	            if (elemType === 4 && !content) {
	                content = thisLayer("ADBE Root Vectors Group");
	            }
	            if (!effect) {
	                effect = thisLayer(4);
	            }
	            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	            if (hasParent && !parent) {
	                parent = elem.hierarchy[0].layerInterface;
	            }
	            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
	            if (needsVelocity) {
	                velocity = velocityAtTime(time);
	            }
	            expression_function();
	            this.frameExpressionId = elem.globalData.frameId;
	
	            //TODO: Check if it's possible to return on ShapeInterface the .v value
	            if (scoped_bm_rt.propType === "shape") {
	                scoped_bm_rt = shape_pool.clone(scoped_bm_rt.v);
	            }
	            return scoped_bm_rt;
	        }
	        return executeExpression;
	    }
	
	    ob.initiateExpression = initiateExpression;
	    return ob;
	}());
	(function addPropertyDecorator() {
	
	    function getStaticValueAtTime() {
	        return this.pv;
	    }
	
	    function loopOut(type,duration,durationFlag){
	        if(!this.k || !this.keyframes){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var lastKeyFrame = keyframes[keyframes.length - 1].t;
	        if(currentFrame<=lastKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, firstKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
	                } else {
	                    cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
	                }
	                firstKeyFrame = lastKeyFrame - cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(iterations % 2 !== 0){
	                    return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = (endV[i]-initV[i])*repeats + current[i];
	                    }
	                    return ret;
	                }
	                return (endV-initV)*repeats + current;
	            } else if(type === 'continue'){
	                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(lastValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
	                    }
	                    return ret;
	                }
	                return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
	            }
	            return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function loopIn(type,duration, durationFlag) {
	        if(!this.k){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var firstKeyFrame = keyframes[0].t;
	        if(currentFrame>=firstKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, lastKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                lastKeyFrame = keyframes[duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
	                } else {
	                    cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
	                }
	                lastKeyFrame = firstKeyFrame + cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
	                if(iterations % 2 === 0){
	                    return this.getValueAtTime((((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = current[i]-(endV[i]-initV[i])*repeats;
	                    }
	                    return ret;
	                }
	                return current-(endV-initV)*repeats;
	            } else if(type === 'continue'){
	                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(firstValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
	                    }
	                    return ret;
	                }
	                return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
	            }
	            return this.getValueAtTime(((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function getValueAtTime(frameNum) {
	        if(frameNum !== this._cachingAtTime.lastFrame) {
	            frameNum *= this.elem.globalData.frameRate;
	            frameNum -= this.offsetTime;
	            this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	            this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	            this._cachingAtTime.lastFrame = frameNum;
	        }
	        return this._cachingAtTime.value;
	
	    }
	
	    function getSpeedAtTime(frameNum) {
	        var delta = -0.01;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var speed = 0;
	        if(v1.length){
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                speed += Math.pow(v2[i] - v1[i], 2);
	            }
	            speed = Math.sqrt(speed) * 100;
	        } else {
	            speed = 0;
	        }
	        return speed;
	    }
	
	    function getVelocityAtTime(frameNum) {
	        if(this.vel !== undefined){
	            return this.vel;
	        }
	        var delta = -0.001;
	        //frameNum += this.elem.data.st;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var velocity;
	        if(v1.length){
	            velocity = createTypedArray('float32', v1.length);
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                //removing frameRate
	                //if needed, don't add it here
	                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	                velocity[i] = (v2[i] - v1[i])/delta;
	            }
	        } else {
	            velocity = (v2 - v1)/delta;
	        }
	        return velocity;
	    }
	
	    function setGroupProperty(propertyGroup){
	        this.propertyGroup = propertyGroup;
	    }
	
	    function searchExpressions(elem,data,prop){
	        if(data.x){
	            prop.k = true;
	            prop.x = true;
	            prop.initiateExpression = ExpressionManager.initiateExpression;
	            prop.effectsSequence.push(prop.initiateExpression(elem,data,prop).bind(prop));
	        }
	    }
	
	    function getTransformValueAtTime(time) {
	        console.warn('Transform at time not supported');
	    }
	
	    function getTransformStaticValueAtTime(time) {
	
	    }
	
	    var TextExpressionSelectorProp = (function(){
	
	        function getValueProxy(index,total){
	            this.textIndex = index+1;
	            this.textTotal = total;
	            this.getValue();
	            return this.v;
	        }
	
	        return function TextExpressionSelectorProp(elem,data){
	            this.pv = 1;
	            this.comp = elem.comp;
	            this.elem = elem;
	            this.mult = 0.01;
	            this.propType = 'textSelector';
	            this.textTotal = data.totalChars;
	            this.selectorValue = 100;
	            this.lastValue = [1,1,1];
	            searchExpressions.bind(this)(elem,data,this);
	            this.getMult = getValueProxy;
	            this.getVelocityAtTime = getVelocityAtTime;
	            if(this.kf){
	                this.getValueAtTime = getValueAtTime.bind(this);
	            } else {
	                this.getValueAtTime = getStaticValueAtTime.bind(this);
	            }
	            this.setGroupProperty = setGroupProperty;
	        };
	    }());
	
	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	    TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
	        var prop = getTransformProperty(elem, data, container);
	        if(prop.dynamicProperties.length) {
	            prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        return prop;
	    };
	
	    var propertyGetProp = PropertyFactory.getProp;
	    PropertyFactory.getProp = function(elem,data,type, mult, container){
	        var prop = propertyGetProp(elem,data,type, mult, container);
	        //prop.getVelocityAtTime = getVelocityAtTime;
	        //prop.loopOut = loopOut;
	        //prop.loopIn = loopIn;
	        if(prop.kf){
	            prop.getValueAtTime = getValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        prop.loopOut = loopOut;
	        prop.loopIn = loopIn;
	        prop.getVelocityAtTime = getVelocityAtTime.bind(prop);
	        prop.getSpeedAtTime = getSpeedAtTime.bind(prop);
	        prop.numKeys = data.a === 1 ? data.k.length : 0;
	        prop.propertyIndex = data.ix;
	        var value = 0;
	        if(type !== 0) {
	            value = createTypedArray('float32', data.a === 1 ?  data.k[0].s.length : data.k.length);
	        }
	        prop._cachingAtTime = {
	            lastFrame: initialDefaultFrame,
	            lastIndex: 0,
	            value: value
	        };
	        searchExpressions(elem,data,prop);
	        if(prop.k){
	            container.addDynamicProperty(prop);
	        }
	
	        return prop;
	    };
	
	    function getShapeValueAtTime(frameNum) {
	        //For now this caching object is created only when needed instead of creating it when the shape is initialized.
	        if (!this._cachingAtTime) {
	            this._cachingAtTime = {
	                shapeValue: shape_pool.clone(this.pv),
	                lastIndex: 0,
	                lastTime: initialDefaultFrame
	            };
	        }
	        if(frameNum !== this._cachingAtTime.lastTime) {
	            this._cachingAtTime.lastTime = frameNum;
	            frameNum *= this.elem.globalData.frameRate;
	            this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	        }
	        return this._cachingAtTime.shapeValue;
	    }
	
	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
	
	    function ShapeExpressions(){}
	    ShapeExpressions.prototype = {
	        vertices: function(prop, time){
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            var i, len = shapePath._length;
	            var vertices = shapePath[prop];
	            var points = shapePath.v;
	            var arr = createSizedArray(len);
	            for(i = 0; i < len; i += 1) {
	                if(prop === 'i' || prop === 'o') {
	                    arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	                } else {
	                    arr[i] = [vertices[i][0], vertices[i][1]];
	                }
	                
	            }
	            return arr;
	        },
	        points: function(time){
	            return this.vertices('v', time);
	        },
	        inTangents: function(time){
	            return this.vertices('i', time);
	        },
	        outTangents: function(time){
	            return this.vertices('o', time);
	        },
	        isClosed: function(){
	            return this.v.c;
	        },
	        pointOnPath: function(perc, time){
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            if(!this._segmentsLength) {
	                this._segmentsLength = bez.getSegmentsLength(shapePath);
	            }
	
	            var segmentsLength = this._segmentsLength;
	            var lengths = segmentsLength.lengths;
	            var lengthPos = segmentsLength.totalLength * perc;
	            var i = 0, len = lengths.length;
	            var j = 0, jLen;
	            var accumulatedLength = 0, pt;
	            while(i < len) {
	                if(accumulatedLength + lengths[i].addedLength > lengthPos) {
	                    var initIndex = i;
	                    var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
	                    var segmentPerc = (lengthPos - accumulatedLength)/lengths[i].addedLength;
	                    pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	                    break;
	                } else {
	                    accumulatedLength += lengths[i].addedLength;
	                }
	                i += 1;
	            }
	            if(!pt){
	                pt = shapePath.c ? [shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]];
	            }
	            return pt;
	        },
	        vectorOnPath: function(perc, time, vectorType){
	            //perc doesn't use triple equality because it can be a Number object as well as a primitive.
	            perc = perc == 1 ? this.v.c ? 0 : 0.999 : perc;
	            var pt1 = this.pointOnPath(perc, time);
	            var pt2 = this.pointOnPath(perc + 0.001, time);
	            var xLength = pt2[0] - pt1[0];
	            var yLength = pt2[1] - pt1[1];
	            var magnitude = Math.sqrt(Math.pow(xLength,2) + Math.pow(yLength,2));
	            var unitVector = vectorType === 'tangent' ? [xLength/magnitude, yLength/magnitude] : [-yLength/magnitude, xLength/magnitude];
	            return unitVector;
	        },
	        tangentOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'tangent');
	        },
	        normalOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'normal');
	        },
	        setGroupProperty: setGroupProperty,
	        getValueAtTime: getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
	
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
	        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
	        prop.propertyIndex = data.ix;
	        prop.lock = false;
	        if(type === 3){
	            searchExpressions(elem,data.pt,prop);
	        } else if(type === 4){
	            searchExpressions(elem,data.ks,prop);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    };
	
	    var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
	    TextSelectorProp.getTextSelectorProp = function(elem, data,arr){
	        if(data.t === 1){
	            return new TextExpressionSelectorProp(elem, data,arr);
	        } else {
	            return propertyGetTextProp(elem,data,arr);
	        }
	    };
	}());
	(function addDecorator() {
	
	    function searchExpressions(){
	        if(this.data.d.x){
	            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);
	            this.addEffect(this.getExpressionValue.bind(this));
	            return true;
	        }
	    }
	
	    TextProperty.prototype.getExpressionValue = function(currentValue) {
	        var newValue = this.calculateExpression(currentValue.t);
	        currentValue.t = newValue;
	        return currentValue;
	    }
	
	    TextProperty.prototype.searchProperty = function(){
	
	        var isKeyframed = this.searchKeyframes();
	        var hasExpressions = this.searchExpressions();
	        this.kf = isKeyframed || hasExpressions;
	        return this.kf;
	    };
	
	    TextProperty.prototype.searchExpressions = searchExpressions;
	    
	}());
	var ShapeExpressionInterface = (function(){
	
	    function iterateElements(shapes,view, propertyGroup){
	        var arr = [];
	        var i, len = shapes ? shapes.length : 0;
	        for(i=0;i<len;i+=1){
	            if(shapes[i].ty == 'gr'){
	                arr.push(groupInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'fl'){
	                arr.push(fillInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'st'){
	                arr.push(strokeInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tm'){
	                arr.push(trimInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tr'){
	                //arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'el'){
	                arr.push(ellipseInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'sr'){
	                arr.push(starInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'sh'){
	                arr.push(pathInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rc'){
	                arr.push(rectInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rd'){
	                arr.push(roundedInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rp'){
	                arr.push(repeaterInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }
	        }
	        return arr;
	    }
	
	    function contentsInterfaceFactory(shape,view, propertyGroup){
	       var interfaces;
	       var interfaceFunction = function _interfaceFunction(value){
	           var i = 0, len = interfaces.length;
	            while(i<len){
	                if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
	                   return interfaces[i];
	                }
	                i+=1;
	            }
	            if(typeof value === 'number'){
	               return interfaces[value-1];
	            }
	       };
	       interfaceFunction.propertyGroup = function(val){
	           if(val === 1){
	               return interfaceFunction;
	           } else{
	               return propertyGroup(val-1);
	           }
	       };
	       interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	       interfaceFunction.numProperties = interfaces.length;
	       interfaceFunction.propertyIndex = shape.cix;
	       interfaceFunction._name = shape.nm;
	
	       return interfaceFunction;
	   }
	
	    function groupInterfaceFactory(shape,view, propertyGroup){
	        var interfaceFunction = function _interfaceFunction(value){
	            switch(value){
	                case 'ADBE Vectors Group':
	                case 'Contents':
	                case 2:
	                    return interfaceFunction.content;
	                //Not necessary for now. Keeping them here in case a new case appears
	                //case 'ADBE Vector Transform Group':
	                //case 3:
	                default:
	                    return interfaceFunction.transform;
	            }
	        };
	        interfaceFunction.propertyGroup = function(val){
	            if(val === 1){
	                return interfaceFunction;
	            } else{
	                return propertyGroup(val-1);
	            }
	        };
	        var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
	        var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
	        interfaceFunction.content = content;
	        interfaceFunction.transform = transformInterface;
	        Object.defineProperty(interfaceFunction, '_name', {
	            get: function(){
	                return shape.nm;
	            }
	        });
	        //interfaceFunction.content = interfaceFunction;
	        interfaceFunction.numProperties = shape.np;
	        interfaceFunction.propertyIndex = shape.ix;
	        interfaceFunction.nm = shape.nm;
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function fillInterfaceFactory(shape,view,propertyGroup){
	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: function() {
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            },
	            'opacity': {
	                get: function() {
	                    return ExpressionValue(view.o, 100);
	                }
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });
	
	        view.c.setGroupProperty(propertyGroup);
	        view.o.setGroupProperty(propertyGroup);
	        return interfaceFunction;
	    }
	
	    function strokeInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val === 1){
	                return ob;
	            } else{
	                return propertyGroup(val-1);
	            }
	        }
	        function _dashPropertyGroup(val){
	            if(val === 1){
	                return dashOb;
	            } else{
	                return _propertyGroup(val-1);
	            }
	        }
	        function addPropertyToDashOb(i) {
	            Object.defineProperty(dashOb, shape.d[i].nm, {
	                get: function(){
	                    return ExpressionValue(view.d.dataProps[i].p);
	                }
	            });
	        }
	        var i, len = shape.d ? shape.d.length : 0;
	        var dashOb = {};
	        for (i = 0; i < len; i += 1) {
	            addPropertyToDashOb(i);
	            view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	        }
	
	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            } else if(val === 'Stroke Width' || val === 'stroke width'){
	                return interfaceFunction.strokeWidth;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: function() {
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            },
	            'opacity': {
	                get: function() {
	                    return ExpressionValue(view.o, 100);
	                }
	            },
	            'strokeWidth': {
	                get: function() {
	                    return ExpressionValue(view.w);
	                }
	            },
	            'dash': {
	                get: function() {
	                    return dashOb;
	                }
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });
	
	        view.c.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);
	        view.w.setGroupProperty(_propertyGroup);
	        return interfaceFunction;
	    }
	
	    function trimInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	
	        view.s.setGroupProperty(_propertyGroup);
	        view.e.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(val){
	            if(val === shape.e.ix || val === 'End' || val === 'end'){
	                return interfaceFunction.end;
	            }
	            if(val === shape.s.ix){
	                return interfaceFunction.start;
	            }
	            if(val === shape.o.ix){
	                return interfaceFunction.offset;
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	
	        Object.defineProperties(interfaceFunction, {
	            'start': {
	                get: function() {
	                    return ExpressionValue(view.s, 1 / view.s.mult);
	                }
	            },
	            'end': {
	                get: function() {
	                    return ExpressionValue(view.e, 1 / view.e.mult);
	                }
	            },
	            'offset': {
	                get: function() {
	                    return ExpressionValue(view.o);
	                }
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function transformInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        view.transform.mProps.o.setGroupProperty(_propertyGroup);
	        view.transform.mProps.p.setGroupProperty(_propertyGroup);
	        view.transform.mProps.a.setGroupProperty(_propertyGroup);
	        view.transform.mProps.s.setGroupProperty(_propertyGroup);
	        view.transform.mProps.r.setGroupProperty(_propertyGroup);
	        if(view.transform.mProps.sk){
	            view.transform.mProps.sk.setGroupProperty(_propertyGroup);
	            view.transform.mProps.sa.setGroupProperty(_propertyGroup);
	        }
	        view.transform.op.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.a.ix === value || value === 'Anchor Point'){
	                return interfaceFunction.anchorPoint;
	            }
	            if(shape.o.ix === value || value === 'Opacity'){
	                return interfaceFunction.opacity;
	            }
	            if(shape.p.ix === value || value === 'Position'){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation'){
	                return interfaceFunction.rotation;
	            }
	            if(shape.s.ix === value || value === 'Scale'){
	                return interfaceFunction.scale;
	            }
	            if(shape.sk && shape.sk.ix === value || value === 'Skew'){
	                return interfaceFunction.skew;
	            }
	            if(shape.sa && shape.sa.ix === value || value === 'Skew Axis'){
	                return interfaceFunction.skewAxis;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'opacity': {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.o, 1/view.transform.mProps.o.mult);
	                }
	            },
	            'position': {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.p);
	                }
	            },
	            'anchorPoint': {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.a);
	                }
	            },
	            'scale': {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.s, 1 / view.transform.mProps.s.mult);
	                }
	            },
	            'rotation': {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.r, 1 / view.transform.mProps.r.mult);
	                }
	            },
	            'skew': {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sk);
	                }
	            },
	            'skewAxis': {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sa);
	                }
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.ty = 'tr';
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function ellipseInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.s.ix === value){
	                return interfaceFunction.size;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'size': {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            },
	            'position': {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function starInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.or.setGroupProperty(_propertyGroup);
	        prop.os.setGroupProperty(_propertyGroup);
	        prop.pt.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);
	        if(shape.ir){
	            prop.ir.setGroupProperty(_propertyGroup);
	            prop.is.setGroupProperty(_propertyGroup);
	        }
	
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.rotation;
	            }
	            if(shape.pt.ix === value){
	                return interfaceFunction.points;
	            }
	            if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
	                return interfaceFunction.outerRadius;
	            }
	            if(shape.os.ix === value){
	                return interfaceFunction.outerRoundness;
	            }
	            if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
	                return interfaceFunction.innerRadius;
	            }
	            if(shape.is && shape.is.ix === value){
	                return interfaceFunction.innerRoundness;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: function() {
	                    return ExpressionValue(prop.p);
	                }
	            },
	            'rotation': {
	                get: function() {
	                    return ExpressionValue(prop.r, 1 / prop.r.mult);
	                }
	            },
	            'points': {
	                get: function() {
	                    return ExpressionValue(prop.pt);
	                }
	            },
	            'outerRadius': {
	                get: function() {
	                    return ExpressionValue(prop.or);
	                }
	            },
	            'outerRoundness': {
	                get: function(){
	                    return ExpressionValue(prop.os);
	                }
	            },
	            'innerRadius': {
	                get: function(){
	                    if(!prop.ir){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.ir);
	                }
	            },
	            'innerRoundness': {
	                get: function(){
	                    if(!prop.is){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.is, 1 / prop.is.mult);
	                }
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function rectInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.roundness;
	            }
	            if(shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size'){
	                return interfaceFunction.size;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            },
	            'roundness': {
	                get: function(){
	                    return ExpressionValue(prop.r);
	                }
	            },
	            'size': {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function roundedInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.rd.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.r.ix === value || 'Round Corners 1' === value){
	                return interfaceFunction.radius;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'radius': {
	                get: function() {
	                    return ExpressionValue(prop.rd);
	                }
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function repeaterInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.c.setGroupProperty(_propertyGroup);
	        prop.o.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.c.ix === value || 'Copies' === value){
	                return interfaceFunction.copies;
	            } else if(shape.o.ix === value || 'Offset' === value){
	                return interfaceFunction.offset;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'copies': {
	                get: function(){
	                    return ExpressionValue(prop.c);
	                }
	            },
	            'offset': {
	                get: function(){
	                    return ExpressionValue(prop.o);
	                }
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function pathInterfaceFactory(shape,view,propertyGroup){
	        var prop = view.sh;
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        prop.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(val){
	            if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2){
	                return interfaceFunction.path;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'path': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            'shape': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            '_name': { value: shape.nm },
	            'ix': { value: shape.ix },
	            'mn': { value: shape.mn }
	        });
	        return interfaceFunction;
	    }
	
	    return function(shapes,view,propertyGroup) {
	        var interfaces;
	        function _interfaceFunction(value){
	            if(typeof value === 'number'){
	                return interfaces[value-1];
	            } else {
	                var i = 0, len = interfaces.length;
	                while(i<len){
	                    if(interfaces[i]._name === value){
	                        return interfaces[i];
	                    }
	                    i+=1;
	                }
	            }
	        }
	        _interfaceFunction.propertyGroup = propertyGroup;
	        interfaces = iterateElements(shapes, view, _interfaceFunction);
	        return _interfaceFunction;
	    };
	}());
	
	var TextExpressionInterface = (function(){
		return function(elem){
	        var _prevValue, _sourceText;
	        function _thisLayerFunction(){
	        }
	        Object.defineProperty(_thisLayerFunction, "sourceText", {
	            get: function(){
	                var stringValue = elem.textProperty.currentData.t;
	                if(stringValue !== _prevValue) {
	                    elem.textProperty.currentData.t = _prevValue;
	                    _sourceText = new String(stringValue);
	                    //If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	                    _sourceText.value = stringValue ? stringValue : new String(stringValue);
	                }
	                return _sourceText;
	            }
	        });
	        return _thisLayerFunction;
	    };
	}());
	var LayerExpressionInterface = (function (){
	    function toWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	        }
	        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	    }
	    function fromWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	    function fromComp(arr){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	
	    function sampleImage() {
	        return [1,1,1,1];
	    }
	
	
	    return function(elem){
	
	        var transformInterface;
	
	        function _registerMaskInterface(maskManager){
	            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	        }
	        function _registerEffectsInterface(effects){
	            _thisLayerFunction.effect = effects;
	        }
	
	        function _thisLayerFunction(name){
	            switch(name){
	                case "ADBE Root Vectors Group":
	                case "Contents":
	                case 2:
	                    return _thisLayerFunction.shapeInterface;
	                case 1:
	                case 6:
	                case "Transform":
	                case "transform":
	                case "ADBE Transform Group":
	                    return transformInterface;
	                case 4:
	                case "ADBE Effect Parade":
	                    return _thisLayerFunction.effect;
	            }
	        }
	        _thisLayerFunction.toWorld = toWorld;
	        _thisLayerFunction.fromWorld = fromWorld;
	        _thisLayerFunction.toComp = toWorld;
	        _thisLayerFunction.fromComp = fromComp;
	        _thisLayerFunction.sampleImage = sampleImage;
	        _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	        _thisLayerFunction._elem = elem;
	        transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	        var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	        Object.defineProperties(_thisLayerFunction,{
	            hasParent: {
	                get: function(){
	                    return elem.hierarchy.length;
	                }
	            },
	            parent: {
	                get: function(){
	                    return elem.hierarchy[0].layerInterface;
	                }
	            },
	            rotation: getDescriptor(transformInterface, 'rotation'),
	            scale: getDescriptor(transformInterface, 'scale'),
	            position: getDescriptor(transformInterface, 'position'),
	            opacity: getDescriptor(transformInterface, 'opacity'),
	            anchorPoint: anchorPointDescriptor,
	            anchor_point: anchorPointDescriptor,
	            transform: {
	                get: function () {
	                    return transformInterface;
	                }
	            },
	            active: {
	                get: function(){
	                    return elem.isInRange;
	                }
	            }
	        });
	
	        _thisLayerFunction.startTime = elem.data.st;
	        _thisLayerFunction.index = elem.data.ind;
	        _thisLayerFunction.source = elem.data.refId;
	        _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	        _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	
	        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	        return _thisLayerFunction;
	    };
	}());
	
	var CompExpressionInterface = (function (){
	    return function(comp){
	        function _thisLayerFunction(name){
	            var i=0, len = comp.layers.length;
	            while(i<len){
	                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
	                    return comp.elements[i].layerInterface;
	                }
	                i += 1;
	            }
	            return {active:false};
	        }
	        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
	        _thisLayerFunction.layer = _thisLayerFunction;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.height = comp.globalData.compSize.h;
	        _thisLayerFunction.width = comp.globalData.compSize.w;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
	        return _thisLayerFunction;
	    };
	}());
	var TransformExpressionInterface = (function (){
	    return function(transform){
	        function _thisFunction(name){
	            switch(name){
	                case "scale":
	                case "Scale":
	                case "ADBE Scale":
	                case 6:
	                    return _thisFunction.scale;
	                case "rotation":
	                case "Rotation":
	                case "ADBE Rotation":
	                case "ADBE Rotate Z":
	                case 10:
	                    return _thisFunction.rotation;
	                case "ADBE Rotate X":
	                    return _thisFunction.xRotation;
	                case "ADBE Rotate Y":
	                    return _thisFunction.yRotation;
	                case "position":
	                case "Position":
	                case "ADBE Position":
	                case 2:
	                    return _thisFunction.position;
	                case 'ADBE Position_0':
	                    return _thisFunction.xPosition;
	                case 'ADBE Position_1':
	                    return _thisFunction.yPosition;
	                case 'ADBE Position_2':
	                    return _thisFunction.zPosition;
	                case "anchorPoint":
	                case "AnchorPoint":
	                case "Anchor Point":
	                case "ADBE AnchorPoint":
	                case 1:
	                    return _thisFunction.anchorPoint;
	                case "opacity":
	                case "Opacity":
	                case 11:
	                    return _thisFunction.opacity;
	            }
	        }
	
	        Object.defineProperty(_thisFunction, "rotation", {
	            get: function(){
	                if(transform.r) {
	                    return ExpressionValue(transform.r, 1/degToRads);
	                } else {
	                    return ExpressionValue(transform.rz, 1/degToRads);
	                }
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "xRotation", {
	            get: function(){
	                    return ExpressionValue(transform.rx, 1/degToRads);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "yRotation", {
	            get: function(){
	                    return ExpressionValue(transform.ry, 1/degToRads);
	            }
	        });
	        Object.defineProperty(_thisFunction, "scale", {
	            get: function () {
	                return ExpressionValue(transform.s, 100);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "position", {
	            get: function () {
	                if(transform.p) {
	                    return ExpressionValue(transform.p);
	                } else {
	                    return [transform.px.v, transform.py.v, transform.pz ? transform.pz.v : 0];
	                }
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "xPosition", {
	            get: function () {
	                return ExpressionValue(transform.px);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "yPosition", {
	            get: function () {
	                return ExpressionValue(transform.py);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "zPosition", {
	            get: function () {
	                return ExpressionValue(transform.pz);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "anchorPoint", {
	            get: function () {
	                return ExpressionValue(transform.a);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "opacity", {
	            get: function () {
	                return ExpressionValue(transform.o, 100);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skew", {
	            get: function () {
	                return ExpressionValue(transform.sk);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skewAxis", {
	            get: function () {
	                return ExpressionValue(transform.sa);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "orientation", {
	            get: function () {
	                return ExpressionValue(transform.or);
	            }
	        });
	
	        return _thisFunction;
	    };
	}());
	var ProjectInterface = (function (){
	
	    function registerComposition(comp){
	        this.compositions.push(comp);
	    }
	
	    return function(){
	        function _thisProjectFunction(name){
	            var i = 0, len = this.compositions.length;
	            while(i<len){
	                if(this.compositions[i].data && this.compositions[i].data.nm === name){
	                    if(this.compositions[i].prepareFrame) {
	                        this.compositions[i].prepareFrame(this.compositions[i].data.xt ? this.currentFrame : this.compositions[i].renderedFrame);
	                    }
	                    return this.compositions[i].compInterface;
	                }
	                i+=1;
	            }
	        }
	
	        _thisProjectFunction.compositions = [];
	        _thisProjectFunction.currentFrame = 0;
	
	        _thisProjectFunction.registerComposition = registerComposition;
	
	
	
	        return _thisProjectFunction;
	    };
	}());
	var EffectsExpressionInterface = (function (){
	    var ob = {
	        createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup){
	        if(elem.effectsManager){
	
	            var effectElements = [];
	            var effectsData = elem.data.ef;
	            var i, len = elem.effectsManager.effectElements.length;
	            for(i=0;i<len;i+=1){
	                effectElements.push(createGroupInterface(effectsData[i],elem.effectsManager.effectElements[i],propertyGroup,elem));
	            }
	
	            return function(name){
	                var effects = elem.data.ef || [], i = 0, len = effects.length;
	                while(i<len) {
	                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                        return effectElements[i];
	                    }
	                    i += 1;
	                }
	            };
	        }
	    }
	
	    function createGroupInterface(data,elements, propertyGroup, elem){
	        var effectElements = [];
	        var i, len = data.ef.length;
	        for(i=0;i<len;i+=1){
	            if(data.ef[i].ty === 5){
	                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup, elem));
	            } else {
	                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem, _propertyGroup));
	            }
	        }
	
	        function _propertyGroup(val) {
	            if(val === 1){
	               return groupInterface;
	            } else{
	               return propertyGroup(val-1);
	            }
	        }
	
	        var groupInterface = function(name){
	            var effects = data.ef, i = 0, len = effects.length;
	            while(i<len) {
	                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                    if(effects[i].ty === 5){
	                        return effectElements[i];
	                    } else {
	                        return effectElements[i]();
	                    }
	                }
	                i += 1;
	            }
	            return effectElements[0]();
	        };
	
	        groupInterface.propertyGroup = _propertyGroup;
	
	        if(data.mn === 'ADBE Color Control'){
	            Object.defineProperty(groupInterface, 'color', {
	                get: function(){
	                    return effectElements[0]();
	                }
	            });
	        }
	        Object.defineProperty(groupInterface, 'numProperties', {
	            get: function(){
	                return data.np;
	            }
	        });
	        groupInterface.active = data.en !== 0;
	        return groupInterface;
	    }
	
	    function createValueInterface(element, type, elem, propertyGroup){
	        function interfaceFunction(){
	            if(type === 10){
	                return elem.comp.compInterface(element.p.v);
	            }
	            return ExpressionValue(element.p);
	        }
	
	        if(element.p.setGroupProperty) {
	            element.p.setGroupProperty(propertyGroup);
	        }
	
	        return interfaceFunction;
	    }
	
	    return ob;
	
	}());
	var MaskManagerInterface = (function(){
	
		function MaskInterface(mask, data){
			this._mask = mask;
			this._data = data;
		}
		Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	        get: function(){
	                if(this._mask.prop.k){
	                    this._mask.prop.getValue();
	                }
	                return this._mask.prop;
	            }
	        });
	
		var MaskManager = function(maskManager, elem){
			var _maskManager = maskManager;
			var _elem = elem;
			var _masksInterfaces = createSizedArray(maskManager.viewData.length);
			var i, len = maskManager.viewData.length;
			for(i = 0; i < len; i += 1) {
				_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
			}
	
			var maskFunction = function(name){
				i = 0;
			    while(i<len){
			        if(maskManager.masksProperties[i].nm === name){
			            return _masksInterfaces[i];
			        }
			        i += 1;
			    }
			};
			return maskFunction;
		};
		return MaskManager;
	}());
	
	var ExpressionValue = (function() {
		return function(elementProp, mult, type) {
	        mult = mult || 1;
	        var expressionValue, arrayValue;
	
			if (elementProp.k) {
	            elementProp.getValue();
	        }
	        var i, len, arrValue, val;
	        if (type) {
	        	if(type === 'color') {
	        		len = 4;
	                expressionValue = createTypedArray('float32', len);
	                arrValue = createTypedArray('float32', len);
			        for (i = 0; i < len; i += 1) {
			            expressionValue[i] = arrValue[i] = (i < 3) ? elementProp.v[i] * mult : 1;
			        }
		        	expressionValue.value = arrValue;
	        	}
	        } else if (elementProp.propType === 'unidimensional'){
	            val = elementProp.v * mult;
	            expressionValue = new Number(val);
	            expressionValue.value = val;
	        } else {
	        	len = elementProp.pv.length;
	            expressionValue = createTypedArray('float32', len);
	            arrValue = createTypedArray('float32', len);
		        for (i = 0; i < len; i += 1) {
		            expressionValue[i] = arrValue[i] = elementProp.v[i] * mult;
		        }
		        expressionValue.value = arrValue;
	        }
	        
	        expressionValue.numKeys = elementProp.keyframes ? elementProp.keyframes.length : 0;
	        expressionValue.key = function(pos) {
	            if (!expressionValue.numKeys) {
	                return 0;
	            } else {
	                return elementProp.keyframes[pos-1].t;
	            }
	        };
	        expressionValue.valueAtTime = elementProp.getValueAtTime;
	        expressionValue.speedAtTime = elementProp.getSpeedAtTime;
	        expressionValue.velocityAtTime = elementProp.getVelocityAtTime;
	        expressionValue.propertyGroup = elementProp.propertyGroup;
	        return expressionValue;
		};
	}());
	function SliderEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function AngleEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function ColorEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function PointEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function LayerIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function MaskIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function CheckboxEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function NoValueEffect(){
	    this.p = {};
	}
	function EffectsManager(data,element){
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i,len = effects.length;
	    var effectItem;
	    for(i=0;i<len;i++) {
	        effectItem = new GroupEffect(effects[i],element);
	        this.effectElements.push(effectItem);
	    }
	}
	
	function GroupEffect(data,element){
	    this.init(data,element);
	}
	
	extendPrototype([DynamicPropertyContainer], GroupEffect);
	
	GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
	
	GroupEffect.prototype.init = function(data,element){
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i, len = this.data.ef.length;
	    var eff, effects = this.data.ef;
	    for(i=0;i<len;i+=1){
	        eff = null;
	        switch(effects[i].ty){
	            case 0:
	                eff = new SliderEffect(effects[i],element,this);
	                break;
	            case 1:
	                eff = new AngleEffect(effects[i],element,this);
	                break;
	            case 2:
	                eff = new ColorEffect(effects[i],element,this);
	                break;
	            case 3:
	                eff = new PointEffect(effects[i],element,this);
	                break;
	            case 4:
	            case 7:
	                eff = new CheckboxEffect(effects[i],element,this);
	                break;
	            case 10:
	                eff = new LayerIndexEffect(effects[i],element,this);
	                break;
	            case 11:
	                eff = new MaskIndexEffect(effects[i],element,this);
	                break;
	            case 5:
	                eff = new EffectsManager(effects[i],element,this);
	                break;
	            //case 6:
	            default:
	                eff = new NoValueEffect(effects[i],element,this);
	                break;
	        }
	        if(eff) {
	            this.effectElements.push(eff);
	        }
	    }
	};
	    var lottiejs = {};
	
	    function setLocationHref (href) {
	        locationHref = href;
	    }
	    function play(animation){
	        animationManager.play(animation);
	    }
	
	    function pause(animation) {
	        animationManager.pause(animation);
	    }
	
	    function togglePause(animation) {
	        animationManager.togglePause(animation);
	    }
	
	    function setSpeed(value, animation) {
	        animationManager.setSpeed(value, animation);
	    }
	
	    function setDirection(value, animation) {
	        animationManager.setDirection(value, animation);
	    }
	
	    function stop(animation) {
	        animationManager.stop(animation);
	    }
	
	    function searchAnimations() {
	        if (standalone === true) {
	            animationManager.searchAnimations(animationData, standalone, renderer);
	        } else {
	            animationManager.searchAnimations();
	        }
	    }
	
	    function registerAnimation(elem) {
	        return animationManager.registerAnimation(elem);
	    }
	
	    function resize() {
	        animationManager.resize();
	    }
	
	    /*function start() {
	        animationManager.start();
	    }*/
	
	    function goToAndStop(val, isFrame, animation) {
	        animationManager.goToAndStop(val, isFrame, animation);
	    }
	
	    function setSubframeRendering(flag) {
	        subframeEnabled = flag;
	    }
	
	    function loadAnimation(params) {
	        if (standalone === true) {
	            params.animationData = JSON.parse(animationData);
	        }
	        return animationManager.loadAnimation(params);
	    }
	
	    function destroy(animation) {
	        return animationManager.destroy(animation);
	    }
	
	    function setQuality(value) {
	        if (typeof value === 'string') {
	            switch (value) {
	                case 'high':
	                    defaultCurveSegments = 200;
	                    break;
	                case 'medium':
	                    defaultCurveSegments = 50;
	                    break;
	                case 'low':
	                    defaultCurveSegments = 10;
	                    break;
	            }
	        } else if (!isNaN(value) && value > 1) {
	            defaultCurveSegments = value;
	        }
	        if (defaultCurveSegments >= 50) {
	            roundValues(false);
	        } else {
	            roundValues(true);
	        }
	    }
	
	    function inBrowser() {
	        return typeof navigator !== 'undefined';
	    }
	
	    function installPlugin(type, plugin) {
	        if (type === 'expressions') {
	            expressionsPlugin = plugin;
	        }
	    }
	
	    function getFactory(name) {
	        switch (name) {
	            case "propertyFactory":
	                return PropertyFactory;
	            case "shapePropertyFactory":
	                return ShapePropertyFactory;
	            case "matrix":
	                return Matrix;
	        }
	    }
	    lottiejs.play = play;
	    lottiejs.pause = pause;
	    lottiejs.setLocationHref = setLocationHref;
	    lottiejs.togglePause = togglePause;
	    lottiejs.setSpeed = setSpeed;
	    lottiejs.setDirection = setDirection;
	    lottiejs.stop = stop;
	    lottiejs.searchAnimations = searchAnimations;
	    lottiejs.registerAnimation = registerAnimation;
	    lottiejs.loadAnimation = loadAnimation;
	    lottiejs.setSubframeRendering = setSubframeRendering;
	    lottiejs.resize = resize;
	    //lottiejs.start = start;
	    lottiejs.goToAndStop = goToAndStop;
	    lottiejs.destroy = destroy;
	    lottiejs.setQuality = setQuality;
	    lottiejs.inBrowser = inBrowser;
	    lottiejs.installPlugin = installPlugin;
	    lottiejs.__getFactory = getFactory;
	    lottiejs.version = '5.1.13';
	
	    function checkReady() {
	        if (document.readyState === "complete") {
	            clearInterval(readyStateCheckInterval);
	            searchAnimations();
	        }
	    }
	
	    function getQueryVariable(variable) {
	        var vars = queryString.split('&');
	        for (var i = 0; i < vars.length; i++) {
	            var pair = vars[i].split('=');
	            if (decodeURIComponent(pair[0]) == variable) {
	                return decodeURIComponent(pair[1]);
	            }
	        }
	    }
	    var standalone = '__[STANDALONE]__';
	    var animationData = '__[ANIMATIONDATA]__';
	    var renderer = '';
	    if (standalone) {
	        var scripts = document.getElementsByTagName('script');
	        var index = scripts.length - 1;
	        var myScript = scripts[index] || {
	            src: ''
	        };
	        var queryString = myScript.src.replace(/^[^\?]+\??/, '');
	        renderer = getQueryVariable('renderer');
	    }
	    var readyStateCheckInterval = setInterval(checkReady, 100);
	    return lottiejs;
	}));

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)(module)))

/***/ }),

/***/ 2279:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(189)))

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.15.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 2280:
/***/ (function(module, exports) {

	var div = null
	var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]
	
	module.exports = function prefixStyle (prop) {
	  // re-use a dummy div
	  if (!div) {
	    div = document.createElement('div')
	  }
	
	  var style = div.style
	
	  // prop exists without prefix
	  if (prop in style) {
	    return prop
	  }
	
	  // borderRadius -> BorderRadius
	  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)
	
	  // find the vendor-prefixed prop
	  for (var i = prefixes.length; i >= 0; i--) {
	    var name = prefixes[i] + titleCase
	    // e.g. WebkitBorderRadius or webkitBorderRadius
	    if (name in style) {
	      return name
	    }
	  }
	
	  return false
	}


/***/ }),

/***/ 2285:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2279)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 2342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.renderViewDefault = renderViewDefault;
	exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
	exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
	exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
	exports.renderThumbVerticalDefault = renderThumbVerticalDefault;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/* eslint-disable react/prop-types */
	
	function renderViewDefault(props) {
	    return _react2["default"].createElement('div', props);
	}
	
	function renderTrackHorizontalDefault(_ref) {
	    var style = _ref.style,
	        props = _objectWithoutProperties(_ref, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        left: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderTrackVerticalDefault(_ref2) {
	    var style = _ref2.style,
	        props = _objectWithoutProperties(_ref2, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        right: 2,
	        bottom: 2,
	        top: 2,
	        borderRadius: 3
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbHorizontalDefault(_ref3) {
	    var style = _ref3.style,
	        props = _objectWithoutProperties(_ref3, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}
	
	function renderThumbVerticalDefault(_ref4) {
	    var style = _ref4.style,
	        props = _objectWithoutProperties(_ref4, ['style']);
	
	    var finalStyle = _extends({}, style, {
	        cursor: 'pointer',
	        borderRadius: 'inherit',
	        backgroundColor: 'rgba(0,0,0,.2)'
	    });
	    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
	}

/***/ }),

/***/ 2343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _raf2 = __webpack_require__(2285);
	
	var _raf3 = _interopRequireDefault(_raf2);
	
	var _domCss = __webpack_require__(797);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isString = __webpack_require__(2349);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getScrollbarWidth = __webpack_require__(2348);
	
	var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);
	
	var _returnFalse = __webpack_require__(2350);
	
	var _returnFalse2 = _interopRequireDefault(_returnFalse);
	
	var _getInnerWidth = __webpack_require__(2347);
	
	var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);
	
	var _getInnerHeight = __webpack_require__(2346);
	
	var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);
	
	var _styles = __webpack_require__(2344);
	
	var _defaultRenderElements = __webpack_require__(2342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollbars = function (_Component) {
	    _inherits(Scrollbars, _Component);
	
	    function Scrollbars(props) {
	        var _ref;
	
	        _classCallCheck(this, Scrollbars);
	
	        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            rest[_key - 1] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));
	
	        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
	        _this.getScrollTop = _this.getScrollTop.bind(_this);
	        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
	        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
	        _this.getClientWidth = _this.getClientWidth.bind(_this);
	        _this.getClientHeight = _this.getClientHeight.bind(_this);
	        _this.getValues = _this.getValues.bind(_this);
	        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
	        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
	        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
	        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
	
	        _this.scrollLeft = _this.scrollLeft.bind(_this);
	        _this.scrollTop = _this.scrollTop.bind(_this);
	        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
	        _this.scrollToTop = _this.scrollToTop.bind(_this);
	        _this.scrollToRight = _this.scrollToRight.bind(_this);
	        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
	
	        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
	        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
	        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
	        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
	        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
	        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
	        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleDrag = _this.handleDrag.bind(_this);
	        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	
	        _this.state = {
	            didMountUniversal: false
	        };
	        return _this;
	    }
	
	    _createClass(Scrollbars, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.addListeners();
	            this.update();
	            this.componentDidMountUniversal();
	        }
	    }, {
	        key: 'componentDidMountUniversal',
	        value: function componentDidMountUniversal() {
	            // eslint-disable-line react/sort-comp
	            var universal = this.props.universal;
	
	            if (!universal) return;
	            this.setState({ didMountUniversal: true });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.update();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.removeListeners();
	            (0, _raf2.cancel)(this.requestFrame);
	            clearTimeout(this.hideTracksTimeout);
	            clearInterval(this.detectScrollingInterval);
	        }
	    }, {
	        key: 'getScrollLeft',
	        value: function getScrollLeft() {
	            if (!this.view) return 0;
	            return this.view.scrollLeft;
	        }
	    }, {
	        key: 'getScrollTop',
	        value: function getScrollTop() {
	            if (!this.view) return 0;
	            return this.view.scrollTop;
	        }
	    }, {
	        key: 'getScrollWidth',
	        value: function getScrollWidth() {
	            if (!this.view) return 0;
	            return this.view.scrollWidth;
	        }
	    }, {
	        key: 'getScrollHeight',
	        value: function getScrollHeight() {
	            if (!this.view) return 0;
	            return this.view.scrollHeight;
	        }
	    }, {
	        key: 'getClientWidth',
	        value: function getClientWidth() {
	            if (!this.view) return 0;
	            return this.view.clientWidth;
	        }
	    }, {
	        key: 'getClientHeight',
	        value: function getClientHeight() {
	            if (!this.view) return 0;
	            return this.view.clientHeight;
	        }
	    }, {
	        key: 'getValues',
	        value: function getValues() {
	            var _ref2 = this.view || {},
	                _ref2$scrollLeft = _ref2.scrollLeft,
	                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
	                _ref2$scrollTop = _ref2.scrollTop,
	                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
	                _ref2$scrollWidth = _ref2.scrollWidth,
	                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
	                _ref2$scrollHeight = _ref2.scrollHeight,
	                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
	                _ref2$clientWidth = _ref2.clientWidth,
	                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
	                _ref2$clientHeight = _ref2.clientHeight,
	                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
	
	            return {
	                left: scrollLeft / (scrollWidth - clientWidth) || 0,
	                top: scrollTop / (scrollHeight - clientHeight) || 0,
	                scrollLeft: scrollLeft,
	                scrollTop: scrollTop,
	                scrollWidth: scrollWidth,
	                scrollHeight: scrollHeight,
	                clientWidth: clientWidth,
	                clientHeight: clientHeight
	            };
	        }
	    }, {
	        key: 'getThumbHorizontalWidth',
	        value: function getThumbHorizontalWidth() {
	            var _props = this.props,
	                thumbSize = _props.thumbSize,
	                thumbMinSize = _props.thumbMinSize;
	            var _view = this.view,
	                scrollWidth = _view.scrollWidth,
	                clientWidth = _view.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
	            if (trackWidth === width) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(width, thumbMinSize);
	        }
	    }, {
	        key: 'getThumbVerticalHeight',
	        value: function getThumbVerticalHeight() {
	            var _props2 = this.props,
	                thumbSize = _props2.thumbSize,
	                thumbMinSize = _props2.thumbMinSize;
	            var _view2 = this.view,
	                scrollHeight = _view2.scrollHeight,
	                clientHeight = _view2.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
	            if (trackHeight === height) return 0;
	            if (thumbSize) return thumbSize;
	            return Math.max(height, thumbMinSize);
	        }
	    }, {
	        key: 'getScrollLeftForOffset',
	        value: function getScrollLeftForOffset(offset) {
	            var _view3 = this.view,
	                scrollWidth = _view3.scrollWidth,
	                clientWidth = _view3.clientWidth;
	
	            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	            var thumbWidth = this.getThumbHorizontalWidth();
	            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
	        }
	    }, {
	        key: 'getScrollTopForOffset',
	        value: function getScrollTopForOffset(offset) {
	            var _view4 = this.view,
	                scrollHeight = _view4.scrollHeight,
	                clientHeight = _view4.clientHeight;
	
	            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	            var thumbHeight = this.getThumbVerticalHeight();
	            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
	        }
	    }, {
	        key: 'scrollLeft',
	        value: function scrollLeft() {
	            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollLeft = left;
	        }
	    }, {
	        key: 'scrollTop',
	        value: function scrollTop() {
	            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            if (!this.view) return;
	            this.view.scrollTop = top;
	        }
	    }, {
	        key: 'scrollToLeft',
	        value: function scrollToLeft() {
	            if (!this.view) return;
	            this.view.scrollLeft = 0;
	        }
	    }, {
	        key: 'scrollToTop',
	        value: function scrollToTop() {
	            if (!this.view) return;
	            this.view.scrollTop = 0;
	        }
	    }, {
	        key: 'scrollToRight',
	        value: function scrollToRight() {
	            if (!this.view) return;
	            this.view.scrollLeft = this.view.scrollWidth;
	        }
	    }, {
	        key: 'scrollToBottom',
	        value: function scrollToBottom() {
	            if (!this.view) return;
	            this.view.scrollTop = this.view.scrollHeight;
	        }
	    }, {
	        key: 'addListeners',
	        value: function addListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.addEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.addEventListener('resize', this.handleWindowResize);
	        }
	    }, {
	        key: 'removeListeners',
	        value: function removeListeners() {
	            /* istanbul ignore if */
	            if (typeof document === 'undefined' || !this.view) return;
	            var view = this.view,
	                trackHorizontal = this.trackHorizontal,
	                trackVertical = this.trackVertical,
	                thumbHorizontal = this.thumbHorizontal,
	                thumbVertical = this.thumbVertical;
	
	            view.removeEventListener('scroll', this.handleScroll);
	            if (!(0, _getScrollbarWidth2["default"])()) return;
	            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
	            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
	            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
	            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
	            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
	            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
	            window.removeEventListener('resize', this.handleWindowResize);
	            // Possibly setup by `handleDragStart`
	            this.teardownDragging();
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(event) {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                onScroll = _props3.onScroll,
	                onScrollFrame = _props3.onScrollFrame;
	
	            if (onScroll) onScroll(event);
	            this.update(function (values) {
	                var scrollLeft = values.scrollLeft,
	                    scrollTop = values.scrollTop;
	
	                _this2.viewScrollLeft = scrollLeft;
	                _this2.viewScrollTop = scrollTop;
	                if (onScrollFrame) onScrollFrame(values);
	            });
	            this.detectScrolling();
	        }
	    }, {
	        key: 'handleScrollStart',
	        value: function handleScrollStart() {
	            var onScrollStart = this.props.onScrollStart;
	
	            if (onScrollStart) onScrollStart();
	            this.handleScrollStartAutoHide();
	        }
	    }, {
	        key: 'handleScrollStartAutoHide',
	        value: function handleScrollStartAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleScrollStop',
	        value: function handleScrollStop() {
	            var onScrollStop = this.props.onScrollStop;
	
	            if (onScrollStop) onScrollStop();
	            this.handleScrollStopAutoHide();
	        }
	    }, {
	        key: 'handleScrollStopAutoHide',
	        value: function handleScrollStopAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleWindowResize',
	        value: function handleWindowResize() {
	            this.update();
	        }
	    }, {
	        key: 'handleHorizontalTrackMouseDown',
	        value: function handleHorizontalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientX = event.clientX;
	
	            var _target$getBoundingCl = target.getBoundingClientRect(),
	                targetLeft = _target$getBoundingCl.left;
	
	            var thumbWidth = this.getThumbHorizontalWidth();
	            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
	            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	        }
	    }, {
	        key: 'handleVerticalTrackMouseDown',
	        value: function handleVerticalTrackMouseDown(event) {
	            event.preventDefault();
	            var target = event.target,
	                clientY = event.clientY;
	
	            var _target$getBoundingCl2 = target.getBoundingClientRect(),
	                targetTop = _target$getBoundingCl2.top;
	
	            var thumbHeight = this.getThumbVerticalHeight();
	            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
	            this.view.scrollTop = this.getScrollTopForOffset(offset);
	        }
	    }, {
	        key: 'handleHorizontalThumbMouseDown',
	        value: function handleHorizontalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientX = event.clientX;
	            var offsetWidth = target.offsetWidth;
	
	            var _target$getBoundingCl3 = target.getBoundingClientRect(),
	                left = _target$getBoundingCl3.left;
	
	            this.prevPageX = offsetWidth - (clientX - left);
	        }
	    }, {
	        key: 'handleVerticalThumbMouseDown',
	        value: function handleVerticalThumbMouseDown(event) {
	            event.preventDefault();
	            this.handleDragStart(event);
	            var target = event.target,
	                clientY = event.clientY;
	            var offsetHeight = target.offsetHeight;
	
	            var _target$getBoundingCl4 = target.getBoundingClientRect(),
	                top = _target$getBoundingCl4.top;
	
	            this.prevPageY = offsetHeight - (clientY - top);
	        }
	    }, {
	        key: 'setupDragging',
	        value: function setupDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
	            document.addEventListener('mousemove', this.handleDrag);
	            document.addEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = _returnFalse2["default"];
	        }
	    }, {
	        key: 'teardownDragging',
	        value: function teardownDragging() {
	            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
	            document.removeEventListener('mousemove', this.handleDrag);
	            document.removeEventListener('mouseup', this.handleDragEnd);
	            document.onselectstart = undefined;
	        }
	    }, {
	        key: 'handleDragStart',
	        value: function handleDragStart(event) {
	            this.dragging = true;
	            event.stopImmediatePropagation();
	            this.setupDragging();
	        }
	    }, {
	        key: 'handleDrag',
	        value: function handleDrag(event) {
	            if (this.prevPageX) {
	                var clientX = event.clientX;
	
	                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
	                    trackLeft = _trackHorizontal$getB.left;
	
	                var thumbWidth = this.getThumbHorizontalWidth();
	                var clickPosition = thumbWidth - this.prevPageX;
	                var offset = -trackLeft + clientX - clickPosition;
	                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
	            }
	            if (this.prevPageY) {
	                var clientY = event.clientY;
	
	                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
	                    trackTop = _trackVertical$getBou.top;
	
	                var thumbHeight = this.getThumbVerticalHeight();
	                var _clickPosition = thumbHeight - this.prevPageY;
	                var _offset = -trackTop + clientY - _clickPosition;
	                this.view.scrollTop = this.getScrollTopForOffset(_offset);
	            }
	            return false;
	        }
	    }, {
	        key: 'handleDragEnd',
	        value: function handleDragEnd() {
	            this.dragging = false;
	            this.prevPageX = this.prevPageY = 0;
	            this.teardownDragging();
	            this.handleDragEndAutoHide();
	        }
	    }, {
	        key: 'handleDragEndAutoHide',
	        value: function handleDragEndAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'handleTrackMouseEnter',
	        value: function handleTrackMouseEnter() {
	            this.trackMouseOver = true;
	            this.handleTrackMouseEnterAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseEnterAutoHide',
	        value: function handleTrackMouseEnterAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.showTracks();
	        }
	    }, {
	        key: 'handleTrackMouseLeave',
	        value: function handleTrackMouseLeave() {
	            this.trackMouseOver = false;
	            this.handleTrackMouseLeaveAutoHide();
	        }
	    }, {
	        key: 'handleTrackMouseLeaveAutoHide',
	        value: function handleTrackMouseLeaveAutoHide() {
	            var autoHide = this.props.autoHide;
	
	            if (!autoHide) return;
	            this.hideTracks();
	        }
	    }, {
	        key: 'showTracks',
	        value: function showTracks() {
	            clearTimeout(this.hideTracksTimeout);
	            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
	            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
	        }
	    }, {
	        key: 'hideTracks',
	        value: function hideTracks() {
	            var _this3 = this;
	
	            if (this.dragging) return;
	            if (this.scrolling) return;
	            if (this.trackMouseOver) return;
	            var autoHideTimeout = this.props.autoHideTimeout;
	
	            clearTimeout(this.hideTracksTimeout);
	            this.hideTracksTimeout = setTimeout(function () {
	                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
	                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
	            }, autoHideTimeout);
	        }
	    }, {
	        key: 'detectScrolling',
	        value: function detectScrolling() {
	            var _this4 = this;
	
	            if (this.scrolling) return;
	            this.scrolling = true;
	            this.handleScrollStart();
	            this.detectScrollingInterval = setInterval(function () {
	                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
	                    clearInterval(_this4.detectScrollingInterval);
	                    _this4.scrolling = false;
	                    _this4.handleScrollStop();
	                }
	                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
	                _this4.lastViewScrollTop = _this4.viewScrollTop;
	            }, 100);
	        }
	    }, {
	        key: 'raf',
	        value: function raf(callback) {
	            var _this5 = this;
	
	            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
	            this.requestFrame = (0, _raf3["default"])(function () {
	                _this5.requestFrame = undefined;
	                callback();
	            });
	        }
	    }, {
	        key: 'update',
	        value: function update(callback) {
	            var _this6 = this;
	
	            this.raf(function () {
	                return _this6._update(callback);
	            });
	        }
	    }, {
	        key: '_update',
	        value: function _update(callback) {
	            var _props4 = this.props,
	                onUpdate = _props4.onUpdate,
	                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
	
	            var values = this.getValues();
	            if ((0, _getScrollbarWidth2["default"])()) {
	                var scrollLeft = values.scrollLeft,
	                    clientWidth = values.clientWidth,
	                    scrollWidth = values.scrollWidth;
	
	                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
	                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
	                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
	                var thumbHorizontalStyle = {
	                    width: thumbHorizontalWidth,
	                    transform: 'translateX(' + thumbHorizontalX + 'px)'
	                };
	                var scrollTop = values.scrollTop,
	                    clientHeight = values.clientHeight,
	                    scrollHeight = values.scrollHeight;
	
	                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
	                var thumbVerticalHeight = this.getThumbVerticalHeight();
	                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
	                var thumbVerticalStyle = {
	                    height: thumbVerticalHeight,
	                    transform: 'translateY(' + thumbVerticalY + 'px)'
	                };
	                if (hideTracksWhenNotNeeded) {
	                    var trackHorizontalStyle = {
	                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
	                    };
	                    var trackVerticalStyle = {
	                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
	                    };
	                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
	                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
	                }
	                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
	                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
	            }
	            if (onUpdate) onUpdate(values);
	            if (typeof callback !== 'function') return;
	            callback(values);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
	            /* eslint-disable no-unused-vars */
	
	            var _props5 = this.props,
	                onScroll = _props5.onScroll,
	                onScrollFrame = _props5.onScrollFrame,
	                onScrollStart = _props5.onScrollStart,
	                onScrollStop = _props5.onScrollStop,
	                onUpdate = _props5.onUpdate,
	                renderView = _props5.renderView,
	                renderTrackHorizontal = _props5.renderTrackHorizontal,
	                renderTrackVertical = _props5.renderTrackVertical,
	                renderThumbHorizontal = _props5.renderThumbHorizontal,
	                renderThumbVertical = _props5.renderThumbVertical,
	                tagName = _props5.tagName,
	                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
	                autoHide = _props5.autoHide,
	                autoHideTimeout = _props5.autoHideTimeout,
	                autoHideDuration = _props5.autoHideDuration,
	                thumbSize = _props5.thumbSize,
	                thumbMinSize = _props5.thumbMinSize,
	                universal = _props5.universal,
	                autoHeight = _props5.autoHeight,
	                autoHeightMin = _props5.autoHeightMin,
	                autoHeightMax = _props5.autoHeightMax,
	                style = _props5.style,
	                children = _props5.children,
	                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
	            /* eslint-enable no-unused-vars */
	
	            var didMountUniversal = this.state.didMountUniversal;
	
	
	            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }), style);
	
	            var viewStyle = _extends({}, _styles.viewStyleDefault, {
	                // Hide scrollbars by setting a negative margin
	                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
	                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
	            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
	                // Add scrollbarWidth to autoHeight in order to compensate negative margins
	                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
	                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
	            }), autoHeight && universal && !didMountUniversal && {
	                minHeight: autoHeightMin,
	                maxHeight: autoHeightMax
	            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);
	
	            var trackAutoHeightStyle = {
	                transition: 'opacity ' + autoHideDuration + 'ms',
	                opacity: 0
	            };
	
	            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
	                display: 'none'
	            });
	
	            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
	                    _this7.container = _ref3;
	                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
	                    _this7.view = _ref4;
	                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
	                    _this7.trackHorizontal = _ref5;
	                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
	                    _this7.thumbHorizontal = _ref6;
	                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
	                    _this7.trackVertical = _ref7;
	                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
	                    _this7.thumbVertical = _ref8;
	                } }))]);
	        }
	    }]);
	
	    return Scrollbars;
	}(_react.Component);
	
	exports["default"] = Scrollbars;
	
	
	Scrollbars.propTypes = {
	    onScroll: _propTypes2["default"].func,
	    onScrollFrame: _propTypes2["default"].func,
	    onScrollStart: _propTypes2["default"].func,
	    onScrollStop: _propTypes2["default"].func,
	    onUpdate: _propTypes2["default"].func,
	    renderView: _propTypes2["default"].func,
	    renderTrackHorizontal: _propTypes2["default"].func,
	    renderTrackVertical: _propTypes2["default"].func,
	    renderThumbHorizontal: _propTypes2["default"].func,
	    renderThumbVertical: _propTypes2["default"].func,
	    tagName: _propTypes2["default"].string,
	    thumbSize: _propTypes2["default"].number,
	    thumbMinSize: _propTypes2["default"].number,
	    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
	    autoHide: _propTypes2["default"].bool,
	    autoHideTimeout: _propTypes2["default"].number,
	    autoHideDuration: _propTypes2["default"].number,
	    autoHeight: _propTypes2["default"].bool,
	    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
	    universal: _propTypes2["default"].bool,
	    style: _propTypes2["default"].object,
	    children: _propTypes2["default"].node
	};
	
	Scrollbars.defaultProps = {
	    renderView: _defaultRenderElements.renderViewDefault,
	    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
	    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
	    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
	    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
	    tagName: 'div',
	    thumbMinSize: 30,
	    hideTracksWhenNotNeeded: false,
	    autoHide: false,
	    autoHideTimeout: 1000,
	    autoHideDuration: 200,
	    autoHeight: false,
	    autoHeightMin: 0,
	    autoHeightMax: 200,
	    universal: false
	};

/***/ }),

/***/ 2344:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var containerStyleDefault = exports.containerStyleDefault = {
	    position: 'relative',
	    overflow: 'hidden',
	    width: '100%',
	    height: '100%'
	};
	
	// Overrides containerStyleDefault properties
	var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
	    height: 'auto'
	};
	
	var viewStyleDefault = exports.viewStyleDefault = {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflow: 'scroll',
	    WebkitOverflowScrolling: 'touch'
	};
	
	// Overrides viewStyleDefault properties
	var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
	    position: 'relative',
	    top: undefined,
	    left: undefined,
	    right: undefined,
	    bottom: undefined
	};
	
	var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
	    overflow: 'hidden',
	    marginRight: 0,
	    marginBottom: 0
	};
	
	var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
	    position: 'absolute',
	    height: 6
	};
	
	var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
	    position: 'absolute',
	    width: 6
	};
	
	var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    height: '100%'
	};
	
	var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
	    position: 'relative',
	    display: 'block',
	    width: '100%'
	};
	
	var disableSelectStyle = exports.disableSelectStyle = {
	    userSelect: 'none'
	};
	
	var disableSelectStyleReset = exports.disableSelectStyleReset = {
	    userSelect: ''
	};

/***/ }),

/***/ 2345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scrollbars = undefined;
	
	var _Scrollbars = __webpack_require__(2343);
	
	var _Scrollbars2 = _interopRequireDefault(_Scrollbars);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Scrollbars2["default"];
	exports.Scrollbars = _Scrollbars2["default"];

/***/ }),

/***/ 2346:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerHeight;
	function getInnerHeight(el) {
	    var clientHeight = el.clientHeight;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingTop = _getComputedStyle.paddingTop,
	        paddingBottom = _getComputedStyle.paddingBottom;
	
	    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
	}

/***/ }),

/***/ 2347:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getInnerWidth;
	function getInnerWidth(el) {
	    var clientWidth = el.clientWidth;
	
	    var _getComputedStyle = getComputedStyle(el),
	        paddingLeft = _getComputedStyle.paddingLeft,
	        paddingRight = _getComputedStyle.paddingRight;
	
	    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
	}

/***/ }),

/***/ 2348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = getScrollbarWidth;
	
	var _domCss = __webpack_require__(797);
	
	var _domCss2 = _interopRequireDefault(_domCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var scrollbarWidth = false;
	
	function getScrollbarWidth() {
	    if (scrollbarWidth !== false) return scrollbarWidth;
	    /* istanbul ignore else */
	    if (typeof document !== 'undefined') {
	        var div = document.createElement('div');
	        (0, _domCss2["default"])(div, {
	            width: 100,
	            height: 100,
	            position: 'absolute',
	            top: -9999,
	            overflow: 'scroll',
	            MsOverflowStyle: 'scrollbar'
	        });
	        document.body.appendChild(div);
	        scrollbarWidth = div.offsetWidth - div.clientWidth;
	        document.body.removeChild(div);
	    } else {
	        scrollbarWidth = 0;
	    }
	    return scrollbarWidth || 0;
	}

/***/ }),

/***/ 2349:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = isString;
	function isString(maybe) {
	    return typeof maybe === 'string';
	}

/***/ }),

/***/ 2350:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = returnFalse;
	function returnFalse() {
	    return false;
	}

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(13));
	var classnames = _interopDefault(__webpack_require__(82));
	var onClickOutside = _interopDefault(__webpack_require__(280));
	var moment = _interopDefault(__webpack_require__(275));
	var reactPopper = __webpack_require__(646);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateYears(year, noOfYear, minDate, maxDate) {
	  var list = [];
	  for (var i = 0; i < 2 * noOfYear + 1; i++) {
	    var newYear = year + noOfYear - i;
	    var isInRange = true;
	
	    if (minDate) {
	      isInRange = minDate.year() <= newYear;
	    }
	
	    if (maxDate && isInRange) {
	      isInRange = maxDate.year() >= newYear;
	    }
	
	    if (isInRange) {
	      list.push(newYear);
	    }
	  }
	
	  return list;
	}
	
	var YearDropdownOptions = function (_React$Component) {
	  inherits(YearDropdownOptions, _React$Component);
	
	  function YearDropdownOptions(props) {
	    classCallCheck(this, YearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      var selectedYear = _this.props.year;
	      var options = _this.state.yearsList.map(function (year) {
	        return React.createElement(
	          "div",
	          {
	            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
	            key: year,
	            ref: year,
	            onClick: _this.onChange.bind(_this, year)
	          },
	          selectedYear === year ? React.createElement(
	            "span",
	            { className: "react-datepicker__year-option--selected" },
	            "\u2713"
	          ) : "",
	          year
	        );
	      });
	
	      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
	      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
	
	      if (!maxYear || !_this.state.yearsList.find(function (year) {
	        return year === maxYear;
	      })) {
	        options.unshift(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "upcoming",
	            key: "upcoming",
	            onClick: _this.incrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
	        ));
	      }
	
	      if (!minYear || !_this.state.yearsList.find(function (year) {
	        return year === minYear;
	      })) {
	        options.push(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "previous",
	            key: "previous",
	            onClick: _this.decrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
	        ));
	      }
	
	      return options;
	    };
	
	    _this.onChange = function (year) {
	      _this.props.onChange(year);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.shiftYears = function (amount) {
	      var years = _this.state.yearsList.map(function (year) {
	        return year + amount;
	      });
	
	      _this.setState({
	        yearsList: years
	      });
	    };
	
	    _this.incrementYears = function () {
	      return _this.shiftYears(1);
	    };
	
	    _this.decrementYears = function () {
	      return _this.shiftYears(-1);
	    };
	
	    var yearDropdownItemNumber = props.yearDropdownItemNumber,
	        scrollableYearDropdown = props.scrollableYearDropdown;
	
	    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
	
	    _this.state = {
	      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  YearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__year-dropdown": true,
	      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return YearDropdownOptions;
	}(React.Component);
	
	YearDropdownOptions.propTypes = {
	  minDate: PropTypes.object,
	  maxDate: PropTypes.object,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var dayOfWeekCodes = {
	  1: "mon",
	  2: "tue",
	  3: "wed",
	  4: "thu",
	  5: "fri",
	  6: "sat",
	  7: "sun"
	};
	
	// These functions are not exported so
	// that we avoid magic strings like 'days'
	function set$1(date, unit, to) {
	  return date.set(unit, to);
	}
	
	function add(date, amount, unit) {
	  return date.add(amount, unit);
	}
	
	function subtract(date, amount, unit) {
	  return date.subtract(amount, unit);
	}
	
	function get$1(date, unit) {
	  return date.get(unit);
	}
	
	function getStartOf(date, unit) {
	  return date.startOf(unit);
	}
	
	// ** Date Constructors **
	
	function newDate(point) {
	  return moment(point);
	}
	
	function newDateWithOffset(utcOffset) {
	  return moment().utc().utcOffset(utcOffset);
	}
	
	function now(maybeFixedUtcOffset) {
	  if (maybeFixedUtcOffset == null) {
	    return newDate();
	  }
	  return newDateWithOffset(maybeFixedUtcOffset);
	}
	
	function cloneDate(date) {
	  return date.clone();
	}
	
	function parseDate(value, _ref) {
	  var dateFormat = _ref.dateFormat,
	      locale = _ref.locale;
	
	  var m = moment(value, dateFormat, locale || moment.locale(), true);
	  return m.isValid() ? m : null;
	}
	
	// ** Date "Reflection" **
	
	function isMoment(date) {
	  return moment.isMoment(date);
	}
	
	function isDate(date) {
	  return moment.isDate(date);
	}
	
	// ** Date Formatting **
	
	function formatDate(date, format) {
	  return date.format(format);
	}
	
	function safeDateFormat(date, _ref2) {
	  var dateFormat = _ref2.dateFormat,
	      locale = _ref2.locale;
	
	  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
	}
	
	// ** Date Setters **
	
	function setTime(date, _ref3) {
	  var hour = _ref3.hour,
	      minute = _ref3.minute,
	      second = _ref3.second;
	
	  date.set({ hour: hour, minute: minute, second: second });
	  return date;
	}
	
	function setMonth(date, month) {
	  return set$1(date, "month", month);
	}
	
	function setYear(date, year) {
	  return set$1(date, "year", year);
	}
	
	
	
	// ** Date Getters **
	
	function getSecond(date) {
	  return get$1(date, "second");
	}
	
	function getMinute(date) {
	  return get$1(date, "minute");
	}
	
	function getHour(date) {
	  return get$1(date, "hour");
	}
	
	// Returns day of week
	function getDay(date) {
	  return get$1(date, "day");
	}
	
	function getWeek(date) {
	  return get$1(date, "week");
	}
	
	function getMonth(date) {
	  return get$1(date, "month");
	}
	
	function getYear(date) {
	  return get$1(date, "year");
	}
	
	// Returns day of month
	function getDate(date) {
	  return get$1(date, "date");
	}
	
	
	
	function getDayOfWeekCode(day) {
	  return dayOfWeekCodes[day.isoWeekday()];
	}
	
	// *** Start of ***
	
	function getStartOfDay(date) {
	  return getStartOf(date, "day");
	}
	
	function getStartOfWeek(date) {
	  return getStartOf(date, "week");
	}
	function getStartOfMonth(date) {
	  return getStartOf(date, "month");
	}
	
	function getStartOfDate(date) {
	  return getStartOf(date, "date");
	}
	
	// *** End of ***
	
	
	
	
	
	// ** Date Math **
	
	// *** Addition ***
	
	function addMinutes(date, amount) {
	  return add(date, amount, "minutes");
	}
	
	function addHours(date, amount) {
	  return add(date, amount, "hours");
	}
	
	function addDays(date, amount) {
	  return add(date, amount, "days");
	}
	
	function addWeeks(date, amount) {
	  return add(date, amount, "weeks");
	}
	
	function addMonths(date, amount) {
	  return add(date, amount, "months");
	}
	
	function addYears(date, amount) {
	  return add(date, amount, "years");
	}
	
	// *** Subtraction ***
	function subtractDays(date, amount) {
	  return subtract(date, amount, "days");
	}
	
	function subtractWeeks(date, amount) {
	  return subtract(date, amount, "weeks");
	}
	
	function subtractMonths(date, amount) {
	  return subtract(date, amount, "months");
	}
	
	function subtractYears(date, amount) {
	  return subtract(date, amount, "years");
	}
	
	// ** Date Comparison **
	
	function isBefore(date1, date2) {
	  return date1.isBefore(date2);
	}
	
	function isAfter(date1, date2) {
	  return date1.isAfter(date2);
	}
	
	function equals(date1, date2) {
	  return date1.isSame(date2);
	}
	
	function isSameYear(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "year");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameMonth(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "month");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameDay(moment1, moment2) {
	  if (moment1 && moment2) {
	    return moment1.isSame(moment2, "day");
	  } else {
	    return !moment1 && !moment2;
	  }
	}
	
	
	
	function isDayInRange(day, startDate, endDate) {
	  var before = startDate.clone().startOf("day").subtract(1, "seconds");
	  var after = endDate.clone().startOf("day").add(1, "seconds");
	  return day.clone().startOf("day").isBetween(before, after);
	}
	
	// *** Diffing ***
	
	
	
	// ** Date Localization **
	
	function localizeDate(date, locale) {
	  return date.clone().locale(locale || moment.locale());
	}
	
	
	
	
	
	
	
	function getLocaleData(date) {
	  return date.localeData();
	}
	
	function getLocaleDataForLocale(locale) {
	  return moment.localeData(locale);
	}
	
	function getFormattedWeekdayInLocale(locale, date, formatFunc) {
	  return formatFunc(locale.weekdays(date));
	}
	
	function getWeekdayMinInLocale(locale, date) {
	  return locale.weekdaysMin(date);
	}
	
	function getWeekdayShortInLocale(locale, date) {
	  return locale.weekdaysShort(date);
	}
	
	// TODO what is this format exactly?
	function getMonthInLocale(locale, date, format) {
	  return locale.months(date, format);
	}
	
	function getMonthShortInLocale(locale, date) {
	  return locale.monthsShort(date);
	}
	
	// ** Utils for some components **
	
	function isDayDisabled(day) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref4.minDate,
	      maxDate = _ref4.maxDate,
	      excludeDates = _ref4.excludeDates,
	      includeDates = _ref4.includeDates,
	      filterDate = _ref4.filterDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
	    return isSameDay(day, excludeDate);
	  }) || includeDates && !includeDates.some(function (includeDate) {
	    return isSameDay(day, includeDate);
	  }) || filterDate && !filterDate(day.clone()) || false;
	}
	
	function isOutOfBounds(day) {
	  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref5.minDate,
	      maxDate = _ref5.maxDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day");
	}
	
	function isTimeDisabled(time, disabledTimes) {
	  var l = disabledTimes.length;
	  for (var i = 0; i < l; i++) {
	    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isTimeInDisabledRange(time, _ref6) {
	  var minTime = _ref6.minTime,
	      maxTime = _ref6.maxTime;
	
	  if (!minTime || !maxTime) {
	    throw new Error("Both minTime and maxTime props required");
	  }
	
	  var base = moment().hours(0).minutes(0).seconds(0);
	  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
	  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
	  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));
	
	  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
	}
	
	function allDaysDisabledBefore(day, unit) {
	  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      minDate = _ref7.minDate,
	      includeDates = _ref7.includeDates;
	
	  var dateBefore = day.clone().subtract(1, unit);
	  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateBefore.isBefore(includeDate, unit);
	  }) || false;
	}
	
	function allDaysDisabledAfter(day, unit) {
	  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      maxDate = _ref8.maxDate,
	      includeDates = _ref8.includeDates;
	
	  var dateAfter = day.clone().add(1, unit);
	  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateAfter.isAfter(includeDate, unit);
	  }) || false;
	}
	
	function getEffectiveMinDate(_ref9) {
	  var minDate = _ref9.minDate,
	      includeDates = _ref9.includeDates;
	
	  if (includeDates && minDate) {
	    return moment.min(includeDates.filter(function (includeDate) {
	      return minDate.isSameOrBefore(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.min(includeDates);
	  } else {
	    return minDate;
	  }
	}
	
	function getEffectiveMaxDate(_ref10) {
	  var maxDate = _ref10.maxDate,
	      includeDates = _ref10.includeDates;
	
	  if (includeDates && maxDate) {
	    return moment.max(includeDates.filter(function (includeDate) {
	      return maxDate.isSameOrAfter(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.max(includeDates);
	  } else {
	    return maxDate;
	  }
	}
	
	function getHightLightDaysMap() {
	  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
	
	  var dateClasses = new Map();
	  for (var i = 0, len = highlightDates.length; i < len; i++) {
	    var obj = highlightDates[i];
	    if (isMoment(obj)) {
	      var key = obj.format("MM.DD.YYYY");
	      var classNamesArr = dateClasses.get(key) || [];
	      if (!classNamesArr.includes(defaultClassName)) {
	        classNamesArr.push(defaultClassName);
	        dateClasses.set(key, classNamesArr);
	      }
	    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
	      var keys = Object.keys(obj);
	      var className = keys[0];
	      var arrOfMoments = obj[keys[0]];
	      if (typeof className === "string" && arrOfMoments.constructor === Array) {
	        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
	          var _key = arrOfMoments[k].format("MM.DD.YYYY");
	          var _classNamesArr = dateClasses.get(_key) || [];
	          if (!_classNamesArr.includes(className)) {
	            _classNamesArr.push(className);
	            dateClasses.set(_key, _classNamesArr);
	          }
	        }
	      }
	    }
	  }
	
	  return dateClasses;
	}
	
	function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
	  var l = injectedTimes.length;
	  var times = [];
	  for (var i = 0; i < l; i++) {
	    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
	    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);
	
	    if (injectedTime.isBetween(currentTime, nextTime)) {
	      times.push(injectedTimes[i]);
	    }
	  }
	
	  return times;
	}
	
	var WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions);
	
	var YearDropdown = function (_React$Component) {
	  inherits(YearDropdown, _React$Component);
	
	  function YearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, YearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
	      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
	
	      var options = [];
	      for (var i = minYear; i <= maxYear; i++) {
	        options.push(React.createElement(
	          "option",
	          { key: i, value: i },
	          i
	        ));
	      }
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.year,
	          className: "react-datepicker__year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__year-read-view--selected-year" },
	          _this.props.year
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        year: _this.props.year,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (year) {
	      _this.toggleDropdown();
	      if (year === _this.props.year) return;
	      _this.props.onChange(year);
	    }, _this.toggleDropdown = function (event) {
	      _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      }, function () {
	        if (_this.props.adjustDateOnChange) {
	          _this.handleYearChange(_this.props.date, event);
	        }
	      });
	    }, _this.handleYearChange = function (date, event) {
	      _this.onSelect(date, event);
	      _this.setOpen();
	    }, _this.onSelect = function (date, event) {
	      if (_this.props.onSelect) {
	        _this.props.onSelect(date, event);
	      }
	    }, _this.setOpen = function () {
	      if (_this.props.setOpen) {
	        _this.props.setOpen(true);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  YearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return YearDropdown;
	}(React.Component);
	
	YearDropdown.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number,
	  date: PropTypes.object,
	  onSelect: PropTypes.func,
	  setOpen: PropTypes.func
	};
	
	var MonthDropdownOptions = function (_React$Component) {
	  inherits(MonthDropdownOptions, _React$Component);
	
	  function MonthDropdownOptions() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdownOptions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
	      return _this.props.monthNames.map(function (month, i) {
	        return React.createElement(
	          "div",
	          {
	            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
	            key: month,
	            ref: month,
	            onClick: _this.onChange.bind(_this, i)
	          },
	          _this.props.month === i ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-option--selected" },
	            "\u2713"
	          ) : "",
	          month
	        );
	      });
	    }, _this.onChange = function (month) {
	      return _this.props.onChange(month);
	    }, _this.handleClickOutside = function () {
	      return _this.props.onCancel();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdownOptions.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__month-dropdown" },
	      this.renderOptions()
	    );
	  };
	
	  return MonthDropdownOptions;
	}(React.Component);
	
	MonthDropdownOptions.propTypes = {
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  month: PropTypes.number.isRequired,
	  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	};
	
	var WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
	
	var MonthDropdown = function (_React$Component) {
	  inherits(MonthDropdown, _React$Component);
	
	  function MonthDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function (monthNames) {
	      return monthNames.map(function (M, i) {
	        return React.createElement(
	          "option",
	          { key: i, value: i },
	          M
	        );
	      });
	    }, _this.renderSelectMode = function (monthNames) {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.month,
	          className: "react-datepicker__month-select",
	          onChange: function onChange(e) {
	            return _this.onChange(e.target.value);
	          }
	        },
	        _this.renderSelectOptions(monthNames)
	      );
	    }, _this.renderReadView = function (visible, monthNames) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-read-view",
	          onClick: _this.toggleDropdown
	        },
	        React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-read-view--selected-month" },
	          monthNames[_this.props.month]
	        )
	      );
	    }, _this.renderDropdown = function (monthNames) {
	      return React.createElement(WrappedMonthDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        month: _this.props.month,
	        monthNames: monthNames,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown
	      });
	    }, _this.renderScrollMode = function (monthNames) {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown(monthNames));
	      }
	      return result;
	    }, _this.onChange = function (month) {
	      _this.toggleDropdown();
	      if (month !== _this.props.month) {
	        _this.props.onChange(month);
	      }
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var localeData = getLocaleDataForLocale(this.props.locale);
	    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
	      return getMonthShortInLocale(localeData, newDate({ M: M }));
	    } : function (M) {
	      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
	    });
	
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode(monthNames);
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode(monthNames);
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthDropdown;
	}(React.Component);
	
	MonthDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  locale: PropTypes.string,
	  dateFormat: PropTypes.string.isRequired,
	  month: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired,
	  useShortMonthInDropdown: PropTypes.bool
	};
	
	function generateMonthYears(minDate, maxDate) {
	  var list = [];
	
	  var currDate = getStartOfMonth(cloneDate(minDate));
	  var lastDate = getStartOfMonth(cloneDate(maxDate));
	
	  while (!isAfter(currDate, lastDate)) {
	    list.push(cloneDate(currDate));
	
	    addMonths(currDate, 1);
	  }
	
	  return list;
	}
	
	var MonthYearDropdownOptions = function (_React$Component) {
	  inherits(MonthYearDropdownOptions, _React$Component);
	
	  function MonthYearDropdownOptions(props) {
	    classCallCheck(this, MonthYearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      return _this.state.monthYearsList.map(function (monthYear) {
	        var monthYearPoint = monthYear.valueOf();
	
	        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
	
	        return React.createElement(
	          "div",
	          {
	            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
	            key: monthYearPoint,
	            ref: monthYearPoint,
	            onClick: _this.onChange.bind(_this, monthYearPoint)
	          },
	          isSameMonthYear ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-year-option--selected" },
	            "\u2713"
	          ) : "",
	          formatDate(monthYear, _this.props.dateFormat)
	        );
	      });
	    };
	
	    _this.onChange = function (monthYear) {
	      return _this.props.onChange(monthYear);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.state = {
	      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  MonthYearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__month-year-dropdown": true,
	      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return MonthYearDropdownOptions;
	}(React.Component);
	
	MonthYearDropdownOptions.propTypes = {
	  minDate: PropTypes.object.isRequired,
	  maxDate: PropTypes.object.isRequired,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  date: PropTypes.object.isRequired,
	  dateFormat: PropTypes.string.isRequired
	};
	
	var WrappedMonthYearDropdownOptions = onClickOutside(MonthYearDropdownOptions);
	
	var MonthYearDropdown = function (_React$Component) {
	  inherits(MonthYearDropdown, _React$Component);
	
	  function MonthYearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthYearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
	      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));
	
	      var options = [];
	
	      while (!isAfter(currDate, lastDate)) {
	        var timepoint = currDate.valueOf();
	        options.push(React.createElement(
	          "option",
	          { key: timepoint, value: timepoint },
	          formatDate(currDate, _this.props.dateFormat)
	        ));
	
	        addMonths(currDate, 1);
	      }
	
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: getStartOfMonth(_this.props.date).valueOf(),
	          className: "react-datepicker__month-year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);
	
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-year-read-view--selected-month-year" },
	          yearMonth
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedMonthYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        date: _this.props.date,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: localizeDate(_this.props.minDate, _this.props.locale),
	        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (monthYearPoint) {
	      _this.toggleDropdown();
	
	      var changedDate = newDate(parseInt(monthYearPoint));
	
	      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
	        return;
	      }
	
	      _this.props.onChange(changedDate);
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthYearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthYearDropdown;
	}(React.Component);
	
	MonthYearDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  dateFormat: PropTypes.string.isRequired,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object.isRequired,
	  minDate: PropTypes.object.isRequired,
	  date: PropTypes.object.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool
	};
	
	var Day = function (_React$Component) {
	  inherits(Day, _React$Component);
	
	  function Day() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.isDisabled() && _this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.isDisabled() && _this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.isSameDay = function (other) {
	      return isSameDay(_this.props.day, other);
	    }, _this.isKeyboardSelected = function () {
	      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
	    }, _this.isDisabled = function () {
	      return isDayDisabled(_this.props.day, _this.props);
	    }, _this.getHighLightedClass = function (defaultClassName) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          highlightDates = _this$props.highlightDates;
	
	
	      if (!highlightDates) {
	        return false;
	      }
	
	      // Looking for className in the Map of {'day string, 'className'}
	      var dayStr = day.format("MM.DD.YYYY");
	      return highlightDates.get(dayStr);
	    }, _this.isInRange = function () {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          startDate = _this$props2.startDate,
	          endDate = _this$props2.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isDayInRange(day, startDate, endDate);
	    }, _this.isInSelectingRange = function () {
	      var _this$props3 = _this.props,
	          day = _this$props3.day,
	          selectsStart = _this$props3.selectsStart,
	          selectsEnd = _this$props3.selectsEnd,
	          selectingDate = _this$props3.selectingDate,
	          startDate = _this$props3.startDate,
	          endDate = _this$props3.endDate;
	
	
	      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
	        return false;
	      }
	
	      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
	        return isDayInRange(day, selectingDate, endDate);
	      }
	
	      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
	        return isDayInRange(day, startDate, selectingDate);
	      }
	
	      return false;
	    }, _this.isSelectingRangeStart = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props4 = _this.props,
	          day = _this$props4.day,
	          selectingDate = _this$props4.selectingDate,
	          startDate = _this$props4.startDate,
	          selectsStart = _this$props4.selectsStart;
	
	
	      if (selectsStart) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, startDate);
	      }
	    }, _this.isSelectingRangeEnd = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props5 = _this.props,
	          day = _this$props5.day,
	          selectingDate = _this$props5.selectingDate,
	          endDate = _this$props5.endDate,
	          selectsEnd = _this$props5.selectsEnd;
	
	
	      if (selectsEnd) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, endDate);
	      }
	    }, _this.isRangeStart = function () {
	      var _this$props6 = _this.props,
	          day = _this$props6.day,
	          startDate = _this$props6.startDate,
	          endDate = _this$props6.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(startDate, day);
	    }, _this.isRangeEnd = function () {
	      var _this$props7 = _this.props,
	          day = _this$props7.day,
	          startDate = _this$props7.startDate,
	          endDate = _this$props7.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(endDate, day);
	    }, _this.isWeekend = function () {
	      var weekday = getDay(_this.props.day);
	      return weekday === 0 || weekday === 6;
	    }, _this.isOutsideMonth = function () {
	      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
	    }, _this.getClassNames = function (date) {
	      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
	      return classnames("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
	        "react-datepicker__day--disabled": _this.isDisabled(),
	        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
	        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
	        "react-datepicker__day--range-start": _this.isRangeStart(),
	        "react-datepicker__day--range-end": _this.isRangeEnd(),
	        "react-datepicker__day--in-range": _this.isInRange(),
	        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
	        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
	        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
	        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
	        "react-datepicker__day--weekend": _this.isWeekend(),
	        "react-datepicker__day--outside-month": _this.isOutsideMonth()
	      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Day.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(this.props.day),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        "aria-label": "day-" + getDate(this.props.day),
	        role: "option"
	      },
	      this.props.renderDayContents ? this.props.renderDayContents(getDate(this.props.day)) : getDate(this.props.day)
	    );
	  };
	
	  return Day;
	}(React.Component);
	
	Day.propTypes = {
	  disabledKeyboardNavigation: PropTypes.bool,
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  highlightDates: PropTypes.instanceOf(Map),
	  inline: PropTypes.bool,
	  month: PropTypes.number,
	  onClick: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  renderDayContents: PropTypes.func
	};
	
	var WeekNumber = function (_React$Component) {
	  inherits(WeekNumber, _React$Component);
	
	  function WeekNumber() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, WeekNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  WeekNumber.prototype.render = function render() {
	    var weekNumberClasses = {
	      "react-datepicker__week-number": true,
	      "react-datepicker__week-number--clickable": !!this.props.onClick
	    };
	    return React.createElement(
	      "div",
	      {
	        className: classnames(weekNumberClasses),
	        "aria-label": "week-" + this.props.weekNumber,
	        onClick: this.handleClick
	      },
	      this.props.weekNumber
	    );
	  };
	
	  return WeekNumber;
	}(React.Component);
	
	WeekNumber.propTypes = {
	  weekNumber: PropTypes.number.isRequired,
	  onClick: PropTypes.func
	};
	
	var Week = function (_React$Component) {
	  inherits(Week, _React$Component);
	
	  function Week() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Week);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleWeekClick = function (day, weekNumber, event) {
	      if (typeof _this.props.onWeekSelect === "function") {
	        _this.props.onWeekSelect(day, weekNumber, event);
	      }
	    }, _this.formatWeekNumber = function (startOfWeek) {
	      if (_this.props.formatWeekNumber) {
	        return _this.props.formatWeekNumber(startOfWeek);
	      }
	      return getWeek(startOfWeek);
	    }, _this.renderDays = function () {
	      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
	      var days = [];
	      var weekNumber = _this.formatWeekNumber(startOfWeek);
	      if (_this.props.showWeekNumber) {
	        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
	        days.push(React.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
	      }
	      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        return React.createElement(Day, {
	          key: offset,
	          day: day,
	          month: _this.props.month,
	          onClick: _this.handleDayClick.bind(_this, day),
	          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset,
	          renderDayContents: _this.props.renderDayContents,
	          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
	        });
	      }));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Week.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__week" },
	      this.renderDays()
	    );
	  };
	
	  return Week;
	}(React.Component);
	
	Week.propTypes = {
	  disabledKeyboardNavigation: PropTypes.bool,
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  month: PropTypes.number,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumber: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  renderDayContents: PropTypes.func
	};
	
	var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
	
	var Month = function (_React$Component) {
	  inherits(Month, _React$Component);
	
	  function Month() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleMouseLeave = function () {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave();
	      }
	    }, _this.isWeekInMonth = function (startOfWeek) {
	      var day = _this.props.day;
	      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
	      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
	    }, _this.renderWeeks = function () {
	      var weeks = [];
	      var isFixedHeight = _this.props.fixedHeight;
	      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
	      var i = 0;
	      var breakAfterNextPush = false;
	
	      while (true) {
	        weeks.push(React.createElement(Week, {
	          key: i,
	          day: currentWeekStart,
	          month: getMonth(_this.props.day),
	          onDayClick: _this.handleDayClick,
	          onDayMouseEnter: _this.handleDayMouseEnter,
	          onWeekSelect: _this.props.onWeekSelect,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          showWeekNumber: _this.props.showWeekNumbers,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset,
	          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
	          renderDayContents: _this.props.renderDayContents
	        }));
	
	        if (breakAfterNextPush) break;
	
	        i++;
	        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);
	
	        // If one of these conditions is true, we will either break on this week
	        // or break on the next week
	        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
	        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
	
	        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
	          if (_this.props.peekNextMonth) {
	            breakAfterNextPush = true;
	          } else {
	            break;
	          }
	        }
	      }
	
	      return weeks;
	    }, _this.getClassNames = function () {
	      var _this$props = _this.props,
	          selectingDate = _this$props.selectingDate,
	          selectsStart = _this$props.selectsStart,
	          selectsEnd = _this$props.selectsEnd;
	
	      return classnames("react-datepicker__month", {
	        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Month.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(),
	        onMouseLeave: this.handleMouseLeave,
	        role: "listbox",
	        "aria-label": "month-" + this.props.day.format("YYYY-MM")
	      },
	      this.renderWeeks()
	    );
	  };
	
	  return Month;
	}(React.Component);
	
	Month.propTypes = {
	  disabledKeyboardNavigation: PropTypes.bool,
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  peekNextMonth: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  renderDayContents: PropTypes.func
	};
	
	var Time = function (_React$Component) {
	  inherits(Time, _React$Component);
	
	  function Time() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        return;
	      }
	
	      _this.props.onChange(time);
	    }, _this.liClasses = function (time, currH, currM) {
	      var classes = ["react-datepicker__time-list-item"];
	
	      if (currH === getHour(time) && currM === getMinute(time)) {
	        classes.push("react-datepicker__time-list-item--selected");
	      }
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        classes.push("react-datepicker__time-list-item--disabled");
	      }
	      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
	        classes.push("react-datepicker__time-list-item--injected");
	      }
	
	      return classes.join(" ");
	    }, _this.renderTimes = function () {
	      var times = [];
	      var format = _this.props.format ? _this.props.format : "hh:mm A";
	      var intervals = _this.props.intervals;
	      var activeTime = _this.props.selected ? _this.props.selected : newDate();
	      var currH = getHour(activeTime);
	      var currM = getMinute(activeTime);
	      var base = getStartOfDay(newDate());
	      var multiplier = 1440 / intervals;
	      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
	        return a - b;
	      });
	      for (var i = 0; i < multiplier; i++) {
	        var currentTime = addMinutes(cloneDate(base), i * intervals);
	        times.push(currentTime);
	
	        if (sortedInjectTimes) {
	          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
	          times = times.concat(timesToInject);
	        }
	      }
	
	      return times.map(function (time, i) {
	        return React.createElement(
	          "li",
	          {
	            key: i,
	            onClick: _this.handleClick.bind(_this, time),
	            className: _this.liClasses(time, currH, currM),
	            ref: function ref(li) {
	              if (currH === getHour(time) && currM === getMinute(time) || currH === getHour(time) && !_this.centerLi) {
	                _this.centerLi = li;
	              }
	            }
	          },
	          formatDate(time, format)
	        );
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Time.prototype.componentDidMount = function componentDidMount() {
	    // code to ensure selected time will always be in focus within time window when it first appears
	    this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
	  };
	
	  Time.prototype.render = function render() {
	    var _this2 = this;
	
	    var height = null;
	    if (this.props.monthRef && this.header) {
	      height = this.props.monthRef.clientHeight - this.header.clientHeight;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
	      },
	      React.createElement(
	        "div",
	        {
	          className: "react-datepicker__header react-datepicker__header--time",
	          ref: function ref(header) {
	            _this2.header = header;
	          }
	        },
	        React.createElement(
	          "div",
	          { className: "react-datepicker-time__header" },
	          this.props.timeCaption
	        )
	      ),
	      React.createElement(
	        "div",
	        { className: "react-datepicker__time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker__time-box" },
	          React.createElement(
	            "ul",
	            {
	              className: "react-datepicker__time-list",
	              ref: function ref(list) {
	                _this2.list = list;
	              },
	              style: height ? { height: height } : {}
	            },
	            this.renderTimes.bind(this)()
	          )
	        )
	      )
	    );
	  };
	
	  createClass(Time, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        intervals: 30,
	        onTimeChange: function onTimeChange() {},
	        todayButton: null,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	  return Time;
	}(React.Component);
	
	Time.propTypes = {
	  format: PropTypes.string,
	  includeTimes: PropTypes.array,
	  intervals: PropTypes.number,
	  selected: PropTypes.object,
	  onChange: PropTypes.func,
	  todayButton: PropTypes.node,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  monthRef: PropTypes.object,
	  timeCaption: PropTypes.string,
	  injectTimes: PropTypes.array
	};
	
	Time.calcCenterPosition = function (listHeight, centerLiRef) {
	  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
	};
	
	function CalendarContainer(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      _ref$arrowProps = _ref.arrowProps,
	      arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;
	
	  return React.createElement(
	    "div",
	    { className: className },
	    React.createElement("div", _extends({ className: "react-datepicker__triangle" }, arrowProps)),
	    children
	  );
	}
	
	CalendarContainer.propTypes = {
	  className: PropTypes.string,
	  children: PropTypes.node,
	  arrowProps: PropTypes.object // react-popper arrow props
	};
	
	var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
	
	var isDropdownSelect = function isDropdownSelect() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var classNames = (element.className || "").split(/\s+/);
	  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
	    return classNames.indexOf(testClassname) >= 0;
	  });
	};
	
	var Calendar = function (_React$Component) {
	  inherits(Calendar, _React$Component);
	  createClass(Calendar, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        onDropdownFocus: function onDropdownFocus() {},
	        monthsShown: 1,
	        forceShowMonthNavigation: false,
	        timeCaption: "Time",
	        previousMonthButtonLabel: "Previous Month",
	        nextMonthButtonLabel: "Next Month"
	      };
	    }
	  }]);
	
	  function Calendar(props) {
	    classCallCheck(this, Calendar);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClickOutside = function (event) {
	      _this.props.onClickOutside(event);
	    };
	
	    _this.handleDropdownFocus = function (event) {
	      if (isDropdownSelect(event.target)) {
	        _this.props.onDropdownFocus();
	      }
	    };
	
	    _this.getDateInView = function () {
	      var _this$props = _this.props,
	          preSelection = _this$props.preSelection,
	          selected = _this$props.selected,
	          openToDate = _this$props.openToDate,
	          utcOffset = _this$props.utcOffset;
	
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var current = now(utcOffset);
	      var initialDate = openToDate || selected || preSelection;
	      if (initialDate) {
	        return initialDate;
	      } else {
	        if (minDate && isBefore(current, minDate)) {
	          return minDate;
	        } else if (maxDate && isAfter(current, maxDate)) {
	          return maxDate;
	        }
	      }
	      return current;
	    };
	
	    _this.localizeDate = function (date) {
	      return localizeDate(date, _this.props.locale);
	    };
	
	    _this.increaseMonth = function () {
	      _this.setState({
	        date: addMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.decreaseMonth = function () {
	      _this.setState({
	        date: subtractMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.handleDayClick = function (day, event) {
	      return _this.props.onSelect(day, event);
	    };
	
	    _this.handleDayMouseEnter = function (day) {
	      return _this.setState({ selectingDate: day });
	    };
	
	    _this.handleMonthMouseLeave = function () {
	      return _this.setState({ selectingDate: null });
	    };
	
	    _this.handleYearChange = function (date) {
	      if (_this.props.onYearChange) {
	        _this.props.onYearChange(date);
	      }
	    };
	
	    _this.handleMonthChange = function (date) {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(date);
	      }
	      if (_this.props.adjustDateOnChange) {
	        if (_this.props.onSelect) {
	          _this.props.onSelect(date);
	        }
	        if (_this.props.setOpen) {
	          _this.props.setOpen(true);
	        }
	      }
	    };
	
	    _this.handleMonthYearChange = function (date) {
	      _this.handleYearChange(date);
	      _this.handleMonthChange(date);
	    };
	
	    _this.changeYear = function (year) {
	      _this.setState({
	        date: setYear(cloneDate(_this.state.date), year)
	      }, function () {
	        return _this.handleYearChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonth = function (month) {
	      _this.setState({
	        date: setMonth(cloneDate(_this.state.date), month)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonthYear = function (monthYear) {
	      _this.setState({
	        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
	      }, function () {
	        return _this.handleMonthYearChange(_this.state.date);
	      });
	    };
	
	    _this.header = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var startOfWeek = getStartOfWeek(cloneDate(date));
	      var dayNames = [];
	      if (_this.props.showWeekNumbers) {
	        dayNames.push(React.createElement(
	          "div",
	          { key: "W", className: "react-datepicker__day-name" },
	          _this.props.weekLabel || "#"
	        ));
	      }
	      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        var localeData = getLocaleData(day);
	        var weekDayName = _this.formatWeekday(localeData, day);
	
	        return React.createElement(
	          "div",
	          { key: offset, className: "react-datepicker__day-name" },
	          weekDayName
	        );
	      }));
	    };
	
	    _this.formatWeekday = function (localeData, day) {
	      if (_this.props.formatWeekDay) {
	        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
	      }
	      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
	    };
	
	    _this.renderPreviousMonthButton = function () {
	      if (_this.props.renderCustomHeader) {
	        return;
	      }
	
	      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
	
	      var clickHandler = _this.decreaseMonth;
	
	      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--previous--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement(
	        "button",
	        {
	          type: "button",
	          className: classes.join(" "),
	          onClick: clickHandler
	        },
	        _this.props.previousMonthButtonLabel
	      );
	    };
	
	    _this.renderNextMonthButton = function () {
	      if (_this.props.renderCustomHeader) {
	        return;
	      }
	
	      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
	      if (_this.props.showTimeSelect) {
	        classes.push("react-datepicker__navigation--next--with-time");
	      }
	      if (_this.props.todayButton) {
	        classes.push("react-datepicker__navigation--next--with-today-button");
	      }
	
	      var clickHandler = _this.increaseMonth;
	
	      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--next--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement(
	        "button",
	        {
	          type: "button",
	          className: classes.join(" "),
	          onClick: clickHandler
	        },
	        _this.props.nextMonthButtonLabel
	      );
	    };
	
	    _this.renderCurrentMonth = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var classes = ["react-datepicker__current-month"];
	
	      if (_this.props.showYearDropdown) {
	        classes.push("react-datepicker__current-month--hasYearDropdown");
	      }
	      if (_this.props.showMonthDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthDropdown");
	      }
	      if (_this.props.showMonthYearDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
	      }
	      return React.createElement(
	        "div",
	        { className: classes.join(" ") },
	        formatDate(date, _this.props.dateFormat)
	      );
	    };
	
	    _this.renderYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(YearDropdown, {
	        adjustDateOnChange: _this.props.adjustDateOnChange,
	        date: _this.state.date,
	        onSelect: _this.props.onSelect,
	        setOpen: _this.props.setOpen,
	        dropdownMode: _this.props.dropdownMode,
	        onChange: _this.changeYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        year: getYear(_this.state.date),
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    };
	
	    _this.renderMonthDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonth,
	        month: getMonth(_this.state.date),
	        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
	      });
	    };
	
	    _this.renderMonthYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthYearDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonthYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        date: _this.state.date,
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    };
	
	    _this.renderTodayButton = function () {
	      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
	        return;
	      }
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__today-button",
	          onClick: function onClick(e) {
	            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
	          }
	        },
	        _this.props.todayButton
	      );
	    };
	
	    _this.renderDefaultHeader = function (_ref) {
	      var monthDate = _ref.monthDate,
	          i = _ref.i;
	      return React.createElement(
	        "div",
	        { className: "react-datepicker__header" },
	        _this.renderCurrentMonth(monthDate),
	        React.createElement(
	          "div",
	          {
	            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
	            onFocus: _this.handleDropdownFocus
	          },
	          _this.renderMonthDropdown(i !== 0),
	          _this.renderMonthYearDropdown(i !== 0),
	          _this.renderYearDropdown(i !== 0)
	        ),
	        React.createElement(
	          "div",
	          { className: "react-datepicker__day-names" },
	          _this.header(monthDate)
	        )
	      );
	    };
	
	    _this.renderCustomHeader = function (_ref2) {
	      var monthDate = _ref2.monthDate,
	          i = _ref2.i;
	
	      if (i !== 0) {
	        return null;
	      }
	
	      var prevMonthButtonDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      var nextMonthButtonDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__header react-datepicker__header--custom",
	          onFocus: _this.props.onDropdownFocus
	        },
	        _this.props.renderCustomHeader(_extends({}, _this.state, {
	          changeMonth: _this.changeMonth,
	          changeYear: _this.changeYear,
	          decreaseMonth: _this.decreaseMonth,
	          increaseMonth: _this.increaseMonth,
	          prevMonthButtonDisabled: prevMonthButtonDisabled,
	          nextMonthButtonDisabled: nextMonthButtonDisabled
	        })),
	        React.createElement(
	          "div",
	          { className: "react-datepicker__day-names" },
	          _this.header(monthDate)
	        )
	      );
	    };
	
	    _this.renderMonths = function () {
	      if (_this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var monthList = [];
	      for (var i = 0; i < _this.props.monthsShown; ++i) {
	        var monthDate = addMonths(cloneDate(_this.state.date), i);
	        var monthKey = "month-" + i;
	        monthList.push(React.createElement(
	          "div",
	          {
	            key: monthKey,
	            ref: function ref(div) {
	              _this.monthContainer = div;
	            },
	            className: "react-datepicker__month-container"
	          },
	          _this.props.renderCustomHeader ? _this.renderCustomHeader({ monthDate: monthDate, i: i }) : _this.renderDefaultHeader({ monthDate: monthDate, i: i }),
	          React.createElement(Month, {
	            day: monthDate,
	            dayClassName: _this.props.dayClassName,
	            onDayClick: _this.handleDayClick,
	            onDayMouseEnter: _this.handleDayMouseEnter,
	            onMouseLeave: _this.handleMonthMouseLeave,
	            onWeekSelect: _this.props.onWeekSelect,
	            formatWeekNumber: _this.props.formatWeekNumber,
	            minDate: _this.props.minDate,
	            maxDate: _this.props.maxDate,
	            excludeDates: _this.props.excludeDates,
	            highlightDates: _this.props.highlightDates,
	            selectingDate: _this.state.selectingDate,
	            includeDates: _this.props.includeDates,
	            inline: _this.props.inline,
	            fixedHeight: _this.props.fixedHeight,
	            filterDate: _this.props.filterDate,
	            preSelection: _this.props.preSelection,
	            selected: _this.props.selected,
	            selectsStart: _this.props.selectsStart,
	            selectsEnd: _this.props.selectsEnd,
	            showWeekNumbers: _this.props.showWeekNumbers,
	            startDate: _this.props.startDate,
	            endDate: _this.props.endDate,
	            peekNextMonth: _this.props.peekNextMonth,
	            utcOffset: _this.props.utcOffset,
	            renderDayContents: _this.props.renderDayContents,
	            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
	          })
	        ));
	      }
	      return monthList;
	    };
	
	    _this.renderTimeSection = function () {
	      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
	        return React.createElement(Time, {
	          selected: _this.props.selected,
	          onChange: _this.props.onTimeChange,
	          format: _this.props.timeFormat,
	          includeTimes: _this.props.includeTimes,
	          intervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          todayButton: _this.props.todayButton,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          monthRef: _this.state.monthContainer,
	          injectTimes: _this.props.injectTimes
	        });
	      }
	    };
	
	    _this.state = {
	      date: _this.localizeDate(_this.getDateInView()),
	      selectingDate: null,
	      monthContainer: null
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // monthContainer height is needed in time component
	    // to determine the height for the ul in the time component
	    // setState here so height is given after final component
	    // layout is rendered
	    if (this.props.showTimeSelect) {
	      this.assignMonthContainer = function () {
	        _this2.setState({ monthContainer: _this2.monthContainer });
	      }();
	    }
	  };
	
	  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
	      this.setState({
	        date: this.localizeDate(this.props.preSelection)
	      });
	    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
	      this.setState({
	        date: this.localizeDate(this.props.openToDate)
	      });
	    }
	  };
	
	  Calendar.prototype.render = function render() {
	    var Container = this.props.container || CalendarContainer;
	
	    return React.createElement(
	      Container,
	      {
	        className: classnames("react-datepicker", this.props.className, {
	          "react-datepicker--time-only": this.props.showTimeSelectOnly
	        })
	      },
	      this.renderPreviousMonthButton(),
	      this.renderNextMonthButton(),
	      this.renderMonths(),
	      this.renderTodayButton(),
	      this.renderTimeSection(),
	      this.props.children
	    );
	  };
	
	  return Calendar;
	}(React.Component);
	
	Calendar.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  container: PropTypes.func,
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	  dayClassName: PropTypes.func,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]),
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  onClickOutside: PropTypes.func.isRequired,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  forceShowMonthNavigation: PropTypes.bool,
	  onDropdownFocus: PropTypes.func,
	  onSelect: PropTypes.func.isRequired,
	  onWeekSelect: PropTypes.func,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  onTimeChange: PropTypes.func,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  timeCaption: PropTypes.string,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  startDate: PropTypes.object,
	  todayButton: PropTypes.node,
	  useWeekdaysShort: PropTypes.bool,
	  formatWeekDay: PropTypes.func,
	  withPortal: PropTypes.bool,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  weekLabel: PropTypes.string,
	  yearDropdownItemNumber: PropTypes.number,
	  setOpen: PropTypes.func,
	  useShortMonthInDropdown: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  previousMonthButtonLabel: PropTypes.string,
	  nextMonthButtonLabel: PropTypes.string,
	  renderCustomHeader: PropTypes.func,
	  renderDayContents: PropTypes.func
	};
	
	var popperPlacementPositions = ["bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];
	
	var PopperComponent = function (_React$Component) {
	  inherits(PopperComponent, _React$Component);
	
	  function PopperComponent() {
	    classCallCheck(this, PopperComponent);
	    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PopperComponent.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        hidePopper = _props.hidePopper,
	        popperComponent = _props.popperComponent,
	        popperModifiers = _props.popperModifiers,
	        popperPlacement = _props.popperPlacement,
	        popperProps = _props.popperProps,
	        targetComponent = _props.targetComponent;
	
	
	    var popper = void 0;
	
	    if (!hidePopper) {
	      var classes = classnames("react-datepicker-popper", className);
	      popper = React.createElement(
	        reactPopper.Popper,
	        _extends({
	          modifiers: popperModifiers,
	          placement: popperPlacement
	        }, popperProps),
	        function (_ref) {
	          var ref = _ref.ref,
	              style = _ref.style,
	              placement = _ref.placement,
	              arrowProps = _ref.arrowProps;
	          return React.createElement(
	            "div",
	            _extends({ ref: ref, style: style }, {
	              className: classes,
	              "data-placement": placement
	            }),
	            React.cloneElement(popperComponent, { arrowProps: arrowProps })
	          );
	        }
	      );
	    }
	
	    if (this.props.popperContainer) {
	      popper = React.createElement(this.props.popperContainer, {}, popper);
	    }
	
	    return React.createElement(
	      reactPopper.Manager,
	      null,
	      React.createElement(
	        reactPopper.Reference,
	        null,
	        function (_ref2) {
	          var ref = _ref2.ref;
	          return React.createElement(
	            "div",
	            { ref: ref, className: "react-datepicker-wrapper" },
	            targetComponent
	          );
	        }
	      ),
	      popper
	    );
	  };
	
	  createClass(PopperComponent, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        hidePopper: true,
	        popperModifiers: {
	          preventOverflow: {
	            enabled: true,
	            escapeWithReference: true,
	            boundariesElement: "viewport"
	          }
	        },
	        popperProps: {},
	        popperPlacement: "bottom-start"
	      };
	    }
	  }]);
	  return PopperComponent;
	}(React.Component);
	
	PopperComponent.propTypes = {
	  className: PropTypes.string,
	  hidePopper: PropTypes.bool,
	  popperComponent: PropTypes.element,
	  popperModifiers: PropTypes.object, // <datepicker/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <datepicker/> props
	  popperContainer: PropTypes.func,
	  popperProps: PropTypes.object,
	  targetComponent: PropTypes.element
	};
	
	var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
	var WrappedCalendar = onClickOutside(Calendar);
	
	// Compares dates year+month combinations
	function hasPreSelectionChanged(date1, date2) {
	  if (date1 && date2) {
	    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
	  }
	
	  return date1 !== date2;
	}
	
	function hasSelectionChanged(date1, date2) {
	  if (date1 && date2) {
	    return !equals(date1, date2);
	  }
	
	  return false;
	}
	
	/**
	 * General datepicker component.
	 */
	var INPUT_ERR_1 = "Date input not valid.";
	
	var DatePicker = function (_React$Component) {
	  inherits(DatePicker, _React$Component);
	  createClass(DatePicker, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        allowSameDay: false,
	        dateFormat: "L",
	        dateFormatCalendar: "MMMM YYYY",
	        onChange: function onChange() {},
	
	        disabled: false,
	        disabledKeyboardNavigation: false,
	        dropdownMode: "scroll",
	        onFocus: function onFocus() {},
	        onBlur: function onBlur() {},
	        onKeyDown: function onKeyDown() {},
	        onInputClick: function onInputClick() {},
	        onSelect: function onSelect() {},
	        onClickOutside: function onClickOutside$$1() {},
	        onMonthChange: function onMonthChange() {},
	
	        preventOpenOnFocus: false,
	        onYearChange: function onYearChange() {},
	        onInputError: function onInputError() {},
	
	        monthsShown: 1,
	        readOnly: false,
	        withPortal: false,
	        shouldCloseOnSelect: true,
	        showTimeSelect: false,
	        timeIntervals: 30,
	        timeCaption: "Time",
	        previousMonthButtonLabel: "Previous Month",
	        nextMonthButtonLabel: "Next month",
	        renderDayContents: function renderDayContents(date) {
	          return date;
	        }
	      };
	    }
	  }]);
	
	  function DatePicker(props) {
	    classCallCheck(this, DatePicker);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getPreSelection = function () {
	      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
	    };
	
	    _this.calcInitialState = function () {
	      var defaultPreSelection = _this.getPreSelection();
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
	      return {
	        open: _this.props.startOpen || false,
	        preventFocus: false,
	        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
	        // transforming highlighted days (perhaps nested array)
	        // to flat Map for faster access in day.jsx
	        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
	        focused: false
	      };
	    };
	
	    _this.clearPreventFocusTimeout = function () {
	      if (_this.preventFocusTimeout) {
	        clearTimeout(_this.preventFocusTimeout);
	      }
	    };
	
	    _this.setFocus = function () {
	      if (_this.input && _this.input.focus) {
	        _this.input.focus();
	      }
	    };
	
	    _this.setBlur = function () {
	      if (_this.input && _this.input.blur) {
	        _this.input.blur();
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur();
	      }
	
	      _this.cancelFocusInput();
	    };
	
	    _this.setOpen = function (open) {
	      var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _this.setState({
	        open: open,
	        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
	        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
	      }, function () {
	        if (!open) {
	          _this.setState(function (prev) {
	            return {
	              focused: skipSetBlur ? prev.focused : false
	            };
	          }, function () {
	            !skipSetBlur && _this.setBlur();
	
	            _this.setState({ inputValue: null });
	          });
	        }
	      });
	    };
	
	    _this.inputOk = function () {
	      return isMoment(_this.state.preSelection) || isDate(_this.state.preSelection);
	    };
	
	    _this.isCalendarOpen = function () {
	      return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
	    };
	
	    _this.handleFocus = function (event) {
	      if (!_this.state.preventFocus) {
	        _this.props.onFocus(event);
	        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
	          _this.setOpen(true);
	        }
	      }
	      _this.setState({ focused: true });
	    };
	
	    _this.cancelFocusInput = function () {
	      clearTimeout(_this.inputFocusTimeout);
	      _this.inputFocusTimeout = null;
	    };
	
	    _this.deferFocusInput = function () {
	      _this.cancelFocusInput();
	      _this.inputFocusTimeout = setTimeout(function () {
	        return _this.setFocus();
	      }, 1);
	    };
	
	    _this.handleDropdownFocus = function () {
	      _this.cancelFocusInput();
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.state.open && !_this.props.withPortal) {
	        _this.deferFocusInput();
	      } else {
	        _this.props.onBlur(event);
	      }
	      _this.setState({ focused: false });
	    };
	
	    _this.handleCalendarClickOutside = function (event) {
	      if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	      _this.props.onClickOutside(event);
	      if (_this.props.withPortal) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleChange = function () {
	      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
	        allArgs[_key] = arguments[_key];
	      }
	
	      var event = allArgs[0];
	      if (_this.props.onChangeRaw) {
	        _this.props.onChangeRaw.apply(_this, allArgs);
	        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
	          return;
	        }
	      }
	      _this.setState({
	        inputValue: event.target.value,
	        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
	      });
	      var date = parseDate(event.target.value, _this.props);
	      if (date || !event.target.value) {
	        _this.setSelected(date, event, true);
	      }
	    };
	
	    _this.handleSelect = function (date, event) {
	      // Preventing onFocus event to fix issue
	      // https://github.com/Hacker0x01/react-datepicker/issues/628
	      _this.setState({ preventFocus: true }, function () {
	        _this.preventFocusTimeout = setTimeout(function () {
	          return _this.setState({ preventFocus: false });
	        }, 50);
	        return _this.preventFocusTimeout;
	      });
	      _this.setSelected(date, event);
	      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
	        _this.setPreSelection(date);
	      } else if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	    };
	
	    _this.setSelected = function (date, event, keepInput) {
	      var changedDate = date;
	
	      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
	        if (isOutOfBounds(changedDate, _this.props)) {
	          _this.props.onChange(date, event);
	          _this.props.onSelect(changedDate, event);
	        }
	
	        return;
	      }
	
	      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
	        if (changedDate !== null) {
	          if (_this.props.selected) {
	            var selected = _this.props.selected;
	            if (keepInput) selected = newDate(changedDate);
	            changedDate = setTime(newDate(changedDate), {
	              hour: getHour(selected),
	              minute: getMinute(selected),
	              second: getSecond(selected)
	            });
	          }
	          if (!_this.props.inline) {
	            _this.setState({
	              preSelection: changedDate
	            });
	          }
	        }
	        _this.props.onChange(changedDate, event);
	      }
	
	      _this.props.onSelect(changedDate, event);
	
	      if (!keepInput) {
	        _this.setState({ inputValue: null });
	      }
	    };
	
	    _this.setPreSelection = function (date) {
	      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
	      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
	      if (isValidDateSelection) {
	        _this.setState({
	          preSelection: date
	        });
	      }
	    };
	
	    _this.handleTimeChange = function (time) {
	      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
	      var changedDate = setTime(cloneDate(selected), {
	        hour: getHour(time),
	        minute: getMinute(time)
	      });
	
	      _this.setState({
	        preSelection: changedDate
	      });
	
	      _this.props.onChange(changedDate);
	      if (_this.props.shouldCloseOnSelect) {
	        _this.setOpen(false);
	      }
	      _this.setState({ inputValue: null });
	    };
	
	    _this.onInputClick = function () {
	      if (!_this.props.disabled && !_this.props.readOnly) {
	        _this.setOpen(true);
	      }
	
	      _this.props.onInputClick();
	    };
	
	    _this.onInputKeyDown = function (event) {
	      _this.props.onKeyDown(event);
	      var eventKey = event.key;
	      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
	        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
	          _this.onInputClick();
	        }
	        return;
	      }
	      var copy = newDate(_this.state.preSelection);
	      if (eventKey === "Enter") {
	        event.preventDefault();
	        if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
	          _this.handleSelect(copy, event);
	          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
	        } else {
	          _this.setOpen(false);
	        }
	      } else if (eventKey === "Escape") {
	        event.preventDefault();
	
	        _this.setOpen(false);
	        if (!_this.inputOk()) {
	          _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
	        }
	      } else if (eventKey === "Tab") {
	        _this.setOpen(false, true);
	      } else if (!_this.props.disabledKeyboardNavigation) {
	        var newSelection = void 0;
	        switch (eventKey) {
	          case "ArrowLeft":
	            newSelection = subtractDays(copy, 1);
	            break;
	          case "ArrowRight":
	            newSelection = addDays(copy, 1);
	            break;
	          case "ArrowUp":
	            newSelection = subtractWeeks(copy, 1);
	            break;
	          case "ArrowDown":
	            newSelection = addWeeks(copy, 1);
	            break;
	          case "PageUp":
	            newSelection = subtractMonths(copy, 1);
	            break;
	          case "PageDown":
	            newSelection = addMonths(copy, 1);
	            break;
	          case "Home":
	            newSelection = subtractYears(copy, 1);
	            break;
	          case "End":
	            newSelection = addYears(copy, 1);
	            break;
	        }
	        if (!newSelection) {
	          if (_this.props.onInputError) {
	            _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
	          }
	          return; // Let the input component handle this keydown
	        }
	        event.preventDefault();
	        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
	        if (_this.props.adjustDateOnChange) {
	          _this.setSelected(newSelection);
	        }
	        _this.setPreSelection(newSelection);
	      }
	    };
	
	    _this.onClearClick = function (event) {
	      if (event) {
	        if (event.preventDefault) {
	          event.preventDefault();
	        }
	      }
	      _this.props.onChange(null, event);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.clear = function () {
	      _this.onClearClick();
	    };
	
	    _this.renderCalendar = function () {
	      if (!_this.props.inline && !_this.isCalendarOpen()) {
	        return null;
	      }
	      return React.createElement(
	        WrappedCalendar,
	        {
	          ref: function ref(elem) {
	            _this.calendar = elem;
	          },
	          locale: _this.props.locale,
	          adjustDateOnChange: _this.props.adjustDateOnChange,
	          setOpen: _this.setOpen,
	          dateFormat: _this.props.dateFormatCalendar,
	          useWeekdaysShort: _this.props.useWeekdaysShort,
	          formatWeekDay: _this.props.formatWeekDay,
	          dropdownMode: _this.props.dropdownMode,
	          selected: _this.props.selected,
	          preSelection: _this.state.preSelection,
	          onSelect: _this.handleSelect,
	          onWeekSelect: _this.props.onWeekSelect,
	          openToDate: _this.props.openToDate,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          excludeDates: _this.props.excludeDates,
	          filterDate: _this.props.filterDate,
	          onClickOutside: _this.handleCalendarClickOutside,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          highlightDates: _this.state.highlightDates,
	          includeDates: _this.props.includeDates,
	          includeTimes: _this.props.includeTimes,
	          injectTimes: _this.props.injectTimes,
	          inline: _this.props.inline,
	          peekNextMonth: _this.props.peekNextMonth,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showWeekNumbers: _this.props.showWeekNumbers,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
	          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
	          scrollableYearDropdown: _this.props.scrollableYearDropdown,
	          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
	          todayButton: _this.props.todayButton,
	          weekLabel: _this.props.weekLabel,
	          utcOffset: _this.props.utcOffset,
	          outsideClickIgnoreClass: outsideClickIgnoreClass,
	          fixedHeight: _this.props.fixedHeight,
	          monthsShown: _this.props.monthsShown,
	          onDropdownFocus: _this.handleDropdownFocus,
	          onMonthChange: _this.props.onMonthChange,
	          onYearChange: _this.props.onYearChange,
	          dayClassName: _this.props.dayClassName,
	          showTimeSelect: _this.props.showTimeSelect,
	          showTimeSelectOnly: _this.props.showTimeSelectOnly,
	          onTimeChange: _this.handleTimeChange,
	          timeFormat: _this.props.timeFormat,
	          timeIntervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          className: _this.props.calendarClassName,
	          container: _this.props.calendarContainer,
	          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
	          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
	          nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
	          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
	          renderCustomHeader: _this.props.renderCustomHeader,
	          popperProps: _this.props.popperProps,
	          renderDayContents: _this.props.renderDayContents
	        },
	        _this.props.children
	      );
	    };
	
	    _this.renderDateInput = function () {
	      var _classnames, _React$cloneElement;
	
	      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
	
	      var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
	      var customInputRef = _this.props.customInputRef || "ref";
	      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
	
	      return React.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
	        _this.input = input;
	      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
	    };
	
	    _this.renderClearButton = function () {
	      if (_this.props.isClearable && _this.props.selected != null) {
	        return React.createElement("button", {
	          type: "button",
	          className: "react-datepicker__close-icon",
	          onClick: _this.onClearClick,
	          title: _this.props.clearButtonTitle,
	          tabIndex: -1
	        });
	      } else {
	        return null;
	      }
	    };
	
	    _this.state = _this.calcInitialState();
	    return _this;
	  }
	
	  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
	      this.setPreSelection(this.props.selected);
	    }
	    if (prevProps.highlightDates !== this.props.highlightDates) {
	      this.setState({
	        highlightDates: getHightLightDaysMap(this.props.highlightDates)
	      });
	    }
	    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
	      this.setState({ inputValue: null });
	    }
	  };
	
	  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearPreventFocusTimeout();
	  };
	
	  DatePicker.prototype.render = function render() {
	    var calendar = this.renderCalendar();
	
	    if (this.props.inline && !this.props.withPortal) {
	      return calendar;
	    }
	
	    if (this.props.withPortal) {
	      return React.createElement(
	        "div",
	        null,
	        !this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__input-container" },
	          this.renderDateInput(),
	          this.renderClearButton()
	        ) : null,
	        this.state.open || this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__portal" },
	          calendar
	        ) : null
	      );
	    }
	
	    return React.createElement(PopperComponent, {
	      className: this.props.popperClassName,
	      hidePopper: !this.isCalendarOpen(),
	      popperModifiers: this.props.popperModifiers,
	      targetComponent: React.createElement(
	        "div",
	        { className: "react-datepicker__input-container" },
	        this.renderDateInput(),
	        this.renderClearButton()
	      ),
	      popperContainer: this.props.popperContainer,
	      popperComponent: calendar,
	      popperPlacement: this.props.popperPlacement,
	      popperProps: this.props.popperProps
	    });
	  };
	
	  return DatePicker;
	}(React.Component);
	
	DatePicker.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  allowSameDay: PropTypes.bool,
	  autoComplete: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  calendarClassName: PropTypes.string,
	  calendarContainer: PropTypes.func,
	  children: PropTypes.node,
	  className: PropTypes.string,
	  customInput: PropTypes.element,
	  customInputRef: PropTypes.string,
	  // eslint-disable-next-line react/no-unused-prop-types
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  dateFormatCalendar: PropTypes.string,
	  dayClassName: PropTypes.func,
	  disabled: PropTypes.bool,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  id: PropTypes.string,
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  isClearable: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  name: PropTypes.string,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func.isRequired,
	  onSelect: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  onClickOutside: PropTypes.func,
	  onChangeRaw: PropTypes.func,
	  onFocus: PropTypes.func,
	  onInputClick: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  onInputError: PropTypes.func,
	  open: PropTypes.bool,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  placeholderText: PropTypes.string,
	  popperContainer: PropTypes.func,
	  popperClassName: PropTypes.string, // <PopperComponent/> props
	  popperModifiers: PropTypes.object, // <PopperComponent/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <PopperComponent/> props
	  popperProps: PropTypes.object,
	  preventOpenOnFocus: PropTypes.bool,
	  readOnly: PropTypes.bool,
	  required: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  forceShowMonthNavigation: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  startDate: PropTypes.object,
	  startOpen: PropTypes.bool,
	  tabIndex: PropTypes.number,
	  timeCaption: PropTypes.string,
	  title: PropTypes.string,
	  todayButton: PropTypes.node,
	  useWeekdaysShort: PropTypes.bool,
	  formatWeekDay: PropTypes.func,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  value: PropTypes.string,
	  weekLabel: PropTypes.string,
	  withPortal: PropTypes.bool,
	  yearDropdownItemNumber: PropTypes.number,
	  shouldCloseOnSelect: PropTypes.bool,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  useShortMonthInDropdown: PropTypes.bool,
	  clearButtonTitle: PropTypes.string,
	  previousMonthButtonLabel: PropTypes.string,
	  nextMonthButtonLabel: PropTypes.string,
	  renderCustomHeader: PropTypes.func,
	  renderDayContents: PropTypes.func
	};
	var PRESELECT_CHANGE_VIA_INPUT = "input";
	var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";
	
	exports['default'] = DatePicker;
	exports.CalendarContainer = CalendarContainer;


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(739);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(178);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(740);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(226);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(225);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lottieWeb = __webpack_require__(629);
	
	var _lottieWeb2 = _interopRequireDefault(_lottieWeb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lottie = function (_React$Component) {
	  (0, _inherits3.default)(Lottie, _React$Component);
	
	  function Lottie() {
	    (0, _classCallCheck3.default)(this, Lottie);
	    return (0, _possibleConstructorReturn3.default)(this, (Lottie.__proto__ || (0, _getPrototypeOf2.default)(Lottie)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Lottie, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          _props$options = _props.options,
	          loop = _props$options.loop,
	          autoplay = _props$options.autoplay,
	          animationData = _props$options.animationData,
	          rendererSettings = _props$options.rendererSettings,
	          eventListeners = _props.eventListeners;
	
	
	      this.options = {
	        container: this.el,
	        renderer: 'svg',
	        loop: loop !== false,
	        autoplay: autoplay !== false,
	        animationData: animationData,
	        rendererSettings: rendererSettings
	      };
	
	      this.anim = _lottieWeb2.default.loadAnimation(this.options);
	      this.registerEvents(eventListeners);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps /* , nextState */) {
	      /* Recreate the animation handle if the data is changed */
	      if (this.options.animationData !== nextProps.options.animationData) {
	        this.deRegisterEvents(this.props.eventListeners);
	        this.destroy();
	        this.options.animationData = nextProps.options.animationData;
	        this.anim = _lottieWeb2.default.loadAnimation(this.options);
	        this.registerEvents(nextProps.eventListeners);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.props.isStopped ? this.stop() : this.play();
	      this.pause();
	      this.setSpeed();
	      this.setDirection();
	    }
	  }, {
	    key: 'setSpeed',
	    value: function setSpeed() {
	      this.anim.setSpeed(this.props.speed);
	    }
	  }, {
	    key: 'setDirection',
	    value: function setDirection() {
	      this.anim.setDirection(this.props.direction);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.anim.play();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.anim.stop();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (this.props.isPaused && !this.anim.isPaused) {
	        this.anim.pause();
	      } else if (!this.props.isPaused && this.anim.isPaused) {
	        this.anim.pause();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.anim.destroy();
	    }
	  }, {
	    key: 'registerEvents',
	    value: function registerEvents(eventListeners) {
	      var _this2 = this;
	
	      eventListeners.forEach(function (eventListener) {
	        _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
	      });
	    }
	  }, {
	    key: 'deRegisterEvents',
	    value: function deRegisterEvents(eventListeners) {
	      var _this3 = this;
	
	      eventListeners.forEach(function (eventListener) {
	        _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height;
	
	
	      var getSize = function getSize(initial) {
	        var size = void 0;
	
	        if (typeof initial === 'number') {
	          size = initial + 'px';
	        } else {
	          size = initial || '100%';
	        }
	
	        return size;
	      };
	
	      var lottieStyles = {
	        width: getSize(width),
	        height: getSize(height),
	        overflow: 'hidden',
	        margin: '0 auto'
	      };
	
	      return _react2.default.createElement('div', {
	        ref: function ref(c) {
	          _this4.el = c;
	        },
	        style: lottieStyles
	      });
	    }
	  }]);
	  return Lottie;
	}(_react2.default.Component);
	
	exports.default = Lottie;
	
	
	Lottie.propTypes = {
	  eventListeners: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  options: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  isStopped: _propTypes2.default.bool,
	  isPaused: _propTypes2.default.bool,
	  speed: _propTypes2.default.number,
	  direction: _propTypes2.default.number
	};
	
	Lottie.defaultProps = {
	  eventListeners: [],
	  isStopped: false,
	  isPaused: false,
	  speed: 1
	};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(38);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.props.disableOnClickOutside) return;
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
	        }
	      }
	
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = reactDom.findDOMNode(this.getInstance());
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(91);
	
	var _interopRequireDefault = __webpack_require__(39);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(122));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(90));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(89));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(648));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(91);
	
	var _interopRequireDefault = __webpack_require__(39);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(360));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(193));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(122));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(90));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(89));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(605));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(634));
	
	var _Manager = __webpack_require__(164);
	
	var _utils = __webpack_require__(281);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(91);
	
	var _interopRequireDefault = __webpack_require__(39);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(193));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(122));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(90));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(89));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(103));
	
	var _Manager = __webpack_require__(164);
	
	var _utils = __webpack_require__(281);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(39);
	
	var _interopRequireWildcard = __webpack_require__(91);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(644));
	
	var _Manager = _interopRequireDefault(__webpack_require__(164));
	
	var _Reference = _interopRequireDefault(__webpack_require__(645));

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(610);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(103);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(647);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 2480:
/***/ (function(module, exports, __webpack_require__) {

	
	var space = __webpack_require__(2482)
	
	/**
	 * Export.
	 */
	
	module.exports = toCamelCase
	
	/**
	 * Convert a `string` to camel case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toCamelCase(string) {
	  return space(string).replace(/\s(\w)/g, function (matches, letter) {
	    return letter.toUpperCase()
	  })
	}


/***/ }),

/***/ 2481:
/***/ (function(module, exports) {

	
	/**
	 * Export.
	 */
	
	module.exports = toNoCase
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/
	var hasSeparator = /(_|-|\.|:)/
	var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase(string) {
	  if (hasSpace.test(string)) return string.toLowerCase()
	  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
	  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
	  return string.toLowerCase()
	}
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate(string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : ''
	  })
	}
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize(string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
	  })
	}


/***/ }),

/***/ 2482:
/***/ (function(module, exports, __webpack_require__) {

	
	var clean = __webpack_require__(2481)
	
	/**
	 * Export.
	 */
	
	module.exports = toSpaceCase
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toSpaceCase(string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : ''
	  }).trim()
	}


/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    var _props = this.props,
	        width = _props.width,
	        height = _props.height,
	        fill = _props.fill;
	
	    return _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: width,
	        height: height,
	        viewBox: '0 0 67 60'
	      },
	      _react2.default.createElement(
	        'g',
	        { fill: fill, fillRule: 'evenodd' },
	        _react2.default.createElement('path', { d: 'M35.985 0c-.628 0-1.24.264-1.668.746-.295.333-2.778 3.412 1.097 9.173l4.734 6.947v.032l-.08.61c-.347.18-2.135 1.111-2.86 1.486a7.09 7.09 0 0 0-.364.1c-.063.018-.132.042-.205.06a10.217 10.217 0 0 0-.73-.023c-.089 0-.179 0-.268.002a9.54 9.54 0 0 0-1.654-1.863c.014-.04.026-.08.039-.122.054-.156.127-.376.171-.638a8.06 8.06 0 0 0 .186-.496c1.439-4.208-1.307-5.666-2.21-6.144-.08-.044-.159-.084-.231-.127-.646-.375-1.46-.453-2.028-.453-1.572 0-3.014.594-3.956 1.631-.639.703-1.35 1.935-1.253 3.896-.081.439-.167 1.063-.127 1.633a2.438 2.438 0 0 0-.484 1.015c-1 1.419-2.206 4.474-2.395 10.998-.004.147.006.295.032.44.283 1.614.791 3.405 1.704 4.628-.318 1.078-.485 2.56-.234 4.56-.125 1.85-.598 5.054-1.412 6.387l-.273.475c-.546.207-1.286.517-2.06.936-.595.226-1.726.91-3.77 3.367-.035.044-.071.09-.105.136-.532.277-1.047.665-1.504 1.01-.193.145-.377.286-.539.393-.735.494-1.178 1.252-1.217 2.08-.008.182.003.355.029.518-.11.295-.211.634-.28 1.004-.277 1.481.284 2.836 1.5 3.62.548.356 2.116 1.017 3.428 1.017 1.366 0 2.559-.799 3.134-1.59.286-.391.456-.827.507-1.266 2.489-1.676 5.173-3.42 5.733-3.678.234-.092.412-.207.602-.371 0 0 .32-.274.59-.51.654-.273.988-.553 1.198-.79.294-.312 2.405-2.551 2.552-2.704l-.016-.016c.138-.14.275-.306.408-.503l.286-.428a2.39 2.39 0 0 0 .39-1.047l1.902-2.53c1.979.749 4.87 1.823 6.242 2.25.103.71.254 1.635.453 2.538.06.272.172.532.329.763.276.418.647 1.28.574 1.714a9.549 9.549 0 0 0-.147 1.819 5.573 5.573 0 0 0-.819 1.626 2.63 2.63 0 0 0 .335 2.304c.906 1.31 2.594 1.418 3.825 1.497.12.008.225.013.306.022 1.307.426 3.232.505 4.468.505 1.064 0 1.723-.12 2.271-.412 1.248-.666 1.904-2.008 1.631-3.338a2.781 2.781 0 0 0-2.408-2.22c-.096-.03-.306-.12-.757-.386a3.238 3.238 0 0 0-.007-.383l.074-3.94.183-4.79a2.218 2.218 0 0 0-.065-.62c-.122-.48-.253-.902-.426-1.263.003-.157.01-.344.021-.507.066-.946-.233-2.034-.995-2.768l-1.554-3.515a2.216 2.216 0 0 0-.973-1.051 3.017 3.017 0 0 0-1.415-.34c-.618 0-1.614.182-2.576 1.14-2.112-1.58-4.311-3.145-5.775-3.972a21.286 21.286 0 0 1-.567-2.017l.219-.158c.44.128.986.198 1.582.198.177 0 .367-.007.57-.02.068 0 .14-.004.22-.012.07-.006.301-.035.416-.05 1.355-.16 2.302-.385 3.01-.723 1.434-.433 2.362-.825 2.403-.841a2.77 2.77 0 0 0 .288-.148c.195-.119.452-.259.609-.336 1.548-.32 3.478-2.331 4.105-3.47.76-1.381.757-2.847-.007-4.022a2.19 2.19 0 0 0-.233-.3l-.02-.098a3.138 3.138 0 0 0-1.57-2.08l-.055-.123-.035-.222c-.006-.038-.012-.076-.021-.114-.133-.633-.499-1.74-1.468-2.33l-.028-.024c-.238-.223-.678-.632-1.339-.802a551.802 551.802 0 0 0-2.952-4.922L40.14 4.238C37.796.57 37.425.323 36.604.087a2.235 2.235 0 0 0-.62-.087m-4.87 17.97c.006-.01.011-.02.018-.029-.004.004-.01.005-.016.01l-.007.016.005.003m4.87-15.766c.274.078 2.249 3.165 2.249 3.165l2.06 3.415.008.014c1.651 2.715 3.219 5.37 3.585 5.992l.155.003c.18 0 .34-.014.417-.059a.179.179 0 0 1 .089-.023c.226 0 .508.422.79.563.32.158.48.915.48.915l.08.514.32.71.24.474s-.004.069.213.11c.399.074.745.346.829.74.07.325-.004.577-.004.577l.563.556c1.12 1.72-2.313 4.136-2.63 4.136l-.01-.001a.332.332 0 0 0-.038-.003c-.299 0-1.321.621-1.321.621s-.917.388-2.357.813l-.016.006c-.42.24-1.165.437-2.449.587-.07.01-.294.037-.35.043H38.8a5.85 5.85 0 0 1-.488.022c-.453 0-.792-.058-1.03-.131l-.033-.01a1.823 1.823 0 0 1-.351-.146l-.005-.003a1.155 1.155 0 0 1-.11-.071l-.88.237-.291.21-.587.424a.392.392 0 0 0-.217-.07.416.416 0 0 0-.104.014c-.036.007-.074.04-.111.061-.048.035-.098.066-.136.113-.08.098-.16.224-.232.437a1.407 1.407 0 0 0-.042.508c.05 1.149.782 3.316 1.011 3.969l.035.098.035.1c1.36.396 8.157 5.617 8.157 5.617.072-.173.142-.332.214-.479.688-1.415 1.387-1.663 1.794-1.663.218 0 .352.073.352.073l1.793 4.059c.64.237.574 1.189.574 1.189s-.094 1.345.065 1.425c.16.08.4 1.031.4 1.031l-.184 4.834-.076 4.101c.045.137-.036.715-.123 1.23.062.055.713.624.989.788.287.171 1.211.758 1.846.817.637.059.751 1.03 0 1.43-.2.108-.654.15-1.216.15-1.53 0-3.85-.31-3.972-.437-.165-.171-3.183.057-2.841-1.03.343-1.087 1.038-1.545 1.038-1.545s-.265-.63 0-2.194c.264-1.565-.923-3.31-.923-3.31a38.36 38.36 0 0 1-.578-3.567c-.226-.442-.552-.525-.77-.525-.132 0-.223.032-.223.032-1.12-.256-8.074-2.914-8.074-2.914l-3.458 4.601-.03.054.083.071c.084.071.1.194.04.284l-.43.64c-.003 0-2.608 2.764-2.608 2.764-.116.144-.709.34-.709.34-.189.17-.88.767-.88.767-.973.381-7.034 4.503-7.034 4.503-.077-.008-.138-.022-.212-.03.002 0 .015.01.015.01s.043.62.139.906c.096.287-.674.974-1.425.974-.75 0-1.905-.458-2.216-.66-.31-.199-.67-.6-.526-1.373a4.331 4.331 0 0 1 .526-1.373s-.54-.44 0-.802c.542-.362 1.292-1.011 1.87-1.296.577-.287.751-.669.751-.669s2.108-2.537 2.94-2.737c1.36-.761 2.692-1.16 2.692-1.16l.655-1.14c1.454-2.377 1.743-7.606 1.743-7.606-.56-4.04.88-5.23.88-5.23a.765.765 0 0 1-.174.02c-1.467 0-2.218-4.277-2.218-4.277.254-8.797 2.391-10.243 2.391-10.243-.192-.508.142-.598.397-.598.111 0 .207.018.237.024-.11-.434-.1-.807-.098-.833-.003-.094.003-.16.004-.163l.052.01c-.004-.012-.005-.02-.01-.033a.904.904 0 0 1-.089-.3c-.066-.468.125-1.365.125-1.365s.006-.003.015-.003l.006.001c-.305-2.902 1.702-3.53 2.963-3.53.425 0 .766.071.903.152.916.529 2.392.933 1.46 3.66a4.317 4.317 0 0 1-.293.698l.002-.004h.005c.088 0-.085.477-.085.477a3.932 3.932 0 0 1-.333.814l.029.012c-.009.02-.027.03-.037.05l.042.014a3.411 3.411 0 0 1-.336.659l-.013.031c2.3 1.24 3.099 3.325 3.099 3.325s.468-.03.968-.038c.192-.005.393-.009.583-.009.273 0 .525.008.697.027h.048c.495 0 .978-.243 1.285-.26.248-.125 3.221-1.672 3.221-1.672l1.06-.512v-.714l.16-1.223c-.025-.39-.014-.69.01-.957a4.729 4.729 0 0 0-.022.165l-5.104-7.492c-3.037-4.517-1.278-6.493-1.278-6.493M.779 15.533h.72v-.155h-.72zM1.138 15.379v.155-.155zM65.702 15.533h.72v-.155h-.72zM66.062 15.379v.155-.155z' }),
	        _react2.default.createElement(
	          'g',
	          { opacity: '.561' },
	          _react2.default.createElement('path', { d: 'M47.294 25.879c10.433-1.448 17.412-4.395 17.412-7.376.049-3.004-6.93-5.968-17.412-7.42v14.796zm-1.406 2.057a1.06 1.06 0 0 1-.52-.245c-.234-.195-.368-.452-.368-.702V9.97c0-.248.134-.505.368-.704.284-.241.712-.267.883-.267C59.07 10.572 67 14.212 67 18.503c0 4.284-7.93 7.924-20.696 9.497l-.416-.064zM19.706 11.168C9.273 12.636 2.294 15.625 2.294 18.65c0 3.018 6.98 6.01 17.412 7.482V11.168zM0 18.65c0-4.347 7.93-8.038 20.696-9.636L20.863 9c.272 0 .568.108.77.283.233.202.367.461.367.713V27.26c0 .252-.134.512-.368.714-.162.19-4.097-.724-4.426-.724 0 0-17.206-4.18-17.206-8.6z' }),
	          _react2.default.createElement('path', { d: 'M2.27 41.639c0 4.01 12.825 8.383 31.23 8.383 18.406 0 31.23-4.372 31.23-8.296V22.712c-4.885 3.85-17.203 6.399-31.23 6.399-14.027 0-26.345-2.549-31.23-6.399v18.927zM33.5 52C14.716 52 0 47.509 0 41.771V18.97C0 18.444.52 18 1.136 18c.614 0 1.133.444 1.133.97 0 3.923 12.826 8.293 31.231 8.293 18.406 0 31.23-4.37 31.23-8.294 0-.525.52-.969 1.135-.969s1.135.444 1.135.97V41.77C67 47.51 52.285 52 33.5 52z' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { opacity: '.8' },
	          _react2.default.createElement('path', { d: 'M52.163 33.743c-.454.024-.876-.281-.959-.696-.092-.507.226-.983.703-1.068 3.872-.844 7.224-2.03 9.682-3.424a.865.865 0 0 1 .413-.127.941.941 0 0 1 .834.425c.267.408.134.963-.297 1.238-2.575 1.461-6.098 2.715-10.199 3.639l-.026.005-.15.008zM60.112 36.48a.924.924 0 0 1-.899-.564c-.2-.458.01-.966.494-1.175a15.223 15.223 0 0 0 2.138-1.09.887.887 0 0 1 .423-.133.94.94 0 0 1 .834.424c.267.409.135.965-.296 1.24-.727.428-1.53.808-2.292 1.156-.148.13-.31.138-.402.143m-4.762 1.703a.967.967 0 0 1-.95-.659.873.873 0 0 1 .07-.7.922.922 0 0 1 .545-.437 97.503 97.503 0 0 0 2.36-.744c.085-.026.167-.04.248-.044a.961.961 0 0 1 .933.573c.158.502-.07.99-.531 1.188l-.695.226c-.577.193-1.89.592-1.98.597m-3.408.755c-.227-.023-.375-.447-.456-.681a.961.961 0 0 1 .146-.757.85.85 0 0 1 .548-.348l.468-.11.111-.011a.916.916 0 0 1 .959.705c.23 1.056-1.068 1.274-1.776 1.202M52.704 44.049c-.457.024-.877-.282-.96-.695-.091-.507.226-.985.703-1.07 3.873-.845 7.225-2.03 9.682-3.425a.867.867 0 0 1 .412-.126.941.941 0 0 1 .835.425.845.845 0 0 1 .115.653.93.93 0 0 1-.413.585c-2.574 1.46-6.097 2.716-10.198 3.638l-.026.007-.15.008z' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { opacity: '.8' },
	          _react2.default.createElement('path', { d: 'M5.651 37.492a.916.916 0 0 1-.91-.898c0-4.058 3.35-7.36 7.465-7.36.494 0 .91.41.91.898a.915.915 0 0 1-.91.897c-3.112 0-5.644 2.496-5.644 5.565a.896.896 0 0 1-.91.898M17.724 40.967c-.215 0-.393-.078-.461-.112-.43-.242-.577-.824-.328-1.253a5.511 5.511 0 0 0 .915-3.009c0-.486.417-.896.91-.896.493 0 .91.41.91.896 0 1.421-.402 2.79-1.165 3.958-.159.262-.445.416-.781.416m-5.518 2.987a.916.916 0 0 1-.91-.898c0-.487.417-.898.91-.898.867 0 1.64-.166 2.366-.504.14-.052.26-.074.38-.074.342 0 .65.178.822.476.192.491.021.97-.396 1.206-.994.469-2.026.692-3.172.692' }),
	          _react2.default.createElement('path', { d: 'M12.206 43.953c-.472 0-.95-.042-1.42-.127-.503-.123-.79-.544-.733-1.047.118-.469.483-.749.94-.749l.126.008c.382.08.738.12 1.087.12.494 0 .91.41.91.899 0 .503-.4.896-.91.896' }),
	          _react2.default.createElement('path', { d: 'M12.206 43.669c-.456 0-.912-.04-1.369-.123-.332-.082-.54-.367-.498-.735.083-.327.374-.533.747-.491.373.082.747.122 1.12.122.332 0 .623.287.623.613 0 .327-.25.614-.623.614M8.597 42.85a.763.763 0 0 1-.536-.208 7.647 7.647 0 0 1-2.025-2.004.857.857 0 0 1-.154-.648.928.928 0 0 1 .391-.6.887.887 0 0 1 .518-.167.94.94 0 0 1 .754.396 5.99 5.99 0 0 0 1.588 1.566c.429.304.53.854.237 1.26-.227.28-.47.404-.773.404M5.776 38.718a.939.939 0 0 1-.9-.698 7.661 7.661 0 0 1-.135-1.426c0-.487.416-.898.91-.898.493 0 .91.41.91.898 0 .346.04.696.119 1.042.114.456-.21.95-.709 1.073l-.035.01h-.16z' }),
	          _react2.default.createElement('path', { d: 'M5.776 38.434a.66.66 0 0 1-.623-.49c-.082-.45-.124-.901-.124-1.35 0-.327.29-.613.622-.613s.622.286.622.613a5 5 0 0 0 .126 1.104c.082.328-.167.655-.499.736h-.124zM15.774 32.052a1.09 1.09 0 0 1-.459-.11 5.658 5.658 0 0 0-3.067-.914.915.915 0 0 1-.91-.896c0-.487.416-.898.91-.898 1.46 0 2.887.41 4.017 1.153a.84.84 0 0 1 .386.515.94.94 0 0 1-.088.72c-.24.304-.484.43-.79.43M18.76 37.492a.916.916 0 0 1-.91-.898c0-1.046-.322-2.11-.907-2.995a.932.932 0 0 1 .281-1.243.955.955 0 0 1 .486-.137c.309 0 .603.15.787.406a7.235 7.235 0 0 1 1.174 3.969c0 .503-.4.898-.91.898M14.363 39.617c-.267 0-.495-.084-.66-.246a.863.863 0 0 1 0-1.26c.395-.389.621-.927.621-1.477 0-.549-.226-1.086-.62-1.475a.886.886 0 0 1-.271-.63c0-.233.096-.458.27-.63a.905.905 0 0 1 .639-.269c.239 0 .465.095.64.268a3.828 3.828 0 0 1 1.162 2.736c0 1.054-.425 2.054-1.168 2.742a.917.917 0 0 1-.613.241M10.09 39.617c-.268 0-.495-.084-.66-.246a3.82 3.82 0 0 1-1.163-2.737c0-.579.14-1.16.404-1.68.182-.315.507-.509.836-.509a.8.8 0 0 1 .395.103c.23.128.401.346.47.591a.79.79 0 0 1-.073.614c-.141.28-.211.564-.211.881 0 .549.226 1.088.621 1.477.363.359.363.9 0 1.26-.178.124-.364.246-.62.246' }),
	          _react2.default.createElement('path', { d: 'M12.206 40.477A3.933 3.933 0 0 1 9.43 39.33a.884.884 0 0 1-.27-.63c0-.233.096-.457.27-.63a.911.911 0 0 1 .64-.267c.237 0 .464.095.639.267.41.406.915.611 1.497.611a2.15 2.15 0 0 0 1.497-.611.91.91 0 0 1 .64-.267c.237 0 .464.095.638.267a.862.862 0 0 1 0 1.26c-.703.738-1.69 1.147-2.775 1.147' })
	        )
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	SvgFile.defaultProps = {
	  width: 67,
	  height: 60,
	  fill: '#CAE9FF'
	};
	exports.default = SvgFile;
	module.exports = exports['default'];

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(913);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeAVrCricketStar = function (_Component) {
	  _inherits(BeAVrCricketStar, _Component);
	
	  function BeAVrCricketStar() {
	    _classCallCheck(this, BeAVrCricketStar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BeAVrCricketStar.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return BeAVrCricketStar;
	}(_react.Component);
	
	exports.default = BeAVrCricketStar;
	module.exports = exports['default'];

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    var _props = this.props,
	        width = _props.width,
	        height = _props.height,
	        fill = _props.fill;
	
	    return _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: width,
	        height: height,
	        viewBox: '0 0 42 60'
	      },
	      _react2.default.createElement('path', {
	        fill: fill,
	        fillRule: 'evenodd',
	        d: 'M23.985 0c-.628 0-1.24.264-1.668.746-.295.333-2.778 3.412 1.097 9.173l4.734 6.947v.032l-.08.61c-.347.18-2.135 1.111-2.86 1.486a7.09 7.09 0 0 0-.364.1c-.063.018-.132.042-.205.06a10.217 10.217 0 0 0-.73-.023c-.089 0-.179 0-.268.002a9.54 9.54 0 0 0-1.654-1.863c.014-.04.026-.08.039-.122.054-.156.127-.376.171-.638a8.06 8.06 0 0 0 .186-.496c1.439-4.208-1.307-5.666-2.21-6.144-.08-.044-.159-.084-.231-.127-.646-.375-1.46-.453-2.028-.453-1.572 0-3.014.594-3.956 1.631-.639.703-1.35 1.935-1.253 3.896-.081.439-.167 1.063-.127 1.633a2.438 2.438 0 0 0-.484 1.015c-1 1.419-2.206 4.474-2.395 10.998-.004.147.006.295.032.44.283 1.614.791 3.405 1.704 4.628-.318 1.078-.485 2.56-.234 4.56-.125 1.85-.598 5.054-1.412 6.387l-.273.475c-.546.207-1.286.517-2.06.936-.595.226-1.726.91-3.77 3.367-.035.044-.071.09-.105.136-.532.277-1.047.665-1.504 1.01-.193.145-.377.286-.539.393-.735.494-1.178 1.252-1.217 2.08-.008.182.003.355.029.518-.11.295-.211.634-.28 1.004-.277 1.481.284 2.836 1.5 3.62.548.356 2.116 1.017 3.428 1.017 1.366 0 2.559-.799 3.134-1.59.286-.391.456-.827.507-1.266 2.489-1.676 5.173-3.42 5.733-3.678.234-.092.412-.207.602-.371 0 0 .32-.274.59-.51.654-.273.988-.553 1.198-.79.294-.312 2.405-2.551 2.552-2.704l-.016-.016c.138-.14.275-.306.408-.503l.286-.428a2.39 2.39 0 0 0 .39-1.047l1.902-2.53c1.979.749 4.87 1.823 6.242 2.25.103.71.254 1.635.453 2.538.06.272.172.532.329.763.276.418.647 1.28.574 1.714a9.549 9.549 0 0 0-.147 1.819 5.573 5.573 0 0 0-.819 1.626 2.63 2.63 0 0 0 .335 2.304c.906 1.31 2.594 1.418 3.825 1.497.12.008.225.013.306.022 1.307.426 3.232.505 4.468.505 1.064 0 1.723-.12 2.271-.412 1.248-.666 1.904-2.008 1.631-3.338a2.781 2.781 0 0 0-2.408-2.22c-.096-.03-.306-.12-.757-.386a3.238 3.238 0 0 0-.007-.383l.074-3.94.183-4.79a2.218 2.218 0 0 0-.065-.62c-.122-.48-.253-.902-.426-1.263.003-.157.01-.344.021-.507.066-.946-.233-2.034-.995-2.768l-1.554-3.515a2.216 2.216 0 0 0-.973-1.051 3.017 3.017 0 0 0-1.415-.34c-.618 0-1.614.182-2.576 1.14-2.112-1.58-4.311-3.145-5.775-3.972a21.286 21.286 0 0 1-.567-2.017l.219-.158c.44.128.986.198 1.582.198.177 0 .367-.007.57-.02.068 0 .14-.004.22-.012.07-.006.301-.035.416-.05 1.355-.16 2.302-.385 3.01-.723 1.434-.433 2.362-.825 2.403-.841a2.77 2.77 0 0 0 .288-.148c.195-.119.452-.259.609-.336 1.548-.32 3.478-2.331 4.105-3.47.76-1.381.757-2.847-.007-4.022a2.19 2.19 0 0 0-.233-.3l-.02-.098a3.138 3.138 0 0 0-1.57-2.08l-.055-.123-.035-.222c-.006-.038-.012-.076-.021-.114-.133-.633-.499-1.74-1.468-2.33l-.028-.024c-.238-.223-.678-.632-1.339-.802a551.802 551.802 0 0 0-2.952-4.922L28.14 4.238C25.796.57 25.425.323 24.604.087a2.235 2.235 0 0 0-.62-.087m-4.87 17.97c.006-.01.011-.02.018-.029-.004.004-.01.005-.016.01l-.007.016.005.003m4.87-15.766c.274.078 2.249 3.165 2.249 3.165l2.06 3.415.008.014c1.651 2.715 3.219 5.37 3.585 5.992l.155.003c.18 0 .34-.014.417-.059a.179.179 0 0 1 .089-.023c.226 0 .508.422.79.563.32.158.48.915.48.915l.08.514.32.71.24.474s-.004.069.213.11c.399.074.745.346.829.74.07.325-.004.577-.004.577l.563.556c1.12 1.72-2.313 4.136-2.63 4.136l-.01-.001a.332.332 0 0 0-.038-.003c-.299 0-1.321.621-1.321.621s-.917.388-2.357.813l-.016.006c-.42.24-1.165.437-2.449.587-.07.01-.294.037-.35.043H26.8a5.85 5.85 0 0 1-.488.022c-.453 0-.792-.058-1.03-.131l-.033-.01a1.823 1.823 0 0 1-.351-.146l-.005-.003a1.155 1.155 0 0 1-.11-.071l-.88.237-.291.21-.587.424a.392.392 0 0 0-.217-.07.416.416 0 0 0-.104.014c-.036.007-.074.04-.111.061-.048.035-.098.066-.136.113-.08.098-.16.224-.232.437a1.407 1.407 0 0 0-.042.508c.05 1.149.782 3.316 1.011 3.969l.035.098.035.1c1.36.396 8.157 5.617 8.157 5.617.072-.173.142-.332.214-.479.688-1.415 1.387-1.663 1.794-1.663.218 0 .352.073.352.073l1.793 4.059c.64.237.574 1.189.574 1.189s-.094 1.345.065 1.425c.16.08.4 1.031.4 1.031l-.184 4.834-.076 4.101c.045.137-.036.715-.123 1.23.062.055.713.624.989.788.287.171 1.211.758 1.846.817.637.059.751 1.03 0 1.43-.2.108-.654.15-1.216.15-1.53 0-3.85-.31-3.972-.437-.165-.171-3.183.057-2.841-1.03.343-1.087 1.038-1.545 1.038-1.545s-.265-.63 0-2.194c.264-1.565-.923-3.31-.923-3.31a38.36 38.36 0 0 1-.578-3.567c-.226-.442-.552-.525-.77-.525-.132 0-.223.032-.223.032-1.12-.256-8.074-2.914-8.074-2.914l-3.458 4.601-.03.054.083.071c.084.071.1.194.04.284l-.43.64c-.003 0-2.608 2.764-2.608 2.764-.116.144-.709.34-.709.34-.189.17-.88.767-.88.767-.973.381-7.034 4.503-7.034 4.503-.077-.008-.138-.022-.212-.03.002 0 .015.01.015.01s.043.62.139.906c.096.287-.674.974-1.425.974-.75 0-1.905-.458-2.216-.66-.31-.199-.67-.6-.526-1.373a4.331 4.331 0 0 1 .526-1.373s-.54-.44 0-.802c.542-.362 1.292-1.011 1.87-1.296.577-.287.751-.669.751-.669s2.108-2.537 2.94-2.737c1.36-.761 2.692-1.16 2.692-1.16l.655-1.14c1.454-2.377 1.743-7.606 1.743-7.606-.56-4.04.88-5.23.88-5.23a.765.765 0 0 1-.174.02c-1.467 0-2.218-4.277-2.218-4.277.254-8.797 2.391-10.243 2.391-10.243-.192-.508.142-.598.397-.598.111 0 .207.018.237.024-.11-.434-.1-.807-.098-.833-.003-.094.003-.16.004-.163l.052.01c-.004-.012-.005-.02-.01-.033a.904.904 0 0 1-.089-.3c-.066-.468.125-1.365.125-1.365s.006-.003.015-.003l.006.001c-.305-2.902 1.702-3.53 2.963-3.53.425 0 .766.071.903.152.916.529 2.392.933 1.46 3.66a4.317 4.317 0 0 1-.293.698l.002-.004h.005c.088 0-.085.477-.085.477a3.932 3.932 0 0 1-.333.814l.029.012c-.009.02-.027.03-.037.05l.042.014a3.411 3.411 0 0 1-.336.659l-.013.031c2.3 1.24 3.099 3.325 3.099 3.325s.468-.03.968-.038c.192-.005.393-.009.583-.009.273 0 .525.008.697.027h.048c.495 0 .978-.243 1.285-.26.248-.125 3.221-1.672 3.221-1.672l1.06-.512v-.714l.16-1.223c-.025-.39-.014-.69.01-.957a4.729 4.729 0 0 0-.022.165l-5.104-7.492c-3.037-4.517-1.278-6.493-1.278-6.493'
	      })
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	SvgFile.defaultProps = {
	  width: 42,
	  height: 60,
	  fill: '#CAE9FF'
	};
	exports.default = SvgFile;
	module.exports = exports['default'];

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(915);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BringOutCricketerInYou = function (_Component) {
	  _inherits(BringOutCricketerInYou, _Component);
	
	  function BringOutCricketerInYou() {
	    _classCallCheck(this, BringOutCricketerInYou);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BringOutCricketerInYou.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return BringOutCricketerInYou;
	}(_react.Component);
	
	exports.default = BringOutCricketerInYou;
	module.exports = exports['default'];

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "14",
	        height: "15",
	        viewBox: "0 0 14 15"
	      },
	      _react2.default.createElement(
	        "g",
	        {
	          fill: "none",
	          fillRule: "evenodd",
	          stroke: "#FFF",
	          strokeLinecap: "round",
	          strokeLinejoin: "round",
	          transform: "translate(1 1)"
	        },
	        _react2.default.createElement("rect", { width: "12", height: "11.7", y: "1.3", rx: "1.333" }),
	        _react2.default.createElement("path", { d: "M8.667 0v2.6M3.333 0v2.6M0 5.2h12" })
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	exports.default = SvgFile;
	module.exports = exports["default"];

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(364);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar() {
	    _classCallCheck(this, Calendar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Calendar.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return Calendar;
	}(_react.Component);
	
	exports.default = Calendar;
	module.exports = exports['default'];

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    var _props = this.props,
	        width = _props.width,
	        height = _props.height,
	        fill = _props.fill;
	
	    return _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: width,
	        height: height,
	        viewBox: '0 0 48 48'
	      },
	      _react2.default.createElement(
	        'g',
	        { fill: fill, fillRule: 'evenodd' },
	        _react2.default.createElement('path', { d: 'M17.999 18.034a.94.94 0 0 0 0 1.326.933.933 0 0 0 1.323 0 .938.938 0 0 0 0-1.326.935.935 0 0 0-1.323 0z' }),
	        _react2.default.createElement('path', { d: 'M33.796 29.885l.942-2.2a.939.939 0 0 0-.181-1.015l-2.314-2.444 14.824-14.104a2.81 2.81 0 0 0 .785-2.557 9.537 9.537 0 0 0-7.495-7.51 2.798 2.798 0 0 0-2.552.787L23.946 15.464 10.102.842l-.017-.018A2.798 2.798 0 0 0 7.55.055a9.516 9.516 0 0 0-4.882 2.618A9.547 9.547 0 0 0 .055 7.565a2.819 2.819 0 0 0 .785 2.557l14.829 14.095-2.32 2.454a.939.939 0 0 0-.18 1.014l.94 2.2L.823 43.199A2.796 2.796 0 0 0 0 45.188c0 .751.292 1.457.822 1.988.53.532 1.235.824 1.985.824s1.455-.292 1.985-.824L18.08 33.863l2.196.943a.931.931 0 0 0 1.012-.18l2.667-2.532 2.663 2.53a.935.935 0 0 0 1.012.182l2.196-.943 13.289 13.313c.53.532 1.235.824 1.984.824.75 0 1.455-.292 1.985-.824.53-.53.822-1.237.822-1.988 0-.751-.292-1.458-.822-1.989L33.796 29.885zm-2.12 3.18c.111-.053.218-.113.32-.18a.93.93 0 0 0 .825-.826 2.8 2.8 0 0 0 .18-.32l9.982 10.003-1.323 1.325-9.984-10.002zm7.476-30.922a.932.932 0 0 1 .838-.25 7.67 7.67 0 0 1 6.027 6.04.936.936 0 0 1-.249.839L30.955 22.866l-5.719-6.04L39.152 2.143zM17.026 25.507l2.104 2-2.8 2.806-1.2-2.8 1.896-2.006zm-10.78 17.56l-1.322-1.325 9.982-10.003a2.8 2.8 0 0 0 .18.32.934.934 0 0 0 .824.826c.102.067.21.127.32.18L6.247 43.067zm-2.778 2.784a.929.929 0 0 1-.661.274.928.928 0 0 1-.661-.275.932.932 0 0 1-.274-.662c0-.25.097-.486.274-.663L3.6 43.067l1.323 1.326-1.455 1.458zm16.98-13.011l-2.795-1.201 2.835-2.841 2.107 2.003-2.147 2.039zm7.011 0L17.635 23.5 2.138 8.771a.932.932 0 0 1-.248-.838A7.677 7.677 0 0 1 3.99 3.999a7.652 7.652 0 0 1 3.926-2.105.933.933 0 0 1 .837.249l24.021 25.37-1.198 2.8-9.608-9.627a.935.935 0 0 0-1.324 0 .939.939 0 0 0 0 1.326l9.609 9.627-2.795 1.2zm18.302 13.01a.929.929 0 0 1-.662.275.928.928 0 0 1-.66-.275l-1.456-1.457 1.323-1.326 1.455 1.458a.932.932 0 0 1 .274.663c0 .25-.098.485-.274.663z' }),
	        _react2.default.createElement('path', { d: 'M23.953 36.188c-3.095 0-5.614 2.523-5.614 5.625 0 3.101 2.519 5.625 5.614 5.625 3.096 0 5.614-2.524 5.614-5.625 0-3.102-2.518-5.625-5.614-5.625zm0 9.375a3.75 3.75 0 0 1 0-7.5 3.75 3.75 0 0 1 0 7.5z' })
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	SvgFile.defaultProps = {
	  width: 48,
	  height: 48,
	  fill: '#CAE9FF'
	};
	exports.default = SvgFile;
	module.exports = exports['default'];

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(917);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompeteWithYourFriends = function (_Component) {
	  _inherits(CompeteWithYourFriends, _Component);
	
	  function CompeteWithYourFriends() {
	    _classCallCheck(this, CompeteWithYourFriends);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CompeteWithYourFriends.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return CompeteWithYourFriends;
	}(_react.Component);
	
	exports.default = CompeteWithYourFriends;
	module.exports = exports['default'];

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "17",
	        height: "14",
	        viewBox: "0 0 17 14"
	      },
	      _react2.default.createElement(
	        "g",
	        {
	          fill: "none",
	          fillRule: "evenodd",
	          stroke: "#FFF",
	          strokeLinecap: "round",
	          strokeLinejoin: "round",
	          transform: "translate(1 1)"
	        },
	        _react2.default.createElement("path", {
	          strokeWidth: "1.333",
	          d: "M10.91 12v-1.333C10.91 9.194 9.687 8 8.181 8H2.727C1.221 8 0 9.194 0 10.667V12"
	        }),
	        _react2.default.createElement("ellipse", { cx: "5.455", cy: "2.667", rx: "2.727", ry: "2.667" }),
	        _react2.default.createElement("path", {
	          strokeWidth: "1.333",
	          d: "M15 12v-1.333c0-1.216-.842-2.277-2.045-2.58M10.227.087c1.207.302 2.051 1.365 2.051 2.583 0 1.218-.844 2.281-2.05 2.583"
	        })
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	exports.default = SvgFile;
	module.exports = exports["default"];

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(366);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactMembers = function (_Component) {
	  _inherits(ContactMembers, _Component);
	
	  function ContactMembers() {
	    _classCallCheck(this, ContactMembers);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ContactMembers.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return ContactMembers;
	}(_react.Component);
	
	exports.default = ContactMembers;
	module.exports = exports['default'];

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "13",
	        height: "13",
	        viewBox: "0 0 13 13"
	      },
	      _react2.default.createElement(
	        "g",
	        {
	          fill: "none",
	          fillRule: "evenodd",
	          stroke: "#FFF",
	          strokeLinecap: "round",
	          strokeLinejoin: "round",
	          transform: "translate(1 1)"
	        },
	        _react2.default.createElement("path", { d: "M11 12v-1.333C11 9.194 9.769 8 8.25 8h-5.5C1.231 8 0 9.194 0 10.667V12" }),
	        _react2.default.createElement("ellipse", { cx: "5.5", cy: "2.667", rx: "2.75", ry: "2.667" })
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	exports.default = SvgFile;
	module.exports = exports["default"];

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(368);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPersonIcon = function (_Component) {
	  _inherits(ContactPersonIcon, _Component);
	
	  function ContactPersonIcon() {
	    _classCallCheck(this, ContactPersonIcon);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ContactPersonIcon.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return ContactPersonIcon;
	}(_react.Component);
	
	exports.default = ContactPersonIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    var _props = this.props,
	        width = _props.width,
	        height = _props.height,
	        fill = _props.fill;
	
	    return _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: width,
	        height: height,
	        viewBox: '0 0 62 50'
	      },
	      _react2.default.createElement(
	        'g',
	        { fill: fill, fillRule: 'nonzero' },
	        _react2.default.createElement('path', { d: 'M31 38.095c-.668 0-1.21.534-1.21 1.19 0 .658.542 1.191 1.21 1.191.668 0 1.21-.533 1.21-1.19 0-.657-.542-1.19-1.21-1.19z' }),
	        _react2.default.createElement('path', { d: 'M54.371 14.602V9.524h1.211c1.617 0 3.137-.62 4.28-1.744a5.864 5.864 0 0 0 1.775-4.209 1.2 1.2 0 0 0-1.211-1.19H53.16a1.2 1.2 0 0 0-1.21 1.19v10.402c-3.582-.833-7.903-1.444-12.64-1.78a117.583 117.583 0 0 0-7.1-.28v-4.77h1.212c1.616 0 3.137-.62 4.28-1.744a5.864 5.864 0 0 0 1.775-4.209A1.2 1.2 0 0 0 38.266 0H31a1.2 1.2 0 0 0-1.21 1.19v10.722c-2.396.024-4.781.118-7.1.282-4.737.335-9.058.946-12.64 1.779v-4.45h1.212c1.616 0 3.137-.618 4.28-1.743a5.864 5.864 0 0 0 1.774-4.209 1.2 1.2 0 0 0-1.21-1.19H8.84a1.2 1.2 0 0 0-1.211 1.19v11.032C2.567 16.08 0 17.976 0 20.237v21.429c0 1.81 1.647 3.392 4.897 4.702 5.221 2.104 13.083 3.055 18.761 3.406 2.404.15 4.874.225 7.342.225s4.938-.076 7.342-.225c5.613-.347 13.521-1.294 18.761-3.406 3.25-1.31 4.897-2.892 4.897-4.702V20.238c0-2.262-2.566-4.157-7.629-5.636zm0-9.84h4.638a3.555 3.555 0 0 1-.859 1.334 3.64 3.64 0 0 1-2.568 1.047h-1.21V4.762zM32.211 2.38h4.638a3.555 3.555 0 0 1-.859 1.334 3.64 3.64 0 0 1-2.568 1.047H32.21V2.38zm-22.16 2.38h4.637a3.555 3.555 0 0 1-.858 1.335 3.64 3.64 0 0 1-2.568 1.047H10.05V4.762zm29.844 9.865c3.988.31 7.641.82 10.747 1.495l-5.373 3.773c-2.498-.339-5.38-.584-8.459-.72l3.085-4.548zM31 14.286c2.052 0 4.098.053 6.107.158l-3.144 4.637a135.42 135.42 0 0 0-5.926 0l-3.144-4.637c2.01-.105 4.055-.158 6.107-.158zm-8.895.34l3.085 4.548c-3.079.136-5.962.381-8.46.72l-5.372-3.773c3.106-.675 6.76-1.185 10.747-1.495zM8.29 16.893l5.075 3.563c-1.125.233-2.084.487-2.864.761-1.074.377-2.494 1.008-2.78 2.196-4.104-1.28-5.3-2.573-5.3-3.175 0-.618 1.256-1.994 5.87-3.345zm6.605 29.55c-9.057-1.437-12.473-3.66-12.473-4.776v-3.704c.69.44 1.526.858 2.508 1.251 2.494 1 5.925 1.85 9.965 2.48v4.75zm0-7.161c-3.692-.593-6.802-1.372-9.052-2.273-2.525-1.01-3.421-1.97-3.421-2.485V30.84c.682.437 1.507.852 2.475 1.242 2.493 1.005 5.935 1.858 9.998 2.484v4.715zm0-7.124C5.838 30.72 2.422 28.498 2.422 27.38v-3.674c1.791 1.147 4.572 2.135 8.33 2.957 1.292.281 2.683.536 4.143.76v4.734zm7.628 15.153a97.03 97.03 0 0 1-5.207-.521v-4.756c1.67.212 3.412.385 5.207.518v4.759zm.136-7.137a96.879 96.879 0 0 1-5.343-.54v-4.73c2.508.313 5.17.539 7.903.671-.041.038-.084.075-.125.114a8.244 8.244 0 0 0-2.435 4.485zm-5.343-7.67V27.76c3.892.485 8.154.76 12.473.804v4.761c-4.333-.044-8.6-.325-12.473-.822zm19.739 14.959c-1.597.082-3.218.132-4.844.148v-3.563A1.2 1.2 0 0 0 31 42.858a1.2 1.2 0 0 0-1.21 1.19v3.563a116.752 116.752 0 0 1-4.845-.148v-5.796c0-.063.001-.125.003-.188.102-3.233 2.76-5.765 6.052-5.765 1.617 0 3.138.62 4.281 1.743a5.884 5.884 0 0 1 1.774 4.21v5.796zm7.629-.673c-1.667.214-3.41.388-5.207.52v-4.758c1.795-.133 3.537-.307 5.207-.518v4.756zm0-7.157a96.635 96.635 0 0 1-5.344.54 8.258 8.258 0 0 0-2.346-4.4c-.07-.068-.14-.133-.212-.198 2.733-.132 5.394-.358 7.902-.671v4.73zm0-7.13c-3.872.498-8.14.779-12.473.823v-4.761c4.321-.044 8.583-.319 12.473-.804v4.743zM31 26.19c-5.132 0-10.22-.334-14.715-.967a69.739 69.739 0 0 1-4.61-.8 1.22 1.22 0 0 0-.223-.108 7.14 7.14 0 0 1-1.051-.465c3.213-1.72 13.332-2.274 17.033-2.373 2.338-.064 4.793-.064 7.133 0 4.025.108 7.785.4 10.875.846 3.894.56 5.513 1.186 6.151 1.528-.273.155-.733.369-1.491.62a69.303 69.303 0 0 1-4.383.75c-4.492.634-9.582.97-14.719.97zm28.578 15.477c0 1.117-3.416 3.34-12.473 4.776v-4.75c4.04-.628 7.471-1.48 9.965-2.479.982-.393 1.818-.81 2.508-1.251v3.704zm0-7.143c0 .514-.896 1.474-3.421 2.485-2.25.901-5.36 1.68-9.052 2.273v-4.715c4.063-.626 7.505-1.479 9.998-2.484.968-.39 1.793-.805 2.475-1.242v3.683zm0-7.143c0 1.117-3.416 3.34-12.473 4.776v-4.732c3.716-.571 9.339-1.709 12.473-3.715v3.671zm-5.306-3.964c-.289-1.205-1.746-1.843-2.852-2.225-.767-.264-1.699-.51-2.786-.735l5.076-3.564c4.613 1.351 5.868 2.727 5.868 3.345 0 .613-1.207 1.904-5.306 3.179z' })
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	SvgFile.defaultProps = {
	  width: 62,
	  height: 50,
	  fill: '#CAE9FF'
	};
	exports.default = SvgFile;
	module.exports = exports['default'];

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(972);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayInStadium = function (_Component) {
	  _inherits(PlayInStadium, _Component);
	
	  function PlayInStadium() {
	    _classCallCheck(this, PlayInStadium);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PlayInStadium.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return PlayInStadium;
	}(_react.Component);
	
	exports.default = PlayInStadium;
	module.exports = exports['default'];

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "12",
	        height: "16",
	        viewBox: "0 0 12 16"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "evenodd", transform: "translate(1 1)" },
	        _react2.default.createElement("rect", {
	          width: "10",
	          height: "14",
	          stroke: "#FFF",
	          strokeLinecap: "round",
	          strokeLinejoin: "round",
	          rx: "1.412"
	        }),
	        _react2.default.createElement("circle", { cx: "5", cy: "11", r: "1", fill: "#FFF" })
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	exports.default = SvgFile;
	module.exports = exports["default"];

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(370);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SmartPhone = function (_Component) {
	  _inherits(SmartPhone, _Component);
	
	  function SmartPhone() {
	    _classCallCheck(this, SmartPhone);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SmartPhone.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return SmartPhone;
	}(_react.Component);
	
	exports.default = SmartPhone;
	module.exports = exports['default'];

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "50",
	        height: "50",
	        viewBox: "0 0 50 50"
	      },
	      _react2.default.createElement(
	        "g",
	        { fill: "none", fillRule: "nonzero" },
	        _react2.default.createElement("path", {
	          fill: "#FF8B0C",
	          fillOpacity: ".254",
	          d: "M50 25c0 6.677-2.6 12.956-7.323 17.678C37.955 47.4 31.677 50 25 50c-6.678 0-12.955-2.6-17.677-7.322C2.6 37.956 0 31.678 0 25c0-6.678 2.6-12.956 7.323-17.678C12.045 2.6 18.323 0 25 0c6.678 0 12.955 2.6 17.677 7.322C47.4 12.044 50 18.322 50 25z"
	        }),
	        _react2.default.createElement("path", {
	          fill: "#FF8B0C",
	          d: "M44 25c0 10.477-8.524 19-19 19S6 35.477 6 25C6 14.524 14.524 6 25 6s19 8.524 19 19z"
	        }),
	        _react2.default.createElement("path", {
	          fill: "#FFF",
	          d: "M32.601 21.31l-7.1 7.043-1.276 1.265c-.015.015-.031.028-.047.042-.016.014-.03.03-.047.043l-.055.04c-.018.013-.034.027-.052.038-.018.013-.039.024-.058.035-.018.011-.035.023-.054.033-.02.01-.041.02-.061.028-.019.01-.036.018-.055.025-.022.01-.044.016-.067.025-.017.006-.035.013-.053.018-.024.008-.049.013-.073.018-.017.004-.033.01-.049.012-.029.006-.057.009-.086.012l-.039.007a1.232 1.232 0 0 1-.253 0l-.04-.007c-.029-.003-.058-.007-.087-.013l-.048-.012c-.025-.006-.052-.011-.076-.018l-.052-.02a1.027 1.027 0 0 1-.124-.051c-.021-.01-.043-.019-.064-.03l-.054-.033c-.02-.012-.04-.022-.06-.036l-.052-.04-.054-.04-.05-.046c-.015-.015-.03-.027-.045-.043l-3.983-4.06a1.363 1.363 0 0 1 0-1.902 1.302 1.302 0 0 1 1.867 0l3.062 3.12 2.184-2.166 5.259-5.216a1.303 1.303 0 0 1 1.867.026 1.364 1.364 0 0 1-.025 1.902z"
	        })
	      )
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	exports.default = SvgFile;
	module.exports = exports["default"];

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(372);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessLogo = function (_Component) {
	  _inherits(SuccessLogo, _Component);
	
	  function SuccessLogo() {
	    _classCallCheck(this, SuccessLogo);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SuccessLogo.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return SuccessLogo;
	}(_react.Component);
	
	exports.default = SuccessLogo;
	module.exports = exports['default'];

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatepicker = __webpack_require__(639);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _dateFns = __webpack_require__(117);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _DateConstants = __webpack_require__(221);
	
	var _Icons = __webpack_require__(35);
	
	var _styles = __webpack_require__(376);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _styledComponents = __webpack_require__(375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Pavan
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CalendarWrapperContainer = function CalendarWrapperContainer(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _styledComponents.CalendarContainer,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: className },
	      _react2.default.createElement(
	        'div',
	        { style: { position: 'relative' } },
	        children
	      )
	    )
	  );
	};
	
	var DateFieldCustomInput = function DateFieldCustomInput(props) {
	  return _react2.default.createElement(
	    _styledComponents.TextInputContainer,
	    { onClick: props.onClick },
	    _react2.default.createElement(CalendarIcon, {
	      strokeColor: props.calendarIconColor ? props.calendarIconColor : props.dateFieldFocused ? _Colors2.default.twilightBlueTwo : _Colors2.default.blueyGreyThree
	    }),
	    _react2.default.createElement(_styledComponents.StyledCustomInput, {
	      isMobile: props.isMobile,
	      value: props.value,
	      placeholder: props.placeholderText,
	      style: props.dateFieldFocused ? _styles2.default.focusedStyles : props.displayError ? _styles2.default.errorStyles : _styles2.default.defaultStyles,
	      onFocus: props.setDateFieldFocused,
	      onBlur: props.setDateFieldFocused,
	      className: props.inputClassName,
	      displayErrorBorder: props.displayErrorBorder,
	      height: props.height,
	      readOnly: true
	    }),
	    _react2.default.createElement(ChevronDownIcon, {
	      strokeColor: props.calendarIconColor ? props.calendarIconColor : _Colors2.default.blueyGreyThree,
	      strokeWidth: props.arrowStrokeWidth ? props.arrowStrokeWidth : '1.5',
	      rightMargin: props.arrowRightMargin
	    })
	  );
	};
	
	var ChevronDownIcon = function ChevronDownIcon(props) {
	  return _react2.default.createElement(
	    _styledComponents.AbsoluteIconContainer,
	    { rightMargin: props.rightMargin },
	    _react2.default.createElement(_Icons.IcChevronDown, props)
	  );
	};
	var CalendarIcon = function CalendarIcon(props) {
	  return _react2.default.createElement(
	    _styledComponents.AbsoluteLeftIconContainer,
	    null,
	    _react2.default.createElement(_Icons.IcCalendar, { strokeColor: props.strokeColor })
	  );
	};
	
	var BaseDateField = function (_Component) {
	  _inherits(BaseDateField, _Component);
	
	  function BaseDateField() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BaseDateField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      errorMsg: '',
	      displayError: false,
	      dateValue: '',
	      dateFieldFocused: false
	    }, _this.updatedDate = '', _this.reset = function () {
	      _this.setState({
	        errorMsg: '',
	        displayError: false,
	        dateValue: '',
	        dateFieldFocused: false
	      });
	    }, _this.setDateFieldFocused = function () {
	      _this.setState({ dateFieldFocused: !_this.state.dateFieldFocused });
	    }, _this.captureDateFieldRef = function (ref) {
	      _this.dateFieldInstance = ref;
	    }, _this.setError = function (error) {
	      _this.setState({ errorMsg: error });
	    }, _this.setDisplayError = function (displayError) {
	      _this.setState({ displayError: displayError });
	    }, _this.validate = function (response) {
	      if (response.displayError) {
	        _this.setError(response.errorMsg);
	      }
	      _this.setDisplayError(response.displayError);
	    }, _this.setBaseDateRef = function (ref) {
	      if (ref) {
	        var _captureBaseRef = _this.props.captureBaseRef;
	
	        _this.dateField = ref;
	        if (_captureBaseRef) {
	          _captureBaseRef(ref);
	        }
	      }
	    }, _this.validateDateInput = function (value) {
	      var _this$props = _this.props,
	          validationEnabled = _this$props.validationEnabled,
	          validate = _this$props.validate;
	
	      var validateResponse = { displayError: false, errorMsg: '' };
	      if (validationEnabled) {
	        if (validate) {
	          validateResponse = validate(value);
	          _this.validate(validateResponse);
	        }
	      }
	      return validateResponse;
	    }, _this.onChangeInnerDate = function (value) {
	      var _this$props2 = _this.props,
	          onChangeDate = _this$props2.onChangeDate,
	          showTimeSelect = _this$props2.showTimeSelect,
	          minTime = _this$props2.minTime;
	
	      if (showTimeSelect) {
	        // Note: Logic to make time selection mandatory
	        if (minTime) {
	          if (_this.state.dateValue === '') {
	            if (value.get('hour') < minTime.get('hour')) {
	              _this.updatedDate = value;
	              _this.setState({ dateValue: '', dateFieldFocused: false });
	            } else {
	              _this.updatedDate = _this.updatedDate.set('hour', value.get('hour'));
	              _this.setState({
	                dateValue: _this.updatedDate,
	                dateFieldFocused: false
	              });
	            }
	          } else {
	            _this.updatedDate = value;
	            _this.setState({
	              dateValue: _this.updatedDate,
	              dateFieldFocused: false
	            });
	          }
	        }
	      } else {
	        _this.setState({ dateValue: value, dateFieldFocused: false });
	      }
	
	      onChangeDate(value);
	      _this.validateDateInput(value);
	    }, _this.renderDateContent = function () {
	      var _this$state = _this.state,
	          dateFieldFocused = _this$state.dateFieldFocused,
	          displayError = _this$state.displayError;
	
	      var _this$props3 = _this.props,
	          onChangeDate = _this$props3.onChangeDate,
	          dateLabel = _this$props3.dateLabel,
	          placeholderText = _this$props3.placeholderText,
	          isMobile = _this$props3.isMobile,
	          excludeDates = _this$props3.excludeDates,
	          inputClassName = _this$props3.inputClassName,
	          calendarIconColor = _this$props3.calendarIconColor,
	          validationEnabled = _this$props3.validationEnabled,
	          dateFormat = _this$props3.dateFormat,
	          minTime = _this$props3.minTime,
	          maxTime = _this$props3.maxTime,
	          showTimeSelect = _this$props3.showTimeSelect,
	          id = _this$props3.id,
	          otherProps = _objectWithoutProperties(_this$props3, ['onChangeDate', 'dateLabel', 'placeholderText', 'isMobile', 'excludeDates', 'inputClassName', 'calendarIconColor', 'validationEnabled', 'dateFormat', 'minTime', 'maxTime', 'showTimeSelect', 'id']);
	
	      return _react2.default.createElement(_reactDatepicker2.default, _extends({
	        ref: _this.setBaseDateRef,
	        customInput: _react2.default.createElement(DateFieldCustomInput, _extends({
	          isMobile: isMobile,
	          id: id,
	          displayError: _this.state.displayError,
	          placeholderText: placeholderText,
	          key: _this.state.displayError + 'placeholderText',
	          setDateFieldFocused: _this.setDateFieldFocused,
	          dateFieldFocused: dateFieldFocused,
	          inputClassName: inputClassName,
	          calendarIconColor: calendarIconColor,
	          displayErrorBorder: validationEnabled && displayError
	        }, otherProps)),
	        selected: _this.state.dateValue,
	        openToDate: _this.updatedDate,
	        onChange: _this.onChangeInnerDate,
	        key: dateLabel,
	        dateFormat: dateFormat,
	        calendarContainer: CalendarWrapperContainer,
	        showTimeSelect: showTimeSelect,
	        minTime: minTime,
	        maxTime: maxTime
	      }, otherProps, {
	        excludeDates: excludeDates,
	        dayClassName: function dayClassName() {
	          return excludeDates.filter(function (dateValue) {
	            return (0, _dateFns.isToday)(dateValue);
	          }).length > 0 ? 'disableToday' : undefined;
	        }
	      }));
	    }, _this.renderErrorTextContent = function () {
	      var _this$props4 = _this.props,
	          validationEnabled = _this$props4.validationEnabled,
	          id = _this$props4.id;
	      var _this$state2 = _this.state,
	          displayError = _this$state2.displayError,
	          errorMsg = _this$state2.errorMsg;
	
	      if (!displayError || !validationEnabled) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _styledComponents.ErrorText,
	        { id: id + '-error-message' },
	        errorMsg
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BaseDateField.prototype.render = function render() {
	    var _props = this.props,
	        containerClassName = _props.containerClassName,
	        id = _props.id;
	    var _props2 = this.props,
	        dateLabel = _props2.dateLabel,
	        isMobile = _props2.isMobile,
	        displayLabel = _props2.displayLabel;
	
	    var LabelTextComponent = isMobile ? _styledComponents.MobileLabelText : _styledComponents.LabelText;
	    return _react2.default.createElement(
	      _styledComponents.DateFieldContainer,
	      { className: containerClassName, id: id },
	      displayLabel && _react2.default.createElement(
	        LabelTextComponent,
	        {
	          id: 'date_picker_label',
	          displayError: this.state.displayError
	        },
	        dateLabel
	      ),
	      _react2.default.createElement(
	        _styledComponents.DateInputContainer,
	        null,
	        this.renderDateContent()
	      ),
	      _react2.default.createElement(
	        'span',
	        { style: { minHeight: '20px' } },
	        this.renderErrorTextContent()
	      )
	    );
	  };
	
	  return BaseDateField;
	}(_react.Component);
	
	BaseDateField.defaultProps = {
	  validationEnabled: true,
	  isMobile: false,
	  onChangeDate: function onChangeDate() {},
	  excludeDates: [],
	  displayLabel: true,
	  dateFormat: _DateConstants.UI_FORMAT
	};
	exports.default = BaseDateField;
	module.exports = exports['default'];

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CalendarContainer = exports.StyledCustomInput = exports.TextInputContainer = exports.ErrorText = exports.AbsoluteLeftIconContainer = exports.AbsoluteIconContainer = exports.MobileLabelText = exports.LabelText = exports.DateInputContainer = exports.DateFieldContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Fonts = __webpack_require__(12);
	
	var _Din = __webpack_require__(8);
	
	var _BaseInput = __webpack_require__(65);
	
	var _BaseInput2 = _interopRequireDefault(_BaseInput);
	
	var _IconContainer = __webpack_require__(378);
	
	var _IconContainer2 = _interopRequireDefault(_IconContainer);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _themeConstants = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// DateField Styles
	/**
	 * 
	 * @author: Pavan
	 */
	
	var DateFieldContainer = /*#__PURE__*/exports.DateFieldContainer = (0, _reactEmotion2.default)('div', {
	  target: 'ebd7q30'
	})('display:flex;flex-direction:column;flex:1;');
	var DateInputContainer = /*#__PURE__*/exports.DateInputContainer = (0, _reactEmotion2.default)('div', {
	  target: 'ebd7q31'
	})();
	
	var LabelText = /*#__PURE__*/exports.LabelText = (0, _reactEmotion2.default)(_Fonts.Typo13DarkGreyBlueRR, {
	  target: 'ebd7q32'
	})('text-align:left;margin-bottom:3px;line-height:1.428;color:', function (props) {
	  if (props.displayError) {
	    return _Colors2.default.dullRed;
	  }
	  return _Colors2.default.darkGreyBlue;
	}, ';');
	var MobileLabelText = /*#__PURE__*/exports.MobileLabelText = (0, _reactEmotion2.default)(_Fonts.Typo13White2RR, {
	  target: 'ebd7q33'
	})('text-align:left;margin-bottom:3px;color:', function (props) {
	  if (props.displayError) {
	    return _Colors2.default.dullRed;
	  }
	  return _Colors2.default.white;
	}, ';');
	
	var AbsoluteIconContainer = /*#__PURE__*/exports.AbsoluteIconContainer = (0, _reactEmotion2.default)(_IconContainer2.default, {
	  target: 'ebd7q34'
	})('right:', function (props) {
	  return props.rightMargin ? props.rightMargin : '17px';
	}, ';position:absolute;');
	var AbsoluteLeftIconContainer = /*#__PURE__*/exports.AbsoluteLeftIconContainer = (0, _reactEmotion2.default)(_IconContainer2.default, {
	  target: 'ebd7q35'
	})('left:14px;position:absolute;');
	
	var ErrorText = /*#__PURE__*/exports.ErrorText = (0, _reactEmotion2.default)(_Din.Typo12DullRedDR, {
	  target: 'ebd7q36'
	})('margin-top:5px;margin-bottom:5px;text-align:left;');
	var TextInputContainer = /*#__PURE__*/exports.TextInputContainer = (0, _reactEmotion2.default)('div', {
	  target: 'ebd7q37'
	})('display:flex;align-items:center;box-sizing:border-box;position:relative;');
	var StyledCustomInput = /*#__PURE__*/exports.StyledCustomInput = (0, _reactEmotion2.default)(_BaseInput2.default, {
	  target: 'ebd7q38'
	})('font-family:din-2014;font-size:14px;background-color:', _themeConstants.textInputBackgroundColor, ';border-radius:2px;width:', function (props) {
	  if (props.isMobile) {
	    return _themeConstants.mobileDateInputWidth + 'px';
	  }
	  return _themeConstants.defaultDateInputWidth + 'px';
	}, ';border:', function (props) {
	  return props.displayErrorBorder ? '1px solid rgb(188, 68, 68) !important' : 'none';
	}, ';height:', function (props) {
	  return props.height ? props.height : '38px';
	}, ';padding-left:37px;padding-right:30px;outline:none;letter-spacing:0.4px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;text-align:left;@media (min-width:992px) and (max-width:1352px){width:100%;}::placeholder{letter-spacing:0.4px;color:', _themeConstants.placeholderColor, ';}::-moz-placeholder{line-height:2.43;color:', _themeConstants.placeholderColor, ';}&:focus{outline:none;border:solid 1px ', _themeConstants.focussedBorderColor, ';color:', _themeConstants.focussedTextColor, ';::placeholder{line-height:1.58;color:', _Colors2.default.white, ';}:-ms-input-placeholder{line-height:1.58;color:', _Colors2.default.white, ';}::-ms-input-placeholder{line-height:1.58;color:', _Colors2.default.white, ';}}::-webkit-inner-spin-button,::-webkit-outer-spin-button{-webkit-appearance:none;}');
	var CalendarContainer = /*#__PURE__*/exports.CalendarContainer = (0, _reactEmotion2.default)('div', {
	  target: 'ebd7q39'
	})('padding-left:15px;padding-right:15px;padding-top:15px;padding-bottom:15px;border-radius:4px;background-color:', _Colors2.default.white, ';', (0, _mixins.customDevice)(320, 340), '{padding-right:0px;padding-left:0px;}', (0, _mixins.customDevice)(341, 767), '{padding-right:10px;padding-left:10px;}');

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _themeConstants = __webpack_require__(202);
	
	var styles = {
	  errorStyles: {
	    border: '1px solid ' + _themeConstants.errorBorderColor
	  },
	  defaultStyles: {
	    border: '1px solid ' + _themeConstants.borderColor
	  },
	  focusedStyles: {
	    border: '1px solid ' + _themeConstants.focussedBorderColor
	  }
	}; /**
	    * 
	    * @author: Pavan
	    */
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultDateInputWidth = exports.mobileDateInputWidth = exports.textInputBackgroundColor = exports.focussedBorderColor = exports.errorBorderColor = exports.borderColor = exports.focussedTextColor = exports.placeholderColor = undefined;
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var placeholderColor = exports.placeholderColor = _Colors2.default.blueyGreyThree; /**
	                                                                                    * 
	                                                                                    * @author: Pavan
	                                                                                    */
	var focussedTextColor = exports.focussedTextColor = _Colors2.default.lightNavyThree;
	var borderColor = exports.borderColor = _Colors2.default.lightBlueGreyThree;
	var errorBorderColor = exports.errorBorderColor = _Colors2.default.dullRed;
	var focussedBorderColor = exports.focussedBorderColor = _Colors2.default.lightNavyThree;
	var textInputBackgroundColor = exports.textInputBackgroundColor = _Colors2.default.iceBlue;
	var mobileDateInputWidth = exports.mobileDateInputWidth = 280;
	var defaultDateInputWidth = exports.defaultDateInputWidth = 220;

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(643);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _CloseModalIcon = __webpack_require__(66);
	
	var _CloseModalIcon2 = _interopRequireDefault(_CloseModalIcon);
	
	var _styledComponents = __webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Pavan
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	_reactModal2.default.defaultStyles.overlay.backgroundColor = _Colors2.default.black80;
	
	var BaseModalContainer = function (_Component) {
	  _inherits(BaseModalContainer, _Component);
	
	  function BaseModalContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BaseModalContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      modalIsOpen: false
	    }, _this.openModal = function () {
	      _this.setState({
	        modalIsOpen: true
	      });
	      document.body.style.overflowY = 'hidden';
	    }, _this.closeModal = function () {
	      _this.setState({
	        modalIsOpen: false
	      });
	      document.body.style.overflowY = 'scroll';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BaseModalContainer.prototype.componentWillMount = function componentWillMount() {
	    _reactModal2.default.setAppElement('body');
	  };
	
	  BaseModalContainer.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        hideCloseIcon = _props.hideCloseIcon,
	        other = _objectWithoutProperties(_props, ['children', 'hideCloseIcon']);
	
	    var modalIsOpen = this.state.modalIsOpen;
	
	    return _react2.default.createElement(
	      _reactModal2.default,
	      _extends({ closeTimeoutMS: 150, isOpen: modalIsOpen }, other),
	      hideCloseIcon ? null : _react2.default.createElement(
	        _styledComponents.CloseIconWrapper,
	        { onClick: this.closeModal },
	        _react2.default.createElement(_CloseModalIcon2.default, null)
	      ),
	      children
	    );
	  };
	
	  return BaseModalContainer;
	}(_react.Component);
	
	BaseModalContainer.defaultProps = {
	  hideCloseIcon: false
	};
	exports.default = BaseModalContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CloseIconWrapper = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CloseIconWrapper = /*#__PURE__*/exports.CloseIconWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'ecxc5g00'
	})('user-select:none;cursor:pointer;position:absolute;right:5%;top:4%;@media only screen and (max-width:767px){position:absolute;right:6%;top:6%;padding:10px;padding-bottom:0px;}'); /**
	                                                                                                                                                                                       * 
	                                                                                                                                                                                       * @author: Vamsi
	                                                                                                                                                                                       */

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1fdt7rv0'
	})('display:flex;align-items:center;justify-content:center;width:20px;height:20px;cursor:pointer;user-select:none;'); /**
	                                                                                                                       * 
	                                                                                                                       * @author: Pavan
	                                                                                                                       */
	
	exports.default = IconContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickoutside = __webpack_require__(280);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _stylesModule = __webpack_require__(327);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.openDropDown = function () {
	      if (_this.props.onhover) {
	        _this.setState({
	          isOpen: true
	        });
	      }
	    };
	
	    _this.closeDropDown = function () {
	      if (_this.props.onhover) {
	        _this.setState({
	          isOpen: false
	        });
	      }
	    };
	
	    _this.toggleDropDown = function () {
	      _this.setState(function (prevState) {
	        return {
	          isOpen: !prevState.isOpen
	        };
	      }, function () {
	        _this.props.getDropdownState(_this.state.isOpen);
	        if (_this.state.isOpen) {
	          _this.props.onPressDropdown();
	        }
	      });
	    };
	
	    _this.handleClickOutside = function () {
	      if (_this.state.isOpen) {
	        _this.toggleDropDown();
	      }
	    };
	
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  Dropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var isOpen = this.state.isOpen;
	    var _props = this.props,
	        buttonComponent = _props.buttonComponent,
	        children = _props.children,
	        dropdownStyle = _props.dropdownStyle,
	        className = _props.className,
	        dropdownMainContainerStyles = _props.dropdownMainContainerStyles,
	        id = _props.id;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _stylesModule2.default.dropdownContainer,
	        style: dropdownMainContainerStyles,
	        id: id
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: { position: 'relative', width: '100%' },
	          onMouseEnter: this.openDropDown,
	          onMouseLeave: this.closeDropDown
	        },
	        _react2.default.createElement(
	          'div',
	          { onClick: this.toggleDropDown },
	          buttonComponent
	        ),
	        isOpen ? _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(dropdownContainer) {
	              _this2.dropdownContainer = dropdownContainer;
	            },
	            style: _extends({
	              position: 'absolute',
	              top: '100%',
	              zIndex: 10
	            }, dropdownStyle),
	            className: className,
	            onClick: this.closeDropDown
	          },
	          children
	        ) : null
	      )
	    );
	  };
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.defaultProps = {
	  onPressDropdown: function onPressDropdown() {},
	  getDropdownState: function getDropdownState() {}
	};
	
	exports.default = (0, _reactOnclickoutside2.default)(Dropdown);
	module.exports = exports['default'];

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(62);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _moment = __webpack_require__(275);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BaseDateField = __webpack_require__(374);
	
	var _BaseDateField2 = _interopRequireDefault(_BaseDateField);
	
	var _FormValidations = __webpack_require__(42);
	
	var _DateConstants = __webpack_require__(221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Pavan
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var DateField = function (_Component) {
	  _inherits(DateField, _Component);
	
	  function DateField() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DateField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.captureDateFieldRef = function (ref) {
	      _this.dateFieldInstance = ref;
	    }, _this.validate = function () {
	      return _this.dateFieldInstance.validateDateInput(_this.dateFieldInstance.state.dateValue);
	    }, _this.reset = function () {
	      _this.dateFieldInstance.reset();
	    }, _this.queryParams = { arcades: '' }, _this.isBhowaniporePresentInQueryParams = function () {
	      return _this.queryParams.arcades === 'bhowanipore';
	    }, _this.isVrCricketBhowaniporePresentInQueryParams = function () {
	      return _this.queryParams.arcades === 'vr-cricket-bhowanipore';
	    }, _this.renderDateLabel = function () {
	      var dateConstants = _this.props.dateConstants;
	
	      if (_this.isVrCricketBhowaniporePresentInQueryParams()) {
	        return 'Preferred Date (optional)';
	      } else if (_this.isBhowaniporePresentInQueryParams()) {
	        return 'Date & Time';
	      }
	      return dateConstants.dateLabel;
	    }, _this.renderDateValidation = function () {
	      if (_this.isBhowaniporePresentInQueryParams()) {
	        return _FormValidations.validatePreferredDateAndTime;
	      }
	      return _FormValidations.validatePreferredDate;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DateField.prototype.render = function render() {
	    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	      this.queryParams = _queryString2.default.parse(window.location.search);
	    }
	    var _props = this.props,
	        dateConstants = _props.dateConstants,
	        isMobile = _props.isMobile,
	        excludeDates = _props.excludeDates,
	        id = _props.id;
	
	    return _react2.default.createElement(_BaseDateField2.default, {
	      id: id,
	      isMobile: isMobile,
	      ref: this.captureDateFieldRef,
	      validate: this.renderDateValidation(),
	      dateLabel: this.renderDateLabel(),
	      placeholderText: this.isVrCricketBhowaniporePresentInQueryParams() ? 'Preferred Date (optional)' : dateConstants.placeholderText,
	      minDate: (0, _moment2.default)(),
	      showDisabledMonthNavigation: true,
	      excludeDates: excludeDates,
	      showTimeSelect: this.queryParams.arcades === 'bhowanipore',
	      dateFormat: this.queryParams.arcades === 'bhowanipore' ? _DateConstants.DATE_FORMAT_WITH_TIME : _DateConstants.UI_FORMAT,
	      timeIntervals: 30,
	      validationEnabled: this.queryParams.arcades !== 'vr-cricket-bhowanipore',
	      minTime: this.queryParams.arcades === 'bhowanipore' ? (0, _moment2.default)().hours(10).minutes(0) : null,
	      maxTime: this.queryParams.arcades === 'bhowanipore' ? (0, _moment2.default)().hours(22).minutes(0) : null
	    });
	  };
	
	  return DateField;
	}(_react.Component);
	
	DateField.defaultProps = {
	  isMobile: false
	};
	exports.default = DateField;
	module.exports = exports['default'];

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _styledComponents = __webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Manikanta
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setError = function (error) {
	      _this.setState({ errorMsg: error });
	    };
	
	    _this.setDisplayError = function (displayError) {
	      _this.setState({ displayError: displayError });
	    };
	
	    _this.validate = function () {
	      var _this$props = _this.props,
	          validationEnabled = _this$props.validationEnabled,
	          validate = _this$props.validate;
	
	      var response = void 0;
	      if (validationEnabled) {
	        if (validate) {
	          response = validate(_this.state.value);
	          if (response.displayError) {
	            _this.setError(response.errorMsg);
	          }
	          _this.setDisplayError(response.displayError);
	        }
	      }
	      return response;
	    };
	
	    _this.reset = function () {
	      _this.setState({
	        value: '',
	        errorMsg: '',
	        displayError: false,
	        isFocused: false
	      });
	    };
	
	    _this.onFocusInput = function () {
	      _this.setState({
	        isFocused: true,
	        displayError: false,
	        errorMsg: ''
	      });
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) {
	        onFocus();
	      }
	    };
	
	    _this.onBlurInput = function () {
	      _this.setState({
	        isFocused: false
	      });
	      _this.validate();
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) {
	        onBlur();
	      }
	    };
	
	    _this.onChangeInput = function (e) {
	      var value = e.target.value;
	
	      _this.setState({
	        value: value,
	        errorMsg: '',
	        displayError: false
	      });
	    };
	
	    _this.getUserIcon = function () {
	      var isFocused = _this.state.isFocused;
	      var _this$props2 = _this.props,
	          Icon = _this$props2.icon,
	          iconStyle = _this$props2.iconStyle;
	
	      var strokeColor = _Colors2.default.blueyGreyThree;
	      if (isFocused) {
	        strokeColor = _Colors2.default.twilightBlueTwo;
	      }
	
	      return _react2.default.createElement(
	        _styledComponents.IconContainer,
	        { style: iconStyle },
	        _react2.default.createElement(Icon, { strokeColor: strokeColor })
	      );
	    };
	
	    _this.state = {
	      value: '',
	      errorMsg: '',
	      displayError: false,
	      isFocused: false
	    };
	    return _this;
	  }
	
	  Input.prototype.render = function render() {
	    var _state = this.state,
	        value = _state.value,
	        errorMsg = _state.errorMsg,
	        displayError = _state.displayError,
	        isFocused = _state.isFocused;
	
	    var _props = this.props,
	        label = _props.label,
	        className = _props.className,
	        Icon = _props.icon,
	        isMobile = _props.isMobile,
	        id = _props.id,
	        isBhowaniporePresentInQueryParams = _props.isBhowaniporePresentInQueryParams,
	        other = _objectWithoutProperties(_props, ['label', 'className', 'icon', 'isMobile', 'id', 'isBhowaniporePresentInQueryParams']);
	
	    return _react2.default.createElement(
	      _styledComponents.InputContainer,
	      _extends({}, other, {
	        isBhowaniporePresentInQueryParams: isBhowaniporePresentInQueryParams,
	        id: id
	      }),
	      label && _react2.default.createElement(
	        _styledComponents.LabelText,
	        {
	          id: 'input_label',
	          displayError: displayError,
	          isMobile: isMobile
	        },
	        label
	      ),
	      _react2.default.createElement(
	        _styledComponents.MainContainer,
	        {
	          isMobile: isMobile,
	          isFocused: isFocused,
	          className: className,
	          displayError: displayError,
	          value: value,
	          isBhowaniporePresentInQueryParams: isBhowaniporePresentInQueryParams
	        },
	        _react2.default.createElement(
	          _styledComponents.IconView,
	          null,
	          this.getUserIcon()
	        ),
	        _react2.default.createElement(_styledComponents.CustomInput, _extends({}, other, {
	          value: value,
	          isFocused: isFocused,
	          onFocus: this.onFocusInput,
	          onBlur: this.onBlurInput,
	          onChange: this.onChangeInput
	        }))
	      ),
	      _react2.default.createElement(
	        _styledComponents.ErrorText,
	        { id: id + '-error-message' },
	        errorMsg
	      )
	    );
	  };
	
	  return Input;
	}(_react.Component);
	
	Input.propTypes = {
	  isMobile: _propTypes2.default.bool,
	  validationEnabled: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  icon: _propTypes2.default.node.isRequired,
	  validate: _propTypes2.default.func,
	  placeholder: _propTypes2.default.string,
	  iconStyle: _propTypes2.default.object
	};
	
	Input.defaultProps = {
	  isMobile: false,
	  validationEnabled: true,
	  placeholder: '',
	  label: ''
	};
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InputContainer = exports.IconContainer = exports.LabelText = exports.ErrorText = exports.CustomInput = exports.IconView = exports.Icon = exports.MainContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _BaseInput = __webpack_require__(65);
	
	var _BaseInput2 = _interopRequireDefault(_BaseInput);
	
	var _mixins = __webpack_require__(4);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Din = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainContainer = /*#__PURE__*/exports.MainContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e8ce0j80'
	})('@media (min-width:992px) and (max-width:1352px){width:auto;}width:', function (props) {
	  return props.isMobile ? '280px' : '220px';
	}, ';height:38px;border-radius:2px;display:flex;align-items:center;background-color:', _Colors2.default.iceBlue, ';box-shadow:', function (props) {
	  return props.isFocused ? '0 1px 9px 0 ' + _Colors2.default.twilightBlue15 : undefined;
	}, ';border:solid 1px\n    ', function (props) {
	  return props.displayError ? _Colors2.default.dullRed : props.isFocused ? _Colors2.default.lightNavyThree : _Colors2.default.lightBlueGreyThree;
	}, ';box-sizing:border-box;flex-direction:row;justify-content:center;width:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? 'auto' : '220px';
	}, ';', (0, _mixins.customDevice)(320, 991), '{width:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? 'auto' : '280px';
	}, ';}'); /**
	           * 
	           * @author: Manikanta
	           */
	
	/* eslint-disable no-confusing-arrow */
	
	var Icon = /*#__PURE__*/exports.Icon = (0, _reactEmotion2.default)('img', {
	  target: 'e8ce0j81'
	})('object-fit:contain;');
	
	var IconView = /*#__PURE__*/exports.IconView = (0, _reactEmotion2.default)('div', {
	  target: 'e8ce0j82'
	})('padding-left:14px;padding-right:10px;user-select:none;');
	var CustomInput = /*#__PURE__*/exports.CustomInput = (0, _reactEmotion2.default)(_BaseInput2.default, {
	  target: 'e8ce0j83'
	})('background-color:', _Colors2.default.iceBlue, ';border-radius:2px;width:100%;height:100%;border:none;outline:none;font-family:din-2014;font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.43;color:', function (props) {
	  return props.isFocused ? _Colors2.default.twilightBlueTwo : _Colors2.default.charcoalGrey;
	}, ';\':focus\':{border:none;outline:none;}::placeholder{color:', _Colors2.default.blueyGreyThree, ';line-height:1.43;}:-ms-input-placeholder{color:', _Colors2.default.blueyGreyThree, ';line-height:1.43;}::-ms-input-placeholder{color:', _Colors2.default.blueyGreyThree, ';line-height:1.43;}::-moz-placeholder{color:', _Colors2.default.blueyGreyThree, ';line-height:2.43;}');
	var ErrorText = /*#__PURE__*/exports.ErrorText = (0, _reactEmotion2.default)(_Din.Typo12DullRedDR, {
	  target: 'e8ce0j84'
	})('margin-top:5px;');
	
	var LabelText = /*#__PURE__*/exports.LabelText = (0, _reactEmotion2.default)(_Din.Typo13DarkGreyBlueDR, {
	  target: 'e8ce0j85'
	})('display:block;margin-bottom:3px;line-height:1.428;color:', function (props) {
	  return props.displayError ? _Colors2.default.dullRed : props.isMobile ? _Colors2.default.whiteTwo : undefined;
	}, ';');
	
	var IconContainer = /*#__PURE__*/exports.IconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e8ce0j86'
	})('user-select:none;width:11px;height:100%;');
	var InputContainer = /*#__PURE__*/exports.InputContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e8ce0j87'
	})('@media (min-width:992px) and (max-width:1352px){display:flex;flex-direction:column;flex:1;}@media (min-width:1025px){flex:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? 0.8 : 1;
	}, ';min-width:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '120px' : 'auto';
	}, ';}');

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Vishnu
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var TermsAndConditions = function (_Component) {
	  _inherits(TermsAndConditions, _Component);
	
	  function TermsAndConditions() {
	    _classCallCheck(this, TermsAndConditions);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TermsAndConditions.prototype.render = function render() {
	    var termsAndConditionsData = this.props.termsAndConditionsData;
	    var heading = termsAndConditionsData.heading,
	        description = termsAndConditionsData.description;
	
	    return _react2.default.createElement(
	      _styledComponents.TermsAndConditionsContainer,
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _styledComponents.TitleContainer,
	          null,
	          _react2.default.createElement(_styledComponents.TnCTitle, {
	            dangerouslySetInnerHTML: {
	              __html: decodeURIComponent(escape(heading))
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _styledComponents.ContentContainer,
	          { className: 'tnc-scroll-bar' },
	          _react2.default.createElement(_styledComponents.TnCContent, {
	            dangerouslySetInnerHTML: {
	              __html: description
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return TermsAndConditions;
	}(_react.Component);
	
	exports.default = TermsAndConditions;
	module.exports = exports['default'];

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var frmConstants = {
	  dateField: {
	    dateLabel: 'Preferred Date',
	    placeholderText: 'Date'
	  },
	  nameField: {
	    label: 'Name',
	    placeholderText: 'John Doe'
	  },
	  mobileNumberField: {
	    label: 'Mobile Number',
	    placeholderText: '82933 32903'
	  },
	  mobileNumberOrEMailField: {
	    label: 'Mobile Number/Email ID',
	    placeholderText: 'Mobile Number/Email ID'
	  },
	  packageField: {
	    dropDownValues: ['2 Overs', '3 Overs', 'Hourly Pack'],
	    label: 'Package'
	  },
	  submitBtnText: 'BOOK NOW'
	};
	
	var NO_OF_PEOPLE = exports.NO_OF_PEOPLE = 'no-of-people';
	var PREFERRED_DATE = exports.PREFERRED_DATE = 'preferred-date';
	var BOOK_NOW_BUTTON = exports.BOOK_NOW_BUTTON = 'book-now-button';
	var KOLKATA_BHOWANIPORE = exports.KOLKATA_BHOWANIPORE = 'kolkata-bhowanipore';
	
	exports.default = frmConstants;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(62);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _BaseModalContainer = __webpack_require__(203);
	
	var _BaseModalContainer2 = _interopRequireDefault(_BaseModalContainer);
	
	var _TermsAndConditionsModal = __webpack_require__(134);
	
	var _TermsAndConditionsModal2 = _interopRequireDefault(_TermsAndConditionsModal);
	
	var _CloseModalIcon = __webpack_require__(66);
	
	var _CloseModalIcon2 = _interopRequireDefault(_CloseModalIcon);
	
	var _PunePageResponsiveContainer = __webpack_require__(458);
	
	var _PunePageResponsiveContainer2 = _interopRequireDefault(_PunePageResponsiveContainer);
	
	var _FormDropdown = __webpack_require__(428);
	
	var _FormDropdown2 = _interopRequireDefault(_FormDropdown);
	
	var _AppUtils = __webpack_require__(135);
	
	var _navigationUtils = __webpack_require__(16);
	
	var _StringUtils = __webpack_require__(177);
	
	var _Icons = __webpack_require__(35);
	
	var _FormValidations = __webpack_require__(42);
	
	var _forms = __webpack_require__(44);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _constants = __webpack_require__(401);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _DateField = __webpack_require__(398);
	
	var _DateField2 = _interopRequireDefault(_DateField);
	
	var _TermsAndConditions = __webpack_require__(294);
	
	var _TermsAndConditions2 = _interopRequireDefault(_TermsAndConditions);
	
	var _styledComponents = __webpack_require__(169);
	
	var _styles = __webpack_require__(402);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	__webpack_require__(609);
	
	__webpack_require__(607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: Pavan
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// import MediaQuery from 'react-responsive'
	
	
	// eslint-disable-line
	
	var iconWidth = 14;
	var iconHeight = 14;
	
	var FormHomePage = function (_Component) {
	  _inherits(FormHomePage, _Component);
	
	  function FormHomePage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FormHomePage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      parsedQueryParams: false
	    }, _this.renderTermsAndConditions = function () {
	      var showFaq = _this.props.showFaq;
	
	      return _react2.default.createElement(
	        _styledComponents.TandCTextContainer,
	        { showFaq: showFaq },
	        showFaq ? _react2.default.createElement(
	          _styledComponents.FaqButton,
	          { id: 'new-landing-faqs-button' },
	          _react2.default.createElement(
	            _styledComponents.FaqText,
	            { onClick: _navigationUtils.scrollToFaqSection },
	            'FAQs'
	          )
	        ) : null,
	        _react2.default.createElement(
	          _styledComponents.TandCTextInnerContainer,
	          { id: 'terms-and-conditions-container' },
	          _react2.default.createElement(
	            _styledComponents.TandCApplyText,
	            {
	              id: 'terms-and-conditions-text',
	              onClick: _this.openTnCModal
	            },
	            '*T&C apply'
	          )
	        )
	      );
	    }, _this.validateAllFields = function (dateRef, nameRef, mobileRef, dropdownRef) {
	      // DateFieldValidation
	      var validationResponse = dateRef.validate();
	      var isValidDateField = !validationResponse.displayError;
	      // NameFieldValidation
	      var nameValidationResponse = nameRef.validate();
	      var isValidNameField = !nameValidationResponse.displayError;
	      // MobileFieldValidation
	      var mobileValidationResponse = mobileRef.validate();
	      var isValidMobileNumberField = !mobileValidationResponse.displayError;
	
	      // DropdownFieldValidation
	      dropdownRef.validateDropDownValue();
	      var isValidDropdownField = !dropdownRef.state.displayError;
	
	      return isValidDateField && isValidNameField && isValidMobileNumberField && isValidDropdownField;
	    }, _this.getFormData = function (dateRef, nameRef, mobileRef, dropdownRef, packageDropdownRef, slotIdLength, chars, slotIdPrefix) {
	      var commonRequestObject = {
	        slotId: (0, _AppUtils.getRandomBookingSlotId)(slotIdLength, chars, slotIdPrefix),
	        name: nameRef.state.value,
	        mobileNumber: mobileRef.state.value,
	        noOfPeople: dropdownRef.state.dropdownValue,
	        dateOfBooking: dateRef.dateFieldInstance.state.dateValue
	      };
	      if (_this.isBhowaniporePresentInQueryParams()) {
	        return _extends({}, commonRequestObject, {
	          package: packageDropdownRef.state.dropdownValue
	        });
	      } else if (_this.props.isOnePlusOneOfferPresentInPriceCards) {
	        return _extends({}, commonRequestObject, {
	          offers: '1+1 rcb offer'
	        });
	      }
	      return commonRequestObject;
	    }, _this.prepareRequestObject = function (formData, arcadeCity) {
	      return {
	        slot_unique_id: formData.slotId,
	        date_of_slot: formData.dateOfBooking !== '' && formData.dateOfBooking.format('DD MM YYYY, h:mm a'),
	        f_name: formData.name,
	        phone_number: formData.mobileNumber,
	        no_of_people_attending: formData.noOfPeople,
	        package: formData.package,
	        offers: formData.offers,
	        arcade_name: arcadeCity
	      };
	    }, _this.onFailureSubmitForm = function () {
	      // TODO: Need to ask for UI to design team: @dependency on Anesh,Design
	      // alert('Form Submission Failed! Try again!') //eslint-disable-line
	    }, _this.trackUser = function () {
	      if (typeof fbq === 'function') {
	        // this is for tracking analytics in fb
	        fbq('track', 'iBCricketBookingSuccess', {}); // eslint-disable-line
	      }
	    }, _this.handleSubmitFn = function (dateRef, nameRef, mobileRef, dropdownRef, packageDropdownRef) {
	      // Do validation
	
	      var isValidForm = _this.validateAllFields(dateRef, nameRef, mobileRef, dropdownRef);
	
	      if (isValidForm) {
	        // do submit with mautic
	        var _this$props = _this.props,
	            _onFormSubmitSuccess = _this$props.onFormSubmitSuccess,
	            slotIdLength = _this$props.slotIdLength,
	            chars = _this$props.chars,
	            slotIdPrefix = _this$props.slotIdPrefix,
	            arcadeFormMauticID = _this$props.arcadeFormMauticID,
	            arcadeCity = _this$props.arcadeCity;
	
	        var formData = _this.getFormData(dateRef, nameRef, mobileRef, dropdownRef, packageDropdownRef, slotIdLength, chars, slotIdPrefix);
	
	        var prepareRequestObject = _this.prepareRequestObject(formData, arcadeCity);
	        (0, _forms.submitForm)(prepareRequestObject, arcadeFormMauticID, 'iBCPuneArcadeSlotBooking', _this.trackUser, function () {}, _this.onFailureSubmitForm);
	        _onFormSubmitSuccess(formData);
	      }
	    }, _this.captureDateRef = function (ref) {
	      _this.dateField = ref;
	    }, _this.captureDropdownRef = function (ref) {
	      _this.dropdownRef = ref;
	    }, _this.capturePackageDropdownRef = function (ref) {
	      _this.packageDropdownRef = ref;
	    }, _this.captureModalRef = function (ref) {
	      if (ref) {
	        _this.modalRef = ref;
	      }
	    }, _this.openModal = function () {
	      if (_this.modalRef) {
	        _this.modalRef.openModal();
	      }
	    }, _this.closeModal = function () {
	      if (_this.modalRef) {
	        _this.modalRef.closeModal();
	      }
	    }, _this.captureTnCModalRef = function (ref) {
	      if (ref) {
	        _this.tncModalRef = ref;
	      }
	    }, _this.openTnCModal = function () {
	      if (_this.tncModalRef) {
	        _this.tncModalRef.openTnCModal();
	      }
	    }, _this.closeTnCModal = function () {
	      if (_this.tncModalRef) {
	        _this.tncModalRef.closeTnCModal();
	      }
	    }, _this.storeFullNameRef = function (ref) {
	      _this.usernameRef = ref;
	    }, _this.storeMobileNumberRef = function (ref) {
	      _this.mobileNumberRef = ref;
	    }, _this.storeDesktopFullNameRef = function (ref) {
	      _this.desktopNameRef = ref;
	    }, _this.storeDesktopMobileNumberRef = function (ref) {
	      _this.desktopMobileNumberRef = ref;
	    }, _this.captureDesktopDateRef = function (ref) {
	      _this.desktopDateField = ref;
	    }, _this.captureDesktopDropdownRef = function (ref) {
	      _this.desktopDropdownRef = ref;
	    }, _this.capturePackageDesktopDropdownRef = function (ref) {
	      _this.desktopPackageDropdownRef = ref;
	    }, _this.resetForm = function () {
	      if (_this.desktopNameRef) {
	        _this.desktopNameRef.reset();
	      }
	
	      if (_this.usernameRef) {
	        _this.usernameRef.reset();
	      }
	      if (_this.mdDesktopNameRef) {
	        _this.mdDesktopNameRef.reset();
	      }
	
	      if (_this.desktopMobileNumberRef) {
	        _this.desktopMobileNumberRef.reset();
	      }
	      if (_this.mdDesktopMobileNumberRef) {
	        _this.mdDesktopMobileNumberRef.reset();
	      }
	      if (_this.mobileNumberRef) {
	        _this.mobileNumberRef.reset();
	      }
	      if (_this.desktopDropdownRef) {
	        _this.desktopDropdownRef.reset();
	      }
	      if (_this.desktopPackageDropdownRef) {
	        _this.desktopPackageDropdownRef.reset();
	      }
	      if (_this.mdDesktopDropdownRef) {
	        _this.mdDesktopDropdownRef.reset();
	      }
	      if (_this.mdDesktopPackageDropdownRef) {
	        _this.mdDesktopPackageDropdownRef.reset();
	      }
	      if (_this.dropdownRef) {
	        _this.dropdownRef.reset();
	      }
	      if (_this.packageDropdownRef) {
	        _this.packageDropdownRef.reset();
	      }
	      if (_this.mdDesktopDateField) {
	        _this.mdDesktopDateField.reset();
	      }
	      if (_this.desktopDateField) {
	        _this.desktopDateField.reset();
	      }
	      if (_this.dateField) {
	        _this.dateField.reset();
	      }
	    }, _this.storeMdDesktopFullNameRef = function (ref) {
	      _this.mdDesktopNameRef = ref;
	    }, _this.storeMdDesktopMobileNumberRef = function (ref) {
	      _this.mdDesktopMobileNumberRef = ref;
	    }, _this.captureMdDesktopDateRef = function (ref) {
	      _this.mdDesktopDateField = ref;
	    }, _this.captureMdDesktopDropdownRef = function (ref) {
	      _this.mdDesktopDropdownRef = ref;
	    }, _this.captureMdDesktopPackageDropdownRef = function (ref) {
	      _this.mdDesktopPackageDropdownRef = ref;
	    }, _this.replaceSpacesAndHypensInStringAndConvertToLowerCase = function (srcString) {
	      return (0, _StringUtils.replaceSpacesAndHypensInString)(srcString).toLowerCase();
	    }, _this.queryParams = { arcades: '' }, _this.isBhowaniporePresentInQueryParams = function () {
	      return _this.queryParams.arcades === 'bhowanipore';
	    }, _this.renderMdDesktop = function () {
	      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	        _this.queryParams = _queryString2.default.parse(window.location.search);
	        if (_this.state.parsedQueryParams === false) _this.setState({ parsedQueryParams: true });
	      }
	      var _this$props2 = _this.props,
	          formConstants = _this$props2.formConstants,
	          termsAndConditionsData = _this$props2.termsAndConditionsData,
	          excludeDates = _this$props2.excludeDates;
	      var dateField = formConstants.dateField,
	          submitBtnText = formConstants.submitBtnText,
	          nameField = formConstants.nameField,
	          mobileNumberField = formConstants.mobileNumberField,
	          mobileNumberOrEMailField = formConstants.mobileNumberOrEMailField,
	          packageField = formConstants.packageField;
	      var dropDownValues = packageField.dropDownValues,
	          label = packageField.label;
	
	      return _this.state.parsedQueryParams && _react2.default.createElement(
	        _styledComponents.MdDesktop,
	        null,
	        _react2.default.createElement(
	          _styledComponents.MainMdContainer,
	          { id: 'slot-booking-main-container' },
	          _react2.default.createElement(
	            _styledComponents.FormMdContainer,
	            { id: 'slot-booking-form-container' },
	            _react2.default.createElement(_styledComponents.InputContainer, {
	              id: _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(nameField.label),
	              isMobile: false,
	              innerRef: _this.storeMdDesktopFullNameRef,
	              label: nameField.label,
	              placeholder: nameField.placeholderText,
	              icon: _Icons.IcUser,
	              validate: _FormValidations.validateFullName,
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _react2.default.createElement(_styledComponents.Separator, {
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _react2.default.createElement(_styledComponents.InputContainer, {
	              id: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(mobileNumberOrEMailField.label) : _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(mobileNumberField.label),
	              type: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? 'text' : 'number',
	              isMobile: false,
	              innerRef: _this.storeMdDesktopMobileNumberRef,
	              label: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? mobileNumberOrEMailField.label : mobileNumberField.label,
	              placeholder: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? mobileNumberOrEMailField.placeholderText : mobileNumberField.placeholderText,
	              icon: _Icons.IcSmartPhone,
	              iconStyle: _styles2.default.phoneIcon,
	              validate: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? _FormValidations.validateEmailOrMobileNumber : _FormValidations.validateMobileNumber,
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _react2.default.createElement(_styledComponents.Separator, {
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _react2.default.createElement(_FormDropdown2.default, {
	              id: _constants.NO_OF_PEOPLE,
	              ref: _this.captureMdDesktopDropdownRef,
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _react2.default.createElement(_styledComponents.Separator, {
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _this.isBhowaniporePresentInQueryParams() && _react2.default.createElement(_FormDropdown2.default, {
	              id: _constants.NO_OF_PEOPLE,
	              ref: _this.captureMdDesktopPackageDropdownRef,
	              dropdownOptions: dropDownValues,
	              dropdownLabel: label,
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _this.isBhowaniporePresentInQueryParams() && _react2.default.createElement(_styledComponents.Separator, {
	              isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	            }),
	            _react2.default.createElement(_DateField2.default, {
	              id: _constants.PREFERRED_DATE,
	              ref: _this.captureMdDesktopDateRef,
	              dateConstants: dateField,
	              isMobile: false,
	              excludeDates: excludeDates
	            })
	          ),
	          _react2.default.createElement(_styledComponents.Divider, null),
	          _react2.default.createElement(_styledComponents.Divider, null),
	          _react2.default.createElement(
	            _styledComponents.SubmitButton,
	            {
	              id: _constants.BOOK_NOW_BUTTON,
	              onClick: function onClick() {
	                return _this.handleSubmitFn(_this.mdDesktopDateField, _this.mdDesktopNameRef, _this.mdDesktopMobileNumberRef, _this.mdDesktopDropdownRef, _this.mdDesktopPackageDropdownRef);
	              }
	            },
	            _react2.default.createElement(
	              _styledComponents.ButtonContainer,
	              null,
	              _react2.default.createElement(
	                _styledComponents.ButtonLabel,
	                null,
	                _react2.default.createElement(
	                  _styledComponents.LabelText,
	                  null,
	                  submitBtnText
	                ),
	                _react2.default.createElement(_styledComponents.ArrowIcon, null)
	              ),
	              _react2.default.createElement(
	                _styledComponents.ButtonText,
	                { as: 'p' },
	                'You can avail offers/discounts while making the payment at our arcade.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _TermsAndConditionsModal2.default,
	            {
	              handleCloseModal: _this.closeTnCModal,
	              ref: _this.captureTnCModalRef
	            },
	            _react2.default.createElement(
	              _styledComponents.TnCContainer,
	              null,
	              _react2.default.createElement(
	                _styledComponents.IconContainer,
	                { onClick: _this.closeTnCModal },
	                _react2.default.createElement(_Icons.IcClose, {
	                  strokeColor: _Colors2.default.lightGrey,
	                  width: iconWidth,
	                  height: iconHeight
	                })
	              ),
	              _react2.default.createElement(_TermsAndConditions2.default, {
	                termsAndConditionsData: termsAndConditionsData
	              })
	            )
	          )
	        ),
	        _this.renderTermsAndConditions()
	      );
	    }, _this.renderDesktopOrMdDesktopOrMobile = function () {
	      var _this$props3 = _this.props,
	          formConstants = _this$props3.formConstants,
	          excludeDates = _this$props3.excludeDates;
	      var dateField = formConstants.dateField,
	          submitBtnText = formConstants.submitBtnText,
	          nameField = formConstants.nameField,
	          mobileNumberField = formConstants.mobileNumberField,
	          mobileNumberOrEMailField = formConstants.mobileNumberOrEMailField,
	          packageField = formConstants.packageField;
	      var dropDownValues = packageField.dropDownValues,
	          label = packageField.label;
	
	
	      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	        _this.queryParams = _queryString2.default.parse(window.location.search);
	        if (_this.state.parsedQueryParams === false) _this.setState({ parsedQueryParams: true });
	      }
	      return _this.state.parsedQueryParams && _react2.default.createElement(
	        _PunePageResponsiveContainer2.default,
	        null,
	        _react2.default.createElement(
	          _styledComponents.Desktop,
	          null,
	          _react2.default.createElement(
	            _styledComponents.MainContainer,
	            { id: 'slot-booking-main-container' },
	            _react2.default.createElement(
	              _styledComponents.FormContainer,
	              { id: 'slot-booking-form-container' },
	              _react2.default.createElement(_styledComponents.InputContainer, {
	                id: _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(nameField.label),
	                isMobile: false,
	                innerRef: _this.storeDesktopFullNameRef,
	                label: nameField.label,
	                placeholder: nameField.placeholderText,
	                icon: _Icons.IcUser,
	                validate: _FormValidations.validateFullName,
	                isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	              }),
	              _react2.default.createElement(_styledComponents.InputContainer, {
	                id: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(mobileNumberOrEMailField.label) : _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(mobileNumberField.label),
	                type: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? 'text' : 'number',
	                isMobile: false,
	                innerRef: _this.storeDesktopMobileNumberRef,
	                label: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? mobileNumberOrEMailField.label : mobileNumberField.label,
	                placeholder: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? mobileNumberOrEMailField.placeholderText : mobileNumberField.placeholderText,
	                icon: _Icons.IcSmartPhone,
	                iconStyle: _styles2.default.phoneIcon,
	                validate: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? _FormValidations.validateEmailOrMobileNumber : _FormValidations.validateMobileNumber,
	                isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	              }),
	              _react2.default.createElement(_FormDropdown2.default, {
	                id: _constants.NO_OF_PEOPLE,
	                ref: _this.captureDesktopDropdownRef,
	                isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	              }),
	              _this.isBhowaniporePresentInQueryParams() && _react2.default.createElement(_FormDropdown2.default, {
	                id: _constants.NO_OF_PEOPLE,
	                ref: _this.capturePackageDesktopDropdownRef,
	                dropdownOptions: dropDownValues,
	                dropdownLabel: label,
	                isBhowaniporePresentInQueryParams: _this.isBhowaniporePresentInQueryParams()
	              }),
	              _react2.default.createElement(_DateField2.default, {
	                id: _constants.PREFERRED_DATE,
	                ref: _this.captureDesktopDateRef,
	                dateConstants: dateField,
	                isMobile: false,
	                excludeDates: excludeDates
	              })
	            ),
	            _react2.default.createElement(
	              _styledComponents.SubmitButton,
	              {
	                id: _constants.BOOK_NOW_BUTTON,
	                onClick: function onClick() {
	                  return _this.handleSubmitFn(_this.desktopDateField, _this.desktopNameRef, _this.desktopMobileNumberRef, _this.desktopDropdownRef, _this.desktopPackageDropdownRef);
	                }
	              },
	              _react2.default.createElement(
	                _styledComponents.ButtonContainer,
	                null,
	                _react2.default.createElement(
	                  _styledComponents.ButtonLabel,
	                  null,
	                  _react2.default.createElement(
	                    _styledComponents.LabelText,
	                    null,
	                    submitBtnText
	                  ),
	                  _react2.default.createElement(_styledComponents.ArrowIcon, null)
	                ),
	                _react2.default.createElement(
	                  _styledComponents.ButtonText,
	                  { as: 'p' },
	                  'You can avail offers/discounts while making the payment at our arcade.'
	                )
	              )
	            )
	          ),
	          _this.renderTermsAndConditions()
	        ),
	        _this.renderMdDesktop(),
	        _react2.default.createElement(
	          _styledComponents.Mobile,
	          null,
	          _react2.default.createElement(
	            _BaseModalContainer2.default,
	            {
	              ref: _this.captureModalRef,
	              style: _styles2.default,
	              hideCloseIcon: true
	            },
	            _react2.default.createElement(
	              _styledComponents.FormMobileMainContainer,
	              null,
	              _react2.default.createElement(
	                _styledComponents.CloseIconWrapper,
	                { onClick: _this.closeModal },
	                _react2.default.createElement(_CloseModalIcon2.default, null)
	              ),
	              _react2.default.createElement(_styledComponents.InputContainer, {
	                isMobile: true,
	                innerRef: _this.storeFullNameRef,
	                label: nameField.label,
	                id: _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(nameField.label),
	                placeholder: nameField.placeholderText,
	                icon: _Icons.IcUser,
	                validate: _FormValidations.validateFullName
	              }),
	              _react2.default.createElement(_styledComponents.Divider, null),
	              _react2.default.createElement(_styledComponents.InputContainer, {
	                type: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? 'text' : 'number',
	                isMobile: true,
	                innerRef: _this.storeMobileNumberRef,
	                label: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? mobileNumberOrEMailField.label : mobileNumberField.label,
	                id: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(mobileNumberOrEMailField.label) : _this.replaceSpacesAndHypensInStringAndConvertToLowerCase(mobileNumberField.label),
	                placeholder: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? mobileNumberOrEMailField.placeholderText : mobileNumberField.placeholderText,
	                icon: _Icons.IcSmartPhone,
	                iconStyle: _styles2.default.phoneIcon,
	                validate: _this.queryParams.arcades === _constants.KOLKATA_BHOWANIPORE ? _FormValidations.validateEmailOrMobileNumber : _FormValidations.validateMobileNumber
	              }),
	              _react2.default.createElement(_styledComponents.Divider, null),
	              _react2.default.createElement(_FormDropdown2.default, {
	                isMobile: true,
	                ref: _this.captureDropdownRef,
	                id: _constants.NO_OF_PEOPLE
	              }),
	              _react2.default.createElement(_styledComponents.Divider, null),
	              _this.isBhowaniporePresentInQueryParams() && _react2.default.createElement(_FormDropdown2.default, {
	                isMobile: true,
	                ref: _this.capturePackageDropdownRef,
	                dropdownOptions: dropDownValues,
	                dropdownLabel: label,
	                id: _constants.NO_OF_PEOPLE
	              }),
	              _react2.default.createElement(_styledComponents.Divider, null),
	              _react2.default.createElement(_DateField2.default, {
	                ref: _this.captureDateRef,
	                dateConstants: dateField,
	                isMobile: true,
	                excludeDates: excludeDates,
	                id: _constants.PREFERRED_DATE
	              }),
	              _react2.default.createElement(_styledComponents.Divider, null),
	              _react2.default.createElement(_styledComponents.Divider, null),
	              _react2.default.createElement(
	                _styledComponents.SubmitBtnContainer,
	                {
	                  id: _constants.BOOK_NOW_BUTTON,
	                  onClick: function onClick() {
	                    return _this.handleSubmitFn(_this.dateField, _this.usernameRef, _this.mobileNumberRef, _this.dropdownRef, _this.packageDropdownRef);
	                  }
	                },
	                _react2.default.createElement(
	                  _styledComponents.ButtonWrapper,
	                  null,
	                  submitBtnText,
	                  _react2.default.createElement(
	                    _styledComponents.ButtonIconContainer,
	                    null,
	                    _react2.default.createElement(_styledComponents.ArrowIcon, null)
	                  )
	                )
	              ),
	              _this.renderTermsAndConditions()
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FormHomePage.prototype.render = function render() {
	    return this.renderDesktopOrMdDesktopOrMobile();
	  };
	
	  return FormHomePage;
	}(_react.Component);
	
	FormHomePage.defaultProps = {
	  formConstants: _constants2.default,
	  onFormSubmitSuccess: function onFormSubmitSuccess() {},
	  slotIdLength: 5,
	  chars: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
	  slotIdPrefix: 'iBCPUNE',
	  arcadeFormMauticID: 26
	};
	exports.default = FormHomePage;
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FaqText = exports.FaqButton = exports.ArrowIcon = exports.TnCContent = exports.ContentContainer = exports.TnCTitle = exports.TitleContainer = exports.TermsAndConditionsContainer = exports.TnCCloseIconWrapper = exports.TnCMobileMainContainer = exports.TnCContainer = exports.IconContainer = exports.ButtonContainer = exports.ButtonText = exports.OffersContainer = exports.TandCTextContainer = exports.TandCTextInnerContainer = exports.OfferText = exports.TandCApplyText = exports.CloseIconWrapper = exports.Separator = exports.Mobile = exports.Desktop = exports.MdDesktop = exports.SubmitMdButton = exports.FormMdContainer = exports.MainMdContainer = exports.LabelText = exports.ButtonLabel = exports.SubmitButton = exports.FormContainer = exports.MainContainer = exports.InputContainer = exports.Divider = exports.ButtonWrapper = exports.SubmitBtnContainer = exports.ButtonIconContainer = exports.FormMobileMainContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Icons = __webpack_require__(35);
	
	var _BaseButton = __webpack_require__(167);
	
	var _BaseButton2 = _interopRequireDefault(_BaseButton);
	
	var _mixins = __webpack_require__(4);
	
	var _Fonts = __webpack_require__(12);
	
	var _Din = __webpack_require__(8);
	
	var _Input = __webpack_require__(399);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 
	 * @author: Pavan
	 */
	var FormMobileMainContainer = /*#__PURE__*/exports.FormMobileMainContainer = (0, _reactEmotion2.default)('section', {
	  target: 'e13rjx8t0'
	})('user-select:none;display:flex;flex:1;align-items:center;flex-direction:column;');
	
	var ButtonIconContainer = /*#__PURE__*/exports.ButtonIconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t1'
	})('margin-left:10px;');
	
	var SubmitBtnContainer = /*#__PURE__*/exports.SubmitBtnContainer = (0, _reactEmotion2.default)(_BaseButton2.default, {
	  target: 'e13rjx8t2'
	})('width:280px;height:40px;border-radius:2px;background-color:', _Colors2.default.pumpkinOrange, ';color:', _Colors2.default.white, ';');
	var ButtonWrapper = /*#__PURE__*/exports.ButtonWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t3'
	})('font-family:din-2014;font-size:14px;font-weight:500;color:', _Colors2.default.white, ';display:flex;flex-direction:row;justify-content:center;align-items:center;pointer-events:none;');
	
	var Divider = /*#__PURE__*/exports.Divider = (0, _reactEmotion2.default)('span', {
	  target: 'e13rjx8t4'
	})('height:15px;');
	var InputContainer = /*#__PURE__*/exports.InputContainer = (0, _reactEmotion2.default)(_Input2.default, {
	  target: 'e13rjx8t5'
	})('padding-right:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '10px' : '14px';
	}, ';@media screen and (min-width:1200px) and (max-width:1352px){margin-right:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '10px' : null;
	}, ';}@media screen and (min-width:1353px){margin-right:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '25px' : null;
	}, ';}');
	
	// Desktop Form Components
	
	var MainContainer = /*#__PURE__*/exports.MainContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t6'
	})('width:100%;display:flex;border-left:4px solid ', _Colors2.default.tangerineThree, ';');
	
	var FormContainer = /*#__PURE__*/exports.FormContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t7'
	})('flex:1;padding:23px 30px;display:flex;justify-content:space-between;background-color:', _Colors2.default.whiteTwo, ';');
	
	var SubmitButton = /*#__PURE__*/exports.SubmitButton = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t8'
	})('cursor:pointer;padding-left:23px;padding-right:23px;background-color:', _Colors2.default.pumpkinOrange, ';display:flex;justify-content:center;align-items:center;position:relative;');
	
	var ButtonLabel = /*#__PURE__*/exports.ButtonLabel = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t9'
	})('display:flex;align-items:center;justify-content:center;pointer-events:none;margin-top:7px;');
	
	var LabelText = /*#__PURE__*/exports.LabelText = (0, _reactEmotion2.default)(_Fonts.Typo16White2RB, {
	  target: 'e13rjx8t10'
	})('margin-right:10px;font-family:din-2014;');
	
	// Md Desktop styles
	
	var MainMdContainer = /*#__PURE__*/exports.MainMdContainer = (0, _reactEmotion2.default)(MainContainer, {
	  target: 'e13rjx8t11'
	})();
	
	var FormMdContainer = /*#__PURE__*/exports.FormMdContainer = (0, _reactEmotion2.default)(FormContainer, {
	  target: 'e13rjx8t12'
	})('position:relative;');
	
	var SubmitMdButton = /*#__PURE__*/exports.SubmitMdButton = (0, _reactEmotion2.default)(SubmitButton, {
	  target: 'e13rjx8t13'
	})();
	var MdDesktop = /*#__PURE__*/exports.MdDesktop = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t14'
	})('position:relative;@media (min-width:992px) and (max-width:1352px){display:block;padding-bottom:20px;}@media (min-width:1353px){display:none;}@media (max-width:991px){display:none;}');
	
	var Desktop = /*#__PURE__*/exports.Desktop = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t15'
	})('position:relative;@media (min-width:768px) and (max-width:1352px){display:none;}@media (min-width:1353px){display:block;}@media (max-width:767px){display:none;}');
	
	var Mobile = /*#__PURE__*/exports.Mobile = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t16'
	})('@media (min-width:992px){display:none;}@media (max-width:991px){display:block;}');
	var Separator = /*#__PURE__*/exports.Separator = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t17'
	})('@media (min-width:992px) and (max-width:1024px){width:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '10px' : '15px';
	}, ';}@media screen and (min-width:1025px){width:15px;}');
	
	var CloseIconWrapper = /*#__PURE__*/exports.CloseIconWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t18'
	})('user-select:none;cursor:pointer;@media only screen and (max-width:991px){padding:10px;padding-bottom:0px;align-self:flex-end;margin-right:7px;margin-bottom:10px;}');
	var BaseRobotoRegularWithATag = _Fonts.BaseRobotoRegular.withComponent('a', {
	  target: 'e13rjx8t19'
	});
	
	var TandCApplyText = /*#__PURE__*/exports.TandCApplyText = (0, _reactEmotion2.default)(BaseRobotoRegularWithATag, {
	  target: 'e13rjx8t20'
	})('opacity:0.8;font-family:din-2014;font-size:0.75em;font-style:italic;color:', _Colors2.default.whiteTwo, ';text-align:center;position:relative;line-height:1;padding-left:0;padding-right:0;cursor:pointer;:focus{color:', _Colors2.default.whiteTwo, ';outline:none;text-decoration:none;}:hover{color:', _Colors2.default.whiteTwo, ';outline:none;text-decoration:none;}:active{color:', _Colors2.default.whiteTwo, ';outline:none;text-decoration:none;}', _mixins.mobile, '{line-height:unset;}', _mixins.tablet, '{line-height:unset;}');
	var OfferText = /*#__PURE__*/exports.OfferText = (0, _reactEmotion2.default)(BaseRobotoRegularWithATag, {
	  target: 'e13rjx8t21'
	})('opacity:0.8;font-size:13px;font-style:italic;color:', _Colors2.default.whiteTwo, ';text-align:center;position:relative;line-height:1;padding-left:0;padding-right:0;cursor:pointer;:focus{color:', _Colors2.default.whiteTwo, ';outline:none;text-decoration:none;}:hover{color:', _Colors2.default.whiteTwo, ';outline:none;text-decoration:none;}:active{color:', _Colors2.default.whiteTwo, ';outline:none;text-decoration:none;}', _mixins.mobile, '{line-height:unset;}', _mixins.tablet, '{line-height:unset;}');
	var TandCTextInnerContainer = /*#__PURE__*/exports.TandCTextInnerContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t22'
	})('width:194px;display:flex;justify-content:center;position:relative;top:8px;left:0;@media only screen and (max-width:991px){display:block;position:unset;width:unset;margin-top:10px;margin-left:-15px;}@media (min-width:992px) and (max-width:1024px){padding-bottom:20px;}');
	var TandCTextContainer = /*#__PURE__*/exports.TandCTextContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t23'
	})('user-select:none;display:flex;justify-content:', function (props) {
	  return props.showFaq ? 'space-between' : 'flex-end';
	}, ';@media only screen and (max-width:991px){width:280px;display:flex;flex-direction:column;justify-content:center;align-items:center;}');
	var OffersContainer = /*#__PURE__*/exports.OffersContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t24'
	})('display:none;@media only screen and (max-width:991px){display:flex;justify-content:center;padding-top:10px;}');
	var ButtonText = /*#__PURE__*/exports.ButtonText = (0, _reactEmotion2.default)(_Din.Typo13WhiteDR, {
	  target: 'e13rjx8t25'
	})('width:165px;text-align:center;margin:0;padding-top:7px;padding-bottom:8px;');
	
	var ButtonContainer = /*#__PURE__*/exports.ButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t26'
	})(';');
	var IconContainer = /*#__PURE__*/exports.IconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t27'
	})('user-select:none;-moz-user-select:none;cursor:pointer;display:flex;align-items:center;justify-content:center;position:absolute;', _mixins.mobile, '{top:16px;right:16px;width:20px;height:20px;z-index:100;}', _mixins.desktop, '{top:30px;right:30px;width:20px;height:20px;}', _mixins.tablet, '{top:30px;right:30px;width:20px;height:20px;z-index:100;}');
	var TnCContainer = /*#__PURE__*/exports.TnCContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t28'
	})('position:relative;');
	var TnCMobileMainContainer = /*#__PURE__*/exports.TnCMobileMainContainer = (0, _reactEmotion2.default)('section', {
	  target: 'e13rjx8t29'
	})('display:flex;flex:1;align-items:center;flex-direction:column;');
	var TnCCloseIconWrapper = /*#__PURE__*/exports.TnCCloseIconWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t30'
	})('user-select:none;cursor:pointer;@media only screen and (max-width:991px){padding:10px;padding-bottom:0px;align-self:flex-end;margin-right:7px;margin-bottom:10px;}');
	// TermsAndConditions Styled Components
	var TermsAndConditionsContainer = /*#__PURE__*/exports.TermsAndConditionsContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t31'
	})('display:flex;flex-direction:column;justify-content:flex-start;background-color:', _Colors2.default.whiteTwo, ';overflow:hidden;', _mixins.desktop, '{width:830px;padding:60px;height:calc(100vh - 150px);}', _mixins.mobile, '{position:relative;padding:40px 15px 40px 30px;width:100%;height:calc(100vh - 150px);}', _mixins.tablet, '{position:relative;padding:50px;height:calc(100vh - 350px);width:670px;}');
	var TitleContainer = /*#__PURE__*/exports.TitleContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13rjx8t32'
	})('padding-right:15px;');
	var TnCTitle = /*#__PURE__*/exports.TnCTitle = (0, _reactEmotion2.default)(_Fonts.Typo24BlackRM, {
	  target: 'e13rjx8t33'
	})('font-family:din-2014;', _mixins.mobile, '{font-size:1.429em;line-height:1.4;margin-bottom:21.1px;}', _mixins.tablet, '{font-size:1.714em;}', _mixins.desktop, '{font-size:1.714em;line-height:1;}');
	
	var ContentContainer = /*#__PURE__*/exports.ContentContainer = (0, _reactEmotion2.default)('section', {
	  target: 'e13rjx8t34'
	})('user-select:text;display:flex;overflow-y:auto;', _mixins.desktop, '{margin-top:24px;height:calc(100vh - 310px);}', _mixins.tablet, '{margin-top:24px;height:calc(100vh - 500px);}', _mixins.mobile, '{padding-right:15px;margin-top:21px;height:calc(100vh - 310px);}');
	var TnCContent = /*#__PURE__*/exports.TnCContent = (0, _reactEmotion2.default)(_Fonts.Typo14BlackRR, {
	  target: 'e13rjx8t35'
	})('font-size:1em;font-family:din-2014;line-height:1.7;', _mixins.mobile, '{font-size:0.929em;}');
	var ArrowIcon = /*#__PURE__*/exports.ArrowIcon = (0, _reactEmotion2.default)(_Icons.IcChevronRight, {
	  target: 'e13rjx8t36'
	})('display:flex;');
	
	var FaqButton = /*#__PURE__*/exports.FaqButton = (0, _reactEmotion2.default)('button', {
	  target: 'e13rjx8t37'
	})('background:transparent;border:none;cursor:pointer;outline:none;padding:0px;display:flex;', (0, _mixins.maxDeviceWidth)(991), '{display:none;}');
	
	var FaqText = /*#__PURE__*/exports.FaqText = (0, _reactEmotion2.default)(_Din.Typo14VeryLightBlueTwoDD, {
	  target: 'e13rjx8t38'
	})('line-height:normal;letter-spacing:normal;border-bottom:solid 2px ', _Colors2.default.warmGreyThree, ';border-bottom-left-radius:1px;color:', _Colors2.default.blueyGreyThree, ';margin-top:5px;', _mixins.mobile, '{font-size:10px;font-weight:normal;color:', _Colors2.default.veryLightBlueTwo, ';}');

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * 
	 * @author: Pavan
	 */
	
	var styles = {
	  overlay: {
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    flex: 1,
	    zIndex: 100,
	    userSelect: 'none'
	  },
	  content: {
	    userSelect: 'none',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    margin: 'auto',
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    background: 'none',
	    border: 'none'
	  },
	  phoneIcon: {
	    height: '17px'
	  }
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MediaAndTextComponent = __webpack_require__(128);
	
	var _MediaAndTextComponent2 = _interopRequireDefault(_MediaAndTextComponent);
	
	var _AlignTwoChildrenInRow = __webpack_require__(213);
	
	var _AlignTwoChildrenInRow2 = _interopRequireDefault(_AlignTwoChildrenInRow);
	
	var _AlignTwoChildrenInColumn = __webpack_require__(212);
	
	var _AlignTwoChildrenInColumn2 = _interopRequireDefault(_AlignTwoChildrenInColumn);
	
	var _ImageTestimonial = __webpack_require__(127);
	
	var _ImageTestimonial2 = _interopRequireDefault(_ImageTestimonial);
	
	var _TextTestimonial = __webpack_require__(129);
	
	var _TextTestimonial2 = _interopRequireDefault(_TextTestimonial);
	
	var _VideoTestimonial = __webpack_require__(92);
	
	var _VideoTestimonial2 = _interopRequireDefault(_VideoTestimonial);
	
	var _styledComponents = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// import { testimonialsContent } from '../../../../constants/IbcArcadeConstants'
	
	
	var DesktopTestimonialSection = function (_Component) {
	  _inherits(DesktopTestimonialSection, _Component);
	
	  function DesktopTestimonialSection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DesktopTestimonialSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderFirstRow = function () {
	      return _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	        firstChildComponentWidth: '32.4841%',
	        secondChildComponentWidth: '66.2420%',
	        firstChildComponent: _react2.default.createElement(_AlignTwoChildrenInColumn2.default, {
	          firstChildComponent: _react2.default.createElement(_MediaAndTextComponent2.default, {
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/kids-with-ib-cricket.webp',
	            altText: 'Play iB Cricket in VR Arcade',
	            textTestimonialHeading: 'OH MY GOD!! \n What a game!',
	            textTestimonialContent: 'This is as close as you can get to playing real cricket in the stadium from your bedroom.',
	            ImageCustomWidth: '34.3137%',
	            TextTestimonialCustomWidth: '61.7674%',
	            includeBottomMargin: true
	          }),
	          secondChildComponent: _react2.default.createElement(_ImageTestimonial2.default, {
	            draggable: false,
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/families-in-ib-cricket-arcade.png',
	            alt: 'Everyone can play iB Cricket'
	          })
	        }),
	        secondChildComponent: _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	          firstChildComponentWidth: '49.0835%',
	          secondChildComponentWidth: '49.0835%',
	          firstChildComponent: _react2.default.createElement(_VideoTestimonial2.default, {
	            id: 'ibCricketInPeoplesWords',
	            thumbnailUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/people-about-ibcricket.png'
	            // isVideoThumbnail
	            , videoAltText: 'iB Cricket in People\'s Words',
	            videoId: '0xDt7sc9SS4'
	          }),
	          secondChildComponent: _react2.default.createElement(_AlignTwoChildrenInColumn2.default, {
	            firstChildComponent: _react2.default.createElement(_ImageTestimonial2.default, {
	              draggable: false,
	              imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/president-plays-cricket.png',
	              alt: 'Union Electronics & IT Minister Shri Ravi Shankar Prasad signing and unveiling the custom-made electronic bat used in the vSport.',
	              includeBottomMargin: true
	            }),
	            secondChildComponent: _react2.default.createElement(_TextTestimonial2.default, {
	              textTestimonialHeading: 'Shri Ram Nath Kovind',
	              textTestimonialContent: 'The President of India playing the first ball of iB Cricket',
	              fillHeight: true,
	              isDark: true
	            })
	          })
	        }),
	        excludeBottomMargin: true
	      });
	    }, _this.renderSecondRow = function () {
	      return _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	        firstChildComponentWidth: '32.4841%',
	        secondChildComponentWidth: '66.2420%',
	        firstChildComponent: _react2.default.createElement(_TextTestimonial2.default, {
	          textTestimonialHeading: 'Age is not a barrier',
	          textTestimonialContent: "Refreshing experience, I re-lived my childhood. I am thrilled to be able to play iB Cricket, I'll challenge my grandkids now.",
	          fillHeight: true,
	          isDark: true
	        }),
	        secondChildComponent: _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	          firstChildComponentWidth: '49.0835%',
	          secondChildComponentWidth: '49.0835%',
	          excludeBottomMargin: true,
	          firstChildComponent: _react2.default.createElement(_MediaAndTextComponent2.default, {
	            id: 'theCrazyExperienceOfVrCricketIbCricketVideo',
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/actor-karthikeya-crazy-experience-with-ib-cricket.png'
	            // isVideoThumbnail
	            , thumbnailVideoUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/videos/people-love-ibcricket/Rx100%2BKarthikeya-iBCricket-mobile.webm',
	            videoAltText: 'The Crazy experience of Virtual reality Cricket - iB Cricket Video',
	            videoId: 'Am8T0yHoBVQ',
	            altText: 'iB Cricket Arcade - Fun and Gaming with friends',
	            textTestimonialHeadingWithoutH2: 'Anyone Can Enjoy',
	            textTestimonialContent: 'Equal fun for amateurs and  pros, I keep coming back to it because it\u2019s so challenging.',
	            ImageCustomWidth: '37.7647%',
	            TextTestimonialCustomWidth: '58.3137%',
	            isVideo: true
	          }),
	          secondChildComponent: _react2.default.createElement(_MediaAndTextComponent2.default, {
	            altText: 'iB Cricket Arcade - Fun and Gaming with friends',
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/IT-minister.png',
	            textTestimonialHeadingWithoutH2: 'Shri Ravi Shankar Prasad',
	            textTestimonialContent: 'Union Electronics & IT Minister Shri Ravi Shankar Prasad signing and unveiling the custom-made electronic bat.',
	            ImageCustomWidth: '30.4118%',
	            TextTestimonialCustomWidth: '65.6667%'
	          })
	        })
	      });
	    }, _this.renderThirdRow = function () {
	      return _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	        firstChildComponentWidth: '32.4841%',
	        secondChildComponentWidth: '66.2420%',
	        firstChildComponent: _react2.default.createElement(_MediaAndTextComponent2.default, {
	          altText: '',
	          imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/girl-playing.png',
	          textTestimonialHeading: 'More Fun Together',
	          textTestimonialContent: 'This is the better VR Cricket game compared to everything that is out there today.',
	          ImageCustomWidth: '36.3137%',
	          TextTestimonialCustomWidth: '59.7674%',
	          includeBottomMargin: true,
	          fillHeight: true
	        }),
	        secondChildComponent: _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	          firstChildComponentWidth: '49.0835%',
	          secondChildComponentWidth: '49.0835%',
	          firstChildComponent: _react2.default.createElement(_ImageTestimonial2.default, {
	            draggable: false,
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/family-playing-ib-cricket.png',
	            alt: 'iB Cricket for Everyone',
	            fillHeight: true
	          }),
	          secondChildComponent: _react2.default.createElement(_MediaAndTextComponent2.default, {
	            altText: 'iB Cricket Arcade - Fun and Gaming with friends',
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/v2/girl-playing-ibcricket.png',
	            textTestimonialHeadingWithoutH2: 'Easy to adapt',
	            textTestimonialContent: 'Marvellous! I haven\'t played cricket till now, but I could very easily adapt to iB Cricket. I hit a boundary in first few balls!',
	            ImageCustomWidth: '36.3137%',
	            TextTestimonialCustomWidth: '59.7674%',
	            fillHeight: true,
	            alignRowReverse: true
	          })
	        }),
	        excludeBottomMargin: true
	      });
	    }, _this.renderFourthRow = function () {
	      return _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	        firstChildComponentWidth: '32.4841%',
	        secondChildComponentWidth: '66.2420%',
	        firstChildComponent: _react2.default.createElement(_ImageTestimonial2.default, {
	          draggable: false,
	          imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/v2/corporates-playing-ib-cricket.png',
	          alt: 'Corporates playing iB Cricket',
	          fillHeight: true
	        }),
	        secondChildComponent: _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	          firstChildComponentWidth: '49.0835%',
	          secondChildComponentWidth: '49.0835%',
	          firstChildComponent: _react2.default.createElement(_MediaAndTextComponent2.default, {
	            altText: 'iB Cricket Arcade - Fun and Gaming with friends',
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/youngsters-play-iB-Cricket.png',
	            textTestimonialHeadingWithoutH2: 'A Game Changer',
	            textTestimonialContent: 'Every aspect is very captivating.I see a lot of potential for iB Cricket. It will be a game changer in entertainment.',
	            ImageCustomWidth: '36.3137%',
	            TextTestimonialCustomWidth: '59.7674%',
	            fillHeight: true,
	            alignRowReverse: true
	          }),
	          secondChildComponent: _react2.default.createElement(_ImageTestimonial2.default, {
	            draggable: false,
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/students-playing.png',
	            alt: 'Students playing iB Cricket',
	            fillHeight: true
	          })
	        })
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DesktopTestimonialSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.DesktopTestimonialSectionContainer,
	      null,
	      this.renderFirstRow(),
	      this.renderSecondRow(),
	      this.renderThirdRow(),
	      this.renderFourthRow()
	    );
	  };
	
	  return DesktopTestimonialSection;
	}(_react.Component);
	
	exports.default = DesktopTestimonialSection;
	module.exports = exports['default'];

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DesktopTestimonialSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DesktopTestimonialSectionContainer = /*#__PURE__*/exports.DesktopTestimonialSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e14or0au0'
	})(); /**
	       * 
	       * @author: VaraKumar
	       */

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MediaAndTextComponent = __webpack_require__(128);
	
	var _MediaAndTextComponent2 = _interopRequireDefault(_MediaAndTextComponent);
	
	var _ImageTestimonial = __webpack_require__(127);
	
	var _ImageTestimonial2 = _interopRequireDefault(_ImageTestimonial);
	
	var _TextTestimonial = __webpack_require__(129);
	
	var _TextTestimonial2 = _interopRequireDefault(_TextTestimonial);
	
	var _VideoTestimonial = __webpack_require__(92);
	
	var _VideoTestimonial2 = _interopRequireDefault(_VideoTestimonial);
	
	var _styledComponents = __webpack_require__(410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var MobileTestimonialSection = function (_Component) {
	  _inherits(MobileTestimonialSection, _Component);
	
	  function MobileTestimonialSection() {
	    _classCallCheck(this, MobileTestimonialSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  MobileTestimonialSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.MobileTestimonialSectionContainer,
	      null,
	      _react2.default.createElement(_VideoTestimonial2.default, {
	        id: 'ibCricketInPeoplesWords',
	        thumbnailUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/people-about-ibcricket.png',
	        videoAltText: 'The Crazy experience of Virtual reality Cricket - iB Cricket Video',
	        videoId: '0xDt7sc9SS4'
	      }),
	      _react2.default.createElement(_ImageTestimonial2.default, {
	        draggable: false,
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/president-plays-cricket.png',
	        alt: 'altText'
	      }),
	      _react2.default.createElement(_TextTestimonial2.default, {
	        textTestimonialHeading: 'Shri Ram Nath Kovind',
	        textTestimonialContent: 'The President of India playing the first ball of iB Cricket',
	        fillHeight: true,
	        isDark: true
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        altText: 'iB Cricket Arcade - Fun and Gaming with friends',
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/IT-minister.webp',
	        textTestimonialHeadingWithoutH2: 'Shri Ravi Shankar Prasad',
	        textTestimonialContent: 'Union Electronics & IT Minister Shri Ravi Shankar Prasad signing and unveiling the custom-made electronic bat.'
	      }),
	      _react2.default.createElement(_ImageTestimonial2.default, {
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/v2/family-playing-ib-cricket.png',
	        alt: 'iB Cricket for Everyone'
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/actor-karthikeya-crazy-experience-with-ib-cricket.webp',
	        isVideo: true,
	        id: 'theCrazyExperienceOfVrCricketIbCricketVideo',
	        videoAltText: 'The Crazy experience of Virtual reality Cricket - iB Cricket Video',
	        videoId: 'Am8T0yHoBVQ',
	        textTestimonialHeadingWithoutH2: 'Anyone Can Enjoy',
	        textTestimonialContent: 'Equal fun for amateurs and  pros, I keep coming back to it because it\u2019s so challenging.',
	        ImageCustomWidth: '48.3%',
	        TextTestimonialCustomWidth: '48.3%'
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileKidPlaying.webp',
	        textTestimonialHeading: 'OH MY GOD!! \n What a game!',
	        textTestimonialContent: 'This is as close as you can get to playing real cricket in the stadium from your bedroom.',
	        alignRowReverse: true,
	        isDark: true,
	        ImageCustomWidth: '48.3%',
	        TextTestimonialCustomWidth: '48.3%'
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/girl-playing-ib-cricket.png',
	        textTestimonialHeading: 'Easy to adapt',
	        textTestimonialContent: 'Marvellous! I haven\'t played cricket till now, but I could very easily adapt to iB Cricket. I hit a boundary in first few balls!',
	        ImageCustomWidth: '48.3%',
	        TextTestimonialCustomWidth: '48.3%'
	      }),
	      _react2.default.createElement(_ImageTestimonial2.default, {
	        altText: '',
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/v2/corporates-playing-ib-cricket.png'
	      }),
	      _react2.default.createElement(_ImageTestimonial2.default, {
	        altText: '',
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/families-in-ib-cricket-arcade.png'
	      }),
	      _react2.default.createElement(_TextTestimonial2.default, {
	        textTestimonialHeading: 'Age is not a barrier',
	        textTestimonialContent: "Refreshing experience, I re-lived my childhood. I am thrilled to be able to play iB Cricket, I'll challenge my grandkids now.",
	        isDark: true
	      }),
	      _react2.default.createElement(_ImageTestimonial2.default, {
	        altText: 'youngsters playing iB Cricket',
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/students-plays-ibcricket.png'
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/girl-playing.png',
	        textTestimonialHeading: 'More Fun Together',
	        textTestimonialContent: 'This is the better VR Cricket game compared to everything that is out there today.',
	        ImageCustomWidth: '48.3%',
	        TextTestimonialCustomWidth: '48.3%'
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/mobile/v2/man-playing-ib-cricket.png',
	        textTestimonialHeadingWithoutH2: 'A Game Changer',
	        textTestimonialContent: 'Every aspect is very captivating.I see a lot of potential for iB Cricket. It will be a game changer in entertainment.',
	        ImageCustomWidth: '48.3%',
	        TextTestimonialCustomWidth: '48.3%',
	        alignRowReverse: true
	      })
	    );
	  };
	
	  return MobileTestimonialSection;
	}(_react.Component);
	
	exports.default = MobileTestimonialSection;
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MobileTestimonialSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileTestimonialSectionContainer = /*#__PURE__*/exports.MobileTestimonialSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1oyxh9f0'
	})('display:flex;flex-direction:column;'); /**
	                                            * 
	                                            * @author: VaraKumar
	                                            */

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(81);
	
	var _Images2 = _interopRequireDefault(_Images);
	
	var _VideoTestimonial = __webpack_require__(92);
	
	var _VideoTestimonial2 = _interopRequireDefault(_VideoTestimonial);
	
	var _AlignTwoChildrenInRow = __webpack_require__(213);
	
	var _AlignTwoChildrenInRow2 = _interopRequireDefault(_AlignTwoChildrenInRow);
	
	var _MediaAndTextComponent = __webpack_require__(128);
	
	var _MediaAndTextComponent2 = _interopRequireDefault(_MediaAndTextComponent);
	
	var _AlignTwoChildrenInColumn = __webpack_require__(212);
	
	var _AlignTwoChildrenInColumn2 = _interopRequireDefault(_AlignTwoChildrenInColumn);
	
	var _ImageTestimonial = __webpack_require__(127);
	
	var _ImageTestimonial2 = _interopRequireDefault(_ImageTestimonial);
	
	var _styledComponents = __webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TabletTestimonialSection = function (_Component) {
	  _inherits(TabletTestimonialSection, _Component);
	
	  function TabletTestimonialSection() {
	    _classCallCheck(this, TabletTestimonialSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TabletTestimonialSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.TabletTestimonialSectionContainer,
	      null,
	      _react2.default.createElement(_AlignTwoChildrenInRow2.default, {
	        firstChildComponentWidth: '49.0835%',
	        secondChildComponentWidth: '49.0835%',
	        firstChildComponent: _react2.default.createElement(_AlignTwoChildrenInColumn2.default, {
	          firstChildComponent: _react2.default.createElement(_MediaAndTextComponent2.default, {
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/ipad/kids-playing-iBCricket.png',
	            altText: 'Play iB Cricket in VR Arcade',
	            textTestimonialHeading: 'OH MY GOD!! \n What a game!',
	            textTestimonialContent: 'This is as close as you can get to playing real cricket in the stadium from your bedroom.',
	            ImageCustomWidth: '34.3137%',
	            TextTestimonialCustomWidth: '61.7674%',
	            includeBottomMargin: true
	          }),
	          secondChildComponent: _react2.default.createElement(_ImageTestimonial2.default, {
	            draggable: false,
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/ipad/v2/family-playing-ibcricket.png',
	            alt: 'iB Cricket for Everyone',
	            includeBottomMargin: true
	          })
	        }),
	        secondChildComponent: _react2.default.createElement(_VideoTestimonial2.default, {
	          id: 'ibCricketInPeoplesWords',
	          thumbnailUrl: 'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/people-about-ibcricket.png'
	          // isVideoThumbnail
	          , thumbnailVideoUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/videos/people-love-ibcricket/Rx100%2BKarthikeya-iBCricket-mobile.webm',
	          videoAltText: 'iB Cricket in People\'s Words',
	          videoId: '0xDt7sc9SS4',
	          includeBottomMargin: true
	        })
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: _Images2.default.testimonials.galleryIpadRamNathKovind,
	        textTestimonialHeading: 'Shri Ram Nath Kovind',
	        textTestimonialContent: 'The President of India playing the first ball of iB Cricket',
	        ImageCustomWidth: '48.89%',
	        TextTestimonialCustomWidth: '48.89%',
	        alignRowReverse: true,
	        isDark: true,
	        includeBottomMargin: true
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/ipad/IT-minister.png',
	        textTestimonialHeadingWithoutH2: 'Shri Ravi Shankar Prasad',
	        textTestimonialContent: 'Union Electronics & IT Minister Shri Ravi Shankar Prasad signing and unveiling the custom-made electronic bat.',
	        ImageCustomWidth: '48.89%',
	        TextTestimonialCustomWidth: '48.89%',
	        includeBottomMargin: true
	      }),
	      _react2.default.createElement(
	        _styledComponents.TabletTestimonialSectionRowBlock,
	        null,
	        _react2.default.createElement(
	          _styledComponents.TabletTestimonialSectionChild,
	          { customWidth: '61.63%' },
	          _react2.default.createElement(_MediaAndTextComponent2.default, {
	            imageUrl: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/people-love-ibc/girl-playing.png',
	            textTestimonialHeading: 'More Fun Together',
	            textTestimonialContent: 'This is the better VR Cricket game compared to everything that is out there today.',
	            ImageCustomWidth: '36.06%',
	            TextTestimonialCustomWidth: '60.34%',
	            includeBottomMargin: true
	          })
	        ),
	        _react2.default.createElement(
	          _styledComponents.TabletTestimonialSectionChild,
	          { customWidth: '36%' },
	          _react2.default.createElement(_VideoTestimonial2.default, {
	            isVideo: true,
	            thumbnailUrl: _Images2.default.testimonials.galleryIpadVIdeoThumbnailKarthikeya,
	            videoAltText: 'The Crazy experience of Virtual reality Cricket - iB Cricket Video',
	            videoId: 'Am8T0yHoBVQ',
	            includeBottomMargin: true,
	            id: 'theCrazyExperienceOfVrCricketIbCricketVideo'
	          })
	        )
	      ),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: _Images2.default.testimonials.galleryIpadSeniorsWithOurTeam,
	        textTestimonialHeading: 'Anyone Can Enjoy',
	        textTestimonialContent: 'Equal fun for amateurs and  pros, I keep coming back to it because it’s so challenging.',
	        ImageCustomWidth: '61.63%',
	        TextTestimonialCustomWidth: '36%',
	        isDark: true,
	        includeBottomMargin: true
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: _Images2.default.testimonials.galleryIpadYouthPlaying,
	        altText: 'Youth playing iB Cricket',
	        textTestimonialHeading: 'Age is not a barrier',
	        textTestimonialContent: "Refreshing experience, I re-lived my childhood. I am thrilled to be able to play iB Cricket, I'll challenge my grandkids now.",
	        ImageCustomWidth: '36%',
	        TextTestimonialCustomWidth: '61.63%',
	        alignRowReverse: true,
	        includeBottomMargin: true
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: _Images2.default.testimonials.galleryIpadManPlaying,
	        textTestimonialHeadingWithoutH2: 'A Game Changer',
	        textTestimonialContent: 'Every aspect is very captivating.I see a lot of potential for iB Cricket. It will be a game changer in entertainment.',
	        ImageCustomWidth: '48.89%',
	        TextTestimonialCustomWidth: '48.89%',
	        isDark: true,
	        includeBottomMargin: true
	      }),
	      _react2.default.createElement(_MediaAndTextComponent2.default, {
	        imageUrl: _Images2.default.testimonials.galleryIpadWomenExperiencingIbc,
	        textTestimonialHeading: 'Easy to adapt',
	        textTestimonialContent: 'Marvellous! I haven\'t played cricket till now, but I could very easily adapt to iB Cricket. I hit a boundary in first few balls!',
	        ImageCustomWidth: '48.89%',
	        TextTestimonialCustomWidth: '48.89%',
	        alignRowReverse: true,
	        includeBottomMargin: true
	      })
	    );
	  };
	
	  return TabletTestimonialSection;
	}(_react.Component);
	
	exports.default = TabletTestimonialSection;
	module.exports = exports['default'];

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TabletTestimonialSectionChild = exports.TabletTestimonialSectionRowBlock = exports.TabletTestimonialSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabletTestimonialSectionContainer = /*#__PURE__*/exports.TabletTestimonialSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1o30tk60'
	})('display:flex;flex-direction:column;'); /**
	                                            * 
	                                            * @author: VaraKumar
	                                            */
	
	var TabletTestimonialSectionRowBlock = /*#__PURE__*/exports.TabletTestimonialSectionRowBlock = (0, _reactEmotion2.default)('div', {
	  target: 'e1o30tk61'
	})('display:flex;flex-direction:row;justify-content:space-between;align-items:stretch;width:100%;');
	
	var TabletTestimonialSectionChild = /*#__PURE__*/exports.TabletTestimonialSectionChild = (0, _reactEmotion2.default)('div', {
	  target: 'e1o30tk62'
	})('width:', function (props) {
	  return props.customWidth ? props.customWidth : '50%';
	}, ';');

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlignTwoChildrenInRow = function (_Component) {
	  _inherits(AlignTwoChildrenInRow, _Component);
	
	  function AlignTwoChildrenInRow() {
	    _classCallCheck(this, AlignTwoChildrenInRow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AlignTwoChildrenInRow.prototype.render = function render() {
	    var _props = this.props,
	        firstChildComponent = _props.firstChildComponent,
	        secondChildComponent = _props.secondChildComponent,
	        excludeBottomMargin = _props.excludeBottomMargin;
	
	    return _react2.default.createElement(
	      _styledComponents.AlignTwoChildrenInColumnBlock,
	      { excludeBottomMargin: excludeBottomMargin },
	      firstChildComponent,
	      secondChildComponent
	    );
	  };
	
	  return AlignTwoChildrenInRow;
	}(_react.Component);
	
	exports.default = AlignTwoChildrenInRow;
	module.exports = exports['default'];

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AlignTwoChildrenInColumnBlock = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlignTwoChildrenInColumnBlock = /*#__PURE__*/exports.AlignTwoChildrenInColumnBlock = (0, _reactEmotion2.default)('div', {
	  target: 'e7gluwm0'
	})('display:flex;flex-direction:column;flex:1;width:100%;'); /**
	                                                              * 
	                                                              * @author: VaraKumar
	                                                              */

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(414);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var AlignTwoChildrenInRow = function (_Component) {
	  _inherits(AlignTwoChildrenInRow, _Component);
	
	  function AlignTwoChildrenInRow() {
	    _classCallCheck(this, AlignTwoChildrenInRow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AlignTwoChildrenInRow.prototype.render = function render() {
	    var _props = this.props,
	        firstChildComponent = _props.firstChildComponent,
	        firstChildComponentWidth = _props.firstChildComponentWidth,
	        secondChildComponent = _props.secondChildComponent,
	        secondChildComponentWidth = _props.secondChildComponentWidth,
	        excludeBottomMargin = _props.excludeBottomMargin;
	
	    return _react2.default.createElement(
	      _styledComponents.AlignTwoChildrenInRowRowBlock,
	      { excludeBottomMargin: excludeBottomMargin },
	      _react2.default.createElement(
	        _styledComponents.AlignTwoChildrenInRowChild,
	        { customWidth: firstChildComponentWidth },
	        firstChildComponent
	      ),
	      _react2.default.createElement(
	        _styledComponents.AlignTwoChildrenInRowChild,
	        { customWidth: secondChildComponentWidth },
	        secondChildComponent
	      )
	    );
	  };
	
	  return AlignTwoChildrenInRow;
	}(_react.Component);
	
	exports.default = AlignTwoChildrenInRow;
	module.exports = exports['default'];

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AlignTwoChildrenInRowChild = exports.AlignTwoChildrenInRowRowBlock = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 
	 * @author: VaraKumar
	 */
	
	var AlignTwoChildrenInRowRowBlock = /*#__PURE__*/exports.AlignTwoChildrenInRowRowBlock = (0, _reactEmotion2.default)('div', {
	  target: 'e1kh9d0q0'
	})('display:flex;flex-direction:row;justify-content:space-between;align-items:stretch;width:100%;', _mixins.desktop, '{padding-bottom:', function (props) {
	  return props.excludeBottomMargin ? 0 : '0.9375em';
	}, ';}');
	
	var AlignTwoChildrenInRowChild = /*#__PURE__*/exports.AlignTwoChildrenInRowChild = (0, _reactEmotion2.default)('div', {
	  target: 'e1kh9d0q1'
	})('display:flex;flex-direction:column;width:', function (props) {
	  return props.customWidth ? props.customWidth : '50%';
	}, ';');

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(415);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var FullWidthImage = function (_Component) {
	  _inherits(FullWidthImage, _Component);
	
	  function FullWidthImage() {
	    _classCallCheck(this, FullWidthImage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FullWidthImage.prototype.render = function render() {
	    var _props = this.props,
	        imageUrl = _props.imageUrl,
	        altText = _props.altText,
	        includeBottomMargin = _props.includeBottomMargin;
	
	
	    return _react2.default.createElement(
	      _styledComponents.FullWidthImageContainer,
	      { includeBottomMargin: includeBottomMargin },
	      _react2.default.createElement(_styledComponents.TestimonialImage, {
	        draggable: false,
	        className: 'lazyload',
	        dataSrc: imageUrl,
	        alt: altText
	      })
	    );
	  };
	
	  return FullWidthImage;
	}(_react.Component);
	
	exports.default = FullWidthImage;
	module.exports = exports['default'];

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TestimonialImage = exports.FullWidthImageContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullWidthImageContainer = /*#__PURE__*/exports.FullWidthImageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e9t5w3m0'
	})('display:flex;margin-bottom:', function (props) {
	  return props.includeBottomMargin ? '0.9375em' : 0;
	}, ';', _mixins.mobile, '{margin-bottom:12px;}'); /**
	                                                   * 
	                                                   * @author: VaraKumar
	                                                   */
	
	var TestimonialImage = /*#__PURE__*/exports.TestimonialImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'e9t5w3m1'
	})('width:100%;height:100%;');

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextTestimonial = __webpack_require__(129);
	
	var _TextTestimonial2 = _interopRequireDefault(_TextTestimonial);
	
	var _VideoTestimonial = __webpack_require__(92);
	
	var _VideoTestimonial2 = _interopRequireDefault(_VideoTestimonial);
	
	var _styledComponents = __webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ImageIncludedTextComponent = function (_Component) {
	  _inherits(ImageIncludedTextComponent, _Component);
	
	  function ImageIncludedTextComponent() {
	    _classCallCheck(this, ImageIncludedTextComponent);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ImageIncludedTextComponent.prototype.render = function render() {
	    var _props = this.props,
	        imageUrl = _props.imageUrl,
	        textTestimonialHeading = _props.textTestimonialHeading,
	        textTestimonialHeadingWithoutH2 = _props.textTestimonialHeadingWithoutH2,
	        textTestimonialContent = _props.textTestimonialContent,
	        ImageCustomWidth = _props.ImageCustomWidth,
	        TextTestimonialCustomWidth = _props.TextTestimonialCustomWidth,
	        alignRowReverse = _props.alignRowReverse,
	        isDark = _props.isDark,
	        isVideo = _props.isVideo,
	        videoId = _props.videoId,
	        altText = _props.altText,
	        videoAltText = _props.videoAltText,
	        isVideoThumbnail = _props.isVideoThumbnail,
	        thumbnailVideoUrl = _props.thumbnailVideoUrl,
	        includeBottomMargin = _props.includeBottomMargin,
	        id = _props.id;
	
	
	    return _react2.default.createElement(
	      _styledComponents.ImageIncludedTextComponentContainer,
	      {
	        id: id,
	        alignRowReverse: alignRowReverse,
	        includeBottomMargin: includeBottomMargin
	      },
	      isVideo ? _react2.default.createElement(
	        _styledComponents.ImageContainer,
	        { ImageCustomWidth: ImageCustomWidth },
	        _react2.default.createElement(_VideoTestimonial2.default, {
	          thumbnailUrl: imageUrl,
	          videoAltText: videoAltText,
	          videoId: videoId,
	          excludeBottomMargin: true,
	          isVideoThumbnail: isVideoThumbnail,
	          thumbnailVideoUrl: thumbnailVideoUrl
	        })
	      ) : _react2.default.createElement(
	        _styledComponents.ImageContainer,
	        { ImageCustomWidth: ImageCustomWidth },
	        _react2.default.createElement(_styledComponents.TestimonialImage, {
	          className: 'lazyload',
	          draggable: false,
	          dataSrc: imageUrl,
	          alt: altText
	        })
	      ),
	      _react2.default.createElement(
	        _styledComponents.TextTestimonialContainer,
	        {
	          TextTestimonialCustomWidth: TextTestimonialCustomWidth
	        },
	        _react2.default.createElement(_TextTestimonial2.default, {
	          textTestimonialHeading: textTestimonialHeading,
	          textTestimonialHeadingWithoutH2: textTestimonialHeadingWithoutH2,
	          textTestimonialContent: textTestimonialContent,
	          isDark: isDark,
	          excludeBottomMargin: true
	        })
	      )
	    );
	  };
	
	  return ImageIncludedTextComponent;
	}(_react.Component);
	
	exports.default = ImageIncludedTextComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TextTestimonialContainer = exports.ImageContainer = exports.TestimonialImage = exports.ImageIncludedTextComponentContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageIncludedTextComponentContainer = /*#__PURE__*/exports.ImageIncludedTextComponentContainer = (0, _reactEmotion2.default)('div', {
	  target: 'evhwg5b0'
	})('display:flex;flex-direction:', function (props) {
	  return props.alignRowReverse ? 'row-reverse' : 'row';
	}, ';justify-content:space-between;align-items:stretch;width:100%;margin-bottom:', function (props) {
	  return props.includeBottomMargin ? '0.9375em' : 0;
	}, ';', _mixins.mobile, '{margin-bottom:12px;}'); /* eslint-disable no-confusing-arrow */
	
	/**
	 * 
	 * @author: VaraKumar
	 */
	
	var TestimonialImage = /*#__PURE__*/exports.TestimonialImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'evhwg5b1'
	})('width:100%;');
	
	var ImageContainer = /*#__PURE__*/exports.ImageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'evhwg5b2'
	})('width:', function (props) {
	  return props.ImageCustomWidth ? props.ImageCustomWidth : '29.625%';
	}, ';');
	
	var TextTestimonialContainer = /*#__PURE__*/exports.TextTestimonialContainer = (0, _reactEmotion2.default)('div', {
	  target: 'evhwg5b3'
	})('width:', function (props) {
	  return props.TextTestimonialCustomWidth ? props.TextTestimonialCustomWidth : '67.812%';
	}, ';');

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Images = __webpack_require__(81);
	
	var _Images2 = _interopRequireDefault(_Images);
	
	var _styledComponents = __webpack_require__(417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TextTestimonial = function (_Component) {
	  _inherits(TextTestimonial, _Component);
	
	  function TextTestimonial(props) {
	    _classCallCheck(this, TextTestimonial);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setElementsHeights = function (containerHeight, headingHeight) {
	      _this.setState({
	        containerHeight: containerHeight,
	        headingHeight: headingHeight
	      });
	    };
	
	    _this.mouseOnHover = function () {
	      _this.setState({ onHovered: true });
	    };
	
	    _this.mouseOnLeave = function () {
	      _this.setState({ onHovered: false });
	    };
	
	    _this.captureContainerRef = function (innerRef) {
	      _this.containerRef = innerRef;
	    };
	
	    _this.captureHeadingRef = function (innerRef) {
	      _this.headingRef = innerRef;
	    };
	
	    _this.containerRef = _react2.default.createRef();
	    _this.state = {
	      containerHeight: undefined,
	      headingHeight: undefined,
	      onHovered: false
	    };
	    return _this;
	  }
	
	  TextTestimonial.prototype.componentDidMount = function componentDidMount() {
	    var containerHeight = this.containerRef.clientHeight;
	    var headingHeight = this.headingRef.clientHeight;
	    this.setElementsHeights(containerHeight, headingHeight);
	  };
	
	  TextTestimonial.prototype.render = function render() {
	    var _state = this.state,
	        containerHeight = _state.containerHeight,
	        headingHeight = _state.headingHeight,
	        onHovered = _state.onHovered;
	    var _props = this.props,
	        textTestimonialHeading = _props.textTestimonialHeading,
	        textTestimonialHeadingWithoutH2 = _props.textTestimonialHeadingWithoutH2,
	        textTestimonialContent = _props.textTestimonialContent,
	        isDark = _props.isDark,
	        excludeBottomMargin = _props.excludeBottomMargin,
	        fillHeight = _props.fillHeight;
	
	    return _react2.default.createElement(
	      _styledComponents.TextTestimonialContainerWrapper,
	      {
	        isDark: isDark,
	        excludeBottomMargin: excludeBottomMargin,
	        onMouseEnter: this.mouseOnHover,
	        onMouseLeave: this.mouseOnLeave,
	        fillHeight: fillHeight
	      },
	      _react2.default.createElement(
	        _styledComponents.TextTestimonialContainer,
	        {
	          isDark: isDark,
	          onHovered: onHovered,
	          outerElementHeight: containerHeight,
	          innerRef: this.captureContainerRef
	        },
	        !textTestimonialHeadingWithoutH2 ? _react2.default.createElement(
	          _styledComponents.Heading,
	          {
	            as: 'h2',
	            onHovered: onHovered,
	            outerElementHeight: containerHeight,
	            headingHeight: headingHeight,
	            innerRef: this.captureHeadingRef
	          },
	          textTestimonialHeading
	        ) : _react2.default.createElement(
	          _styledComponents.HeadingWithoutH2,
	          {
	            onHovered: onHovered,
	            outerElementHeight: containerHeight,
	            headingHeight: headingHeight,
	            innerRef: this.captureHeadingRef
	          },
	          textTestimonialHeadingWithoutH2
	        ),
	        _react2.default.createElement(
	          _styledComponents.TestimonialText,
	          { onHovered: onHovered },
	          textTestimonialContent
	        )
	      ),
	      _react2.default.createElement(
	        _styledComponents.TestimonialQuote,
	        null,
	        _react2.default.createElement(_styledComponents.QuoteImage, {
	          draggable: false,
	          className: 'lazyload',
	          dataSrc: _Images2.default.testimonials.galleryDesktopTestimonialQuote
	        })
	      )
	    );
	  };
	
	  return TextTestimonial;
	}(_react.Component);
	
	TextTestimonial.defaultProps = {
	  textTestimonialHeading: '',
	  textTestimonialContent: ''
	};
	exports.default = TextTestimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TestimonialText = exports.HeadingWithoutH2 = exports.Heading = exports.QuoteImage = exports.TestimonialQuote = exports.TextTestimonialContainer = exports.TextTestimonialContainerWrapper = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Din = __webpack_require__(8);
	
	var _Nort = __webpack_require__(11);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-confusing-arrow */
	
	/**
	 * 
	 * @author: VaraKumar
	 */
	
	var TextTestimonialContainerWrapper = /*#__PURE__*/exports.TextTestimonialContainerWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'esgxn3a0'
	})('overflow:hidden;position:relative;display:flex;align-items:center;background-color:', function (props) {
	  return props.isDark ? _Colors2.default.lightNavy2 : _Colors2.default.azure;
	}, ';height:', function (props) {
	  return props.fillHeight ? 'unset' : '100%';
	}, ';flex:', function (props) {
	  return props.fillHeight ? 1 : 'unset';
	}, ';', _mixins.mobile, '{margin-bottom:', function (props) {
	  return props.excludeBottomMargin ? 0 : '12px';
	}, ';}');
	
	var TextTestimonialContainer = /*#__PURE__*/exports.TextTestimonialContainer = (0, _reactEmotion2.default)('div', {
	  target: 'esgxn3a1'
	})('display:flex;flex-direction:column;justify-content:center;position:relative;background-color:', function (props) {
	  return props.isDark ? _Colors2.default.lightNavy2 : _Colors2.default.azure;
	}, ';height:100%;', _mixins.mobile, '{padding:1.429em 1.786em 1.429em 1.786em;}', _mixins.tablet, '{padding:0.625em 1.5625em 0.625em 1.5625em;}', _mixins.desktop, '{padding:0.625em 1.5625em 0.625em 1.5625em;}');
	
	// // NOTE: Below code commented to hide text animation temporarily
	// `
	//   ${lgDesktop} {
	//     height: ${props =>
	//       props.onHovered
	//         ? `${props.outerElementHeight}px`
	//         : `${props.outerElementHeight}px`};
	//     justify-content: flex-start;
	//   }
	// `
	
	var TestimonialQuote = /*#__PURE__*/exports.TestimonialQuote = (0, _reactEmotion2.default)('div', {
	  target: 'esgxn3a2'
	})('position:absolute;top:0px;', _mixins.mobile, '{right:1.429em;}', _mixins.tablet, '{right:1.25em;}', _mixins.desktop, '{right:1.25em;}');
	
	var QuoteImage = /*#__PURE__*/exports.QuoteImage = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'esgxn3a3'
	})(_mixins.mobile, '{width:4em;height:2.571em;}', _mixins.tablet, '{width:3.5em;height:2.25em;}', _mixins.desktop, '{width:3.5em;height:2.25em;}');
	
	var Heading = /*#__PURE__*/exports.Heading = (0, _reactEmotion2.default)(_Nort.Typo18VeryLightBlueTwoNBI, {
	  target: 'esgxn3a4'
	})('font-family:din-2014;font-weight:bold;font-style:italic;color:', _Colors2.default.veryLightBlueTwo, ';letter-spacing:-0.2px;margin:0;', _mixins.mobile, '{font-size:1.286em;line-height:1.22;}', _mixins.tablet, '{font-size:1.125em;line-height:1.22;}', _mixins.desktop, '{font-size:1.125em;line-height:1.22;}letter-spacing:-0.2px;');
	var HeadingWithoutH2 = /*#__PURE__*/exports.HeadingWithoutH2 = (0, _reactEmotion2.default)(_Nort.Typo18VeryLightBlueTwoNBI, {
	  target: 'esgxn3a5'
	})('font-family:din-2014;font-weight:bold;font-style:italic;color:', _Colors2.default.veryLightBlueTwo, ';letter-spacing:-0.2px;margin:0;', _mixins.mobile, '{font-size:1.286em;line-height:1.22;}', _mixins.tablet, '{font-size:1.125em;line-height:1.22;}', _mixins.desktop, '{font-size:1.125em;line-height:1.22;}');
	
	// // NOTE: Below code commented to hide text animation temporarily
	//
	// `
	//   ${lgDesktop} {
	//     padding-top: ${props =>
	//       props.onHovered
	//         ? '0'
	//         : `${(props.outerElementHeight - (props.headingHeight + 20)) / 2}px`};
	//     padding-bottom: ${props =>
	//       props.onHovered
	//         ? '0'
	//         : `${(props.outerElementHeight - (props.headingHeight + 20)) / 2}px`};
	//     transition: ${props =>
	//       props.onHovered
	//         ? 'padding-top 0.4s ease-in-out,padding-bottom 0.4s ease-in-out'
	//         : 'padding-top 0.4s ease-in-out,padding-bottom 0.4s ease-in-out'};
	//   }
	// `
	
	var TestimonialText = /*#__PURE__*/exports.TestimonialText = (0, _reactEmotion2.default)(_Din.Typo13VeryLightBlueTwoDR, {
	  target: 'esgxn3a6'
	})('font-family:din-2014;color:', _Colors2.default.veryLightBlueTwo, ';padding-top:3px;', _mixins.mobile, '{font-size:0.929em;line-height:1.46;margin-top:4px;}', _mixins.tablet, '{font-size:0.8125em;line-height:1.46;margin-top:0.692em;}');
	
	// // NOTE: Below code commented to hide text animation temporarily
	// `  ${lgDesktop} {
	//     opacity: ${props => (props.onHovered ? 1 : 0)};
	//     transition: ${props =>
	//       props.onHovered
	//         ? 'opacity 0.4s ease-in-out'
	//         : 'opacity 0.4s ease-in-out'};
	//   }
	// `

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoComponentModal = __webpack_require__(110);
	
	var _VideoComponentModal2 = _interopRequireDefault(_VideoComponentModal);
	
	var _Icons = __webpack_require__(35);
	
	var _IbcArcadeConstants = __webpack_require__(173);
	
	var _styledComponents = __webpack_require__(418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var VideoTestimonial = function (_Component) {
	  _inherits(VideoTestimonial, _Component);
	
	  function VideoTestimonial(props) {
	    _classCallCheck(this, VideoTestimonial);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.playVideo = function () {
	      // console.log('playVideo triggered')
	      _this.setState({
	        videoPlayState: true
	      });
	    };
	
	    _this.closeVideoModal = function (e) {
	      if (e) {
	        e.stopPropagation();
	      }
	      // console.log('closeVideoModal triggered')
	      _this.setState({
	        videoPlayState: false
	      });
	    };
	
	    _this.state = {
	      videoPlayState: false
	    };
	    return _this;
	  }
	
	  VideoTestimonial.prototype.render = function render() {
	    var videoPlayState = this.state.videoPlayState;
	    var _props = this.props,
	        thumbnailUrl = _props.thumbnailUrl,
	        videoId = _props.videoId,
	        excludeBottomMargin = _props.excludeBottomMargin,
	        videoAltText = _props.videoAltText,
	        isVideoThumbnail = _props.isVideoThumbnail,
	        thumbnailVideoUrl = _props.thumbnailVideoUrl,
	        id = _props.id;
	
	    return _react2.default.createElement(
	      _styledComponents.MainContainer,
	      {
	        id: id,
	        onClick: this.playVideo,
	        excludeBottomMargin: excludeBottomMargin
	      },
	      isVideoThumbnail ? _react2.default.createElement(
	        _styledComponents.ThumbnailVideo,
	        {
	          autoPlay: true,
	          muted: true,
	          loop: true,
	          poster: thumbnailUrl,
	          'data-keepplaying': true,
	          id: 'mautic-player-0',
	          className: 'videoImage'
	        },
	        _react2.default.createElement('source', { src: thumbnailVideoUrl, type: 'video/webm' })
	      ) : _react2.default.createElement(
	        _styledComponents.ThumbnailImgSection,
	        null,
	        _react2.default.createElement(_styledComponents.ThumbnailImgContainer, {
	          alt: videoAltText,
	          draggable: false,
	          dataSrc: thumbnailUrl,
	          className: 'lazyload'
	        }),
	        _react2.default.createElement(
	          _styledComponents.PlayButtonContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.IconContainer,
	            null,
	            _react2.default.createElement(_Icons.IcPlay, null)
	          ),
	          _react2.default.createElement(
	            _styledComponents.PlayButtonText,
	            null,
	            'Play\xA0Video'
	          )
	        )
	      ),
	      _react2.default.createElement(_VideoComponentModal2.default, {
	        isOpen: videoPlayState,
	        close: this.closeVideoModal,
	        videoId: videoId
	      })
	    );
	  };
	
	  return VideoTestimonial;
	}(_react.Component);
	
	VideoTestimonial.defaultProps = {
	  thumbnailUrl: '',
	  videoId: _IbcArcadeConstants.TESTIMONIALS_VIDEO_ID
	};
	
	exports.default = VideoTestimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ThumbnailVideo = exports.ThumbnailImgSection = exports.PlayButtonContainer = exports.PlayButtonText = exports.IconContainer = exports.ThumbnailImgContainer = exports.MainContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _CloudinaryS3LazyLoadedImage = __webpack_require__(10);
	
	var _CloudinaryS3LazyLoadedImage2 = _interopRequireDefault(_CloudinaryS3LazyLoadedImage);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainContainer = /*#__PURE__*/exports.MainContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e188bx4h0'
	})('display:flex;align-items:center;cursor:pointer;position:relative;width:100%;', _mixins.mobile, '{display:block;margin-bottom:', function (props) {
	  return props.excludeBottomMargin ? 0 : '12px';
	}, ';}', _mixins.tablet, '{margin-bottom:', function (props) {
	  return props.excludeBottomMargin ? 0 : ' 0.9375em';
	}, ';display:block;}', _mixins.mdDesktop, '{margin-bottom:', function (props) {
	  return props.excludeBottomMargin ? 0 : ' 0.9375em';
	}, ';display:block;}'); /**
	                         * 
	                         * @author: VaraKumar
	                         */
	
	var ThumbnailImgContainer = /*#__PURE__*/exports.ThumbnailImgContainer = (0, _reactEmotion2.default)(_CloudinaryS3LazyLoadedImage2.default, {
	  target: 'e188bx4h1'
	})('height:auto;width:100%;object-fit:cover;');
	var IconContainer = /*#__PURE__*/exports.IconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e188bx4h2'
	})('user-select:none;pointer-events:none;');
	
	var PlayButtonText = /*#__PURE__*/exports.PlayButtonText = (0, _reactEmotion2.default)(_Din.Typo13WhiteTwoDD, {
	  target: 'e188bx4h3'
	})('margin-left:10px;color:', _Colors2.default.white, ';');
	var PlayButtonContainer = /*#__PURE__*/exports.PlayButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e188bx4h4'
	})('cursor:pointer;display:flex;flex-direction:row;align-items:center;background-color:', _Colors2.default.black55, ';position:absolute;bottom:15px;right:15px;padding-left:10px;padding-right:10px;height:30px;border-radius:2px;');
	
	var ThumbnailImgSection = /*#__PURE__*/exports.ThumbnailImgSection = (0, _reactEmotion2.default)('div', {
	  target: 'e188bx4h5'
	})();
	
	var ThumbnailVideo = /*#__PURE__*/exports.ThumbnailVideo = (0, _reactEmotion2.default)('video', {
	  target: 'e188bx4h6'
	})();

/***/ }),

/***/ 2138:
/***/ (function(module, exports) {

	module.exports = {"v":"4.10.2","fr":60,"ip":0,"op":131,"w":300,"h":300,"nm":"Comp 1","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":3,"ty":"el","s":{"a":0,"k":[230.914,230.914],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.57],"y":[0]},"n":["0p833_0p833_0p57_0"],"t":0,"s":[98],"e":[0]},{"t":66}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":0,"s":[6],"e":[-360]},{"t":66}],"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.235,0.729,1,1],"ix":3},"o":{"a":0,"k":98,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-3.613,-4.145],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":66,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[230.914,230.914],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.538],"y":[1]},"o":{"x":[0.212],"y":[0.161]},"n":["0p538_1_0p212_0p161"],"t":65,"s":[0],"e":[98]},{"t":131}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":1,"k":[{"i":{"x":[0.764],"y":[0.911]},"o":{"x":[0.107],"y":[0.207]},"n":["0p764_0p911_0p107_0p207"],"t":65,"s":[0],"e":[360]},{"t":131}],"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.235,0.729,1,1],"ix":3},"o":{"a":0,"k":98,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-2.613,-4.145],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":65,"op":132,"st":65,"bm":0}]}

/***/ }),

/***/ 1214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animationData = __webpack_require__(2138);
	
	var animationData = _interopRequireWildcard(_animationData);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyWindowDependentLibrary = null;
	if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && typeof document !== 'undefined') {
	  // eslint-disable-next-line
	  MyWindowDependentLibrary = __webpack_require__(641).default;
	}
	
	var DefaultLoader = function (_PureComponent) {
	  _inherits(DefaultLoader, _PureComponent);
	
	  function DefaultLoader() {
	    _classCallCheck(this, DefaultLoader);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  DefaultLoader.prototype.render = function render() {
	    var defaultOptions = {
	      loop: true,
	      autoplay: true,
	      animationData: animationData
	    };
	    return MyWindowDependentLibrary && _react2.default.createElement(MyWindowDependentLibrary, {
	      options: defaultOptions,
	      height: 44,
	      width: 44
	    });
	  };
	
	  return DefaultLoader;
	}(_react.PureComponent);
	
	exports.default = DefaultLoader;
	module.exports = exports['default'];

/***/ }),

/***/ 1215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(1216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThumbnailImage = function (_Component) {
	  _inherits(ThumbnailImage, _Component);
	
	  function ThumbnailImage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ThumbnailImage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onPress = function () {
	      var _this$props = _this.props,
	          currentIndex = _this$props.currentIndex,
	          onPress = _this$props.onPress;
	
	      onPress(currentIndex);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ThumbnailImage.prototype.render = function render() {
	    var _props = this.props,
	        currentGalleryItem = _props.currentGalleryItem,
	        currentIndex = _props.currentIndex,
	        selectedIndex = _props.selectedIndex,
	        id = _props.id;
	    var galleryThumbnailUrl = currentGalleryItem.galleryThumbnailUrl,
	        galleryImageAltText = currentGalleryItem.galleryImageAltText;
	
	    return _react2.default.createElement(
	      _styledComponents.GalleryThumbnailImageContainer,
	      null,
	      _react2.default.createElement(_styledComponents.GalleryThumbnailImage, {
	        className: currentIndex === selectedIndex ? _styledComponents.selectedThumbnail : null,
	        src: galleryThumbnailUrl,
	        onClick: this.onPress,
	        alt: galleryImageAltText,
	        draggable: false,
	        id: id
	      })
	    );
	  };
	
	  return ThumbnailImage;
	}(_react.Component);
	
	ThumbnailImage.propTypes = {
	  currentGalleryItem: _propTypes2.default.object,
	  currentIndex: _propTypes2.default.number,
	  selectedIndex: _propTypes2.default.number,
	  onPress: _propTypes2.default.func
	};
	exports.default = ThumbnailImage;
	module.exports = exports['default'];

/***/ }),

/***/ 1216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.selectedThumbnail = exports.GalleryThumbnailImageContainer = exports.GalleryThumbnailImage = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _CloudinaryS3Image = __webpack_require__(23);
	
	var _CloudinaryS3Image2 = _interopRequireDefault(_CloudinaryS3Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GalleryThumbnailImage = /*#__PURE__*/exports.GalleryThumbnailImage = (0, _reactEmotion2.default)(_CloudinaryS3Image2.default, {
	  target: 'e166ez2s0'
	})('box-sizing:border-box;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-o-user-select:none;user-select:none;', _mixins.mobile, '{width:2.857em;height:2.857em;}', _mixins.tablet, '{width:3.75em;}', _mixins.desktop, '{width:6.25em;}');
	var GalleryThumbnailImageContainer = /*#__PURE__*/exports.GalleryThumbnailImageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e166ez2s1'
	})(_mixins.mobile, '{width:2.857em;height:2.857em;margin-right:0.536em;margin-left:0.536em;}', _mixins.tablet, '{width:3.75em;height:3.75em;margin-right:0.75em;}', _mixins.desktop, '{width:6.25em;height:6.25em;margin-right:0.4063em;margin-left:0.4063em;}');
	
	var selectedThumbnail = /*#__PURE__*/exports.selectedThumbnail = (0, _reactEmotion.css)('border:0.125em solid #fff;');

/***/ }),

/***/ 1217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCustomScrollbars = __webpack_require__(2345);
	
	var _ThumbnailImage = __webpack_require__(1215);
	
	var _ThumbnailImage2 = _interopRequireDefault(_ThumbnailImage);
	
	__webpack_require__(2261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThumbnailStrip = function (_Component) {
	  _inherits(ThumbnailStrip, _Component);
	
	  function ThumbnailStrip() {
	    _classCallCheck(this, ThumbnailStrip);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ThumbnailStrip.prototype.render = function render() {
	    var _props = this.props,
	        arcadeGalleryData = _props.arcadeGalleryData,
	        selectedIndex = _props.selectedIndex,
	        onPress = _props.onPress;
	
	    return _react2.default.createElement(
	      _reactCustomScrollbars.Scrollbars,
	      {
	        style: {
	          overflow: 'initial'
	        },
	        renderView: function renderView(props) {
	          return _react2.default.createElement('div', _extends({}, props, { className: 'scrollBarView' }));
	        },
	        renderThumbHorizontal: function renderThumbHorizontal(props) {
	          return _react2.default.createElement('div', _extends({}, props, { className: 'scrollBarViewThumbHorizontal' }));
	        }
	      },
	      arcadeGalleryData.map(function (eachGalleryItem, index) {
	        var galleryID = eachGalleryItem.galleryImageAltText.split(' ').join('');
	        return _react2.default.createElement(_ThumbnailImage2.default, {
	          onPress: onPress,
	          currentGalleryItem: eachGalleryItem,
	          selectedIndex: selectedIndex,
	          currentIndex: index,
	          arcadeGalleryData: arcadeGalleryData,
	          id: '' + galleryID
	        });
	      })
	    );
	  };
	
	  return ThumbnailStrip;
	}(_react.Component);
	
	exports.default = ThumbnailStrip;
	module.exports = exports['default'];

/***/ }),

/***/ 2261:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MobileMediaQuery = __webpack_require__(304);
	
	var _MobileMediaQuery2 = _interopRequireDefault(_MobileMediaQuery);
	
	var _AboveTabletMediaQuery = __webpack_require__(303);
	
	var _AboveTabletMediaQuery2 = _interopRequireDefault(_AboveTabletMediaQuery);
	
	var _ThumbnailStrip = __webpack_require__(1217);
	
	var _ThumbnailStrip2 = _interopRequireDefault(_ThumbnailStrip);
	
	var _styledComponents = __webpack_require__(1219);
	
	__webpack_require__(2262);
	
	var _DefaultLoader = __webpack_require__(1214);
	
	var _DefaultLoader2 = _interopRequireDefault(_DefaultLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArcadeGallery = function (_Component) {
	  _inherits(ArcadeGallery, _Component);
	
	  function ArcadeGallery(props) {
	    _classCallCheck(this, ArcadeGallery);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onPress = function (index) {
	      var selectedIndex = _this.state.selectedIndex;
	
	      if (selectedIndex !== index) {
	        _this.setState({ selectedIndex: index, isImageLoaded: false });
	      }
	    };
	
	    _this.showLoader = function () {
	      var isInitialLoad = _this.state.isInitialLoad;
	
	      return !isInitialLoad ? _react2.default.createElement(
	        _styledComponents.LoaderContainer,
	        null,
	        _react2.default.createElement(_DefaultLoader2.default, null)
	      ) : null;
	    };
	
	    _this.onImageLoaded = function () {
	      _this.setState({ isImageLoaded: true, isInitialLoad: false });
	    };
	
	    _this.state = {
	      selectedIndex: 0,
	      isImageLoaded: false,
	      isInitialLoad: true
	    };
	    return _this;
	  }
	
	  ArcadeGallery.prototype.render = function render() {
	    var _props = this.props,
	        arcadeGalleryData = _props.arcadeGalleryData,
	        pagePrefix = _props.pagePrefix;
	    var _state = this.state,
	        selectedIndex = _state.selectedIndex,
	        isImageLoaded = _state.isImageLoaded;
	
	    var currentItem = arcadeGalleryData[selectedIndex];
	    return _react2.default.createElement(
	      _styledComponents.ArcadeGalleryContainer,
	      { id: 'arcade-gallery-section' },
	      _react2.default.createElement(
	        _styledComponents.GalleryImageWithLoader,
	        null,
	        !isImageLoaded && this.showLoader(),
	        _react2.default.createElement(
	          _MobileMediaQuery2.default,
	          null,
	          _react2.default.createElement(_styledComponents.GalleryImage, {
	            src: currentItem.galleryMobileImageUrl,
	            alt: currentItem.galleryImageAltText,
	            onLoad: this.onImageLoaded,
	            StopRendering: true
	          })
	        ),
	        _react2.default.createElement(
	          _AboveTabletMediaQuery2.default,
	          null,
	          _react2.default.createElement(_styledComponents.GalleryImage, {
	            src: currentItem.galleryDesktopImageUrl,
	            alt: currentItem.galleryImageAltText,
	            onLoad: this.onImageLoaded,
	            StopRendering: true
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _styledComponents.ThumbnailStripContainer,
	        null,
	        _react2.default.createElement(_ThumbnailStrip2.default, {
	          onPress: this.onPress,
	          selectedIndex: selectedIndex,
	          arcadeGalleryData: arcadeGalleryData,
	          pagePrefix: pagePrefix
	        })
	      )
	    );
	  };
	
	  return ArcadeGallery;
	}(_react.Component);
	
	exports.default = ArcadeGallery;
	module.exports = exports['default'];

/***/ }),

/***/ 2262:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GallerySkewText = exports.GallerySkewComponentContainer = exports.ArcadeNameLabelContainer = exports.LoaderContainer = exports.ThumbnailStripContainer = exports.GalleryImage = exports.GalleryImageWithLoader = exports.ArcadeGalleryContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _styledComponents = __webpack_require__(693);
	
	var _CloudinaryS3Image = __webpack_require__(23);
	
	var _CloudinaryS3Image2 = _interopRequireDefault(_CloudinaryS3Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArcadeGalleryContainer = /*#__PURE__*/exports.ArcadeGalleryContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1ytu6lz0'
	})('position:relative;', _mixins.mobile, '{font-size:14px;}', _mixins.tablet, '{font-size:16px;}', _mixins.desktop, '{font-size:16px;}');
	
	var GalleryImageWithLoader = /*#__PURE__*/exports.GalleryImageWithLoader = (0, _reactEmotion2.default)('div', {
	  target: 'e1ytu6lz1'
	})('position:relative;', _mixins.mobile, '{width:100vw;object-fit:contain;}');
	
	var GalleryImage = /*#__PURE__*/exports.GalleryImage = (0, _reactEmotion2.default)(_CloudinaryS3Image2.default, {
	  target: 'e1ytu6lz2'
	})('max-width:100%;', _mixins.mobile, '{object-fit:cover;min-height:224px;}', _mixins.tablet, '{height:480px;object-fit:cover;}', _mixins.desktop, '{width:100%;height:100%;}');
	
	var ThumbnailStripContainer = /*#__PURE__*/exports.ThumbnailStripContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1ytu6lz3'
	})();
	
	var LoaderContainer = /*#__PURE__*/exports.LoaderContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1ytu6lz4'
	})('position:absolute;display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,0.3);height:100%;width:100%;min-height:9.375em;');
	
	var ArcadeNameLabelContainer = /*#__PURE__*/exports.ArcadeNameLabelContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1ytu6lz5'
	})('width:100%;position:absolute;z-index:1;');
	
	var GallerySkewComponentContainer = /*#__PURE__*/exports.GallerySkewComponentContainer = (0, _reactEmotion2.default)(_styledComponents.SkewComponentContainer, {
	  target: 'e1ytu6lz6'
	})(_mixins.mobile, '{margin-left:0.3em;margin-top:1em;padding-left:0.4em;padding-right:0.6em;}', _mixins.tablet, '{margin-left:0.3em;margin-top:2.5em;padding-top:0.125em;padding-bottom:0.125em;}', _mixins.desktop, '{margin-left:6.625em;margin-top:4.9375em;padding-top:0.125em;padding-bottom:0.075em;}');
	
	var GallerySkewText = /*#__PURE__*/exports.GallerySkewText = (0, _reactEmotion2.default)(_styledComponents.SkewText, {
	  target: 'e1ytu6lz7'
	})('color:', _Colors2.default.black, ';font-weight:400;', _mixins.mobile, '{font-size:1em;line-height:1;}', _mixins.tablet, '{font-size:1.25em;}', _mixins.desktop, '{font-size:1.25em;}');

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContactPersonIcon = __webpack_require__(369);
	
	var _ContactPersonIcon2 = _interopRequireDefault(_ContactPersonIcon);
	
	var _SmartPhone = __webpack_require__(371);
	
	var _SmartPhone2 = _interopRequireDefault(_SmartPhone);
	
	var _ContactMembers = __webpack_require__(367);
	
	var _ContactMembers2 = _interopRequireDefault(_ContactMembers);
	
	var _Calendar = __webpack_require__(365);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _styledComponents = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable no-confusing-arrow */
	
	
	var BookingDetails = function (_React$Component) {
	  _inherits(BookingDetails, _React$Component);
	
	  function BookingDetails() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BookingDetails);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getNoOfPeopleLabel = function (noOfPeople) {
	      var castedNoOfPeople = Number(noOfPeople);
	      return castedNoOfPeople === 1 ? noOfPeople + ' member' : noOfPeople + ' members';
	    }, _this.renderPackageContent = function () {
	      var packageBooked = _this.props.packageBooked;
	
	      if (packageBooked) {
	        return _react2.default.createElement(
	          _styledComponents.Container,
	          null,
	          _react2.default.createElement(
	            _styledComponents.PackageText,
	            null,
	            'Package: ',
	            packageBooked
	          )
	        );
	      }
	      return null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BookingDetails.prototype.render = function render() {
	    var _props = this.props,
	        bookingDetailsHeading = _props.bookingDetailsHeading,
	        personName = _props.personName,
	        mobileNumber = _props.mobileNumber,
	        noOfPeople = _props.noOfPeople,
	        dateOfBooking = _props.dateOfBooking,
	        closeLightBox = _props.closeLightBox,
	        continueButtonText = _props.continueButtonText;
	
	
	    return _react2.default.createElement(
	      _styledComponents.BookingDetailsContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.BookingDetailsInnerContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents.BookingWrapper,
	          null,
	          _react2.default.createElement(
	            _styledComponents.BookingDetailsText,
	            null,
	            bookingDetailsHeading
	          ),
	          _react2.default.createElement(
	            _styledComponents.DetailsContainer,
	            null,
	            _react2.default.createElement(
	              _styledComponents.ContactNameContainer,
	              { id: 'name' },
	              _react2.default.createElement(_ContactPersonIcon2.default, null),
	              _react2.default.createElement(
	                _styledComponents.ContactText,
	                null,
	                personName
	              )
	            ),
	            _react2.default.createElement(
	              _styledComponents.MobileNumberContainer,
	              { id: 'phone-number' },
	              _react2.default.createElement(_SmartPhone2.default, null),
	              _react2.default.createElement(
	                _styledComponents.MobileText,
	                null,
	                mobileNumber
	              )
	            ),
	            _react2.default.createElement(
	              _styledComponents.ContactMembersContainer,
	              { id: 'no-of-people' },
	              _react2.default.createElement(_ContactMembers2.default, null),
	              _react2.default.createElement(
	                _styledComponents.MembersCountText,
	                null,
	                '' + this.getNoOfPeopleLabel(noOfPeople)
	              )
	            ),
	            _react2.default.createElement(
	              _styledComponents.CalendarContainer,
	              { id: 'date-of-slot' },
	              _react2.default.createElement(_Calendar2.default, null),
	              _react2.default.createElement(
	                _styledComponents.CalendarText,
	                null,
	                dateOfBooking
	              )
	            ),
	            this.renderPackageContent()
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.ContinueButtonContainer,
	          {
	            onClick: closeLightBox,
	            id: 'continue-to-website-button'
	          },
	          _react2.default.createElement(
	            _styledComponents.ContinueButtonText,
	            null,
	            continueButtonText
	          )
	        )
	      )
	    );
	  };
	
	  return BookingDetails;
	}(_react2.default.Component);
	
	exports.default = BookingDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContinueButtonContainer = exports.ContinueButtonText = exports.CalendarContainer = exports.CalendarText = exports.MembersCountText = exports.ContactMembersContainer = exports.MobileNumberContainer = exports.PackageText = exports.Container = exports.MobileText = exports.ContactText = exports.ContactNameContainer = exports.BookingDetailsText = exports.DetailsContainer = exports.BookingWrapper = exports.BookingDetailsInnerContainer = exports.BookingDetailsContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Fonts = __webpack_require__(12);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookingDetailsContainer = /*#__PURE__*/exports.BookingDetailsContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn20'
	})('font-size:16px;padding-top:3.5em;padding-bottom:1.875em;@media (min-width:320px) and (max-width:1200px){padding-top:0;}@media (min-width:1024px) and (max-width:1200px){width:26em;margin:auto;}', _mixins.mobile, '{padding-bottom:14px;}', _mixins.desktop, '{margin-right:28px;}');
	var BookingDetailsInnerContainer = /*#__PURE__*/exports.BookingDetailsInnerContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn21'
	})('font-size:16px;display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;@media (min-width:320px) and (max-width:767px){padding-left:1.875em;padding-right:1.875em;}@media (min-width:768px) and (max-width:1200px){flex-direction:row;justify-content:space-evenly;align-items:flex-start;}');
	var BookingWrapper = /*#__PURE__*/exports.BookingWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn22'
	})();
	var DetailsContainer = /*#__PURE__*/exports.DetailsContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn23'
	})();
	
	var Typo13White2RRWithArticleTag = _Fonts.Typo13White2RR.withComponent('article', {
	  target: 'etc9kn24'
	});
	var Typo14White2RRWIthArticleTag = _Fonts.Typo14White2RR.withComponent('article', {
	  target: 'etc9kn25'
	});
	var BookingDetailsText = /*#__PURE__*/exports.BookingDetailsText = (0, _reactEmotion2.default)(Typo13White2RRWithArticleTag, {
	  target: 'etc9kn26'
	})('opacity:0.5;text-align:left;padding-bottom:0.75em;@media (min-width:768px) and (max-width:1024px){padding-bottom:0.5em;}font-family:din-2014;');
	var ContactNameContainer = /*#__PURE__*/exports.ContactNameContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn27'
	})('display:flex;flex-direction:row;align-items:center;');
	var ContactText = /*#__PURE__*/exports.ContactText = (0, _reactEmotion2.default)(Typo14White2RRWIthArticleTag, {
	  target: 'etc9kn28'
	})('padding-left:0.429em;font-family:din-2014;');
	var MobileText = /*#__PURE__*/exports.MobileText = (0, _reactEmotion2.default)(Typo14White2RRWIthArticleTag, {
	  target: 'etc9kn29'
	})('padding-left:0.571em;font-family:din-2014;');
	
	var Container = /*#__PURE__*/exports.Container = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn210'
	})('display:flex;flex-direction:row;align-items:center;padding-top:0.5em;');
	
	var PackageText = /*#__PURE__*/exports.PackageText = (0, _reactEmotion2.default)(Typo14White2RRWIthArticleTag, {
	  target: 'etc9kn211'
	})('font-family:din-2014;');
	
	var MobileNumberContainer = /*#__PURE__*/exports.MobileNumberContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn212'
	})('display:flex;flex-direction:row;align-items:center;padding-top:0.5em;');
	var ContactMembersContainer = /*#__PURE__*/exports.ContactMembersContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn213'
	})('display:flex;flex-direction:row;align-items:center;padding-top:0.5em;');
	
	var MembersCountText = /*#__PURE__*/exports.MembersCountText = (0, _reactEmotion2.default)(Typo14White2RRWIthArticleTag, {
	  target: 'etc9kn214'
	})('padding-left:0.286em;font-family:din-2014;');
	var CalendarText = /*#__PURE__*/exports.CalendarText = (0, _reactEmotion2.default)(Typo14White2RRWIthArticleTag, {
	  target: 'etc9kn215'
	})('padding-left:0.5em;font-family:din-2014;');
	var CalendarContainer = /*#__PURE__*/exports.CalendarContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn216'
	})('display:flex;flex-direction:row;align-items:center;padding-top:0.5em;');
	var ContinueButtonText = /*#__PURE__*/exports.ContinueButtonText = (0, _reactEmotion2.default)(Typo14White2RRWIthArticleTag, {
	  target: 'etc9kn217'
	})('font-family:din-2014;');
	var ContinueButtonContainer = /*#__PURE__*/exports.ContinueButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'etc9kn218'
	})('user-select:none;width:12.875em;height:2.5em;border-radius:2px;background-color:', _Colors2.default.whiteTwo10, ';display:flex;cursor:pointer;flex-direction:column;justify-content:center;align-items:center;margin:auto;margin-top:1.5em;cursor:pointer;@media (min-width:320px) and (max-width:767px){margin-left:0;margin-bottom:1em;}@media (min-width:768px) and (max-width:1024px){margin:0;}@media (min-width:1024px) and (max-width:1200px){margin:0;margin-top:1.5em;}');

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(62);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _SuccessLogo = __webpack_require__(373);
	
	var _SuccessLogo2 = _interopRequireDefault(_SuccessLogo);
	
	var _styledComponents = __webpack_require__(422);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessFormMessage = function (_React$Component) {
	  _inherits(SuccessFormMessage, _React$Component);
	
	  function SuccessFormMessage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SuccessFormMessage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.queryParams = { arcades: '' }, _this.isBhowaniporePresentInQueryParams = function () {
	      return _this.queryParams.arcades === 'bhowanipore';
	    }, _this.isVrCricketBhowaniporePresentInQueryParams = function () {
	      return _this.queryParams.arcades === 'vr-cricket-bhowanipore';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // renderSuccessText = () => {
	  //   const { thankyouMessage } = this.props
	  //   if (this.isVrCricketBhowaniporePresentInQueryParams()) {
	  //     return 'We will call you shortly to have slots reserved for you.'
	  //   } else if (this.isBhowaniporePresentInQueryParams()) {
	  //     return 'You will receive a confirmation shortly'
	  //   }
	  //   return thankyouMessage
	  // }
	
	  SuccessFormMessage.prototype.render = function render() {
	    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	      this.queryParams = _queryString2.default.parse(window.location.search);
	    }
	    var _props = this.props,
	        slotId = _props.slotId,
	        thankyouWishes = _props.thankyouWishes,
	        thankyouMessage = _props.thankyouMessage;
	
	    return _react2.default.createElement(
	      _styledComponents.SuccessFormInnerContainer,
	      null,
	      _react2.default.createElement(_SuccessLogo2.default, null),
	      _react2.default.createElement(
	        _styledComponents.SuccessfulFormText,
	        null,
	        thankyouWishes,
	        _react2.default.createElement(
	          _styledComponents.SuccessfulFormInnerText,
	          { id: 'booking-id' },
	          'BOOKING ID: ' + slotId
	        )
	      ),
	      _react2.default.createElement(_styledComponents.SuccessfulFormSubText, {
	        dangerouslySetInnerHTML: {
	          __html: thankyouMessage
	        }
	      })
	    );
	  };
	
	  return SuccessFormMessage;
	}(_react2.default.Component);
	
	exports.default = SuccessFormMessage;
	module.exports = exports['default'];

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SuccessfulFormSubText = exports.SuccessfulFormInnerText = exports.SuccessfulFormText = exports.SuccessFormInnerContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Fonts = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessFormInnerContainer = /*#__PURE__*/exports.SuccessFormInnerContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1jawafm0'
	})('display:flex;flex-direction:column;justify-content:center;font-size:16px;align-items:center;padding-left:2.875em;padding-right:2.875em;padding-bottom:0;padding-top:3em;@media (min-width:768px) and (max-width:1024px){padding-left:0px;padding-right:0px;}');
	var Typo14White2RMWithArticleTag = _Fonts.Typo14White2RR.withComponent('article', {
	  target: 'e1jawafm1'
	});
	var SuccessfulFormText = /*#__PURE__*/exports.SuccessfulFormText = (0, _reactEmotion2.default)(Typo14White2RMWithArticleTag, {
	  target: 'e1jawafm2'
	})('padding-top:1.25em;text-align:center;font-family:din-2014;');
	var Typo15Tangerine3RRWithDiv = _Fonts.Typo15Tangerine3RR.withComponent('div', {
	  target: 'e1jawafm3'
	});
	var SuccessfulFormInnerText = /*#__PURE__*/exports.SuccessfulFormInnerText = (0, _reactEmotion2.default)(Typo15Tangerine3RRWithDiv, {
	  target: 'e1jawafm4'
	})('font-weight:normal;font-family:din-2014;');
	
	var Typo16White2RRWithArticleTag = _Fonts.Typo16White2RR.withComponent('article', {
	  target: 'e1jawafm5'
	});
	var SuccessfulFormSubText = /*#__PURE__*/exports.SuccessfulFormSubText = (0, _reactEmotion2.default)(Typo16White2RRWithArticleTag, {
	  target: 'e1jawafm6'
	})('text-align:center;opacity:0.9;padding-bottom:1em;padding-top:0.833em;@media (min-width:320px) and (max-width:767px){padding-bottom:1em;}font-family:din-2014;');

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(62);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _CloseModalIcon = __webpack_require__(66);
	
	var _CloseModalIcon2 = _interopRequireDefault(_CloseModalIcon);
	
	var _BookingDetails = __webpack_require__(419);
	
	var _BookingDetails2 = _interopRequireDefault(_BookingDetails);
	
	var _SuccessFormMessage = __webpack_require__(421);
	
	var _SuccessFormMessage2 = _interopRequireDefault(_SuccessFormMessage);
	
	var _styledComponents = __webpack_require__(424);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SuccessFormDesktop = function (_React$Component) {
	  _inherits(SuccessFormDesktop, _React$Component);
	
	  function SuccessFormDesktop() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SuccessFormDesktop);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.queryParams = { arcades: '' }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SuccessFormDesktop.prototype.render = function render() {
	    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	      this.queryParams = _queryString2.default.parse(window.location.search);
	    }
	    var _props = this.props,
	        closeLightBox = _props.closeLightBox,
	        closeLightBoxAndCloseMobileFormModal = _props.closeLightBoxAndCloseMobileFormModal,
	        bookingResponseData = _props.bookingResponseData,
	        bookingInfo = _props.bookingInfo,
	        amanoraSectionDetails = _props.amanoraSectionDetails;
	    var bookAnotherButtonText = bookingResponseData.bookAnotherButtonText,
	        thankYouWishes = bookingResponseData.thankYouWishes,
	        thankYouMessage = bookingResponseData.thankYouMessage,
	        bookingDetailsHeading = bookingResponseData.bookingDetailsHeading,
	        continueButtonText = bookingResponseData.continueButtonText;
	    var arcadeMapUrl = amanoraSectionDetails.arcadeMapUrl;
	
	    var GOOGLE_MAP_EMBED_URL = arcadeMapUrl + '&disable_scroll=true&t=m';
	    return _react2.default.createElement(
	      _styledComponents.Wrapper,
	      null,
	      _react2.default.createElement(
	        _styledComponents.SuccessFormDesktopContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents.SuccessfulFormDesktopSection,
	          { id: 'slot-booking-success-modal' },
	          _react2.default.createElement(
	            _styledComponents.CloseModalIconContainer,
	            {
	              onClick: closeLightBoxAndCloseMobileFormModal
	            },
	            _react2.default.createElement(_CloseModalIcon2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_SuccessFormMessage2.default, {
	              slotId: bookingInfo.slotId,
	              thankyouWishes: thankYouWishes,
	              thankyouMessage: thankYouMessage
	            }),
	            _react2.default.createElement(
	              _styledComponents.BookAnotherDesktopButtonContainer,
	              {
	                onClick: closeLightBox,
	                id: 'book-another'
	              },
	              _react2.default.createElement(
	                _styledComponents.BookAnotherText,
	                null,
	                bookAnotherButtonText
	              ),
	              _react2.default.createElement(_styledComponents.BookAnotherArrowIcon, null)
	            )
	          ),
	          _react2.default.createElement(_styledComponents.VerticalLine, null),
	          _react2.default.createElement(_BookingDetails2.default, {
	            bookingResponseData: bookingResponseData,
	            closeLightBox: closeLightBoxAndCloseMobileFormModal,
	            bookingDetailsHeading: bookingDetailsHeading,
	            continueButtonText: continueButtonText,
	            personName: bookingInfo.name,
	            mobileNumber: bookingInfo.mobileNumber,
	            noOfPeople: bookingInfo.noOfPeople,
	            packageBooked: bookingInfo.package,
	            dateOfBooking: bookingInfo.dateOfBooking !== '' && (this.queryParams.arcades === 'bhowanipore' ? bookingInfo.dateOfBooking.format('DD MM YYYY, h:mm a') : bookingInfo.dateOfBooking.format('DD MM YYYY'))
	          }),
	          _react2.default.createElement(_styledComponents.MapBackground, {
	            title: 'Amanora mall',
	            src: GOOGLE_MAP_EMBED_URL,
	            frameBorder: 0,
	            marginHeight: 0,
	            marginWidth: 0
	          })
	        )
	      )
	    );
	  };
	
	  return SuccessFormDesktop;
	}(_react2.default.Component);
	
	exports.default = SuccessFormDesktop;
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BaseModalContainer = __webpack_require__(203);
	
	var _BaseModalContainer2 = _interopRequireDefault(_BaseModalContainer);
	
	var _styles = __webpack_require__(425);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _indexDesktop = __webpack_require__(423);
	
	var _indexDesktop2 = _interopRequireDefault(_indexDesktop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookingResponseMessage = function (_React$Component) {
	  _inherits(BookingResponseMessage, _React$Component);
	
	  function BookingResponseMessage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BookingResponseMessage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.closeLightbox = function () {
	      var closeLightBoxCallBack = _this.props.closeLightBoxCallBack;
	
	      _this.closeModal();
	      document.body.style.overflowY = 'scroll';
	      closeLightBoxCallBack();
	    }, _this.closeLightBoxAndCloseMobileFormModal = function () {
	      var closeMobileForm = _this.props.closeMobileForm;
	
	      _this.closeLightbox();
	      document.body.style.overflowY = 'scroll';
	      closeMobileForm();
	    }, _this.captureModalRef = function (ref) {
	      if (ref) {
	        _this.modalRef = ref;
	      }
	    }, _this.openModal = function () {
	      if (_this.modalRef) {
	        _this.modalRef.openModal();
	        document.body.style.overflowY = 'hidden';
	      }
	    }, _this.closeModal = function () {
	      if (_this.modalRef) {
	        _this.modalRef.closeModal();
	      }
	      document.body.style.overflowY = 'scroll';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BookingResponseMessage.prototype.render = function render() {
	    var _props = this.props,
	        amanoraSectionDetails = _props.amanoraSectionDetails,
	        bookingResponseData = _props.bookingResponseData,
	        bookingInfo = _props.bookingInfo,
	        pagePrefix = _props.pagePrefix;
	
	    return _react2.default.createElement(
	      _BaseModalContainer2.default,
	      {
	        ref: this.captureModalRef,
	        hideCloseIcon: true,
	        style: _styles2.default
	      },
	      _react2.default.createElement(_indexDesktop2.default, {
	        closeLightBox: this.closeLightbox,
	        amanoraSectionDetails: amanoraSectionDetails,
	        bookingResponseData: bookingResponseData,
	        bookingInfo: bookingInfo,
	        closeLightBoxAndCloseMobileFormModal: this.closeLightBoxAndCloseMobileFormModal,
	        pagePrefix: pagePrefix
	      })
	    );
	  };
	
	  return BookingResponseMessage;
	}(_react2.default.Component);
	
	BookingResponseMessage.defaultProps = {
	  closeLightBoxCallBack: function closeLightBoxCallBack() {},
	  closeMobileForm: function closeMobileForm() {}
	};
	exports.default = BookingResponseMessage;
	module.exports = exports['default'];

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BookAnotherArrowIcon = exports.MapBackground = exports.ContinueButtonContainer = exports.ContinueButtonText = exports.CloseModalIconContainer = exports.VerticalLine = exports.ModalButtonContainer = exports.ModalButtonText = exports.BookAnotherText = exports.BookAnotherDesktopButtonContainer = exports.BookAnotherButtonContainer = exports.HorizontalLine = exports.SuccessfulFormDesktopSection = exports.SuccessfulFormSection = exports.SuccessFormDesktopContainer = exports.Wrapper = exports.SuccessFormMobileContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _Fonts = __webpack_require__(12);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _BookAnotherArrow = __webpack_require__(442);
	
	var _BookAnotherArrow2 = _interopRequireDefault(_BookAnotherArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessFormMobileContainer = /*#__PURE__*/exports.SuccessFormMobileContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'elv1srf0'
	})('margin-top:15%;display:none;');
	
	var Wrapper = /*#__PURE__*/exports.Wrapper = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf1'
	})('display:flex;flex-direction:row;position:fixed;top:0px;right:0px;left:0px;bottom:0px;z-index:100;background:', _Colors2.default.darkTwoDefault, ';overflow:auto;');
	var SuccessFormDesktopContainer = /*#__PURE__*/exports.SuccessFormDesktopContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'elv1srf2'
	})('@media (min-width:320px) and (max-width:1200px){padding-left:0.5em;padding-right:0.5em;}@media (min-width:768px) and (max-width:1200px){max-width:35.8125em;}');
	
	var SuccessfulFormSection = /*#__PURE__*/exports.SuccessfulFormSection = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf3'
	})('background-color:', _Colors2.default.blackTwo, ';padding-top:1.875em;padding-bottom:1.875em;display:flex;flex-direction:column;justify-content:center;position:relative;');
	var SuccessfulFormDesktopSection = /*#__PURE__*/exports.SuccessfulFormDesktopSection = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf4'
	})('background-color:', _Colors2.default.blackDefault, ';display:flex;flex-direction:row;justify-content:space-evenly;position:relative;margin-top:18%;@media (min-width:320px) and (max-width:1200px){flex-direction:column;margin-bottom:5.214em;}');
	
	var HorizontalLine = /*#__PURE__*/exports.HorizontalLine = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf5'
	})('width:20em;height:1px;opacity:0.1;background-color:', _Colors2.default.gainsBoro, ';');
	
	var BookAnotherButtonContainer = /*#__PURE__*/exports.BookAnotherButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf6'
	})('display:flex;flex-direction:row;align-items:center;justify-content:center;cursor:pointer;padding-top:1.5em;padding-bottom:1.5em;');
	var BookAnotherDesktopButtonContainer = /*#__PURE__*/exports.BookAnotherDesktopButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf7'
	})('user-select:none;display:flex;flex-direction:row;align-items:center;justify-content:center;cursor:pointer;padding-bottom:3.875em;@media (min-width:320px) and (max-width:767px){padding-bottom:0;}');
	var Typo14Tangerine3RMWithArticleTag = _Fonts.Typo14Tangerine3RM.withComponent('article', {
	  target: 'elv1srf8'
	});
	var BookAnotherText = /*#__PURE__*/exports.BookAnotherText = (0, _reactEmotion2.default)(Typo14Tangerine3RMWithArticleTag, {
	  target: 'elv1srf9'
	})('padding-right:0.714em;font-family:din-2014;');
	var ModalButtonText = /*#__PURE__*/exports.ModalButtonText = (0, _reactEmotion2.default)('article', {
	  target: 'elv1srf10'
	})('font-family:din-2014;font-size:0.875em;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:', _Colors2.default.whiteTwo, ';');
	var ModalButtonContainer = /*#__PURE__*/exports.ModalButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf11'
	})('width:12.875em;height:2.5em;border-radius:2px;display:flex;flex-direction:column;justify-content:center;align-items:center;margin:auto;background-color:', _Colors2.default.tangerineThree, ';cursor:pointer;margin-top:1.25em;margin-bottom:1.25em;');
	var VerticalLine = /*#__PURE__*/exports.VerticalLine = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf12'
	})('width:0.2em;height:17em;opacity:0.15;background-color:', _Colors2.default.whiteTwo, ';margin-top:1.875em;margin-right:2.875em;@media (min-width:320px) and (max-width:767px){width:90%;height:1px;opacity:0.1;background-color:', _Colors2.default.gainsBoro, ';margin-bottom:1.875em;margin-left:auto;margin-right:auto;}@media (min-width:768px) and (max-width:1200px){width:31.5em;height:1px;opacity:0.15;background-color:', _Colors2.default.whiteTwo, ';margin:auto;margin-top:1.25em;margin-bottom:2.5em;}');
	var CloseModalIconContainer = /*#__PURE__*/exports.CloseModalIconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf13'
	})('position:absolute;top:-5%;right:-1%;cursor:pointer;z-index:10;@media (min-width:320px) and (max-width:1200px){top:-2%;right:-2%;}');
	var Typo14White2RRWIthArticleTag = _Fonts.Typo14White2RR.withComponent('article', {
	  target: 'elv1srf14'
	});
	var ContinueButtonText = /*#__PURE__*/exports.ContinueButtonText = (0, _reactEmotion2.default)(Typo14White2RRWIthArticleTag, {
	  target: 'elv1srf15'
	})('font-family:din-2014;');
	var ContinueButtonContainer = /*#__PURE__*/exports.ContinueButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'elv1srf16'
	})('width:12.875em;height:2.5em;border-radius:2px;background-color:rgb(255,255,255,0.1);display:flex;flex-direction:column;justify-content:center;align-items:center;margin:auto;margin-top:1.5em;cursor:pointer;');
	
	var MapBackground = /*#__PURE__*/exports.MapBackground = (0, _reactEmotion2.default)('iframe', {
	  target: 'elv1srf17'
	})('width:auto;height:auto;margin:12px;', _mixins.mobile, '{width:auto;height:320px;margin:0px;}', _mixins.tablet, '{width:auto;height:213px;margin:0px;}', _mixins.desktop, '{min-width:425px;}@media screen and (width:1024px) and (orientation:landscape){min-height:400px;}');
	var BookAnotherArrowIcon = /*#__PURE__*/exports.BookAnotherArrowIcon = (0, _reactEmotion2.default)(_BookAnotherArrow2.default, {
	  target: 'elv1srf18'
	})('display:flex;');

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Metrics = __webpack_require__(464);
	
	var styles = {
	  overlay: {
	    position: 'none',
	    backgroundColor: 'none'
	  },
	  content: {
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    margin: 'auto',
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    background: 'none',
	    border: 'none',
	    padding: 0,
	    zIndex: _Metrics.SLOT_BOOKING_SUCCESS_RESPONSE_MODAL_Z_INDEX,
	    position: 'fixed'
	  }
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonComponent = function (_React$Component) {
	  _inherits(ButtonComponent, _React$Component);
	
	  function ButtonComponent() {
	    _classCallCheck(this, ButtonComponent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonComponent.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className;
	
	    var type = typeof children;
	    if (type === 'string') {
	      return _react2.default.createElement(
	        _styledComponents.ButtonContainer,
	        { className: className },
	        _react2.default.createElement(
	          _styledComponents.ButtonText,
	          null,
	          children
	        )
	      );
	    }
	    return _react2.default.createElement(
	      _styledComponents.ButtonContainer,
	      { className: className },
	      children
	    );
	  };
	
	  return ButtonComponent;
	}(_react2.default.Component);
	
	exports.default = ButtonComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonText = exports.ButtonContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Din = __webpack_require__(8);
	
	var _Button = __webpack_require__(292);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonContainer = /*#__PURE__*/exports.ButtonContainer = (0, _reactEmotion2.default)(_Button2.default, {
	  target: 'e18v0new0'
	})('border-radius:0.125em;background-color:', _Colors2.default.tangerineThree, ';padding:0.875em 2.5em;border:none;@media (max-width:767px){font-size:1em;padding:1em 2.857em;border-radius:0.143em;}');
	
	var ButtonText = /*#__PURE__*/exports.ButtonText = (0, _reactEmotion2.default)(_Din.BaseDinDemi, {
	  target: 'e18v0new1'
	})('font-size:0.875em;line-height:normal;letter-spacing:normal;color:', _Colors2.default.whiteTwo, ';margin-right:0.625em;@media (max-width:767px){font-size:1em;margin-right:0.714em;}');

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonTextWithIcon = function (_React$Component) {
	  _inherits(ButtonTextWithIcon, _React$Component);
	
	  function ButtonTextWithIcon() {
	    _classCallCheck(this, ButtonTextWithIcon);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonTextWithIcon.prototype.render = function render() {
	    var _props = this.props,
	        text = _props.text,
	        href = _props.href;
	
	    return _react2.default.createElement(
	      _styledComponents.ButtonTextWithIconContainer,
	      { href: href, target: '_blank' },
	      _react2.default.createElement(_styledComponents.ButtonText, { dangerouslySetInnerHTML: { __html: text } }),
	      _react2.default.createElement(_styledComponents.ArrowIcon, null)
	    );
	  };
	
	  return ButtonTextWithIcon;
	}(_react2.default.Component);
	
	exports.default = ButtonTextWithIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ArrowIcon = exports.ButtonText = exports.ButtonTextWithIconContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _IcChevronRight = __webpack_require__(200);
	
	var _Din = __webpack_require__(8);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonTextWithIconContainer = /*#__PURE__*/exports.ButtonTextWithIconContainer = (0, _reactEmotion2.default)('a', {
	  target: 'eks4unz0'
	})('display:flex;align-items:baseline;justify-content:center;pointer-events:none;');
	
	var ButtonText = /*#__PURE__*/exports.ButtonText = (0, _reactEmotion2.default)(_Din.BaseDinDemi, {
	  target: 'eks4unz1'
	})('font-size:0.875em;line-height:normal;letter-spacing:normal;color:', _Colors2.default.whiteTwo, ';margin-right:0.625em;@media (max-width:767px){font-size:14px;margin-right:0.714em;}');
	
	var ArrowIcon = /*#__PURE__*/exports.ArrowIcon = (0, _reactEmotion2.default)(_IcChevronRight.IcChevronRight, {
	  target: 'eks4unz2'
	})('display:flex;');

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(392);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _navigationUtils = __webpack_require__(16);
	
	var _styledComponents = __webpack_require__(429);
	
	var _styles = __webpack_require__(430);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormDropdown = function (_Component) {
	  _inherits(FormDropdown, _Component);
	
	  function FormDropdown(props) {
	    _classCallCheck(this, FormDropdown);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setError = function (error) {
	      _this.setState({ errorMsg: error });
	    };
	
	    _this.setDisplayError = function (displayError) {
	      _this.setState({ displayError: displayError });
	    };
	
	    _this.validate = function (response) {
	      if (response.displayError) {
	        _this.setError(response.errorMsg);
	      }
	      _this.setDisplayError(response.displayError);
	    };
	
	    _this.reset = function () {
	      _this.setState({
	        dropdownValue: _this.props.dropdownOptions[0],
	        dropdownExpanded: false,
	        displayError: false,
	        errorMsg: 'Please select option'
	      });
	    };
	
	    _this.validateDropDownValue = function () {
	      var _this$props = _this.props,
	          validationEnabled = _this$props.validationEnabled,
	          validate = _this$props.validate;
	      var dropdownValue = _this.state.dropdownValue;
	
	      if (validationEnabled) {
	        if (validate) {
	          _this.validate(validate(dropdownValue));
	        }
	      }
	    };
	
	    _this.setSelectedValue = function (dropdownOption) {
	      _this.setState({ dropdownValue: dropdownOption });
	      _this.dropdownRef.instanceRef.toggleDropDown();
	      _this.validateDropDownValue();
	    };
	
	    _this.renderDropDownButtonComponent = function () {
	      var _this$state = _this.state,
	          dropdownValue = _this$state.dropdownValue,
	          dropdownExpanded = _this$state.dropdownExpanded;
	      var _this$props2 = _this.props,
	          dropdownPlaceholder = _this$props2.dropdownPlaceholder,
	          isMobile = _this$props2.isMobile,
	          renderLeftIcon = _this$props2.renderLeftIcon,
	          isBhowaniporePresentInQueryParams = _this$props2.isBhowaniporePresentInQueryParams;
	
	      var strokeColor = _Colors2.default.blueyGreyThree;
	      if (dropdownExpanded) {
	        strokeColor = _Colors2.default.twilightBlueTwo;
	      }
	      return _react2.default.createElement(
	        _styledComponents.DropdownButton,
	        {
	          expanded: dropdownExpanded,
	          isBhowaniporePresentInQueryParams: isBhowaniporePresentInQueryParams
	        },
	        renderLeftIcon || _react2.default.createElement(
	          _styledComponents.DropdownLeftIcon,
	          null,
	          _react2.default.createElement(_styledComponents.LeftIcon, { width: 15, height: 12, strokeColor: strokeColor })
	        ),
	        _react2.default.createElement(
	          _styledComponents.DropdownValue,
	          {
	            expanded: dropdownExpanded,
	            placeholder: dropdownValue,
	            isMobile: isMobile
	          },
	          dropdownValue || dropdownPlaceholder
	        ),
	        _react2.default.createElement(
	          _styledComponents.DropdownDownArrow,
	          null,
	          _react2.default.createElement(_styledComponents.DownArrow, { width: 10, height: 6, fillColor: '#89929f' })
	        )
	      );
	    };
	
	    _this.renderDropdownOptions = function (dropdownOptions) {
	      return dropdownOptions.map(function (dropdownOption) {
	        return _react2.default.createElement(
	          _styledComponents.DropdownText,
	          { onClick: function onClick() {
	              return _this.setSelectedValue(dropdownOption);
	            } },
	          dropdownOption
	        );
	      });
	    };
	
	    _this.setDropdownExpanded = function (dropdownExpanded) {
	      _this.setState({ dropdownExpanded: dropdownExpanded });
	    };
	
	    _this.onPressDropdown = function () {
	      (0, _navigationUtils.scrollToDesktopSBFormDropdown)();
	    };
	
	    _this.onMouseEnter = function () {
	      (0, _navigationUtils.disableScroll)();
	    };
	
	    _this.onMouseLeave = function () {
	      (0, _navigationUtils.enableScroll)();
	    };
	
	    _this.state = {
	      dropdownValue: props.dropdownOptions[0],
	      dropdownExpanded: false,
	      displayError: false,
	      errorMsg: 'Please select option'
	    };
	    return _this;
	  }
	
	  FormDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        dropdownOptions = _props.dropdownOptions,
	        dropdownLabel = _props.dropdownLabel,
	        isMobile = _props.isMobile,
	        isBhowaniporePresentInQueryParams = _props.isBhowaniporePresentInQueryParams;
	    var _state = this.state,
	        errorMsg = _state.errorMsg,
	        displayError = _state.displayError;
	
	    var dropDownOptionsLength = dropdownOptions.length;
	    return _react2.default.createElement(
	      _styledComponents.MainContainer,
	      {
	        id: this.props.id,
	        isBhowaniporePresentInQueryParams: isBhowaniporePresentInQueryParams
	      },
	      _react2.default.createElement(
	        _styledComponents.DropdownLabel,
	        {
	          id: 'dropdown_label',
	          displayError: displayError,
	          isMobile: isMobile
	        },
	        dropdownLabel
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default,
	        {
	          ref: function ref(dropdownRef) {
	            _this2.dropdownRef = dropdownRef;
	          },
	          buttonComponent: this.renderDropDownButtonComponent(),
	          getDropdownState: function getDropdownState(dropdownExpanded) {
	            _this2.setDropdownExpanded(dropdownExpanded);
	          },
	          dropdownMainContainerStyles: _styles2.default.dropdownStyles,
	          onPressDropdown: this.onPressDropdown
	        },
	        _react2.default.createElement(
	          _styledComponents.DropdownOptionsContainer,
	          {
	            className: 'custom-scroll-bar',
	            dropDownOptionsLength: dropDownOptionsLength
	          },
	          this.renderDropdownOptions(dropdownOptions)
	        )
	      ),
	      displayError ? _react2.default.createElement(
	        _styledComponents.DropdownError,
	        null,
	        errorMsg
	      ) : null
	    );
	  };
	
	  return FormDropdown;
	}(_react.Component);
	
	FormDropdown.defaultProps = {
	  dropdownOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'],
	  validationEnabled: true,
	  dropdownPlaceholder: 'Ex : 1',
	  dropdownLabel: 'No. of People',
	  isBhowaniporePresentInQueryParams: false
	};
	exports.default = FormDropdown;
	module.exports = exports['default'];

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DropdownMainDivStyles = exports.DropdownError = exports.DropdownStyles = exports.DropdownText = exports.DropdownOptionsContainer = exports.DownArrow = exports.DropdownDownArrow = exports.LeftIcon = exports.DropdownLeftIcon = exports.DropdownValue = exports.DropdownButton = exports.DropdownLabel = exports.MainContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Icons = __webpack_require__(35);
	
	var _Fonts = __webpack_require__(12);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainContainer = /*#__PURE__*/exports.MainContainer = (0, _reactEmotion2.default)('div', {
	  target: 'ew27pgh0'
	})('display:flex;flex-direction:column;@media (min-width:992px) and (max-width:1352px){flex:1;}@media (min-width:992px){flex:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? 0.8 : 1;
	}, ';min-width:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '120px' : 'auto';
	}, ';}@media (min-width:1025px) and (max-width:1352px){margin-right:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '10px' : null;
	}, ';}@media screen and (min-width:1353px){margin-right:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '25px' : null;
	}, ';}');
	
	var DropdownLabel = /*#__PURE__*/exports.DropdownLabel = (0, _reactEmotion2.default)(_Fonts.Typo13DarkGreyBlueRR, {
	  target: 'ew27pgh1'
	})('margin-bottom:3px;line-height:1.428;color:', function (props) {
	  if (props.displayError) {
	    return _Colors2.default.dullRed;
	  } else if (props.isMobile) {
	    return _Colors2.default.whiteTwo;
	  }
	  return _Colors2.default.darkGreyBlue;
	}, ';');
	
	var DropdownButton = /*#__PURE__*/exports.DropdownButton = (0, _reactEmotion2.default)('div', {
	  target: 'ew27pgh2'
	})('display:flex;width:', function (props) {
	  return props.isBhowaniporePresentInQueryParams ? '100%' : '220px';
	}, ';position:relative;border-radius:2px;background-color:', _Colors2.default.iceBlue, ';border:solid 1px\n    ', function (props) {
	  if (props.expanded) {
	    return _Colors2.default.lightNavyThree;
	  }
	  return _Colors2.default.lightBlueGreyThree;
	}, ';padding:8px 12px 8px 12px;@media (min-width:320px) and (max-width:991px){width:280px;}@media (min-width:992px) and (max-width:1352px){width:100%;}');
	
	var DropdownValue = /*#__PURE__*/exports.DropdownValue = (0, _reactEmotion2.default)(_Fonts.Typo14BlueyGrey3RR, {
	  target: 'ew27pgh3'
	})('opacity:', function (props) {
	  return props.expanded ? 1 : props.placeholder ? 0.9 : 0.6;
	}, ';color:', function (props) {
	  if (props.expanded) {
	    return _Colors2.default.twilightBlueTwo;
	  } else if (props.isMobile) {
	    return _Colors2.default.blueyGreyThree;
	  }
	  return _Colors2.default.charcoalGrey;
	}, ';');
	
	var DropdownLeftIcon = /*#__PURE__*/exports.DropdownLeftIcon = (0, _reactEmotion2.default)('div', {
	  target: 'ew27pgh4'
	})('margin-right:10px;user-select:none;');
	
	var LeftIcon = /*#__PURE__*/exports.LeftIcon = (0, _reactEmotion2.default)(_Icons.IcUsers, {
	  target: 'ew27pgh5'
	})('object-fit:contain;');
	
	var DropdownDownArrow = /*#__PURE__*/exports.DropdownDownArrow = (0, _reactEmotion2.default)('div', {
	  target: 'ew27pgh6'
	})('user-select:none;position:absolute;right:17px;cursor:pointer;height:20px;width:20px;display:flex;justify-content:center;align-items:center;');
	
	var DownArrow = /*#__PURE__*/exports.DownArrow = (0, _reactEmotion2.default)(_Icons.IcChevronDown, {
	  target: 'ew27pgh7'
	})('object-fit:contain;');
	
	var DropdownOptionsContainer = /*#__PURE__*/exports.DropdownOptionsContainer = (0, _reactEmotion2.default)('div', {
	  target: 'ew27pgh8'
	})('overflow-x:auto;overflow-y:scroll;margin-top:10px;padding:10px 10px 10px 10px;height:', function (props) {
	  return props.dropDownOptionsLength > 6 ? '259px' : 'auto';
	}, ';border-radius:2px;background-color:', _Colors2.default.whiteTwo, ';box-shadow:0 2px 6px 0 ', _Colors2.default.black20, ';@media (min-width:320px) and (max-width:425px){width:280px;height:', function (props) {
	  return props.dropDownOptionsLength > 4 ? '200px' : 'auto';
	}, ';}@media (min-width:426px) and (max-width:991px){width:280px;}', _mixins.desktop, '{width:220px;}');
	
	var DropdownText = /*#__PURE__*/exports.DropdownText = (0, _reactEmotion2.default)('div', {
	  target: 'ew27pgh9'
	})('cursor:pointer;font-family:din-2014;font-size:14px;color:', _Colors2.default.charcoalGrey, ';padding:12px 20px 12px 20px;&:hover{border-radius:4px;background-color:', _Colors2.default.twilightBlueTwo, ';color:', _Colors2.default.whiteTwo, ';}');
	
	var DropdownStyles = /*#__PURE__*/exports.DropdownStyles = (0, _reactEmotion.css)('z-index:10000;left:0px;right:0px;');
	
	var DropdownError = /*#__PURE__*/exports.DropdownError = (0, _reactEmotion2.default)(_Fonts.Typo12DullRedRR, {
	  target: 'ew27pgh10'
	})('margin-top:5px;');
	
	var DropdownMainDivStyles = /*#__PURE__*/exports.DropdownMainDivStyles = (0, _reactEmotion.css)('margin:0px;');

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var styles = {
	  dropdownStyles: {
	    padding: 0
	  }
	};
	
	exports.default = styles;
	module.exports = exports["default"];

/***/ }),

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixins = __webpack_require__(4);
	
	var _responsiveUtils = __webpack_require__(27);
	
	var _ButtonComponent = __webpack_require__(171);
	
	var _ButtonComponent2 = _interopRequireDefault(_ButtonComponent);
	
	var _ButtonTextWithIcon = __webpack_require__(172);
	
	var _ButtonTextWithIcon2 = _interopRequireDefault(_ButtonTextWithIcon);
	
	var _SkewComponent = __webpack_require__(692);
	
	var _SkewComponent2 = _interopRequireDefault(_SkewComponent);
	
	var _FormHomePage = __webpack_require__(108);
	
	var _FormHomePage2 = _interopRequireDefault(_FormHomePage);
	
	var _UIStore = __webpack_require__(94);
	
	var _UIStore2 = _interopRequireDefault(_UIStore);
	
	var _index = __webpack_require__(438);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(214);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _styledComponents = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable jsx-a11y/media-has-caption */
	/** the above eslint-rule says to add captions for a video tag but it is not required for muted videos */
	
	var LandingDesktop = function (_React$Component) {
	  _inherits(LandingDesktop, _React$Component);
	
	  function LandingDesktop() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LandingDesktop);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClickBookMySlot = function () {
	      if (_this.sbFormModalRef) {
	        _this.sbFormModalRef.openModal();
	      }
	    }, _this.captureSBFormModalRef = function (ref) {
	      var captureFormMobileRef = _this.props.captureFormMobileRef;
	
	      if (ref) {
	        _this.sbFormModalRef = ref;
	        captureFormMobileRef(ref);
	        _UIStore2.default.setMobileSBFormModalRef(ref);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LandingDesktop.prototype.render = function render() {
	    var _props = this.props,
	        onFormSubmitSuccess = _props.onFormSubmitSuccess,
	        onClickBookMySlot = _props.onClickBookMySlot,
	        captureFormDesktopRef = _props.captureFormDesktopRef,
	        landingPageDetails = _props.landingPageDetails,
	        priceCardsData = _props.priceCardsData,
	        openTnCModal = _props.openTnCModal,
	        videoUrl = _props.videoUrl,
	        videoType = _props.videoType,
	        termsAndConditionsData = _props.termsAndConditionsData,
	        captureFormMobileRef = _props.captureFormMobileRef,
	        slotIdPrefix = _props.slotIdPrefix,
	        arcadeFormMauticID = _props.arcadeFormMauticID,
	        arcadeCity = _props.arcadeCity,
	        pagePrefix = _props.pagePrefix,
	        excludeDates = _props.excludeDates,
	        isOnePlusOneOfferPresentInPriceCards = _props.isOnePlusOneOfferPresentInPriceCards;
	    // const { priceCardsDesktopImagesList } = priceCardsData
	
	    var landingPageDetailsObject = landingPageDetails;
	    return _react2.default.createElement(
	      _styledComponents.DesktopContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.DesktopSectionContainer,
	        { priceCardsData: priceCardsData },
	        _react2.default.createElement(
	          _styledComponents.VideoSectionContainer,
	          null,
	          _mixins.tablet ? _react2.default.createElement(
	            'video',
	            {
	              playsInline: true,
	              muted: true,
	              autoPlay: true,
	              loop: true,
	              poster: landingPageDetailsObject.tabletvideoposter,
	              'data-keepplaying': true,
	              id: 'mautic-player-0'
	            },
	            _react2.default.createElement('source', { src: videoUrl, type: videoType })
	          ) : _react2.default.createElement(
	            'video',
	            {
	              playsInline: true,
	              muted: true,
	              autoPlay: true,
	              loop: true,
	              poster: landingPageDetailsObject.desktopvideoposter,
	              'data-keepplaying': true,
	              id: 'mautic-player-0'
	            },
	            _react2.default.createElement('source', { src: videoUrl, type: videoType })
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.ContentandFormWrapper,
	          null,
	          _responsiveUtils.isTabletDesktopDevice ? _react2.default.createElement(
	            _styledComponents.ContentContainer,
	            null,
	            _react2.default.createElement(_styledComponents.DesktopIbcLogo, {
	              src: landingPageDetailsObject.logoimageurl,
	              alt: 'iB Cricket Logo'
	            }),
	            _react2.default.createElement(
	              _styledComponents.TextContainer,
	              null,
	              landingPageDetailsObject.heading !== '' && _react2.default.createElement(
	                _styledComponents.DesktopHeading,
	                { as: 'div' },
	                landingPageDetailsObject.heading
	              ),
	              _react2.default.createElement(
	                _styledComponents.DescriptionWrapper,
	                null,
	                _react2.default.createElement(_styledComponents.DesktopDescription, {
	                  dangerouslySetInnerHTML: {
	                    __html: landingPageDetailsObject.desktopdescription
	                  },
	                  as: 'h1'
	                }),
	                _react2.default.createElement(_styledComponents.NowatContent, {
	                  dangerouslySetInnerHTML: {
	                    __html: landingPageDetailsObject.nowatcontent
	                  }
	                }),
	                '\xA0\xA0',
	                _react2.default.createElement(_SkewComponent2.default, {
	                  innerText: landingPageDetailsObject.skewsectioncontent
	                }),
	                _react2.default.createElement(
	                  _styledComponents.TabletButtonWrapper,
	                  {
	                    id: 'book-now-button',
	                    onClick: onClickBookMySlot
	                  },
	                  _react2.default.createElement(
	                    _ButtonComponent2.default,
	                    null,
	                    _react2.default.createElement(_ButtonTextWithIcon2.default, {
	                      text: landingPageDetailsObject.buttontext
	                    })
	                  )
	                )
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            _styledComponents.TabletPriceCardContainer,
	            null,
	            priceCardsData && _react2.default.createElement(_index4.default, {
	              ref: this.captureLandingMobileRef,
	              captureFormMobileRef: captureFormMobileRef,
	              onFormSubmitSuccess: onFormSubmitSuccess,
	              termsAndConditionsData: termsAndConditionsData,
	              priceCardsData: priceCardsData
	            })
	          ),
	          _react2.default.createElement(
	            _styledComponents.DesktopPriceCardContainer,
	            null,
	            priceCardsData && _react2.default.createElement(_index2.default, { priceCardsData: priceCardsData })
	          ),
	          _react2.default.createElement(
	            _styledComponents.FormWrapper,
	            {
	              priceCardsData: priceCardsData,
	              id: 'scroll-to-sb-form',
	              className: 'cd-secondary-nav-container'
	            },
	            _react2.default.createElement(_FormHomePage2.default, {
	              onFormSubmitSuccess: onFormSubmitSuccess,
	              ref: captureFormDesktopRef,
	              openTnCModal: openTnCModal,
	              termsAndConditionsData: termsAndConditionsData,
	              slotIdPrefix: slotIdPrefix,
	              arcadeFormMauticID: arcadeFormMauticID,
	              arcadeCity: arcadeCity,
	              pagePrefix: pagePrefix,
	              excludeDates: excludeDates,
	              priceCardsData: priceCardsData,
	              isOnePlusOneOfferPresentInPriceCards: isOnePlusOneOfferPresentInPriceCards
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return LandingDesktop;
	}(_react2.default.Component);
	
	exports.default = LandingDesktop;
	module.exports = exports['default'];

/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateFns = __webpack_require__(117);
	
	var _AppUtils = __webpack_require__(135);
	
	var _UIStore = __webpack_require__(94);
	
	var _UIStore2 = _interopRequireDefault(_UIStore);
	
	var _BookingResponseMessage = __webpack_require__(170);
	
	var _BookingResponseMessage2 = _interopRequireDefault(_BookingResponseMessage);
	
	var _styledComponents = __webpack_require__(130);
	
	var _index = __webpack_require__(1220);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(1222);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LandingPage = function (_React$Component) {
	  _inherits(LandingPage, _React$Component);
	
	  function LandingPage(props) {
	    _classCallCheck(this, LandingPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.isPageResized = function () {
	      if (window.innerWidth > window.innerHeight && !(0, _AppUtils.isMobileDevice)()) {
	        _this.closeMobileForm();
	        _this.bookingResponseModalRef.closeModal();
	      }
	    };
	
	    _this.setFormDataState = function (formData) {
	      _this.setState({
	        formData: formData // eslint-disable-line
	      });
	    };
	
	    _this.onFormSubmitSuccess = function (formData) {
	      _this.setFormDataState(formData);
	      // open booking response modal
	      _this.openBookingResponseModal();
	    };
	
	    _this.openBookingResponseModal = function () {
	      if (_this.bookingResponseModalRef) {
	        _this.bookingResponseModalRef.openModal();
	      }
	    };
	
	    _this.captureBookingResponseModalRef = function (ref) {
	      if (ref) {
	        _this.bookingResponseModalRef = ref;
	      }
	    };
	
	    _this.captureFormDesktopRef = function (ref) {
	      if (ref) {
	        _this.formDesktopRef = ref;
	      }
	    };
	
	    _this.captureFormMobileRef = function (ref) {
	      if (ref) {
	        _this.formMobileRef = ref;
	        _UIStore2.default.captureFormMobileRef(ref);
	      }
	    };
	
	    _this.closeLightBoxCallBack = function () {
	      if (_this.formDesktopRef) {
	        _this.formDesktopRef.resetForm();
	      }
	      if (_this.formMobileRef) {
	        _this.formMobileRef.resetForm();
	      }
	    };
	
	    _this.closeMobileForm = function () {
	      if (_this.formMobileRef) {
	        _this.formMobileRef.closeModal();
	      }
	    };
	
	    _this.onClickBookMySlot = function () {
	      if (_this.formMobileRef) {
	        _this.formMobileRef.openModal();
	      }
	    };
	
	    _this.getVideoUrl = function () {
	      var landingPageDetails = _this.props.landingPageDetails;
	
	      var landingPageDetailsObject = landingPageDetails;
	      if ((0, _AppUtils.isWebmSupported)()) {
	        return {
	          mobile: landingPageDetailsObject.tabletbgvideowebm,
	          desktop: landingPageDetailsObject.desktopbgvideowebm,
	          tablet: landingPageDetailsObject.mobilebgvideowebm,
	          type: 'video/webm'
	        };
	      }
	      return {
	        mobile: landingPageDetailsObject.tabletbgvideomp4,
	        desktop: landingPageDetailsObject.desktopbgvideomp4,
	        tablet: landingPageDetailsObject.mobilebgvideomp4,
	        type: 'video/mp4'
	      };
	    };
	
	    _this.getConvertedDate = function (date) {
	      return date ? new Date(date) : null;
	    };
	
	    _this.state = {
	      formData: null // eslint-disable-line
	    };
	    return _this;
	  }
	
	  LandingPage.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('resize', this.isPageResized, false);
	  };
	
	  LandingPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _getVideoUrl = this.getVideoUrl(),
	        mobileVideoUrl = _getVideoUrl.mobile,
	        desktopVideoUrl = _getVideoUrl.desktop,
	        videoType = _getVideoUrl.type;
	
	    var _props = this.props,
	        amanoraSectionDetails = _props.amanoraSectionDetails,
	        landingPageDetails = _props.landingPageDetails,
	        priceCardsData = _props.priceCardsData,
	        termsAndConditionsData = _props.termsAndConditionsData,
	        bookingResponseData = _props.bookingResponseData,
	        pagePrefix = _props.pagePrefix,
	        isOnePlusOneOfferPresentInPriceCards = _props.isOnePlusOneOfferPresentInPriceCards;
	    var formData = this.state.formData;
	    var bookingIDPrefix = bookingResponseData.bookingIDPrefix,
	        arcadeFormMauticID = bookingResponseData.arcadeFormMauticID,
	        arcadeCity = bookingResponseData.arcadeCity,
	        arcadeClosingDate = bookingResponseData.arcadeClosingDate,
	        arcadeClosingEndDate = bookingResponseData.arcadeClosingEndDate,
	        arcadeClosedDatesList = bookingResponseData.arcadeClosedDatesList;
	
	    var excludeDates = arcadeClosedDatesList ? (0, _dateFns.eachDay)(this.getConvertedDate(arcadeClosingDate), this.getConvertedDate(arcadeClosingEndDate)).concat(arcadeClosedDatesList.split(',').map(function (date) {
	      return _this2.getConvertedDate(date);
	    })) : (0, _dateFns.eachDay)(this.getConvertedDate(arcadeClosingDate), this.getConvertedDate(arcadeClosingEndDate));
	    return _react2.default.createElement(
	      'div',
	      { id: 'arcade-landing-section' },
	      _react2.default.createElement(
	        _styledComponents.MobileContainer,
	        null,
	        _react2.default.createElement(_index4.default, {
	          ref: this.captureLandingMobileRef,
	          videoType: videoType,
	          videoUrl: mobileVideoUrl,
	          onFormSubmitSuccess: this.onFormSubmitSuccess,
	          captureFormMobileRef: this.captureFormMobileRef,
	          landingPageDetails: landingPageDetails,
	          termsAndConditionsData: termsAndConditionsData,
	          slotIdPrefix: bookingIDPrefix,
	          arcadeFormMauticID: arcadeFormMauticID,
	          arcadeCity: arcadeCity,
	          pagePrefix: pagePrefix,
	          priceCardsData: priceCardsData,
	          excludeDates: excludeDates,
	          amanoraSectionDetails: amanoraSectionDetails,
	          bookingResponseData: bookingResponseData,
	          bookingInfo: formData,
	          isOnePlusOneOfferPresentInPriceCards: isOnePlusOneOfferPresentInPriceCards
	        })
	      ),
	      _react2.default.createElement(
	        _styledComponents.DesktopContainer,
	        { className: 'cd-hero-container' },
	        _react2.default.createElement(_index2.default, {
	          videoType: videoType,
	          pagePrefix: pagePrefix,
	          videoUrl: desktopVideoUrl,
	          onClickBookMySlot: this.onClickBookMySlot,
	          onFormSubmitSuccess: this.onFormSubmitSuccess,
	          captureFormDesktopRef: this.captureFormDesktopRef,
	          captureFormMobileRef: this.captureFormMobileRef,
	          landingPageDetails: landingPageDetails,
	          termsAndConditionsData: termsAndConditionsData,
	          slotIdPrefix: bookingIDPrefix,
	          arcadeFormMauticID: arcadeFormMauticID,
	          arcadeCity: arcadeCity,
	          priceCardsData: priceCardsData,
	          excludeDates: excludeDates,
	          isOnePlusOneOfferPresentInPriceCards: isOnePlusOneOfferPresentInPriceCards
	        })
	      ),
	      _react2.default.createElement(_BookingResponseMessage2.default, {
	        amanoraSectionDetails: amanoraSectionDetails,
	        bookingResponseData: bookingResponseData,
	        bookingInfo: formData,
	        ref: this.captureBookingResponseModalRef,
	        closeLightBoxCallBack: this.closeLightBoxCallBack,
	        closeMobileForm: this.closeMobileForm,
	        pagePrefix: pagePrefix
	      })
	    );
	  };
	
	  return LandingPage;
	}(_react2.default.Component);
	
	exports.default = LandingPage;
	module.exports = exports['default'];

/***/ }),

/***/ 1222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIStore = __webpack_require__(94);
	
	var _UIStore2 = _interopRequireDefault(_UIStore);
	
	var _responsiveUtils = __webpack_require__(27);
	
	var _FormHomePage = __webpack_require__(108);
	
	var _FormHomePage2 = _interopRequireDefault(_FormHomePage);
	
	var _SkewComponent = __webpack_require__(692);
	
	var _SkewComponent2 = _interopRequireDefault(_SkewComponent);
	
	var _index = __webpack_require__(214);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MobileBookNowButton = __webpack_require__(436);
	
	var _MobileBookNowButton2 = _interopRequireDefault(_MobileBookNowButton);
	
	var _styledComponents = __webpack_require__(130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LandingMobile = function (_React$Component) {
	  _inherits(LandingMobile, _React$Component);
	
	  function LandingMobile(props) {
	    _classCallCheck(this, LandingMobile);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onReady = function (event) {
	      _this.setState({
	        player: event.target
	      });
	      _this.state.player.playVideo();
	    };
	
	    _this.pauseVideo = function () {
	      if (_this.state.player) {
	        _this.state.player.pauseVideo();
	      }
	    };
	
	    _this.onClickBookMySlot = function () {
	      if (_this.sbFormModalRef) {
	        _this.sbFormModalRef.openModal();
	      }
	    };
	
	    _this.captureSBFormModalRef = function (ref) {
	      var captureFormMobileRef = _this.props.captureFormMobileRef;
	
	      if (ref) {
	        _this.sbFormModalRef = ref;
	        captureFormMobileRef(ref);
	        _UIStore2.default.setMobileSBFormModalRef(ref);
	      }
	    };
	
	    _this.state = {
	      player: null
	    };
	    return _this;
	  }
	
	  LandingMobile.prototype.render = function render() {
	    var _props = this.props,
	        onFormSubmitSuccess = _props.onFormSubmitSuccess,
	        landingPageDetails = _props.landingPageDetails,
	        videoUrl = _props.videoUrl,
	        videoType = _props.videoType,
	        termsAndConditionsData = _props.termsAndConditionsData,
	        slotIdPrefix = _props.slotIdPrefix,
	        arcadeFormMauticID = _props.arcadeFormMauticID,
	        priceCardsData = _props.priceCardsData,
	        arcadeCity = _props.arcadeCity,
	        pagePrefix = _props.pagePrefix,
	        excludeDates = _props.excludeDates,
	        bookingResponseData = _props.bookingResponseData,
	        amanoraSectionDetails = _props.amanoraSectionDetails,
	        formData = _props.formData,
	        isOnePlusOneOfferPresentInPriceCards = _props.isOnePlusOneOfferPresentInPriceCards;
	
	    var landingPageDetailsObject = landingPageDetails;
	    return _react2.default.createElement(
	      _styledComponents.MobileSectionContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.ResponsiveContainer,
	        null,
	        _react2.default.createElement(
	          _styledComponents.VideoSectionContainer,
	          null,
	          _react2.default.createElement(
	            'video',
	            {
	              muted: true,
	              playsInline: true,
	              autoPlay: true,
	              loop: true,
	              poster: landingPageDetailsObject.mobilevideoposter,
	              'data-keepplaying': true,
	              id: 'mautic-player-0'
	            },
	            _react2.default.createElement('source', { src: videoUrl, type: videoType })
	          )
	        ),
	        (0, _responsiveUtils.isMobileDevice)() ? _react2.default.createElement(
	          _styledComponents.SectionContainer,
	          null,
	          _react2.default.createElement(_styledComponents.IBCLogo, {
	            src: landingPageDetailsObject.logoimageurl,
	            alt: 'iBC logo'
	          }),
	          _react2.default.createElement(
	            _styledComponents.HeadText,
	            { as: 'p' },
	            ' ',
	            landingPageDetailsObject.heading,
	            ' '
	          ),
	          _react2.default.createElement(
	            _styledComponents.DescriptionWrapper,
	            null,
	            _react2.default.createElement(_styledComponents.DescriptionText, {
	              dangerouslySetInnerHTML: {
	                __html: landingPageDetailsObject.mobiledescription
	              },
	              as: 'h1'
	            }),
	            '\xA0\xA0',
	            _react2.default.createElement(_styledComponents.NowatContent, {
	              dangerouslySetInnerHTML: {
	                __html: landingPageDetailsObject.nowatmobilecontent
	              }
	            }),
	            _react2.default.createElement(_SkewComponent2.default, {
	              innerText: landingPageDetailsObject.skewsectioncontent
	            })
	          )
	        ) : null
	      ),
	      priceCardsData && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_index2.default, {
	          priceCardsData: priceCardsData,
	          openSBForm: this.onClickBookMySlot
	        }),
	        _react2.default.createElement(_MobileBookNowButton2.default, {
	          termsAndConditionsData: termsAndConditionsData,
	          slotIdPrefix: slotIdPrefix,
	          arcadeFormMauticID: arcadeFormMauticID,
	          arcadeCity: arcadeCity,
	          pagePrefix: pagePrefix,
	          amanoraSectionDetails: amanoraSectionDetails,
	          bookingResponseData: bookingResponseData,
	          bookingInfo: formData,
	          id: 'open-slot-booking-form'
	        })
	      ),
	      _react2.default.createElement(_FormHomePage2.default, {
	        ref: this.captureSBFormModalRef,
	        onFormSubmitSuccess: onFormSubmitSuccess,
	        termsAndConditionsData: termsAndConditionsData,
	        slotIdPrefix: slotIdPrefix,
	        arcadeFormMauticID: arcadeFormMauticID,
	        arcadeCity: arcadeCity,
	        pagePrefix: pagePrefix,
	        priceCardsData: priceCardsData,
	        excludeDates: excludeDates,
	        isOnePlusOneOfferPresentInPriceCards: isOnePlusOneOfferPresentInPriceCards
	      })
	    );
	  };
	
	  return LandingMobile;
	}(_react2.default.Component);
	
	exports.default = LandingMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NowatContent = exports.FormWrapper = exports.ContentandFormWrapper = exports.DesktopIbcLogo = exports.DescriptionWrapper = exports.DesktopDescription = exports.DesktopHeading = exports.TextContainer = exports.ContentContainer = exports.VideoSectionContainer = exports.DesktopSectionContainer = exports.ButtonSupportText = exports.BookButton = exports.ButtonWrapper = exports.DesktopPriceCardContainer = exports.TabletPriceCardContainer = exports.TabletButtonWrapper = exports.DescriptionText = exports.HeadText = exports.IBCLogo = exports.IplLogo = exports.SectionContainer = exports.ResponsiveContainer = exports.MobileSectionContainer = exports.DesktopContainer = exports.MobileContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _CloudinaryS3Image = __webpack_require__(23);
	
	var _CloudinaryS3Image2 = _interopRequireDefault(_CloudinaryS3Image);
	
	var _Nort = __webpack_require__(11);
	
	var _Din = __webpack_require__(8);
	
	var _Images = __webpack_require__(81);
	
	var _Images2 = _interopRequireDefault(_Images);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _ButtonComponent = __webpack_require__(171);
	
	var _ButtonComponent2 = _interopRequireDefault(_ButtonComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileContainer = /*#__PURE__*/exports.MobileContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t70'
	})('background-color:', function (props) {
	  return props.iplUrl ? 'rgb(0,0,5)' : null;
	}, ';@media (min-width:768px){display:none;}');
	
	var DesktopContainer = /*#__PURE__*/exports.DesktopContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t71'
	})('@media (max-width:767px){display:none;}position:relative;');
	
	var MobileSectionContainer = /*#__PURE__*/exports.MobileSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t72'
	})('@media (max-width:767px){min-height:735px;width:auto;background:url(', _Images2.default.layers.mobileLayer, ');background-size:cover;position:relative;}');
	
	var ResponsiveContainer = /*#__PURE__*/exports.ResponsiveContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t73'
	})('@media (max-width:767px){width:88.889%;margin-left:auto;margin-right:auto;}');
	
	var SectionContainer = /*#__PURE__*/exports.SectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t74'
	})('@media (max-width:767px){display:flex;flex-direction:column;align-items:center;}');
	
	var IplLogo = /*#__PURE__*/exports.IplLogo = (0, _reactEmotion2.default)(_CloudinaryS3Image2.default, {
	  target: 'et5e0t75'
	})('@media (max-width:767px){width:100%;object-fit:contain;padding-top:50px;}');
	
	var IBCLogo = /*#__PURE__*/exports.IBCLogo = (0, _reactEmotion2.default)(_CloudinaryS3Image2.default, {
	  target: 'et5e0t76'
	})('@media (max-width:767px){width:14.286em;height:12.714em;object-fit:contain;margin-bottom:1.429em;margin-top:5.143em;}');
	
	var HeadText = /*#__PURE__*/exports.HeadText = (0, _reactEmotion2.default)(_Nort.Typo24PumpkinOrangeNBRI, {
	  target: 'et5e0t77'
	})('@media (max-width:767px){font-size:1.143em;margin-bottom:0.25em;}');
	
	var DescriptionText = /*#__PURE__*/exports.DescriptionText = (0, _reactEmotion2.default)(_Din.Typo36WhiteTwoDI, {
	  target: 'et5e0t78'
	})('@media (max-width:767px){font-size:1.429em;text-align:center;margin-bottom:0.5em;display:inline;}');
	
	var TabletButtonWrapper = /*#__PURE__*/exports.TabletButtonWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t79'
	})('display:none;@media (min-width:767px) and (max-width:991px){display:block;margin-top:1.429em;margin-bottom:80px;}');
	
	var TabletPriceCardContainer = /*#__PURE__*/exports.TabletPriceCardContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t710'
	})('display:none;@media (min-width:767px) and (max-width:1023px){display:block;}');
	
	var DesktopPriceCardContainer = /*#__PURE__*/exports.DesktopPriceCardContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t711'
	})('display:none;@media (min-width:1024px){display:block;}');
	
	var ButtonWrapper = /*#__PURE__*/exports.ButtonWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t712'
	})('@media (max-width:767px){margin-top:1.429em;margin-bottom:80px;}', _mixins.mobile, '{margin:0;margin-top:20px;}');
	
	var BookButton = /*#__PURE__*/exports.BookButton = (0, _reactEmotion2.default)(_ButtonComponent2.default, {
	  target: 'et5e0t713'
	})('width:100%;height:52px;display:flex;align-items:center;justify-content:center;pointer-events:none;', _mixins.mobile, '{width:40%;height:40px;margin-left:auto;margin-right:auto;text-transform:uppercase;padding:10px 10px;background:rgb(244,116,0);}');
	
	var ButtonSupportText = /*#__PURE__*/exports.ButtonSupportText = (0, _reactEmotion2.default)('p', {
	  target: 'et5e0t714'
	})('font-family:din-2014;font-weight:normal;font-style:normal;font-stretch:normal;opacity:0.8;font-size:13px;font-style:italic;color:#ffffff;text-align:center;position:relative;line-height:unset;padding-left:0;padding-right:0;padding-top:10px;');
	
	var DesktopSectionContainer = /*#__PURE__*/exports.DesktopSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t715'
	})('height:', function (props) {
	  return props.priceCardsData ? '134vh' : '100vh';
	}, ';display:flex;justify-content:center;align-items:center;z-index:10;', _mixins.tablet, '{height:100vh;}', (0, _mixins.customDevice)(1024, 1199), '{height:103vh;}');
	
	var VideoSectionContainer = /*#__PURE__*/exports.VideoSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t716'
	})('position:absolute;width:100%;height:100vh;top:0;left:0;z-index:-10;video{object-fit:cover;width:100%;height:calc(100vh + 33px);display:inline-block;vertical-align:baseline;', _mixins.mobile, '{min-height:130vh;padding-bottom:30px;}', _mixins.tablet, '{height:100vh;}@media (min-width:1200px){height:135vh;}}&:before{content:\'\';position:absolute;top:0;right:0;bottom:0;height:calc(100vh + 33px);left:0;', _mixins.mobile, '{height:100vh;}', _mixins.tablet, '{background:url(', _Images2.default.layers.tabletLayer, ');height:100vh;background-size:cover;}', _mixins.desktop, '{background:url(', _Images2.default.layers.desktopLayer, ');background-size:cover;}@media (min-width:1200px){height:135vh;}}');
	
	var ContentContainer = /*#__PURE__*/exports.ContentContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t717'
	})('display:flex;justify-content:center;align-items:center;@media (min-width:1200px){margin-top:200px;margin-bottom:30px;}');
	
	var TextContainer = /*#__PURE__*/exports.TextContainer = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t718'
	})('display:flex;flex-direction:column;margin-left:2.857em;');
	
	var DesktopHeading = /*#__PURE__*/exports.DesktopHeading = (0, _reactEmotion2.default)(_Nort.Typo24PumpkinOrangeNBRI, {
	  target: 'et5e0t719'
	})('letter-spacing:0.3px;margin-top:4px;');
	
	var DesktopDescription = /*#__PURE__*/exports.DesktopDescription = (0, _reactEmotion2.default)(_Din.Typo36WhiteTwoDI, {
	  target: 'et5e0t720'
	})('font-size:2.25em;line-height:1.36;letter-spacing:0.5px;color:', _Colors2.default.whiteTwo, ';display:inline;margin-top:6px;');
	
	var DescriptionWrapper = /*#__PURE__*/exports.DescriptionWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t721'
	})('@media (max-width:767px){text-align:center;margin-bottom:0.714em;}');
	
	var DesktopIbcLogo = /*#__PURE__*/exports.DesktopIbcLogo = (0, _reactEmotion2.default)(_CloudinaryS3Image2.default, {
	  target: 'et5e0t722'
	})('width:11.143em;height:10em;object-fit:contain;');
	
	var ContentandFormWrapper = /*#__PURE__*/exports.ContentandFormWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t723'
	})();
	
	var FormWrapper = /*#__PURE__*/exports.FormWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'et5e0t724'
	})('@media (max-width:767px){display:none;}', (0, _mixins.customDevice)(768, 1200), '{position:absolute;bottom:0.375em;left:0;width:100%;}@media (min-width:1200px){bottom:-4.625em;margin-top:', function (props) {
	  return props.priceCardsData ? '0' : '200px';
	}, ';}');
	
	var NowatContent = /*#__PURE__*/exports.NowatContent = (0, _reactEmotion2.default)(_Din.Typo36WhiteTwoDI, {
	  target: 'et5e0t725'
	})('font-size:2.25em;line-height:1.67;letter-spacing:-0.9px;color:', _Colors2.default.whiteTwo, ';display:inline;@media (max-width:767px){font-size:1.429em;line-height:1.5;letter-spacing:-0.5px;text-align:center;color:', _Colors2.default.whiteTwo, ';text-shadow:0 4px 8px rgba(0,0,0,0.1);margin-bottom:0.5em;}');

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(433);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapDescriptionSection = function (_Component) {
	  _inherits(MapDescriptionSection, _Component);
	
	  function MapDescriptionSection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MapDescriptionSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getTelLink = function (tel) {
	      return 'tel:' + tel;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MapDescriptionSection.prototype.render = function render() {
	    var _props = this.props,
	        amonaraSectionHeading = _props.amonaraSectionHeading,
	        amonaraSectionDescription = _props.amonaraSectionDescription,
	        addressHeading = _props.addressHeading,
	        address = _props.address,
	        landmarkHeading = _props.landmarkHeading,
	        landmark = _props.landmark,
	        contactNoHeading = _props.contactNoHeading,
	        contactNumber = _props.contactNumber,
	        isSuper30Page = _props.isSuper30Page;
	
	
	    var splitNumber = contactNumber.split(',');
	    return _react2.default.createElement(
	      _styledComponents.MapDescriptionSectionContainer,
	      { isSuper30Page: isSuper30Page },
	      _react2.default.createElement(_styledComponents.MapDescriptionSectionHeading, {
	        dangerouslySetInnerHTML: {
	          __html: amonaraSectionHeading
	        },
	        as: 'h2'
	      }),
	      _react2.default.createElement(_styledComponents.MapDescriptionSectionContent, {
	        dangerouslySetInnerHTML: {
	          __html: amonaraSectionDescription
	        },
	        as: 'p'
	      }),
	      _react2.default.createElement(
	        _styledComponents.AddressWrapper,
	        null,
	        _react2.default.createElement(
	          _styledComponents.AddressContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.AddressHeading,
	            { as: 'div' },
	            addressHeading
	          ),
	          _react2.default.createElement(
	            _styledComponents.Description,
	            { as: 'div' },
	            address
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.AddressContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.AddressHeading,
	            { as: 'div' },
	            landmarkHeading
	          ),
	          _react2.default.createElement(
	            _styledComponents.Description,
	            { as: 'div' },
	            landmark
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.AddressContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.AddressHeading,
	            { as: 'div' },
	            contactNoHeading
	          ),
	          contactNumber && _react2.default.createElement(
	            'div',
	            null,
	            contactNumber.indexOf(',') > -1 ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _styledComponents.ContactNoDescription,
	                {
	                  as: 'a',
	                  href: this.getTelLink(splitNumber[0])
	                },
	                splitNumber[0]
	              ),
	              _react2.default.createElement(
	                _styledComponents.ContactNoDescription,
	                null,
	                _react2.default.createElement(
	                  _styledComponents.ContactNoDescription,
	                  {
	                    as: 'a',
	                    href: this.getTelLink(splitNumber[1])
	                  },
	                  ',',
	                  splitNumber[1]
	                )
	              )
	            ) : _react2.default.createElement(
	              _styledComponents.ContactNoDescription,
	              null,
	              _react2.default.createElement(
	                _styledComponents.ContactNoDescription,
	                {
	                  as: 'a',
	                  href: this.getTelLink(contactNumber)
	                },
	                contactNumber
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return MapDescriptionSection;
	}(_react.Component);
	
	exports.default = MapDescriptionSection;
	module.exports = exports['default'];

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContactNoDescription = exports.AddressWrapper = exports.Description = exports.AddressHeading = exports.AddressContainer = exports.MapDescriptionSectionContent = exports.MapDescriptionSectionHeading = exports.MapDescriptionSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _Nort = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapDescriptionSectionContainer = /*#__PURE__*/exports.MapDescriptionSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e4u4z8c0'
	})('font-size:1em;display:flex;flex-direction:column;justify-content:center;', _mixins.mobile, '{font-size:1.143em;width:90%;margin-left:1.25em;margin-right:1.25em;padding-top:3.75em;padding-bottom:3.75em;}', _mixins.tablet, '{width:90%;margin:auto;padding-top:3.75em;padding-bottom:3.75em;margin-left:3em;margin-right:3em;}', (0, _mixins.customDevice)(1024, 1239), '{width:49.5%;padding-left:3.75em;padding-right:1.688em;padding-top:30px;padding-bottom:30px;min-height:', function (props) {
	  return props.isSuper30Page ? '20em' : '38em';
	}, ';}', (0, _mixins.minDeviceWidth)(1240), '{width:49.5%;padding-left:3.75em;padding-right:4.688em;padding-top:30px;padding-bottom:30px;min-height:', function (props) {
	  return props.isSuper30Page ? '20em' : '37em';
	}, ';}');
	
	var MapDescriptionSectionHeading = /*#__PURE__*/exports.MapDescriptionSectionHeading = (0, _reactEmotion2.default)(_Nort.Typo32PumpkinOrangeBNRI, {
	  target: 'e4u4z8c1'
	})('letter-spacing:0.3px;line-height:normal;margin:0px;margin-bottom:0.32em;', _mixins.mobile, '{font-size:1.625em;margin-bottom:0.385em;}');
	
	var MapDescriptionSectionContent = /*#__PURE__*/exports.MapDescriptionSectionContent = (0, _reactEmotion2.default)(_Din.Typo16VeryLightPinkDR, {
	  target: 'e4u4z8c2'
	})('letter-spacing:normal;line-height:1.56;', _mixins.mobile, '{font-size:0.875em;}');
	var AddressContainer = /*#__PURE__*/exports.AddressContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e4u4z8c3'
	})('display:flex;flex-direction:row;');
	var AddressHeading = /*#__PURE__*/exports.AddressHeading = (0, _reactEmotion2.default)(_Din.Typo15PumpkinOrangeDR, {
	  target: 'e4u4z8c4'
	})('padding-right:5px;line-height:1.56;');
	var Description = /*#__PURE__*/exports.Description = (0, _reactEmotion2.default)(_Din.Typo15VeryLightPinkDR, {
	  target: 'e4u4z8c5'
	})('line-height:1.56;');
	
	var AddressWrapper = /*#__PURE__*/exports.AddressWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e4u4z8c6'
	})('padding-top:10px;');
	
	var ContactNoDescription = /*#__PURE__*/exports.ContactNoDescription = (0, _reactEmotion2.default)(_Din.Typo15VeryLightPinkDR, {
	  target: 'e4u4z8c7'
	})('line-height:1.56;letter-spacing:0.2px;cursor:pointer;&:hover{text-decoration:none;color:', _Colors2.default.veryLightPink, ';}&:focus{text-decoration:none;color:', _Colors2.default.veryLightPink, ';}', _mixins.mobile, '{line-height:20px;}');

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapDescriptionSection = __webpack_require__(432);
	
	var _MapDescriptionSection2 = _interopRequireDefault(_MapDescriptionSection);
	
	var _styledComponents = __webpack_require__(435);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapSection = function (_Component) {
	  _inherits(MapSection, _Component);
	
	  function MapSection() {
	    _classCallCheck(this, MapSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  MapSection.prototype.render = function render() {
	    var _props = this.props,
	        amanoraSectionDetails = _props.amanoraSectionDetails,
	        isSuper30Page = _props.isSuper30Page,
	        isNewArcadePage = _props.isNewArcadePage;
	    var amonaraSectionHeading = amanoraSectionDetails.heading,
	        amonaraSectionDescription = amanoraSectionDetails.description,
	        addressHeading = amanoraSectionDetails.addressHeading,
	        address = amanoraSectionDetails.address,
	        landmarkHeading = amanoraSectionDetails.landmarkHeading,
	        landmark = amanoraSectionDetails.landmark,
	        contactNoHeading = amanoraSectionDetails.contactNoHeading,
	        contactNumber = amanoraSectionDetails.contactNumber,
	        arcadeMapUrl = amanoraSectionDetails.arcadeMapUrl;
	
	    var GOOGLE_MAP_EMBED_URL = arcadeMapUrl + '&disable_scroll=true&t=m';
	
	    return _react2.default.createElement(
	      _styledComponents.MapSectionContainer,
	      {
	        id: 'arcade-map-section',
	        isNewArcadePage: isNewArcadePage
	      },
	      _react2.default.createElement(_MapDescriptionSection2.default, {
	        amonaraSectionHeading: amonaraSectionHeading,
	        amonaraSectionDescription: amonaraSectionDescription,
	        addressHeading: addressHeading,
	        address: address,
	        landmarkHeading: landmarkHeading,
	        landmark: landmark,
	        contactNoHeading: contactNoHeading,
	        contactNumber: contactNumber,
	        isSuper30Page: isSuper30Page
	      }),
	      _react2.default.createElement(_styledComponents.MapBackground, {
	        title: 'Arcade Map Location',
	        src: GOOGLE_MAP_EMBED_URL,
	        frameBorder: 0,
	        marginHeight: 0,
	        marginWidth: 0,
	        className: 'lazyload'
	      })
	    );
	  };
	
	  return MapSection;
	}(_react.Component);
	
	MapSection.defaultProps = {
	  isSuper30Page: false
	};
	exports.default = MapSection;
	
	/*
	maps url parameters info: https://doc.arcgis.com/en/arcgis-online/reference/embed-map-parameters.htm
	*/

	module.exports = exports['default'];

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MapBackground = exports.MapSectionResponsiveContainer = exports.MapSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapSectionContainer = /*#__PURE__*/exports.MapSectionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'esqef4x0'
	})('display:flex;background-color:', function (props) {
	  return props.isNewArcadePage ? _Colors2.default.darkTwoDefault : _Colors2.default.blackDefault;
	}, ';width:100%;', _mixins.mobile, '{font-size:14px;flex-direction:column;}', _mixins.tablet, '{font-size:16px;flex-direction:column;}', _mixins.desktop, '{font-size:16px;}');
	var MapSectionResponsiveContainer = /*#__PURE__*/exports.MapSectionResponsiveContainer = (0, _reactEmotion2.default)('div', {
	  target: 'esqef4x1'
	})('display:flex;flex-direction:row;width:100%;margin:auto;', _mixins.mobile, '{flex-direction:column;}', _mixins.tablet, '{flex-direction:column;}', _mixins.desktop, '{max-width:78.5em;}');
	var MapBackground = /*#__PURE__*/exports.MapBackground = (0, _reactEmotion2.default)('iframe', {
	  target: 'esqef4x2'
	})('width:auto;height:auto;flex:1;', _mixins.mobile, '{min-height:360px;}', _mixins.tablet, '{min-height:360px;}');

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateFns = __webpack_require__(117);
	
	var _UIStore = __webpack_require__(94);
	
	var _UIStore2 = _interopRequireDefault(_UIStore);
	
	var _FormHomePage = __webpack_require__(108);
	
	var _FormHomePage2 = _interopRequireDefault(_FormHomePage);
	
	var _ButtonTextWithIcon = __webpack_require__(172);
	
	var _ButtonTextWithIcon2 = _interopRequireDefault(_ButtonTextWithIcon);
	
	var _BookingResponseMessage = __webpack_require__(170);
	
	var _BookingResponseMessage2 = _interopRequireDefault(_BookingResponseMessage);
	
	var _styledComponents = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileBookNowButton = function (_React$Component) {
	  _inherits(MobileBookNowButton, _React$Component);
	
	  function MobileBookNowButton(props) {
	    _classCallCheck(this, MobileBookNowButton);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleScroll = function () {
	      if (window.pageYOffset > window.innerHeight) {
	        _this.setState({ isVisible: true });
	      } else {
	        _this.setState({ isVisible: false });
	      }
	    };
	
	    _this.captureBookingResponseModalRef = function (ref) {
	      if (ref) {
	        _this.bookingResponseModalRef = ref;
	      }
	    };
	
	    _this.closeLightBoxCallBack = function () {
	      if (_this.formMobileRef) {
	        _this.formMobileRef.resetForm();
	      }
	    };
	
	    _this.closeMobileForm = function () {
	      if (_this.formMobileRef) {
	        _this.formMobileRef.closeModal();
	      }
	    };
	
	    _this.onFormSubmitSuccess = function (formData) {
	      _this.setFormDataState(formData);
	      // open booking response modal
	      _this.openBookingResponseModal();
	    };
	
	    _this.openBookingResponseModal = function () {
	      if (_this.bookingResponseModalRef) {
	        _this.bookingResponseModalRef.openModal();
	      }
	    };
	
	    _this.captureBookingResponseModalRef = function (ref) {
	      if (ref) {
	        _this.bookingResponseModalRef = ref;
	      }
	    };
	
	    _this.captureFormMobileRef = function (ref) {
	      if (ref) {
	        _this.formMobileRef = ref;
	        _UIStore2.default.captureFormMobileRef(ref);
	      }
	    };
	
	    _this.captureSBFormModalRef = function (ref) {
	      if (ref) {
	        _this.sbFormModalRef = ref;
	        _this.captureFormMobileRef(ref);
	        _UIStore2.default.setMobileSBFormModalRef(ref);
	      }
	    };
	
	    _this.closeLightBoxCallBack = function () {
	      if (_this.formDesktopRef) {
	        _this.formDesktopRef.resetForm();
	      }
	      if (_this.formMobileRef) {
	        _this.formMobileRef.resetForm();
	      }
	    };
	
	    _this.closeMobileForm = function () {
	      if (_this.formMobileRef) {
	        _this.formMobileRef.closeModal();
	      }
	    };
	
	    _this.onClickBookMySlot = function () {
	      if (_this.sbFormModalRef) {
	        _this.sbFormModalRef.openModal();
	      }
	    };
	
	    _this.setFormDataState = function (formData) {
	      _this.setState({
	        formData: formData // eslint-disable-line
	      });
	    };
	
	    _this.onFormSubmitSuccess = function (formData) {
	      _this.setFormDataState(formData);
	      // open booking response modal
	      _this.openBookingResponseModal();
	    };
	
	    _this.getConvertedDate = function (date) {
	      return date ? new Date(date) : null;
	    };
	
	    _this.state = {
	      formData: null, // eslint-disable-line
	      isVisible: false
	    };
	    return _this;
	  }
	
	  MobileBookNowButton.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  MobileBookNowButton.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  MobileBookNowButton.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        termsAndConditionsData = _props.termsAndConditionsData,
	        slotIdPrefix = _props.slotIdPrefix,
	        arcadeFormMauticID = _props.arcadeFormMauticID,
	        arcadeCity = _props.arcadeCity,
	        pagePrefix = _props.pagePrefix,
	        amanoraSectionDetails = _props.amanoraSectionDetails,
	        bookingResponseData = _props.bookingResponseData,
	        priceCardsData = _props.priceCardsData,
	        id = _props.id;
	    var arcadeClosingDate = bookingResponseData.arcadeClosingDate,
	        arcadeClosingEndDate = bookingResponseData.arcadeClosingEndDate,
	        arcadeClosedDatesList = bookingResponseData.arcadeClosedDatesList;
	    var _state = this.state,
	        formData = _state.formData,
	        isVisible = _state.isVisible;
	
	    var excludeDates = arcadeClosedDatesList ? (0, _dateFns.eachDay)(this.getConvertedDate(arcadeClosingDate), this.getConvertedDate(arcadeClosingEndDate)).concat(arcadeClosedDatesList.split(',').map(function (date) {
	      return _this2.getConvertedDate(date);
	    })) : (0, _dateFns.eachDay)(this.getConvertedDate(arcadeClosingDate), this.getConvertedDate(arcadeClosingEndDate));
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _styledComponents.ButtonWrapper,
	        { onClick: this.onClickBookMySlot, id: id },
	        _react2.default.createElement(
	          _styledComponents.BookButton,
	          null,
	          _react2.default.createElement(_ButtonTextWithIcon2.default, { text: 'BOOK NOW' })
	        ),
	        _react2.default.createElement(
	          _styledComponents.ButtonSupportText,
	          null,
	          'Pay when you visit the arcade.'
	        )
	      ),
	      _react2.default.createElement(
	        _styledComponents.ScrollButtonWrapper,
	        {
	          isVisible: isVisible,
	          onClick: this.onClickBookMySlot,
	          id: id
	        },
	        _react2.default.createElement(
	          _styledComponents.ScrollBookButton,
	          null,
	          _react2.default.createElement(_ButtonTextWithIcon2.default, { text: 'BOOK NOW' }),
	          _react2.default.createElement(
	            _styledComponents.ScrollButtonSupportText,
	            null,
	            'Pay when you visit the arcade.'
	          )
	        )
	      ),
	      _react2.default.createElement(_FormHomePage2.default, {
	        ref: this.captureSBFormModalRef,
	        onFormSubmitSuccess: this.onFormSubmitSuccess,
	        termsAndConditionsData: termsAndConditionsData,
	        slotIdPrefix: slotIdPrefix,
	        arcadeFormMauticID: arcadeFormMauticID,
	        arcadeCity: arcadeCity,
	        pagePrefix: pagePrefix,
	        excludeDates: excludeDates,
	        priceCardsData: priceCardsData
	      }),
	      _react2.default.createElement(_BookingResponseMessage2.default, {
	        amanoraSectionDetails: amanoraSectionDetails,
	        bookingResponseData: bookingResponseData,
	        bookingInfo: formData,
	        ref: this.captureBookingResponseModalRef,
	        closeLightBoxCallBack: this.closeLightBoxCallBack,
	        closeMobileForm: this.closeMobileForm,
	        pagePrefix: pagePrefix
	      })
	    );
	  };
	
	  return MobileBookNowButton;
	}(_react2.default.Component);
	
	exports.default = MobileBookNowButton;
	module.exports = exports['default'];

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonSupportText = exports.ScrollButtonSupportText = exports.ScrollBookButton = exports.ScrollButtonWrapper = exports.BookButton = exports.ButtonWrapper = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _ButtonComponent = __webpack_require__(171);
	
	var _ButtonComponent2 = _interopRequireDefault(_ButtonComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonWrapper = /*#__PURE__*/exports.ButtonWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e1oz3gg20'
	})('@media (max-width:767px){margin-top:1.429em;margin-bottom:80px;}', _mixins.mobile, '{margin:0;margin-top:20px;}');
	
	var BookButton = /*#__PURE__*/exports.BookButton = (0, _reactEmotion2.default)(_ButtonComponent2.default, {
	  target: 'e1oz3gg21'
	})('width:100%;height:52px;display:block;align-items:center;justify-content:center;pointer-events:none;', _mixins.mobile, '{width:40%;height:40px;margin-left:auto;margin-right:auto;text-transform:uppercase;padding:10px 10px;background:', _Colors2.default.darkSaturatedOrange, ';}');
	
	var ScrollButtonWrapper = /*#__PURE__*/exports.ScrollButtonWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e1oz3gg22'
	})('display:none;position:fixed;bottom:0%;left:0%;z-index:1;width:100vw;', _mixins.mobile, '{margin:0;margin-top:20px;display:', function (props) {
	  return props.isVisible ? 'block' : 'none';
	}, ';}');
	
	var ScrollBookButton = /*#__PURE__*/exports.ScrollBookButton = (0, _reactEmotion2.default)(_ButtonComponent2.default, {
	  target: 'e1oz3gg23'
	})('width:100vw;height:52px;display:block;align-items:center;justify-content:center;pointer-events:none;', _mixins.mobile, '{margin-left:auto;margin-right:auto;padding:10px 10px;background:', _Colors2.default.darkSaturatedOrange, ';}');
	
	var ScrollButtonSupportText = /*#__PURE__*/exports.ScrollButtonSupportText = (0, _reactEmotion2.default)(_Din.Typo24WhiteTwoDI, {
	  target: 'e1oz3gg24'
	})('display:block;opacity:0.8;font-size:13px;text-align:center;position:relative;line-height:unset;padding-left:0;padding-right:0;');
	
	var ButtonSupportText = /*#__PURE__*/exports.ButtonSupportText = (0, _reactEmotion2.default)(_Din.Typo24WhiteTwoDI, {
	  target: 'e1oz3gg25'
	})('display:block;opacity:0.8;font-size:13px;text-align:center;position:relative;line-height:unset;padding-left:0;padding-right:0;padding-top:10px;');

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var PLAY_IN_STADIUM_ICON = exports.PLAY_IN_STADIUM_ICON = 'PLAY_IN_STADIUM_ICON';
	var BRING_OUT_CRICKETER_IN_YOU_ICON = exports.BRING_OUT_CRICKETER_IN_YOU_ICON = 'BRING_OUT_CRICKETER_IN_YOU_ICON';
	var COMPETE_WITH_YOUR_FRIENDS_ICON = exports.COMPETE_WITH_YOUR_FRIENDS_ICON = 'COMPETE_WITH_YOUR_FRIENDS_ICON';
	var BE_A_VR_CRICKETER_ICON = exports.BE_A_VR_CRICKETER_ICON = 'BE_A_VR_CRICKETER_ICON';

/***/ }),

/***/ 1228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlayInStadium = __webpack_require__(973);
	
	var _PlayInStadium2 = _interopRequireDefault(_PlayInStadium);
	
	var _BringOutCricketerInYou = __webpack_require__(916);
	
	var _BringOutCricketerInYou2 = _interopRequireDefault(_BringOutCricketerInYou);
	
	var _CompeteWithYourFriends = __webpack_require__(918);
	
	var _CompeteWithYourFriends2 = _interopRequireDefault(_CompeteWithYourFriends);
	
	var _BeAVrCricketStar = __webpack_require__(914);
	
	var _BeAVrCricketStar2 = _interopRequireDefault(_BeAVrCricketStar);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _styledComponents = __webpack_require__(1229);
	
	var _constants = __webpack_require__(1227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayInInternationalStadiumStrip = function (_React$Component) {
	  _inherits(PlayInInternationalStadiumStrip, _React$Component);
	
	  function PlayInInternationalStadiumStrip() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PlayInInternationalStadiumStrip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getIcon = function (iconData) {
	      switch (iconData) {
	        case _constants.PLAY_IN_STADIUM_ICON:
	          return _react2.default.createElement(_PlayInStadium2.default, { fill: _Colors2.default.whiteTwo });
	        case _constants.BRING_OUT_CRICKETER_IN_YOU_ICON:
	          return _react2.default.createElement(_BringOutCricketerInYou2.default, { fill: _Colors2.default.whiteTwo });
	        case _constants.COMPETE_WITH_YOUR_FRIENDS_ICON:
	          return _react2.default.createElement(_CompeteWithYourFriends2.default, { fill: _Colors2.default.whiteTwo });
	        case _constants.BE_A_VR_CRICKETER_ICON:
	          return _react2.default.createElement(_BeAVrCricketStar2.default, { fill: _Colors2.default.whiteTwo });
	        default:
	          return null;
	      }
	    }, _this.renderStadiumComponent = function (playInInternationalStrip) {
	      return _react2.default.createElement(
	        _styledComponents.PlayInInternationalStadiumStripContainer,
	        null,
	        playInInternationalStrip.map(function (stadium) {
	          return _react2.default.createElement(
	            _styledComponents.PlayInInternationalStadiumInnerContainer,
	            null,
	            _react2.default.createElement(
	              _styledComponents.PlayInInternationalStadiumSvgContainer,
	              null,
	              _this.getIcon(stadium.svg)
	            ),
	            _react2.default.createElement(
	              _styledComponents.PlayInInternationalStadiumText,
	              { as: 'h2' },
	              stadium.description
	            )
	          );
	        })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PlayInInternationalStadiumStrip.prototype.render = function render() {
	    var playInInternationalStrip = this.props.playInInternationalStrip;
	
	    return _react2.default.createElement(
	      _styledComponents.PlayInInternationalStadiumStripSection,
	      {
	        className: 'sub-nav-hero-container',
	        id: 'arcade-international-strip-section'
	      },
	      _react2.default.createElement(
	        _styledComponents.PlayInStripContainer,
	        null,
	        this.renderStadiumComponent(playInInternationalStrip)
	      )
	    );
	  };
	
	  return PlayInInternationalStadiumStrip;
	}(_react2.default.Component);
	
	exports.default = PlayInInternationalStadiumStrip;
	module.exports = exports['default'];

/***/ }),

/***/ 1229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MobileContainer = exports.PlayInInternationalStadiumSvgContainer = exports.PlayInInternationalStadiumText = exports.PlayInInternationalStadiumInnerContainer = exports.PlayInInternationalStadiumStripContainer = exports.PlayInStripContainer = exports.PlayInInternationalStadiumStripSection = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Din = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayInInternationalStadiumStripSection = /*#__PURE__*/exports.PlayInInternationalStadiumStripSection = (0, _reactEmotion2.default)('div', {
	  target: 'e152151b0'
	})('background:', _Colors2.default.blackDefault, ';background-repeat:no-repeat;background-size:cover;font-size:16px;@media only screen and (min-width:320px) and (max-width:1023px){margin-top:-14px;padding-bottom:3.75em;}');
	var PlayInStripContainer = /*#__PURE__*/exports.PlayInStripContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e152151b1'
	})();
	var PlayInInternationalStadiumStripContainer = /*#__PURE__*/exports.PlayInInternationalStadiumStripContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'e152151b2'
	})('display:flex;flex-direction:row;justify-content:space-evenly;padding-top:5.375em;padding-bottom:5em;@media only screen and (min-width:320px) and (max-width:767px){flex-direction:column;padding-top:3.75em;padding-bottom:0;}@media only screen and (min-width:768px) and (max-width:1024px){flex-wrap:wrap;padding-top:3.75em;padding-bottom:3.75em;}');
	var PlayInInternationalStadiumInnerContainer = /*#__PURE__*/exports.PlayInInternationalStadiumInnerContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e152151b3'
	})('display:flex;flex-direction:column;justify-content:center;align-items:center;@media only screen and (min-width:320px) and (max-width:767px){margin-bottom:1.5625em;}@media only screen and (min-width:768px) and (max-width:1024px){margin-right:3.75em;margin-bottom:2.875em;}@media only screen and (min-width:1025px){width:25%;}');
	
	var PlayInInternationalStadiumText = /*#__PURE__*/exports.PlayInInternationalStadiumText = (0, _reactEmotion2.default)(_Din.Typo16WhiteTwoDR, {
	  target: 'e152151b4'
	})('text-align:center;color:', _Colors2.default.whiteTwo, ';margin-top:1.4375em;line-height:normal;letter-spacing:normal;');
	
	var PlayInInternationalStadiumSvgContainer = /*#__PURE__*/exports.PlayInInternationalStadiumSvgContainer = (0, _reactEmotion2.default)('span', {
	  target: 'e152151b5'
	})('min-height:4.0625em;display:flex;align-items:center;@media only screen and (min-width:320px) and (max-width:767px){min-height:auto;}');
	var MobileContainer = /*#__PURE__*/exports.MobileContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e152151b6'
	})(' */}@media (min-width:768px){display:none;}');

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(102);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactAriaModal = __webpack_require__(100);
	
	var _reactAriaModal2 = _interopRequireDefault(_reactAriaModal);
	
	var _responsiveUtils = __webpack_require__(27);
	
	var _PriceCardsArrow = __webpack_require__(444);
	
	__webpack_require__(276);
	
	var _stylesModule = __webpack_require__(270);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _styledComponents = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DesktopPriceCards = function (_Component) {
	  _inherits(DesktopPriceCards, _Component);
	
	  function DesktopPriceCards(props) {
	    _classCallCheck(this, DesktopPriceCards);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.next = function () {
	      _this.slider.slickNext();
	    };
	
	    _this.previous = function () {
	      _this.slider.slickPrev();
	    };
	
	    _this.dragging = function (e) {
	      e.preventDefault();
	    };
	
	    _this.testimonialStopSliding = function (index) {
	      _this.setState({
	        testimonialIndex: index
	      });
	    };
	
	    _this.handleClick = function () {
	      _this.setState({ modalStatus: true });
	    };
	
	    _this.onHideModal = function () {
	      _this.setState({ modalStatus: false });
	    };
	
	    _this.renderMembershipModal = function (_ref) {
	      var imageUrl = _ref.imageUrl,
	          imageAltText = _ref.imageAltText,
	          visitArcadeText = _ref.visitArcadeText,
	          packageText = _ref.packageText;
	      var modalStatus = _this.state.modalStatus;
	
	      return _react2.default.createElement(
	        _reactAriaModal2.default,
	        {
	          titleId: 'custom-modal',
	          underlayClass: _stylesModule2.default.dialogStyle,
	          focusDialog: true,
	          mounted: modalStatus,
	          onExit: _this.onHideModal,
	          ariaHideApp: false
	        },
	        _react2.default.createElement(
	          _styledComponents.CloseButton,
	          {
	            type: 'button',
	            className: _stylesModule2.default.closeButton,
	            'aria-label': 'Close',
	            onClick: _this.onHideModal
	          },
	          _react2.default.createElement(_styledComponents.CloseImage, {
	            src: 'https://cdn.zeplin.io/5b9ba4851a546d689032f416/assets/11D7F9E7-5526-4A37-B8F9-3A3AD77CA0C2.svg',
	            alt: 'close-icon',
	            id: 'close-icon-membership-card'
	          })
	        ),
	        _react2.default.createElement(
	          _styledComponents.ImageContentContainer,
	          null,
	          _react2.default.createElement(_styledComponents.MembershipCardImage, {
	            id: imageAltText,
	            src: imageUrl,
	            alt: imageAltText
	          }),
	          _react2.default.createElement(
	            _styledComponents.PointContentWrapper,
	            null,
	            _react2.default.createElement(_styledComponents.Point, null),
	            _react2.default.createElement(
	              _styledComponents.VisitText,
	              null,
	              visitArcadeText
	            )
	          ),
	          packageText ? _react2.default.createElement(
	            _styledComponents.PointContentWrapper,
	            null,
	            _react2.default.createElement(_styledComponents.Point, null),
	            _react2.default.createElement(
	              _styledComponents.VisitText,
	              null,
	              packageText
	            )
	          ) : null
	        )
	      );
	    };
	
	    _this.state = {
	      testimonialIndex: 0,
	      testimonialMaxIndexLimit: 1,
	      modalStatus: false
	    };
	    return _this;
	  }
	
	  DesktopPriceCards.prototype.componentDidMount = function componentDidMount() {
	    var priceCardsData = this.props.priceCardsData;
	    var priceCardsDesktopImagesList = priceCardsData.priceCardsDesktopImagesList;
	    // const { testimonialsList } = testimonialsDataProps
	
	    if ((0, _responsiveUtils.customMaxWidth)(1101)) {
	      // TODO: At this break point 1100, In the slick we need to change the number of cards to be displayed for proper alignment.
	      // eslint-disable-next-line
	      this.setState({
	        testimonialMaxIndexLimit: priceCardsDesktopImagesList.length - 1
	      });
	    } else {
	      // eslint-disable-next-line
	      this.setState({
	        testimonialMaxIndexLimit: priceCardsDesktopImagesList.length - 3
	      });
	    }
	  };
	
	  DesktopPriceCards.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        testimonialIndex = _state.testimonialIndex,
	        testimonialMaxIndexLimit = _state.testimonialMaxIndexLimit;
	    var priceCardsData = this.props.priceCardsData;
	    var priceCardsDesktopImagesList = priceCardsData.priceCardsDesktopImagesList;
	
	    var testimonialsSettings = {
	      dots: false,
	      infinite: false,
	      speed: 500,
	      slidesToShow: 4,
	      slidesToScroll: 1,
	      afterChange: this.testimonialStopSliding,
	      arrows: false,
	      draggable: true,
	      responsive: [{
	        breakpoint: 767,
	        settings: {
	          dots: false,
	          slidesToShow: 3,
	          slidesToScroll: 1,
	          arrows: false,
	          draggable: true
	        }
	      }, {
	        breakpoint: 1023,
	        settings: {
	          infinite: false,
	          autoplay: false,
	          slidesToShow: 2.5,
	          slidesToScroll: 1,
	          arrows: false,
	          draggable: true
	        }
	      }, {
	        breakpoint: 1162,
	        settings: {
	          infinite: false,
	          autoplay: false,
	          slidesToShow: 4,
	          slidesToScroll: 1,
	          arrows: false,
	          draggable: true
	        }
	      }]
	    };
	    return _react2.default.createElement(
	      _styledComponents.PriceCardsSection,
	      null,
	      _react2.default.createElement(
	        _styledComponents.PriceCardsContainer,
	        null,
	        priceCardsDesktopImagesList.length > 3 ? _react2.default.createElement(
	          _styledComponents.SliderContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.PrevArrowSection,
	            {
	              onClick: this.previous,
	              id: 'price-card-previous-arrow'
	            },
	            _react2.default.createElement(
	              _styledComponents.PriceCardSvgContainer,
	              { disableArrow: testimonialIndex === 0 },
	              _react2.default.createElement(_PriceCardsArrow.PriceCardsArrow, null)
	            )
	          ),
	          _react2.default.createElement(
	            _styledComponents.DesktopSlider,
	            null,
	            _react2.default.createElement(
	              _reactSlick2.default,
	              _extends({
	                ref: function ref(c) {
	                  _this2.slider = c;
	                },
	                className: 'PriceCardsSlickSection'
	              }, testimonialsSettings),
	              priceCardsDesktopImagesList.map(function (_ref2) {
	                var imageUrl = _ref2.imageUrl,
	                    altText = _ref2.altText,
	                    buttonText = _ref2.buttonText,
	                    buttonRedirectText = _ref2.buttonRedirectText,
	                    cardId = _ref2.cardId,
	                    isMembershipCard = _ref2.isMembershipCard,
	                    membershipCardModalData = _ref2.membershipCardModalData;
	                return _react2.default.createElement(
	                  _styledComponents.CardItemContainer,
	                  {
	                    removeRightMargin: false,
	                    isMembershipCard: isMembershipCard
	                  },
	                  _react2.default.createElement(
	                    _styledComponents.CardContainer,
	                    null,
	                    _react2.default.createElement(_styledComponents.CardImage, {
	                      onClick: isMembershipCard ? _this2.handleClick : null,
	                      src: imageUrl,
	                      alt: altText,
	                      id: cardId
	                    })
	                  ),
	                  buttonText && _react2.default.createElement(
	                    _styledComponents.KnowMoreButton,
	                    {
	                      as: 'a',
	                      href: buttonRedirectText,
	                      target: '_blank'
	                    },
	                    buttonText
	                  ),
	                  isMembershipCard ? _this2.renderMembershipModal(membershipCardModalData) : null
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _styledComponents.NextArrowSection,
	            {
	              id: 'price-card-next-arrow',
	              onClick: testimonialIndex >= testimonialMaxIndexLimit ? null : this.next
	            },
	            _react2.default.createElement(
	              _styledComponents.PriceCardNextSvgContainer,
	              {
	                disableArrow: testimonialIndex >= testimonialMaxIndexLimit
	              },
	              _react2.default.createElement(_PriceCardsArrow.PriceCardsArrow, null)
	            )
	          )
	        ) : _react2.default.createElement(
	          _styledComponents.SliderContainer,
	          null,
	          _react2.default.createElement(
	            _styledComponents.DesktopCardsWrapper,
	            {
	              alignCenter: priceCardsDesktopImagesList.length < 3
	            },
	            priceCardsDesktopImagesList.map(function (_ref3) {
	              var imageUrl = _ref3.imageUrl,
	                  altText = _ref3.altText,
	                  buttonText = _ref3.buttonText,
	                  buttonRedirectText = _ref3.buttonRedirectText,
	                  cardId = _ref3.cardId,
	                  isMembershipCard = _ref3.isMembershipCard,
	                  membershipCardModalData = _ref3.membershipCardModalData;
	              return _react2.default.createElement(
	                _styledComponents.CardItemContainer,
	                {
	                  removeRightMargin: true,
	                  isMembershipCard: isMembershipCard
	                },
	                _react2.default.createElement(
	                  _styledComponents.CardContainer,
	                  null,
	                  _react2.default.createElement(_styledComponents.CardImage, {
	                    onClick: isMembershipCard ? _this2.handleClick : null,
	                    src: imageUrl,
	                    alt: altText,
	                    id: cardId
	                  })
	                ),
	                buttonText && _react2.default.createElement(
	                  _styledComponents.KnowMoreButton,
	                  {
	                    as: 'a',
	                    href: buttonRedirectText,
	                    target: '_blank'
	                  },
	                  buttonText
	                ),
	                isMembershipCard ? _this2.renderMembershipModal(membershipCardModalData) : null
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return DesktopPriceCards;
	}(_react.Component);
	
	exports.default = DesktopPriceCards;
	module.exports = exports['default'];

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAriaModal = __webpack_require__(100);
	
	var _reactAriaModal2 = _interopRequireDefault(_reactAriaModal);
	
	var _stylesModule = __webpack_require__(270);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	__webpack_require__(276);
	
	var _styledComponents = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobilePriceCards = function (_Component) {
	  _inherits(MobilePriceCards, _Component);
	
	  function MobilePriceCards(props) {
	    _classCallCheck(this, MobilePriceCards);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleOpenModal = function () {
	      _this.setState({ modalStatus: true });
	    };
	
	    _this.handleCloseModal = function () {
	      _this.setState({ modalStatus: false });
	    };
	
	    _this.renderMembershipModal = function (_ref) {
	      var imageUrl = _ref.imageUrl,
	          imageAltText = _ref.imageAltText,
	          visitArcadeText = _ref.visitArcadeText,
	          packageText = _ref.packageText;
	      var modalStatus = _this.state.modalStatus;
	
	      return _react2.default.createElement(
	        _reactAriaModal2.default,
	        {
	          titleId: 'custom-modal',
	          underlayClass: _stylesModule2.default.dialogStyle,
	          focusDialog: true,
	          mounted: modalStatus,
	          ariaHideApp: false,
	          onExit: _this.handleCloseModal
	        },
	        _react2.default.createElement(
	          _styledComponents.CloseButton,
	          {
	            type: 'button',
	            className: _stylesModule2.default.closeButton,
	            'aria-label': 'Close',
	            onClick: _this.handleCloseModal
	          },
	          _react2.default.createElement(_styledComponents.CloseImage, {
	            src: 'https://cdn.zeplin.io/5b9ba4851a546d689032f416/assets/11D7F9E7-5526-4A37-B8F9-3A3AD77CA0C2.svg',
	            alt: 'close-icon',
	            id: 'close-icon-membership-card-mobile'
	          })
	        ),
	        _react2.default.createElement(
	          _styledComponents.ImageContentContainer,
	          null,
	          _react2.default.createElement(_styledComponents.MembershipCardImage, {
	            id: imageAltText,
	            src: imageUrl,
	            alt: imageAltText
	          }),
	          _react2.default.createElement(
	            _styledComponents.PointContentWrapper,
	            null,
	            _react2.default.createElement(_styledComponents.Point, null),
	            _react2.default.createElement(
	              _styledComponents.VisitText,
	              null,
	              visitArcadeText
	            )
	          ),
	          packageText ? _react2.default.createElement(
	            _styledComponents.PointContentWrapper,
	            null,
	            _react2.default.createElement(_styledComponents.Point, null),
	            _react2.default.createElement(
	              _styledComponents.VisitText,
	              null,
	              packageText
	            )
	          ) : null
	        )
	      );
	    };
	
	    _this.state = { modalStatus: false };
	    return _this;
	  }
	
	  MobilePriceCards.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        openSBForm = _props.openSBForm,
	        priceCardsData = _props.priceCardsData;
	    var priceCardsMobileImagesList = priceCardsData.priceCardsMobileImagesList;
	
	
	    var isOnlyOnePriceCardPresent = priceCardsMobileImagesList.length === 1;
	
	    return _react2.default.createElement(
	      _styledComponents.MobileSlider,
	      null,
	      _react2.default.createElement(
	        _styledComponents.MobileContainer,
	        { isOnlyOnePriceCardPresent: isOnlyOnePriceCardPresent },
	        priceCardsMobileImagesList.map(function (_ref2) {
	          var imageUrl = _ref2.imageUrl,
	              altText = _ref2.altText,
	              buttonText = _ref2.buttonText,
	              buttonRedirectText = _ref2.buttonRedirectText,
	              cardId = _ref2.cardId,
	              isMembershipCard = _ref2.isMembershipCard,
	              membershipCardModalData = _ref2.membershipCardModalData;
	          return _react2.default.createElement(
	            _styledComponents.CardItemContainer,
	            null,
	            _react2.default.createElement(
	              _styledComponents.CardContainer,
	              null,
	              isMembershipCard ? _react2.default.createElement(
	                _styledComponents.ImageModalWrapperContainer,
	                null,
	                _react2.default.createElement(
	                  _styledComponents.CardImageContainer,
	                  {
	                    isMembershipCard: isMembershipCard,
	                    onClick: _this2.handleOpenModal,
	                    id: cardId
	                  },
	                  _react2.default.createElement(_styledComponents.CardImage, { src: imageUrl, alt: altText, id: cardId })
	                ),
	                _this2.renderMembershipModal(membershipCardModalData)
	              ) : buttonText ? _react2.default.createElement(
	                _styledComponents.CardImageContainer,
	                {
	                  href: buttonRedirectText,
	                  target: '_blank'
	                },
	                _react2.default.createElement(_styledComponents.CardImage, { src: imageUrl, alt: altText, id: cardId })
	              ) : _react2.default.createElement(_styledComponents.CardImage, {
	                onClick: openSBForm,
	                src: imageUrl,
	                alt: altText,
	                id: cardId
	              })
	            ),
	            buttonText && _react2.default.createElement(
	              _styledComponents.KnowMoreButton,
	              {
	                as: 'a',
	                href: buttonRedirectText,
	                target: '_blank'
	              },
	              buttonText
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return MobilePriceCards;
	}(_react.Component);
	
	exports.default = MobilePriceCards;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.VisitText = exports.Point = exports.PointContentWrapper = exports.MembershipCardImage = exports.ImageContentContainer = exports.CloseImage = exports.CloseButton = exports.FormWrapper = exports.MobileContainer = exports.MobileSlider = exports.DesktopCardsWrapper = exports.DesktopSlider = exports.CardContainer = exports.CardImageContainer = exports.ImageModalWrapperContainer = exports.CardImage = exports.KnowMoreButton = exports.TestimonialDescriptionContainer = exports.CardItemContainer = exports.NextArrowSection = exports.PriceCardNextSvgContainer = exports.PriceCardSvgContainer = exports.SliderContainer = exports.PrevArrowSection = exports.PriceCardsContainer = exports.ResponsiveContainer = exports.PriceCardsSection = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _mixins = __webpack_require__(4);
	
	var _Din = __webpack_require__(8);
	
	var _CloudinaryS3Image = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceCardsSection = /*#__PURE__*/exports.PriceCardsSection = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw0'
	})(_mixins.mobile, '{padding-top:40px;padding-bottom:0px;}', _mixins.tablet, '{padding-top:0;padding-bottom:0;}@media (min-width:1200px){padding-bottom:20px;}');
	
	var ResponsiveContainer = /*#__PURE__*/exports.ResponsiveContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw1'
	})('width:1160px;margin:auto;display:flex;flex-direction:column;', _mixins.mobile, '{width:100%;}', (0, _mixins.customDevice)(1000, 1161), '{width:900px;}', (0, _mixins.customDevice)(1161, 1279), '{width:1000px;}');
	
	var PriceCardsContainer = /*#__PURE__*/exports.PriceCardsContainer = (0, _reactEmotion2.default)(ResponsiveContainer, {
	  target: 'e16y7zyw2'
	})(_mixins.mobile, '{padding-bottom:10px;}');
	
	var PrevArrowSection = /*#__PURE__*/exports.PrevArrowSection = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw3'
	})('position:absolute;left:-2.2%;top:46%;z-index:10;cursor:pointer;', _mixins.mobile, '{display:none;}', _mixins.tablet, '{left:-2.2%;}');
	var SliderContainer = /*#__PURE__*/exports.SliderContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw4'
	})('padding-top:20px;position:relative;', (0, _mixins.customDevice)(320, 767), '{padding-top:0;}');
	
	var PriceCardSvgContainer = /*#__PURE__*/exports.PriceCardSvgContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw5'
	})('pointer-events:none;user-select:none;display:flex;padding-bottom:10px;padding-top:10px;padding-left:18px;padding-right:18px;border-radius:50%;box-shadow:0 2px 4px 0 rgba(0,0,0,0.5);background-color:', _Colors2.default.white, ';visibility:', function (props) {
	  return props.disableArrow ? 'hidden' : 'initial';
	}, ';');
	var PriceCardNextSvgContainer = /*#__PURE__*/exports.PriceCardNextSvgContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw6'
	})('pointer-events:none;user-select:none;display:flex;padding-bottom:10px;padding-top:14px;padding-left:18px;padding-right:18px;transform:rotate(180deg);border-radius:50%;box-shadow:0 2px 4px 0 rgba(0,0,0,0.5);background-color:', _Colors2.default.white, ';visibility:', function (props) {
	  return props.disableArrow ? 'hidden' : 'initial';
	}, ';');
	
	var NextArrowSection = /*#__PURE__*/exports.NextArrowSection = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw7'
	})('cursor:pointer;position:absolute;right:-2%;top:46%;z-index:10;', _mixins.mobile, '{display:none;}');
	var CardItemContainer = /*#__PURE__*/exports.CardItemContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw8'
	})('margin-right:', function (props) {
	  return props.removeRightMargin ? '0' : '24px !important';
	}, ';position:relative;cursor:', function (props) {
	  return props.isMembershipCard ? 'pointer' : null;
	}, ';width:320px;:nth-last-child(1){width:auto !important;margin-right:0 !important;', (0, _mixins.customDevice)(320, 601), '{margin-right:unset !important;}}', (0, _mixins.customDevice)(320, 601), '{margin-left:unset !important;margin-right:unset !important;}', _mixins.tablet, '{margin-right:0 !important;}', (0, _mixins.customDevice)(1024, 1199), '{margin-right:24px !important;}');
	var TestimonialDescriptionContainer = /*#__PURE__*/exports.TestimonialDescriptionContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw9'
	})('display:flex;flex-direction:column;');
	
	var KnowMoreButton = /*#__PURE__*/exports.KnowMoreButton = (0, _reactEmotion2.default)(_Din.Typo12WhiteDB, {
	  target: 'e16y7zyw10'
	})('border:none;padding-left:20px;padding-right:20px;position:absolute;bottom:16px;right:60px;padding-top:8px;padding-bottom:8px;background-color:', _Colors2.default.pumpkinOrange, ';cursor:pointer;:hover{color:', _Colors2.default.white, ';outline:none;text-decoration:none;}:focus{color:', _Colors2.default.white, ';outline:none;text-decoration:none;}', _mixins.mobile, '{bottom:10px;right:45px;}', _mixins.tablet, '{bottom:16px;right:110px;}');
	
	var CardImage = /*#__PURE__*/exports.CardImage = (0, _reactEmotion2.default)(_CloudinaryS3Image.CloudinaryS3Image, {
	  target: 'e16y7zyw11'
	})('margin-right:20px;margin-top:18px;height:224px;:nth-last-child(1){margin-right:0;}', _mixins.mobile, '{height:160px;}');
	
	var ImageModalWrapperContainer = /*#__PURE__*/exports.ImageModalWrapperContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw12'
	})();
	
	var CardImageContainer = /*#__PURE__*/exports.CardImageContainer = (0, _reactEmotion2.default)('a', {
	  target: 'e16y7zyw13'
	})('cursor:', function (props) {
	  return props.isMembershipCard ? 'pointer' : null;
	}, ';');
	
	var CardContainer = /*#__PURE__*/exports.CardContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw14'
	})('display:flex;position:relative;');
	var DesktopSlider = /*#__PURE__*/exports.DesktopSlider = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw15'
	})(_mixins.mobile, '{display:none;}');
	
	var DesktopCardsWrapper = /*#__PURE__*/exports.DesktopCardsWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw16'
	})('display:flex;justify-content:center;', _mixins.mobile, '{display:none;}', (0, _mixins.customDevice)(1024, 1100), '{width:920px;overflow:scroll;margin:auto;justify-content:', function (props) {
	  return props.alignCenter ? 'center' : 'flex-start';
	}, ';}', (0, _mixins.customDevice)(1101, 1199), '{width:980px;overflow:scroll;margin:auto;justify-content:', function (props) {
	  return props.alignCenter ? 'center' : 'flex-start';
	}, ';}');
	
	var MobileSlider = /*#__PURE__*/exports.MobileSlider = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw17'
	})('display:none;', _mixins.mobile, '{display:block;margin-left:5%;}', _mixins.tablet, '{display:block;margin-left:5%;}');
	var MobileContainer = /*#__PURE__*/exports.MobileContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw18'
	})('display:flex;flex-direction:row;overflow:scroll;justify-content:', function (props) {
	  return props.isOnlyOnePriceCardPresent ? 'center' : 'flex-start';
	}, ';::-webkit-scrollbar{width:0 !important;}');
	var FormWrapper = /*#__PURE__*/exports.FormWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw19'
	})('display:block;', (0, _mixins.customDevice)(992, 1023), '{display:none;}');
	
	var CloseButton = /*#__PURE__*/exports.CloseButton = (0, _reactEmotion2.default)('button', {
	  target: 'e16y7zyw20'
	})();
	
	var CloseImage = /*#__PURE__*/exports.CloseImage = (0, _reactEmotion2.default)(_CloudinaryS3Image.CloudinaryS3Image, {
	  target: 'e16y7zyw21'
	})();
	
	var ImageContentContainer = /*#__PURE__*/exports.ImageContentContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw22'
	})('display:flex;flex-direction:column;padding-bottom:20px;', _mixins.mobile, '{padding-top:10px;}');
	
	var MembershipCardImage = /*#__PURE__*/exports.MembershipCardImage = (0, _reactEmotion2.default)(_CloudinaryS3Image.CloudinaryS3Image, {
	  target: 'e16y7zyw23'
	})('object-fit:contain;margin-bottom:20px;width:400px;', _mixins.mobile, '{margin-bottom:16px;width:auto;}');
	
	var PointContentWrapper = /*#__PURE__*/exports.PointContentWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw24'
	})('display:flex;align-items:center;margin-bottom:5px;', _mixins.mobile, '{margin-bottom:9px;}');
	
	var Point = /*#__PURE__*/exports.Point = (0, _reactEmotion2.default)('div', {
	  target: 'e16y7zyw25'
	})('width:4px;height:4px;background-color:', _Colors2.default.whiteSeven, ';border-radius:50%;');
	
	var VisitText = /*#__PURE__*/exports.VisitText = (0, _reactEmotion2.default)(_Din.Typo14IceBlueTwoDINDI, {
	  target: 'e16y7zyw26'
	})('margin-left:3px;line-height:normal;letter-spacing:0.5px;', _mixins.mobile, '{font-size:11px;margin-left:2px;line-height:normal;letter-spacing:normal;}');

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"closeButton":"src-components-IbcArcade-PriceCards----styles-module---closeButton---2Dq3v","dialogStyle":"src-components-IbcArcade-PriceCards----styles-module---dialogStyle---3aO7t"};

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SkewComponent = function (_React$Component) {
	  _inherits(SkewComponent, _React$Component);
	
	  function SkewComponent() {
	    _classCallCheck(this, SkewComponent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SkewComponent.prototype.render = function render() {
	    var innerText = this.props.innerText;
	
	    return _react2.default.createElement(
	      _styledComponents.SkewComponentContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.SkewText,
	        null,
	        innerText
	      )
	    );
	  };
	
	  return SkewComponent;
	}(_react2.default.Component);
	
	exports.default = SkewComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SkewText = exports.SkewComponentContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Nort = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SkewComponentContainer = /*#__PURE__*/exports.SkewComponentContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e13i6lq40'
	})('margin-left:10px;background-color:', _Colors2.default.whiteTwo, ';box-shadow:0 0.25em 0.5em 0 ', _Colors2.default.black10, ';padding:1px 0.8em 1px 0.254em;transform:skewX(-25deg);display:inline-block;@media (min-width:320px) and (max-width:767px){transform:skewX(-15deg);padding:0.286em 0.714em;box-shadow:0 0.286em 0.571em 0 ', _Colors2.default.black10, ';}');
	
	var SkewText = /*#__PURE__*/exports.SkewText = (0, _reactEmotion2.default)(_Nort.Typo24TwilightBlueBNI, {
	  target: 'e13i6lq41'
	})('transform:skewX(25deg);display:block;padding-left:5px;@media (min-width:320px) and (max-width:767px){transform:skewX(15deg);font-weight:normal;font-size:1.143em;}');

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _navigationUtils = __webpack_require__(16);
	
	var _ButtonTextWithIcon = __webpack_require__(172);
	
	var _ButtonTextWithIcon2 = _interopRequireDefault(_ButtonTextWithIcon);
	
	var _styledComponents = __webpack_require__(1231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TestimonialFooter = function (_Component) {
	  _inherits(TestimonialFooter, _Component);
	
	  function TestimonialFooter() {
	    _classCallCheck(this, TestimonialFooter);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TestimonialFooter.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.BookNowButtonContainer,
	      { id: 'testimonials-desktop-book-now-button' },
	      _react2.default.createElement(
	        _styledComponents.BookNowButton,
	        { onClick: _navigationUtils.scrollToDesktopSBForm },
	        _react2.default.createElement(_ButtonTextWithIcon2.default, { text: 'BOOK NOW' })
	      ),
	      _react2.default.createElement(
	        _styledComponents.ButtonSupportText,
	        null,
	        'Pay when you visit the arcade.'
	      )
	    );
	  };
	
	  return TestimonialFooter;
	}(_react.Component);
	
	exports.default = TestimonialFooter;
	module.exports = exports['default'];

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonSupportText = exports.BookNowButton = exports.BookNowButtonContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookNowButtonContainer = /*#__PURE__*/exports.BookNowButtonContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1cioent0'
	})('display:flex;flex-direction:column;align-items:center;margin-top:10px;');
	
	var BookNowButton = /*#__PURE__*/exports.BookNowButton = (0, _reactEmotion2.default)('button', {
	  target: 'e1cioent1'
	})('font-size:14px;background-color:rgb(244,116,0);padding:10px 20px;color:#ffffff;border:none;cursor:pointer;width:120px;height:40px;', _mixins.mobile, '{margin-left:auto;margin-right:auto;text-transform:uppercase;padding:10px 10px;max-height:38px;}');
	
	var ButtonSupportText = /*#__PURE__*/exports.ButtonSupportText = (0, _reactEmotion2.default)('p', {
	  target: 'e1cioent2'
	})('font-family:din-2014;font-weight:normal;font-style:normal;font-stretch:normal;opacity:0.8;font-size:13px;font-style:italic;color:#ffffff;text-align:center;position:relative;line-height:unset;padding-left:0;padding-right:0;padding-top:10px;');

/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(35);
	
	var _styledComponents = __webpack_require__(1233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TestimonialTitle = function (_Component) {
	  _inherits(TestimonialTitle, _Component);
	
	  function TestimonialTitle() {
	    _classCallCheck(this, TestimonialTitle);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TestimonialTitle.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.TestimonialTitleContainer,
	      null,
	      _react2.default.createElement(
	        _styledComponents.TestimonialHeading,
	        { as: 'h2' },
	        'PEOPLE'
	      ),
	      _react2.default.createElement(
	        _styledComponents.IconContainer,
	        null,
	        _react2.default.createElement(_Icons.IcHeart, null)
	      ),
	      _react2.default.createElement(
	        _styledComponents.TestimonialHeading,
	        null,
	        'iB CRICKET!'
	      )
	    );
	  };
	
	  return TestimonialTitle;
	}(_react.Component);
	
	exports.default = TestimonialTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IconContainer = exports.PeopleLoveIbCricketImage = exports.TestimonialHeading = exports.TestimonialTitleContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _Nort = __webpack_require__(11);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 
	 * @author: VaraKumar
	 */
	var TestimonialTitleContainer = /*#__PURE__*/exports.TestimonialTitleContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'e1krvckh0'
	})('display:flex;flex-direction:row;justify-content:flex-start;align-items:center;font-size:16px;', _mixins.desktop, '{padding-top:1em;padding-bottom:1.5em;}', _mixins.tablet, '{padding-top:1em;padding-bottom:20px;}', _mixins.mobile, '{padding-top:0.5em;padding-bottom:1.25em;}');
	
	var TestimonialHeading = /*#__PURE__*/exports.TestimonialHeading = (0, _reactEmotion2.default)(_Nort.Typo30WhiteTwoBNBI, {
	  target: 'e1krvckh1'
	})('line-height:1.23;letter-spacing:0.5px;', _mixins.mobile, '{font-size:1.625em;line-height:2.1875rem;}', _mixins.tablet, '{font-size:1.75em;}', _mixins.desktop, '{font-size:1.75em;}');
	var PeopleLoveIbCricketImage = /*#__PURE__*/exports.PeopleLoveIbCricketImage = (0, _reactEmotion2.default)('img', {
	  target: 'e1krvckh2'
	})('margin-left:0.75em;margin-right:0.75em;');
	var IconContainer = /*#__PURE__*/exports.IconContainer = (0, _reactEmotion2.default)('div', {
	  target: 'e1krvckh3'
	})('user-select:none;margin-left:12px;margin-right:12px;display:flex;align-items:center;@media (min-width:320px) and (max-width:334px){margin-left:5px;margin-right:5px;}');

/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MobileTestimonialSection = __webpack_require__(409);
	
	var _MobileTestimonialSection2 = _interopRequireDefault(_MobileTestimonialSection);
	
	var _TabletTestimonialSection = __webpack_require__(411);
	
	var _TabletTestimonialSection2 = _interopRequireDefault(_TabletTestimonialSection);
	
	var _DesktopTestimonialSection = __webpack_require__(407);
	
	var _DesktopTestimonialSection2 = _interopRequireDefault(_DesktopTestimonialSection);
	
	var _TestimonialTitle = __webpack_require__(1232);
	
	var _TestimonialTitle2 = _interopRequireDefault(_TestimonialTitle);
	
	var _TestimonialFooter = __webpack_require__(1230);
	
	var _TestimonialFooter2 = _interopRequireDefault(_TestimonialFooter);
	
	var _responsiveUtils = __webpack_require__(1235);
	
	var _styledComponents = __webpack_require__(1236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author: VaraKumar
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TestimonialSection = function (_Component) {
	  _inherits(TestimonialSection, _Component);
	
	  function TestimonialSection() {
	    _classCallCheck(this, TestimonialSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TestimonialSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.TestimonialSectionWrapper,
	      { id: 'arcade-testimonials-section' },
	      _react2.default.createElement(_TestimonialTitle2.default, null),
	      _react2.default.createElement(
	        _styledComponents.TestimonialSectionContainer,
	        null,
	        (0, _responsiveUtils.isMobileDevice)() ? _react2.default.createElement(_MobileTestimonialSection2.default, null) : null,
	        (0, _responsiveUtils.isTabletDevice)() ? _react2.default.createElement(_TabletTestimonialSection2.default, null) : null,
	        (0, _responsiveUtils.isMediumDesktopDevice)() ? _react2.default.createElement(_TabletTestimonialSection2.default, null) : null,
	        (0, _responsiveUtils.isDesktopDevice)() ? _react2.default.createElement(_DesktopTestimonialSection2.default, null) : null,
	        (0, _responsiveUtils.isDesktopDevice)() && _react2.default.createElement(_TestimonialFooter2.default, null)
	      )
	    );
	  };
	
	  return TestimonialSection;
	}(_react.Component);
	
	exports.default = TestimonialSection;
	module.exports = exports['default'];

/***/ }),

/***/ 1235:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isMobileDevice = exports.isMobileDevice = function isMobileDevice() {
	  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	    if (window.innerWidth <= 767) {
	      return true;
	    }
	  }
	  return false;
	};
	
	var isTabletDevice = exports.isTabletDevice = function isTabletDevice() {
	  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	    if (window.innerWidth >= 768 && window.innerWidth <= 1023) {
	      return true;
	    }
	  }
	  return false;
	};
	
	var isMediumDesktopDevice = exports.isMediumDesktopDevice = function isMediumDesktopDevice() {
	  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	    if (window.innerWidth >= 1024 && window.innerWidth <= 1279) {
	      return true;
	    }
	  }
	  return false;
	};
	
	var isDesktopDevice = exports.isDesktopDevice = function isDesktopDevice() {
	  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	    if (window.innerWidth >= 1280) {
	      return true;
	    }
	  }
	  return false;
	};

/***/ }),

/***/ 1236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MdDesktopComponent = exports.TabletComponent = exports.DesktopComponent = exports.MobileComponent = exports.TestimonialSectionWrapper = exports.TestimonialSectionContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _mixins = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Have to remove font-size in px and have add em based on body section
	/**
	 * 
	 * @author: VaraKumar
	 */
	
	var TestimonialSectionContainer = /*#__PURE__*/exports.TestimonialSectionContainer = (0, _reactEmotion2.default)(_ResponsiveContainer2.default, {
	  target: 'e5kdb500'
	})(_mixins.mobile, '{font-size:14px;}', _mixins.tablet, '{font-size:16px;}', _mixins.desktop, '{font-size:16px;}');
	var TestimonialSectionWrapper = /*#__PURE__*/exports.TestimonialSectionWrapper = (0, _reactEmotion2.default)('div', {
	  target: 'e5kdb501'
	})('background:', _Colors2.default.darkTwoDefault, ';', _mixins.desktop, '{padding-bottom:4.063em;padding-top:30px;}', _mixins.tablet, '{padding-bottom:4.643em;}', _mixins.mobile, '{padding-bottom:55px;padding-top:25px;}');
	
	var MobileComponent = /*#__PURE__*/exports.MobileComponent = (0, _reactEmotion2.default)('div', {
	  target: 'e5kdb502'
	})(_mixins.desktop, '{display:none;}', _mixins.tablet, '{display:none;}', _mixins.mdDesktop, '{display:none;}');
	
	var DesktopComponent = /*#__PURE__*/exports.DesktopComponent = (0, _reactEmotion2.default)('div', {
	  target: 'e5kdb503'
	})(_mixins.tablet, '{display:none;}', _mixins.mobile, '{display:none;}', _mixins.mdDesktop, '{display:none;}');
	var TabletComponent = /*#__PURE__*/exports.TabletComponent = (0, _reactEmotion2.default)('div', {
	  target: 'e5kdb504'
	})(_mixins.desktop, '{display:none;}', _mixins.mobile, '{display:none;}');
	var MdDesktopComponent = /*#__PURE__*/exports.MdDesktopComponent = (0, _reactEmotion2.default)('div', {
	  target: 'e5kdb505'
	})('display:none;', _mixins.mdDesktop, '{display:block;}');

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgFile = function (_Component) {
	  _inherits(SvgFile, _Component);
	
	  function SvgFile() {
	    _classCallCheck(this, SvgFile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SvgFile.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "8",
	        height: "14",
	        viewBox: "0 0 8 14"
	      },
	      _react2.default.createElement("path", {
	        fill: "none",
	        fillRule: "evenodd",
	        stroke: "#FF8B0C",
	        strokeLinecap: "round",
	        strokeLinejoin: "round",
	        strokeWidth: "1.5",
	        d: "M1 13l6-6-6-6"
	      })
	    );
	  };
	
	  return SvgFile;
	}(_react.Component);
	
	exports.default = SvgFile;
	module.exports = exports["default"];

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(441);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookAnotherArrow = function (_Component) {
	  _inherits(BookAnotherArrow, _Component);
	
	  function BookAnotherArrow() {
	    _classCallCheck(this, BookAnotherArrow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BookAnotherArrow.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return BookAnotherArrow;
	}(_react.Component);
	
	exports.default = BookAnotherArrow;
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceCardsArrowSvg = function (_Component) {
	  _inherits(PriceCardsArrowSvg, _Component);
	
	  function PriceCardsArrowSvg() {
	    _classCallCheck(this, PriceCardsArrowSvg);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PriceCardsArrowSvg.prototype.render = function render() {
	    return _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "10",
	        height: "18",
	        viewBox: "0 0 10 18"
	      },
	      _react2.default.createElement("path", {
	        fill: "#1C202C",
	        fillRule: "nonzero",
	        d: "M3.018 9l6.616 6.805a1.312 1.312 0 0 1 0 1.818 1.226 1.226 0 0 1-1.768 0L.366 9.91a1.312 1.312 0 0 1 0-1.818l7.5-7.714a1.226 1.226 0 0 1 1.768 0 1.312 1.312 0 0 1 0 1.818L3.018 9z"
	      })
	    );
	  };
	
	  return PriceCardsArrowSvg;
	}(_react.Component);
	
	exports.default = PriceCardsArrowSvg;
	module.exports = exports["default"];

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PriceCardsArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgComponent = __webpack_require__(9);
	
	var _SvgComponent2 = _interopRequireDefault(_SvgComponent);
	
	var _SvgFile = __webpack_require__(443);
	
	var _SvgFile2 = _interopRequireDefault(_SvgFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceCardsArrow = function (_Component) {
	  _inherits(PriceCardsArrow, _Component);
	
	  function PriceCardsArrow() {
	    _classCallCheck(this, PriceCardsArrow);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PriceCardsArrow.prototype.render = function render() {
	    return _react2.default.createElement(_SvgComponent2.default, _extends({ renderComponent: _SvgFile2.default }, this.props));
	  };
	
	  return PriceCardsArrow;
	}(_react.Component);
	
	exports.PriceCardsArrow = PriceCardsArrow;

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var PunePageResponsiveContainer = function (_Component) {
	  _inherits(PunePageResponsiveContainer, _Component);
	
	  function PunePageResponsiveContainer() {
	    _classCallCheck(this, PunePageResponsiveContainer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PunePageResponsiveContainer.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        id = _props.id;
	
	    return _react2.default.createElement(
	      _styledComponents.MainContainer,
	      { id: id, className: className },
	      children
	    );
	  };
	
	  return PunePageResponsiveContainer;
	}(_react.Component);
	
	exports.default = PunePageResponsiveContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e2e82x40'
	})('width:1256px;margin-right:auto;margin-left:auto;@media (min-width:320px) and (max-width:425px){width:93.75%;}@media (min-width:426px) and (max-width:767px){width:90%;}@media (min-width:768px) and (max-width:1200px){width:90%;}@media (min-width:1200px) and (max-width:1339px){width:1160px;}');
	
	exports.default = {
	  MainContainer: MainContainer
	};
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_React$Component) {
	  _inherits(SEO, _React$Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var SEOData = this.props.SEOData;
	    var title = SEOData.title,
	        description = SEOData.description,
	        ogTitle = SEOData.ogTitle,
	        ogUrl = SEOData.ogUrl,
	        ogImage = SEOData.ogImage,
	        ogDescription = SEOData.ogDescription,
	        ogSiteName = SEOData.ogSiteName,
	        ogType = SEOData.ogType,
	        twitterTitle = SEOData.twitterTitle,
	        twitterUrl = SEOData.twitterUrl,
	        twitterDescription = SEOData.twitterDescription,
	        twitterImage = SEOData.twitterImage,
	        twitterSite = SEOData.twitterSite,
	        schemaData = SEOData.schemaData,
	        canonicalUrl = SEOData.canonicalUrl,
	        isRobotsTextEnabled = SEOData.isRobotsTextEnabled;
	
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      schemaData && _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        '' + schemaData
	      ),
	      title && _react2.default.createElement(
	        'title',
	        null,
	        title
	      ),
	      description && _react2.default.createElement('meta', { name: 'description', content: description }),
	      ogTitle && _react2.default.createElement('meta', { property: 'og:title', content: ogTitle }),
	      ogUrl && _react2.default.createElement('meta', { property: 'og:url', content: ogUrl }),
	      ogImage && _react2.default.createElement('meta', { property: 'og:image', content: ogImage }),
	      ogDescription && _react2.default.createElement('meta', { property: 'og:description', content: ogDescription }),
	      ogType && _react2.default.createElement('meta', { property: 'og:type', content: ogType }),
	      ogSiteName && _react2.default.createElement('meta', { property: 'og:site_name', content: ogSiteName }),
	      twitterTitle && _react2.default.createElement('meta', { property: 'twitter:title', content: twitterTitle }),
	      twitterUrl && _react2.default.createElement('meta', { name: 'twitter:url', content: twitterUrl }),
	      twitterSite && _react2.default.createElement('meta', { name: 'twitter:site', content: twitterSite }),
	      twitterDescription && _react2.default.createElement('meta', { property: 'twitter:description', content: twitterDescription }),
	      twitterImage && _react2.default.createElement('meta', { name: 'twitter:image', content: twitterImage }),
	      canonicalUrl && _react2.default.createElement('link', { rel: 'canonical', href: canonicalUrl }),
	      isRobotsTextEnabled && _react2.default.createElement('meta', { name: 'robots', content: 'noindex' })
	    );
	  };
	
	  return SEO;
	}(_react2.default.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var UI_FORMAT = exports.UI_FORMAT = 'MMM DD, YYYY - ddd';
	var DATE_FORMAT_WITH_TIME = exports.DATE_FORMAT_WITH_TIME = 'DD MMM, YY - h:mm a';

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * 
	 * @author: Manikanta
	 */
	
	var GOOGLE_MAP_URL = exports.GOOGLE_MAP_URL = 'https://goo.gl/maps/3wczs3tvwRT2';
	
	var ANAMORA_MALL_URL = exports.ANAMORA_MALL_URL = 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7566.464100873733!2d73.93424831739591!3d18.518412999999992!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xaf17bb8c37c33c68!2siB+Cricket!5e0!3m2!1sen!2sin!4v1536120661865';
	
	var GOOGLE_MAP_EMBED_URL = exports.GOOGLE_MAP_EMBED_URL = ANAMORA_MALL_URL + '&disable_scroll=true&t=m';
	
	var TESTIMONIALS_VIDEO_ID = exports.TESTIMONIALS_VIDEO_ID = 'Hhq0I1jkMFg';
	
	var IS_BOOKING_SLOT_STRIRP_CLOSED = exports.IS_BOOKING_SLOT_STRIRP_CLOSED = 'QWEeDmXxV24M0I2';
	
	var testimonialsContent = exports.testimonialsContent = {
	  presidentTestimonialHeading: 'President of India',
	  presidentTestimonialContent: 'Shri Ram Nath Kovind playing the first ball of iB Cricket'
	};

/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(20);
	
	var _queryString = __webpack_require__(62);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _styledComponents = __webpack_require__(130);
	
	var _styledComponents2 = __webpack_require__(77);
	
	var _Header = __webpack_require__(24);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SEO = __webpack_require__(220);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _LandingPage = __webpack_require__(1221);
	
	var _LandingPage2 = _interopRequireDefault(_LandingPage);
	
	var _PlayInInternationalStrip = __webpack_require__(1228);
	
	var _PlayInInternationalStrip2 = _interopRequireDefault(_PlayInInternationalStrip);
	
	var _TestimonialSection = __webpack_require__(1234);
	
	var _TestimonialSection2 = _interopRequireDefault(_TestimonialSection);
	
	var _MapSection = __webpack_require__(434);
	
	var _MapSection2 = _interopRequireDefault(_MapSection);
	
	var _ArcadeGallery = __webpack_require__(1218);
	
	var _ArcadeGallery2 = _interopRequireDefault(_ArcadeGallery);
	
	var _darkTheme = __webpack_require__(30);
	
	var _darkTheme2 = _interopRequireDefault(_darkTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArcadeTemplate = function (_React$Component) {
	  _inherits(ArcadeTemplate, _React$Component);
	
	  function ArcadeTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArcadeTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.queryParams = {}, _this.state = {
	      parsedQueryParams: false
	    }, _this.isOnePlusOneOfferPresent = function () {
	      if (_this.queryParams) {
	        if (_this.queryParams.utm_campaign) {
	          return _this.queryParams.utm_campaign.includes('1Offer');
	        }
	      }
	      return false;
	    }, _this.getPriceCardsData = function () {
	      var data = _this.props.data;
	      var parsedQueryParams = _this.state.parsedQueryParams;
	
	      if (data && parsedQueryParams) {
	        var arcadesPageData = data.arcadePageData.edges;
	        var _arcadesPageData$0$no = arcadesPageData[0].node.frontmatter,
	            priceCardsData = _arcadesPageData$0$no.priceCardsData,
	            customPriceCardsData = _arcadesPageData$0$no.customPriceCardsData;
	
	        if (_this.isOnePlusOneOfferPresent()) {
	          return customPriceCardsData;
	        }
	        return priceCardsData;
	      }
	      return null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ArcadeTemplate.prototype.render = function render() {
	    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	      this.queryParams = _queryString2.default.parse(window.location.search);
	      if (this.state.parsedQueryParams === false) this.setState({ parsedQueryParams: true });
	    }
	    var _props = this.props,
	        data = _props.data,
	        headerPropsData = _props.headerPropsData,
	        footerProps = _props.footerProps,
	        bookNowModalData = _props.bookNowModalData;
	
	    if (data) {
	      var arcadesPageData = data.arcadePageData.edges,
	          arcadePagesInterNationalStripData = data.arcadePageInterNationalStripData.edges;
	      var _arcadesPageData$0$no2 = arcadesPageData[0].node.frontmatter,
	          mapSectionData = _arcadesPageData$0$no2.mapSectionData,
	          landingPageData = _arcadesPageData$0$no2.landingPageData,
	          arcadeGalleryData = _arcadesPageData$0$no2.arcadeGalleryData,
	          bookingResponseData = _arcadesPageData$0$no2.bookingResponseData,
	          arcadeSEOData = _arcadesPageData$0$no2.arcadeSEOData,
	          termsAndConditionsData = _arcadesPageData$0$no2.termsAndConditionsData,
	          pagePrefix = _arcadesPageData$0$no2.pagePrefix;
	      var playInInternationalStrip = arcadePagesInterNationalStripData[0].node.frontmatter.playInInternationalStrip;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SEO2.default, { SEOData: arcadeSEOData }),
	        _react2.default.createElement(_Header2.default, {
	          headerPropsData: headerPropsData,
	          hideLogoByDefault: true,
	          isSimpleNavigation: false,
	          headerComponent: _styledComponents2.HeaderElement,
	          showBookSlot: false,
	          showBookSlotInSideNav: false,
	          bookNowModalData: bookNowModalData
	        }),
	        _react2.default.createElement(
	          _styledComponents.MobileContainer,
	          { iplUrl: landingPageData.mobileIplImageUrl },
	          _react2.default.createElement(_styledComponents.IplLogo, { src: landingPageData.mobileIplImageUrl, alt: 'Ipl logo' })
	        ),
	        _react2.default.createElement(_LandingPage2.default, {
	          amanoraSectionDetails: mapSectionData,
	          landingPageDetails: landingPageData,
	          termsAndConditionsData: termsAndConditionsData,
	          bookingResponseData: bookingResponseData,
	          pagePrefix: pagePrefix,
	          priceCardsData: this.getPriceCardsData(),
	          isOnePlusOneOfferPresentInPriceCards: this.isOnePlusOneOfferPresent()
	        }),
	        _react2.default.createElement(_PlayInInternationalStrip2.default, {
	          playInInternationalStrip: playInInternationalStrip,
	          pagePrefix: pagePrefix,
	          amanoraSectionDetails: mapSectionData,
	          landingPageDetails: landingPageData,
	          termsAndConditionsData: termsAndConditionsData,
	          bookingResponseData: bookingResponseData
	        }),
	        _react2.default.createElement(_TestimonialSection2.default, {
	          pagePrefix: pagePrefix,
	          amanoraSectionDetails: mapSectionData,
	          landingPageDetails: landingPageData,
	          termsAndConditionsData: termsAndConditionsData,
	          bookingResponseData: bookingResponseData
	        }),
	        _react2.default.createElement(_ArcadeGallery2.default, {
	          arcadeGalleryData: arcadeGalleryData,
	          pagePrefix: pagePrefix,
	          amanoraSectionDetails: mapSectionData,
	          landingPageDetails: landingPageData,
	          termsAndConditionsData: termsAndConditionsData,
	          bookingResponseData: bookingResponseData,
	          priceCardsData: this.getPriceCardsData()
	        }),
	        _react2.default.createElement(_MapSection2.default, {
	          amanoraSectionDetails: mapSectionData,
	          pagePrefix: pagePrefix
	        }),
	        _react2.default.createElement(_Footer2.default, _extends({}, footerProps, { theme: _darkTheme2.default.footerSection }))
	      );
	    }
	    return null;
	  };
	
	  return ArcadeTemplate;
	}(_react2.default.Component);
	
	exports.default = ArcadeTemplate;
	
	// eslint-disable-next-line
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * 
	 * @author: Anesh Parvatha
	 */
	var images = {
	  layers: {
	    desktopLayer: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/arcades/arcade-landing-desktop-overlay.svg',
	    mobileLayer: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/arcades/arcade-landing-desktop-overlay.svg',
	    tabletLayer: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/arcades/arcade-landing-desktop-overlay.svg'
	  },
	  homePageLayers: {
	    desktopLayer: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/iBC_Desktop_Layer.svg',
	    mobileLayer: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/iBC_Stadium_layer.svg',
	    tabletLayer: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/iBC_Home_Page/iBC_stadium_layer_ipad.svg'
	  },
	
	  playInInternationalStadium: {
	    stripSection: 'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_1.0,f_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/InternationalStadiumStrip/background.webp'
	  },
	  officeSectionDesktopOffice360Image: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice360image.webp',
	  officeSectionDesktopOffice1: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice1.webp',
	  officeSectionDesktopOffice2: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice2.webp',
	  officeSectionDesktopOffice3: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice3.webp',
	  officeSectionDesktopOffice4: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice4.webp',
	  officeSectionDesktopOffice5: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectiondesktopoffice5.webp',
	  officeSectionMobileOffice360Image: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice360image.webp',
	  officeSectionMobileOffice1: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice1.webp',
	  officeSectionMobileOffice2: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice2.webp',
	  officeSectionMobileOffice3: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice3.webp',
	  officeSectionMobileOffice4: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice4.webp',
	  officeSectionMobileOffice5: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionmobileoffice5.webp',
	  officeSectionIpadOffice360Image: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice360image.webp',
	  officeSectionIpadOffice1: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice1.webp',
	  officeSectionIpadOffice2: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice2.webp',
	  officeSectionIpadOffice3: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice3.webp',
	  officeSectionIpadOffice4: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice4.webp',
	  officeSectionIpadOffice5: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/officesectionipadoffice5.webp',
	  mapSectionDesktopMapImage: 'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Amanora-Mall-Map-desktop.webp',
	  mapSectionMobileMapImage: 'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Amanora-Mall-Map-Mobile.webp',
	  mapSectionIpadMapImage: 'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Amanora-Mall-Map-ipad.webp',
	  bookingResponseMapImage: 'https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/map-success-popup%403x.webp',
	
	  testimonials: {
	    galleryDesktopKidPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/kids-with-ib-cricket.webp',
	    galleryDesktopVIdeoThumbnailKarthikeya: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/actor-karthikeya-crazy-experience-with-ib-cricket.webp',
	    galleryDesktopRamNathKovind: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/president-plays-cricket.webp',
	    galleryDesktopSeniorsWithOurTeam: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/families-in-ib-cricket-arcade.webp',
	    galleryDesktopIBCricket: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/worlds-most-immersive-virtual-reality-cricket.webp',
	    galleryDesktopYouthPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/Playing-iBCricket.jpeg',
	    galleryDesktopManPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/youngsters-play-iB-Cricket.webp',
	    galleryDesktopWomenExperiencingIbc: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/everyone-plays-vr-cricket.webp',
	    galleryDesktopTestimonialQuote: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryDesktopTestimonialQuote.png',
	    galleryMobileKidPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileKidPlaying.webp',
	    galleryMobileVIdeoThumbnailKarthikeya: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/actor-karthikeya-crazy-experience-with-ib-cricket.webp',
	    galleryMobileRamNathKovind: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileRamNathKovind.webp',
	    galleryMobileSeniorsWithOurTeam: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileSeniorsWithOurTeam.webp',
	    galleryMobileIBCricket: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/worlds-most-immersive-virtual-reality-cricket.webp',
	    galleryMobileYouthPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/Playing-iBCricket.jpeg',
	    galleryMobileManPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileManPlaying.webp',
	    galleryMobileWomenExperiencingIbc: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryMobileWomenExperiencingIbc.webp',
	    galleryIpadKidPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadKidPlaying.webp',
	    galleryIpadVIdeoThumbnailKarthikeya: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/ipad/actor-karthikeya-crazy-experience-with-ib-cricket.webp',
	    galleryIpadRamNathKovind: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadRamNathKovind.webp',
	    galleryIpadSeniorsWithOurTeam: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadSeniorsWithOurTeam.webp',
	    galleryIpadIBCricket: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/ipad/worlds-most-immersive-virtual-reality-cricket.webp',
	    galleryIpadYouthPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/Images-updated-names/Playing-iBCricket.jpeg',
	    galleryIpadManPlaying: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/IbcPune/galleryIpadManPlaying.webp',
	    galleryIpadWomenExperiencingIbc: 'https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/home-page/people-love-ibc/ipad/woman-experiencing-ib-cricket.png'
	  }
	};
	
	exports.default = images;
	module.exports = exports['default'];

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * 
	 * @author: Anesh Parvatha
	 */
	
	// ----- zIndex stats -----
	
	// WRITE ALL zIndex values here so that it wont break other elements
	
	var MOBILE_BOOK_NOW_BOTTOM_FIXED_BUTTON_Z_INDEX = exports.MOBILE_BOOK_NOW_BOTTOM_FIXED_BUTTON_Z_INDEX = 10;
	var SLOT_BOOKING_FORM_MODAL_Z_INDEX = exports.SLOT_BOOKING_FORM_MODAL_Z_INDEX = 100;
	var SLOT_BOOKING_RESPONSE_MODAL_Z_INDEX = exports.SLOT_BOOKING_RESPONSE_MODAL_Z_INDEX = 1000;
	var SLOT_BOOKING_SUCCESS_RESPONSE_MODAL_Z_INDEX = exports.SLOT_BOOKING_SUCCESS_RESPONSE_MODAL_Z_INDEX = 101;
	
	// ----- zIndex ends -----

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	
	// Convert a string to proper case
	var ToProperCase = exports.ToProperCase = function ToProperCase(sourceString) {
	  return sourceString.replace(/\w\S*/g, function (txt) {
	    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	  });
	};
	
	var replaceSpacesAndHypensInString = exports.replaceSpacesAndHypensInString = function replaceSpacesAndHypensInString(sourceString) {
	  return sourceString.replace(/-|\s/g, '');
	};
	
	var combineAndConvertToLowerCase = exports.combineAndConvertToLowerCase = function combineAndConvertToLowerCase(sourceString) {
	  var lowerCaseString = sourceString.toLowerCase();
	  var updatedString = lowerCaseString.replace(/-|\s/g, '');
	  return updatedString;
	};

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * 
	 * @author: Preethi
	 */
	
	var UIStore = function UIStore() {
	  var _this = this;
	
	  _classCallCheck(this, UIStore);
	
	  this.mobileSBFormModalRef = null;
	  this.formMobileRef = null;
	
	  this.setMobileSBFormModalRef = function (ref) {
	    _this.mobileSBFormModalRef = ref;
	  };
	
	  this.getMobileSBFormModalRef = function () {
	    return _this.mobileSBFormModalRef;
	  };
	
	  this.captureFormMobileRef = function (ref) {
	    _this.formMobileRef = ref;
	  };
	
	  this.getFormMobileRef = function () {
	    return _this.formMobileRef;
	  };
	};
	
	var uiStore = new UIStore();
	
	exports.default = uiStore;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-arcade-pages-template-js-14f0c180a7aea133f973.js